const blocks = {
  Nicobars: [
    {
      _id: '60ab6e9486ed1c1a3559dc33',
      name: 'Campbell Bay',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc34',
      name: 'Car Nicobar',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc35',
      name: 'Nancowrie',
    },
  ],
  'North And Middle Andaman': [
    {
      _id: '60ab6e9486ed1c1a3559dc36',
      name: 'Diglipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc37',
      name: 'Mayabunder',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc3c',
      name: 'Rangat',
    },
  ],
  'South Andamans': [
    {
      _id: '60ab6e9486ed1c1a3559dc38',
      name: 'Ferrargunj',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc39',
      name: 'Little Andaman',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc3a',
      name: 'Prothrapur',
    },
  ],
  Anantapur: [
    {
      _id: '60ab6e9486ed1c1a3559dc3b',
      name: 'Agali',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc3d',
      name: 'Amadagur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc3e',
      name: 'Amarapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc3f',
      name: 'Anantapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc40',
      name: 'Atmakur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc41',
      name: 'Bathalapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc42',
      name: 'Bommanahal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc43',
      name: 'Beluguppa',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc44',
      name: 'Bukkapatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc45',
      name: 'Brahmasamudram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc46',
      name: 'Chennekothapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc47',
      name: 'Chilamathur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc48',
      name: 'Dharmavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc49',
      name: 'D.Hirehal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc4a',
      name: 'Gandlapenta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc4b',
      name: 'Garladinne',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc4c',
      name: 'Gooty',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc4d',
      name: 'Gorantla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc4e',
      name: 'Gudibanda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc4f',
      name: 'Gummagatta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc50',
      name: 'Guntakal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc51',
      name: 'Hindupur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc52',
      name: 'Bukkarayasamudram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc53',
      name: 'Kalyandrug',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc54',
      name: 'Kadiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc55',
      name: 'Kambadur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc56',
      name: 'Kanaganapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc57',
      name: 'Kanekal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc58',
      name: 'Kudair',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc59',
      name: 'Kundurpi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc5a',
      name: 'Lepakshi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc5b',
      name: 'Madakasira',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc5c',
      name: 'Kothacheruvu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc5d',
      name: 'Nallacheruvu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc5e',
      name: 'Nallamada',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc5f',
      name: 'Nambulapulikunta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc60',
      name: 'Narpala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc61',
      name: 'Obuladevarecheruvu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc62',
      name: 'Pamidi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc63',
      name: 'Parigi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc64',
      name: 'Peddapappur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc65',
      name: 'Peddavadugur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc66',
      name: 'Penukonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc67',
      name: 'Putlur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc68',
      name: 'Puttaparthi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc69',
      name: 'Mudigubba',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc6a',
      name: 'Ramagiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc6b',
      name: 'Raptadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc6c',
      name: 'Rayadurg',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc6d',
      name: 'Roddam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc6e',
      name: 'Settur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc6f',
      name: 'Singanamala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc70',
      name: 'Somandepalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc71',
      name: 'Tadimarri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc72',
      name: 'Tadipatri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc73',
      name: 'Talupula',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc74',
      name: 'Tanakal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc75',
      name: 'Rolla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc76',
      name: 'Uravakonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc77',
      name: 'Vidapanakal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc78',
      name: 'Vajrakarur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc79',
      name: 'Yadiki',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc7a',
      name: 'Yellanur',
    },
  ],
  Chittoor: [
    {
      _id: '60ab6e9486ed1c1a3559dc7b',
      name: 'Baireddipalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc7c',
      name: 'B.Kothakota',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc7d',
      name: 'Bangarupalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc7e',
      name: 'Buchinadidu Khandriga',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc7f',
      name: 'Chandragiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc80',
      name: 'Chinnagottigallu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc81',
      name: 'Chittoor',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc82',
      name: 'Chowdepalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc83',
      name: 'Gangadhara Nellore',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc84',
      name: 'Gangavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc85',
      name: 'Gudipala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc86',
      name: 'Gurramkonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc87',
      name: 'Irala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc88',
      name: 'Gudupalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc89',
      name: 'Kalakada',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc8a',
      name: 'Kalikiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc8b',
      name: 'Karvetinagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc8c',
      name: 'Kambhamvaripalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc8d',
      name: 'Kuppam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc8e',
      name: 'Kurabalakota',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc8f',
      name: 'K.V.B.Puram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc90',
      name: 'Madanapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc91',
      name: 'Mulakalacheruvu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc92',
      name: 'Nagalapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc93',
      name: 'Narayanavanam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc94',
      name: 'Nagari',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc95',
      name: 'Nimmanapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc96',
      name: 'Nindra',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc97',
      name: 'Pakala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc98',
      name: 'Palasamudram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc99',
      name: 'Palamaner',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc9a',
      name: 'Peddapanjani',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc9b',
      name: 'Peddathippasamudram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc9c',
      name: 'Peddamandyam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc9d',
      name: 'Penumuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc9e',
      name: 'Piler',
    },
    {
      _id: '60ab6e9486ed1c1a3559dc9f',
      name: 'Pulicherla H/O Reddivaripalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca0',
      name: 'Punganur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca1',
      name: 'Puthalapattu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca2',
      name: 'Puttur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca3',
      name: 'Ramachandrapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca4',
      name: 'Ramakuppam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca5',
      name: 'Ramasamudram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca6',
      name: 'Renigunta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca7',
      name: 'Rompicherla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca8',
      name: 'Santhipuram Ho Arimuthanapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dca9',
      name: 'Satyavedu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcaa',
      name: 'Sodam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcab',
      name: 'Pitchatur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcac',
      name: 'Srikalahasti',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcad',
      name: 'Srirangarajapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcae',
      name: 'Somala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcaf',
      name: 'Thamballapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb0',
      name: 'Thottambedu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb1',
      name: 'Thavanampalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb2',
      name: 'Tirupati (Rural)',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb3',
      name: 'Vadamalapeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb4',
      name: 'Valmikipuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb5',
      name: 'Varadaiahpalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb6',
      name: 'Vedurukuppam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb7',
      name: 'Venkatagirikota',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb8',
      name: 'Vijayapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcb9',
      name: 'Yerpedu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcba',
      name: 'Yerravaripalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcbb',
      name: 'Yadamari',
    },
  ],
  'East Godavari': [
    {
      _id: '60ab6e9486ed1c1a3559dcbc',
      name: 'Ainavilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcbd',
      name: 'Addateegala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcbe',
      name: 'Alamuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcbf',
      name: 'Allavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc0',
      name: 'Amalapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc1',
      name: 'Ambajipeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc2',
      name: 'Anaparthy',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc3',
      name: 'Biccavolu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc4',
      name: 'Chintoor',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc5',
      name: 'Atreyapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc6',
      name: 'Devipatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc7',
      name: 'Gandepalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc8',
      name: 'Gangavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcc9',
      name: 'Gollaprolu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcca',
      name: 'I. Polavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dccb',
      name: 'Gokavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dccc',
      name: 'Jaggampeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dccd',
      name: 'Kadiam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcce',
      name: 'Kajuluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dccf',
      name: 'Kakinada Rural',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd0',
      name: 'Kakinada Urban',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd1',
      name: 'Kapileswarapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd2',
      name: 'Katrenikona',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd3',
      name: 'Karapa',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd4',
      name: 'Kirlampudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd5',
      name: 'Korukonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd6',
      name: 'Kotananduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd7',
      name: 'Kunavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd8',
      name: 'Kothapeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcd9',
      name: 'Malikipuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcda',
      name: 'Mamidikuduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcdb',
      name: 'Mandapeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcdc',
      name: 'Mummidivaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcdd',
      name: 'Maredumilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcde',
      name: 'Nellipaka',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcdf',
      name: 'Pamarru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce0',
      name: 'Peddapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce1',
      name: 'Pedapudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce2',
      name: 'Pithapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce3',
      name: 'P.Gannavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce4',
      name: 'Prathipadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce5',
      name: 'Rajahmundry Rural',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce6',
      name: 'Rajahmundry Urban',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce7',
      name: 'Rajavommangi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce8',
      name: 'Ramachandrapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dce9',
      name: 'Rampachodavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcea',
      name: 'Rangampeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dceb',
      name: 'Ravulapalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcec',
      name: 'Rayavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dced',
      name: 'Razole',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcee',
      name: 'Routhulapudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcef',
      name: 'Sakhinetipalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf0',
      name: 'Samalkota',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf1',
      name: 'Sankhavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf2',
      name: 'Seethanagaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf3',
      name: 'Thallarevu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf4',
      name: 'Thondangi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf5',
      name: 'Tuni',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf6',
      name: 'U.Kothapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf7',
      name: 'Uppalaguptam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf8',
      name: 'Vararamachandrapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcf9',
      name: 'Rajanagaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcfa',
      name: 'Yeleswaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcfb',
      name: 'Y. Ramavaram',
    },
  ],
  Guntur: [
    {
      _id: '60ab6e9486ed1c1a3559dcfc',
      name: 'Amaravathi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcfd',
      name: 'Atchempet',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcfe',
      name: 'Bapatla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dcff',
      name: 'Bellamkonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd00',
      name: 'Bhattiprolu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd01',
      name: 'Bollapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd02',
      name: 'Chebrole',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd03',
      name: 'Amruthalur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd04',
      name: 'Cherukupalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd05',
      name: 'Chilakaluripet',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd06',
      name: 'Duggirala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd07',
      name: 'Durgi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd08',
      name: 'Edlapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd09',
      name: 'Guntur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd0a',
      name: 'Gurazala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd0b',
      name: 'Dachepalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd0c',
      name: 'Kakumanu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd0d',
      name: 'Ipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd0e',
      name: 'Karempudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd0f',
      name: 'Karlapalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd10',
      name: 'Kollur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd11',
      name: 'Krosuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd12',
      name: 'Kollipara',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd13',
      name: 'Machavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd14',
      name: 'Macherla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd15',
      name: 'Medikonduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd16',
      name: 'Mangalagiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd17',
      name: 'Muppalla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd18',
      name: 'Nadendla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd19',
      name: 'Nagaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd1a',
      name: 'Nekarikallu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd1b',
      name: 'Narasaraopeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd1c',
      name: 'Nizampatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd1d',
      name: 'Pedakakani',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd1e',
      name: 'Nuzendla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd1f',
      name: 'Pedanandipadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd20',
      name: 'Pedakurapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd21',
      name: 'Phirangipuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd22',
      name: 'Piduguralla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd23',
      name: 'Pittalavanipalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd24',
      name: 'Prathipadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd25',
      name: 'Rajupalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd26',
      name: 'Ponnur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd27',
      name: 'Rentachintala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd28',
      name: 'Repalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd29',
      name: 'Rompicherla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd2a',
      name: 'Sattenapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd2b',
      name: 'Savalyapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd2c',
      name: 'Tadepalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd2d',
      name: 'Tadikonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd2e',
      name: 'Tenali',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd2f',
      name: 'Thullur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd30',
      name: 'Tsundur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd31',
      name: 'Vatticherukuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd32',
      name: 'Veldurthy',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd33',
      name: 'Vinukonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd3f',
      name: 'Vemuru',
    },
  ],
  Krishna: [
    {
      _id: '60ab6e9486ed1c1a3559dd34',
      name: 'Agiripalli',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd35',
      name: 'A.Konduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd36',
      name: 'Avanigadda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd37',
      name: 'Bantumilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd38',
      name: 'Bapulapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd39',
      name: 'Challapalli',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd3a',
      name: 'Chandarlapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd3b',
      name: 'Chatrai',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd3c',
      name: 'Gampalagudem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd3d',
      name: 'Gannavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd3e',
      name: 'Ghantasala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd40',
      name: 'G.Konduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd41',
      name: 'Gudivada',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd42',
      name: 'Guduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd43',
      name: 'Gudlavalleru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd44',
      name: 'Jaggayyapeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd45',
      name: 'Kaikalur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd46',
      name: 'Kalidindi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd47',
      name: 'Kanchikacherla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd48',
      name: 'Kankipadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd49',
      name: 'Koduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd4a',
      name: 'Kruttivennu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd4b',
      name: 'Ibrahimpatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd4c',
      name: 'Machilipatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd4d',
      name: 'Mandavalli',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd4e',
      name: 'Mopidevi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd4f',
      name: 'Movva',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd50',
      name: 'Musunuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd51',
      name: 'Mudinepalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd52',
      name: 'Mylavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd53',
      name: 'Nagayalanka',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd54',
      name: 'Nandigama',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd55',
      name: 'Nandivada',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd56',
      name: 'Pamarru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd57',
      name: 'Nuzvid',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd58',
      name: 'Pamidimukkala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd59',
      name: 'Pedana',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd5a',
      name: 'Pedaparupudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd5b',
      name: 'Penuganchiprolu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd5c',
      name: 'Penamaluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd5d',
      name: 'Reddigudem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd5e',
      name: 'Tiruvuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd5f',
      name: 'Thotlavalluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd60',
      name: 'Unguturu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd61',
      name: 'Vatsavai',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd62',
      name: 'Veerullapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd63',
      name: 'Vijayawada Rural',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd64',
      name: 'Vijayawada Urban',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd65',
      name: 'Vuyyuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd66',
      name: 'Vissannapet',
    },
  ],
  Kurnool: [
    {
      _id: '60ab6e9486ed1c1a3559dd67',
      name: 'Allagadda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd68',
      name: 'Adoni',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd69',
      name: 'Alur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd6a',
      name: 'Atmakur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd6b',
      name: 'Aspari',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd6c',
      name: 'Bandi Atmakur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd6d',
      name: 'Bethamcherla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd6e',
      name: 'C.Belagal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd6f',
      name: 'Chagalamarri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd70',
      name: 'Banaganapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd71',
      name: 'Chippagiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd72',
      name: 'Devanakonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd73',
      name: 'Dhone Alias Dronachalam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd74',
      name: 'Dornipadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd75',
      name: 'Gadivemula',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd76',
      name: 'Gonegandla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd77',
      name: 'Gospadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd78',
      name: 'Gudur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd79',
      name: 'Halaharvi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd7a',
      name: 'Holagunda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd7b',
      name: 'Kallur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd7c',
      name: 'Kodumur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd7d',
      name: 'Koilakuntla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd7e',
      name: 'Kolimigundla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd7f',
      name: 'Kosigi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd80',
      name: 'Kothapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd81',
      name: 'Kowthalam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd82',
      name: 'Krishnagiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd83',
      name: 'Kurnool',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd84',
      name: 'Maddikera (East)',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd86',
      name: 'Mantralayam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd87',
      name: 'Midthur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd88',
      name: 'Nandavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd89',
      name: 'Jupadu Bungalow',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd8a',
      name: 'Nandyal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd8b',
      name: 'Nandikotkur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd8c',
      name: 'Owk',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd8d',
      name: 'Pagidyala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd8e',
      name: 'Orvakal',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd8f',
      name: 'Pamulapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd90',
      name: 'Panyam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd91',
      name: 'Peapully',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd92',
      name: 'Pattikonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd93',
      name: 'Rudravaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd94',
      name: 'Peddakadabur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd95',
      name: 'Sanjamala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd96',
      name: 'Srisailam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd97',
      name: 'Sirivel',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd98',
      name: 'Tuggali',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd99',
      name: 'Uyyalawada',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd9a',
      name: 'Veldurthi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd9b',
      name: 'Velugodu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd9c',
      name: 'Yemmiganur',
    },
  ],
  Prakasam: [
    {
      _id: '60ab6e9486ed1c1a3559dd9d',
      name: 'Addanki',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd9e',
      name: 'Ballikurava',
    },
    {
      _id: '60ab6e9486ed1c1a3559dd9f',
      name: 'Bestavaripeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda0',
      name: 'Ardhaveedu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda1',
      name: 'Chandra Sekhara Puram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda2',
      name: 'Chimakurthi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda3',
      name: 'Chinaganjam',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda4',
      name: 'Cumbum',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda5',
      name: 'Chirala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda6',
      name: 'Donakonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda7',
      name: 'Darsi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda8',
      name: 'Dornala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dda9',
      name: 'Gudluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddaa',
      name: 'Giddaluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddab',
      name: 'Hanumanthuni Padu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddac',
      name: 'Inkollu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddad',
      name: 'Janakavaram Ponguluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddae',
      name: 'Kanigiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddaf',
      name: 'Karamchedu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb0',
      name: 'Komarolu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb1',
      name: 'Konakanamittla',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb2',
      name: 'Kondapi',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb3',
      name: 'Korisapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb4',
      name: 'Kotha Patnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb5',
      name: 'Kurichedu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb6',
      name: 'Lingasamudram',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb7',
      name: 'Maddipadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb8',
      name: 'Markapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddb9',
      name: 'Marripudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddba',
      name: 'Kandukur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddbb',
      name: 'Martur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddbc',
      name: 'Mundlamuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddbd',
      name: 'Naguluppala Padu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddbe',
      name: 'Pamur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddbf',
      name: 'Parchur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc0',
      name: 'Ongole',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc1',
      name: 'Peda Araveedu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc2',
      name: 'Pedacherlo Palle',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc3',
      name: 'Ponnaluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc4',
      name: 'Podili',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc5',
      name: 'Pullalacheruvu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc6',
      name: 'Racherla',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc7',
      name: 'Santhamaguluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc8',
      name: 'Singarayakonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddc9',
      name: 'Santhanuthala Padu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddca',
      name: 'Tallur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddcb',
      name: 'Tangutur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddcc',
      name: 'Tarlupadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddcd',
      name: 'Ulavapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddce',
      name: 'Veligandla',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddcf',
      name: 'Vetapalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd0',
      name: 'Voletivari Palem',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd1',
      name: 'Yddana Pudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd2',
      name: 'Yerragondapalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd3',
      name: 'Zarugumilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd8',
      name: 'Tripuranthakam',
    },
  ],
  'Spsr Nellore': [
    {
      _id: '60ab6e9486ed1c1a3559ddd4',
      name: 'Allur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd5',
      name: 'Ananthasagaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd6',
      name: 'Anumasamudrampeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd7',
      name: 'Atmakur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddd9',
      name: 'Balayapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddda',
      name: 'Bogole',
    },
    {
      _id: '60ab6e9486ed1c1a3559dddb',
      name: 'Butchireddipalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dddc',
      name: 'Chillakur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dddd',
      name: 'Chittamur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddde',
      name: 'Chejerla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dddf',
      name: 'Dagadarthi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde0',
      name: 'Dakkili',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde1',
      name: 'Duttalur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde2',
      name: 'Doravarisatram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde3',
      name: 'Gudur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde4',
      name: 'Indukurpet',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde5',
      name: 'Jaladanki',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde6',
      name: 'Kaligiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde7',
      name: 'Kaluvoya',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde8',
      name: 'Kodavalur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dde9',
      name: 'Kavali',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddea',
      name: 'Kondapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddeb',
      name: 'Kovur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddec',
      name: 'Kota',
    },
    {
      _id: '60ab6e9486ed1c1a3559dded',
      name: 'Manubolu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddee',
      name: 'Marripadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddef',
      name: 'Muthukur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf0',
      name: 'Nellore Rural',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf1',
      name: 'Ozili',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf2',
      name: 'Pellakur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf3',
      name: 'Podalakur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf4',
      name: 'Rapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf5',
      name: 'Sangam',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf6',
      name: 'Seetharamapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf7',
      name: 'Sullurpeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf8',
      name: 'Sydapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddf9',
      name: 'Tada',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddfa',
      name: 'Naidupeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddfb',
      name: 'Thotapalligudur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddfc',
      name: 'Udayagiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddfd',
      name: 'Varikuntapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddfe',
      name: 'Venkatachalam',
    },
    {
      _id: '60ab6e9486ed1c1a3559ddff',
      name: 'Venkatagiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559de00',
      name: 'Vakadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de01',
      name: 'Vidavalur',
    },
    {
      _id: '60ab6e9486ed1c1a3559de02',
      name: 'Vinjamur',
    },
  ],
  Srikakulam: [
    {
      _id: '60ab6e9486ed1c1a3559de03',
      name: 'Amadalavalasa',
    },
    {
      _id: '60ab6e9486ed1c1a3559de04',
      name: 'Bhamini',
    },
    {
      _id: '60ab6e9486ed1c1a3559de05',
      name: 'Burja',
    },
    {
      _id: '60ab6e9486ed1c1a3559de06',
      name: 'Ganguvarisigadam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de07',
      name: 'Gara',
    },
    {
      _id: '60ab6e9486ed1c1a3559de08',
      name: 'Hiramandalam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de09',
      name: 'Ichapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de0a',
      name: 'Etcherla',
    },
    {
      _id: '60ab6e9486ed1c1a3559de0b',
      name: 'Jalumuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de0c',
      name: 'Kaviti',
    },
    {
      _id: '60ab6e9486ed1c1a3559de0d',
      name: 'Kotabommili',
    },
    {
      _id: '60ab6e9486ed1c1a3559de0e',
      name: 'Kanchili',
    },
    {
      _id: '60ab6e9486ed1c1a3559de0f',
      name: 'Laveru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de10',
      name: 'L.N Peta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de11',
      name: 'Kotturu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de12',
      name: 'Mandasa',
    },
    {
      _id: '60ab6e9486ed1c1a3559de13',
      name: 'Meliaputti',
    },
    {
      _id: '60ab6e9486ed1c1a3559de14',
      name: 'Nandigam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de15',
      name: 'Narasannapeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de16',
      name: 'Palakonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559de17',
      name: 'Palasa',
    },
    {
      _id: '60ab6e9486ed1c1a3559de18',
      name: 'Pathapatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de19',
      name: 'Polaki',
    },
    {
      _id: '60ab6e9486ed1c1a3559de1a',
      name: 'Rajam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de1b',
      name: 'Ponduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de1c',
      name: 'Regidi Amadalavalasa',
    },
    {
      _id: '60ab6e9486ed1c1a3559de1d',
      name: 'Ranastalam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de1e',
      name: 'Santhabommali',
    },
    {
      _id: '60ab6e9486ed1c1a3559de1f',
      name: 'Santhakavati',
    },
    {
      _id: '60ab6e9486ed1c1a3559de20',
      name: 'Sarubujjili',
    },
    {
      _id: '60ab6e9486ed1c1a3559de21',
      name: 'Seethampeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de22',
      name: 'Saravakota',
    },
    {
      _id: '60ab6e9486ed1c1a3559de23',
      name: 'Srikakulam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de24',
      name: 'Tekkali',
    },
    {
      _id: '60ab6e9486ed1c1a3559de25',
      name: 'Vajrapukotturu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de26',
      name: 'Vangara',
    },
    {
      _id: '60ab6e9486ed1c1a3559de27',
      name: 'Veeraghattam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de2f',
      name: 'Sompeta',
    },
  ],
  'Alluri Sitharama Raju': [
    {
      _id: '60ab6e9486ed1c1a3559df01',
      name: 'Addateegala',
    },
    {
      _id: '60ab6e9486ed1c1a3559df02',
      name: 'Ananthagiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559df03',
      name: 'Araku Valley',
    },
    {
      _id: '60ab6e9486ed1c1a3559de30',
      name: 'Chintapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559df05',
      name: 'Chintoor',
    },
    {
      _id: '60ab6e9486ed1c1a3559df06',
      name: 'Devipatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559df07',
      name: 'Dumbriguda',
    },
    {
      _id: '60ab6e9486ed1c1a3559df08',
      name: 'G.Madugula',
    },
    {
      _id: '60ab6e9486ed1c1a3559df09',
      name: 'Gangavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0a',
      name: 'Gudem Kotha Veedhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0b',
      name: 'Hukumpeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0c',
      name: 'Koyyuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0d',
      name: 'Kunavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0e',
      name: 'Maredumilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0f',
      name: 'Munchingi Puttu',
    },
    {
      _id: '60ab6e9486ed1c1a3559df10',
      name: 'Nellipaka',
    },
    {
      _id: '60ab6e9486ed1c1a3559df11',
      name: 'Paderu',
    },
    {
      _id: '60ab6e9486ed1c1a3559df12',
      name: 'Peda Bayalu',
    },
    {
      _id: '60ab6e9486ed1c1a3559df13',
      name: 'Rajavommangi',
    },
    {
      _id: '60ab6e9486ed1c1a3559df14',
      name: 'Rampachodavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df15',
      name: 'Vararamachandrapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df16',
      name: 'Y. Ramavaram',
    },
  ],
  Anakapalli: [
    {
      _id: '60ab6e9486ed1c1a3559df21',
      name: 'Achutapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df22',
      name: 'Anakapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559df23',
      name: 'Butchayyapeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559df24',
      name: 'Cheedikada',
    },
    {
      _id: '60ab6e9486ed1c1a3559df25',
      name: 'Chodavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df26',
      name: 'Devarapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559df27',
      name: 'Golugonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559df28',
      name: 'K.Kotapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559df29',
      name: 'Kasimkota',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2a',
      name: 'Kotauratla',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2b',
      name: 'Madugula',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2c',
      name: 'Makavarapalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2d',
      name: 'Munagapaka',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2e',
      name: 'Nakkapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2f',
      name: 'Narsipatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559df30',
      name: 'Nathavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df31',
      name: 'Paravada',
    },
    {
      _id: '60ab6e9486ed1c1a3559df32',
      name: 'Payakaraopeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559df33',
      name: 'Rambilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559df34',
      name: 'Ravikamatham',
    },
    {
      _id: '60ab6e9486ed1c1a3559df35',
      name: 'Rolugunta',
    },
    {
      _id: '60ab6e9486ed1c1a3559df36',
      name: 'S.Rayavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df37',
      name: 'Sabbavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df38',
      name: 'Yelamanchili',
    },
  ],
  Visakhapatanam: [
    {
      _id: '60ab6e9486ed1c1a3559de28',
      name: 'Achutapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de29',
      name: 'Anakapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559de2a',
      name: 'Anandapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de2b',
      name: 'Ananthagiri',
    },
    {
      _id: '60ab6e9486ed1c1a3559de2c',
      name: 'Araku Valley',
    },
    {
      _id: '60ab6e9486ed1c1a3559de2d',
      name: 'Bheemunipatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de2e',
      name: 'Butchayyapeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de31',
      name: 'Chodavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de32',
      name: 'Cheedikada',
    },
    {
      _id: '60ab6e9486ed1c1a3559de33',
      name: 'Devarapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559de34',
      name: 'Dumbriguda',
    },
    {
      _id: '60ab6e9486ed1c1a3559de35',
      name: 'Gajuwaka',
    },
    {
      _id: '60ab6e9486ed1c1a3559de36',
      name: 'G.Madugula',
    },
    {
      _id: '60ab6e9486ed1c1a3559de37',
      name: 'Golugonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559de38',
      name: 'Gudem Kotha Veedhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559de39',
      name: 'Hukumpeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de3a',
      name: 'Kasimkota',
    },
    {
      _id: '60ab6e9486ed1c1a3559de3b',
      name: 'K.Kotapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de3c',
      name: 'Kotauratla',
    },
    {
      _id: '60ab6e9486ed1c1a3559de3d',
      name: 'Koyyuru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de3e',
      name: 'Makavarapalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559de3f',
      name: 'Munagapaka',
    },
    {
      _id: '60ab6e9486ed1c1a3559de40',
      name: 'Madugula',
    },
    {
      _id: '60ab6e9486ed1c1a3559de41',
      name: 'Munchingi Puttu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de42',
      name: 'Nakkapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559de43',
      name: 'Narsipatnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de44',
      name: 'Nathavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de45',
      name: 'Paderu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de46',
      name: 'Padmanabham',
    },
    {
      _id: '60ab6e9486ed1c1a3559de47',
      name: 'Paravada',
    },
    {
      _id: '60ab6e9486ed1c1a3559de48',
      name: 'Payakaraopeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de49',
      name: 'Peda Bayalu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de4a',
      name: 'Pedagantyada',
    },
    {
      _id: '60ab6e9486ed1c1a3559de4b',
      name: 'Pendurthi',
    },
    {
      _id: '60ab6e9486ed1c1a3559de4c',
      name: 'Rambilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559de4d',
      name: 'Rolugunta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de4e',
      name: 'Sabbavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de4f',
      name: 'Ravikamatham',
    },
    {
      _id: '60ab6e9486ed1c1a3559de50',
      name: 'S.Rayavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de51',
      name: 'Yelamanchili',
    },
    {
      _id: '60ab6e9486ed1c1a3559de5b',
      name: 'Visakhapatnam(Rural)',
    },
  ],
  Vizianagaram: [
    {
      _id: '60ab6e9486ed1c1a3559de52',
      name: 'Badangi',
    },
    {
      _id: '60ab6e9486ed1c1a3559de53',
      name: 'Balijipeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de54',
      name: 'Bhoghapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de55',
      name: 'Bobbili',
    },
    {
      _id: '60ab6e9486ed1c1a3559de56',
      name: 'Bondapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559de57',
      name: 'Cheepurupalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559de58',
      name: 'Dattirajeru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de59',
      name: 'Denkada',
    },
    {
      _id: '60ab6e9486ed1c1a3559de5a',
      name: 'Gajapathinagaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de5c',
      name: 'Gantyada',
    },
    {
      _id: '60ab6e9486ed1c1a3559de5d',
      name: 'Garividi',
    },
    {
      _id: '60ab6e9486ed1c1a3559de5e',
      name: 'Gummalakshmipuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de5f',
      name: 'Gurla',
    },
    {
      _id: '60ab6e9486ed1c1a3559de60',
      name: 'Jami',
    },
    {
      _id: '60ab6e9486ed1c1a3559de61',
      name: 'Jiyyammavalasa',
    },
    {
      _id: '60ab6e9486ed1c1a3559de62',
      name: 'Garugubilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559de63',
      name: 'Komarada',
    },
    {
      _id: '60ab6e9486ed1c1a3559de64',
      name: 'Kurupam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de65',
      name: 'Kothavalasa',
    },
    {
      _id: '60ab6e9486ed1c1a3559de66',
      name: 'Lakkavarapukota',
    },
    {
      _id: '60ab6e9486ed1c1a3559de67',
      name: 'Mentada',
    },
    {
      _id: '60ab6e9486ed1c1a3559de68',
      name: 'Merakamudidam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de69',
      name: 'Makkuva',
    },
    {
      _id: '60ab6e9486ed1c1a3559de6a',
      name: 'Nellimarla',
    },
    {
      _id: '60ab6e9486ed1c1a3559de6b',
      name: 'Pachipenta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de6c',
      name: 'Parvathipuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de6d',
      name: 'Pusapatirega',
    },
    {
      _id: '60ab6e9486ed1c1a3559de6e',
      name: 'Ramabhadrapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de6f',
      name: 'Salur',
    },
    {
      _id: '60ab6e9486ed1c1a3559de70',
      name: 'Seethanagaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de71',
      name: 'Therlam',
    },
    {
      _id: '60ab6e9486ed1c1a3559de72',
      name: 'Vepada',
    },
    {
      _id: '60ab6e9486ed1c1a3559de73',
      name: 'Vizianagaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de7d',
      name: 'Srungavarapukota',
    },
  ],
  'West Godavari': [
    {
      _id: '60ab6e9486ed1c1a3559de74',
      name: 'Achanta',
    },
    {
      _id: '60ab6e9486ed1c1a3559de75',
      name: 'Akividu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de76',
      name: 'Attili',
    },
    {
      _id: '60ab6e9486ed1c1a3559de77',
      name: 'Bhimadole',
    },
    {
      _id: '60ab6e9486ed1c1a3559de78',
      name: 'Bhimavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de79',
      name: 'Buttayagudem',
    },
    {
      _id: '60ab6e9486ed1c1a3559de7a',
      name: 'Chagallu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de7b',
      name: 'Chintalapudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559de7c',
      name: 'Denduluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de7e',
      name: 'Devarapalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559de7f',
      name: 'Dwarakatirumala',
    },
    {
      _id: '60ab6e9486ed1c1a3559de80',
      name: 'Elamanchili',
    },
    {
      _id: '60ab6e9486ed1c1a3559de81',
      name: 'Eluru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de82',
      name: 'Gopalapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de83',
      name: 'Iragavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de84',
      name: 'Jangareddigudem',
    },
    {
      _id: '60ab6e9486ed1c1a3559de85',
      name: 'Ganapavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de86',
      name: 'Jeelugumilli',
    },
    {
      _id: '60ab6e9486ed1c1a3559de87',
      name: 'Kamavarapukota',
    },
    {
      _id: '60ab6e9486ed1c1a3559de88',
      name: 'Kalla',
    },
    {
      _id: '60ab6e9486ed1c1a3559de89',
      name: 'Kovvur',
    },
    {
      _id: '60ab6e9486ed1c1a3559de8a',
      name: 'Koyyalagudem',
    },
    {
      _id: '60ab6e9486ed1c1a3559de8b',
      name: 'Lingapalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559de8c',
      name: 'Kukkunur',
    },
    {
      _id: '60ab6e9486ed1c1a3559de8d',
      name: 'Nallajerla',
    },
    {
      _id: '60ab6e9486ed1c1a3559de8e',
      name: 'Mogalthur',
    },
    {
      _id: '60ab6e9486ed1c1a3559de8f',
      name: 'Narsapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559de90',
      name: 'Nidadavole',
    },
    {
      _id: '60ab6e9486ed1c1a3559de91',
      name: 'Palacole',
    },
    {
      _id: '60ab6e9486ed1c1a3559de92',
      name: 'Nidamarru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de93',
      name: 'Palakoderu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de94',
      name: 'Pedapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de95',
      name: 'Pedavegi',
    },
    {
      _id: '60ab6e9486ed1c1a3559de96',
      name: 'Pentapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559de97',
      name: 'Penugonda',
    },
    {
      _id: '60ab6e9486ed1c1a3559de98',
      name: 'Penumantra',
    },
    {
      _id: '60ab6e9486ed1c1a3559de99',
      name: 'Peravali',
    },
    {
      _id: '60ab6e9486ed1c1a3559de9a',
      name: 'Poduru',
    },
    {
      _id: '60ab6e9486ed1c1a3559de9b',
      name: 'Polavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559de9c',
      name: 'Tadepalligudem',
    },
    {
      _id: '60ab6e9486ed1c1a3559de9d',
      name: 'Thallapudi',
    },
    {
      _id: '60ab6e9486ed1c1a3559de9e',
      name: 'Tanuku',
    },
    {
      _id: '60ab6e9486ed1c1a3559de9f',
      name: 'T.Narasapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea0',
      name: 'Undrajavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea1',
      name: 'Unguturu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea2',
      name: 'Veeravasaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea3',
      name: 'Undi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea4',
      name: 'Velairpad',
    },
  ],
  'Y.S.R.': [
    {
      _id: '60ab6e9486ed1c1a3559dea5',
      name: 'Badvel',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea6',
      name: 'Atlur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea7',
      name: 'B.Kodur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea8',
      name: 'Chakrayapet',
    },
    {
      _id: '60ab6e9486ed1c1a3559dea9',
      name: 'Chapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559deaa',
      name: 'Brahmamgarimatham.',
    },
    {
      _id: '60ab6e9486ed1c1a3559deab',
      name: 'Chennur',
    },
    {
      _id: '60ab6e9486ed1c1a3559deac',
      name: 'Chinnamandem',
    },
    {
      _id: '60ab6e9486ed1c1a3559dead',
      name: 'Chitvel',
    },
    {
      _id: '60ab6e9486ed1c1a3559deae',
      name: 'Chintakomma Dinne',
    },
    {
      _id: '60ab6e9486ed1c1a3559deaf',
      name: 'Duvvur',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb0',
      name: 'Galiveedu',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb1',
      name: 'Gopavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb2',
      name: 'Jammalamadugu',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb3',
      name: 'Kadapa',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb4',
      name: 'Kalasapadu',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb5',
      name: 'Kamalapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb6',
      name: 'Khajipet',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb7',
      name: 'Kodur',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb8',
      name: 'Kondapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559deb9',
      name: 'Lakkireddipalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559deba',
      name: 'Lingala',
    },
    {
      _id: '60ab6e9486ed1c1a3559debb',
      name: 'Muddanur',
    },
    {
      _id: '60ab6e9486ed1c1a3559debc',
      name: 'Mydukur',
    },
    {
      _id: '60ab6e9486ed1c1a3559debd',
      name: 'Mylavaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559debe',
      name: 'Nandalur',
    },
    {
      _id: '60ab6e9486ed1c1a3559debf',
      name: 'Obulavaripalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec0',
      name: 'Peddamudium',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec1',
      name: 'Pendlimarri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec2',
      name: 'Penagalur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec3',
      name: 'Porumamilla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec4',
      name: 'Proddatur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec5',
      name: 'Pulivendla',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec6',
      name: 'Rajampet',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec7',
      name: 'Pullampeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec8',
      name: 'Ramapuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559dec9',
      name: 'Rajupalem',
    },
    {
      _id: '60ab6e9486ed1c1a3559deca',
      name: 'Rayachoty',
    },
    {
      _id: '60ab6e9486ed1c1a3559decb',
      name: 'Sidhout',
    },
    {
      _id: '60ab6e9486ed1c1a3559decc',
      name: 'Simhadripuram',
    },
    {
      _id: '60ab6e9486ed1c1a3559decd',
      name: 'Sambepalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559dece',
      name: 'Sri Avadutha Kasinayana',
    },
    {
      _id: '60ab6e9486ed1c1a3559decf',
      name: 'Thondur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded0',
      name: 'Vallur',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded1',
      name: 'T.Sundupalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded2',
      name: 'Veeraballi',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded3',
      name: 'Veerapanayani Palle',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded4',
      name: 'Vempalle',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded5',
      name: 'Vemula',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded6',
      name: 'Vontimitta',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded7',
      name: 'Yerraguntla',
    },
  ],
  Anjaw: [
    {
      _id: '60ab6e9486ed1c1a3559ded8',
      name: 'Chaglagam',
    },
    {
      _id: '60ab6e9486ed1c1a3559ded9',
      name: 'Hawai-Walong',
    },
    {
      _id: '60ab6e9486ed1c1a3559deda',
      name: 'Hayuliang',
    },
    {
      _id: '60ab6e9486ed1c1a3559dedb',
      name: 'Manchal',
    },
  ],
  Changlang: [
    {
      _id: '60ab6e9486ed1c1a3559dedc',
      name: 'Bordumsa',
    },
    {
      _id: '60ab6e9486ed1c1a3559dedd',
      name: 'Changlang',
    },
    {
      _id: '60ab6e9486ed1c1a3559dede',
      name: 'Diyum',
    },
    {
      _id: '60ab6e9486ed1c1a3559dedf',
      name: 'Khagam-Miao',
    },
    {
      _id: '60ab6e9486ed1c1a3559dee0',
      name: 'Manmao',
    },
    {
      _id: '60ab6e9486ed1c1a3559dee1',
      name: 'Khimiyang',
    },
    {
      _id: '60ab6e9486ed1c1a3559dee2',
      name: 'Nampong',
    },
    {
      _id: '60ab6e9486ed1c1a3559dee3',
      name: 'Vijoynagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559dee4',
      name: 'Yatdam',
    },
  ],
  'Dibang Valley': [
    {
      _id: '60ab6e9486ed1c1a3559dee5',
      name: 'Anelih Arzu',
    },
    {
      _id: '60ab6e9486ed1c1a3559dee6',
      name: 'Anini-Mepi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dee7',
      name: 'Etalin Malinye',
    },
  ],
  'East Kameng': [
    {
      _id: '60ab6e9486ed1c1a3559dee8',
      name: 'Bameng',
    },
    {
      _id: '60ab6e9486ed1c1a3559dee9',
      name: 'Bana',
    },
    {
      _id: '60ab6e9486ed1c1a3559deea',
      name: 'Khenewa',
    },
    {
      _id: '60ab6e9486ed1c1a3559deeb',
      name: 'Pipu',
    },
    {
      _id: '60ab6e9486ed1c1a3559deec',
      name: 'Sawa',
    },
    {
      _id: '60ab6e9486ed1c1a3559deed',
      name: 'Seppa',
    },
    {
      _id: '60ab6e9486ed1c1a3559def6',
      name: 'Chayangtajo',
    },
  ],
  'East Siang': [
    {
      _id: '60ab6e9486ed1c1a3559deee',
      name: 'Mebo',
    },
    {
      _id: '60ab6e9486ed1c1a3559deef',
      name: 'Pasighat',
    },
    {
      _id: '60ab6e9486ed1c1a3559def0',
      name: 'Ruksin',
    },
  ],
  Kamle: [
    {
      _id: '60ab6e9486ed1c1a3559def1',
      name: 'Puchi Geko',
    },
    {
      _id: '60ab6e9486ed1c1a3559def2',
      name: 'Tamen-Raga',
    },
  ],
  'Kra Daadi': [
    {
      _id: '60ab6e9486ed1c1a3559def3',
      name: 'Chambang',
    },
    {
      _id: '60ab6e9486ed1c1a3559def4',
      name: 'Gangte',
    },
    {
      _id: '60ab6e9486ed1c1a3559def5',
      name: 'Palin',
    },
    {
      _id: '60ab6e9486ed1c1a3559def7',
      name: 'Pipsorang',
    },
    {
      _id: '60ab6e9486ed1c1a3559def8',
      name: 'Tali',
    },
    {
      _id: '60ab6e9486ed1c1a3559def9',
      name: 'Yangte',
    },
  ],
  'Kurung Kumey': [
    {
      _id: '60ab6e9486ed1c1a3559defa',
      name: 'Damin',
    },
    {
      _id: '60ab6e9486ed1c1a3559defb',
      name: 'Nyapin',
    },
    {
      _id: '60ab6e9486ed1c1a3559defc',
      name: 'Parsiparlo',
    },
    {
      _id: '60ab6e9486ed1c1a3559defd',
      name: 'Sangram',
    },
    {
      _id: '60ab6e9486ed1c1a3559defe',
      name: 'Sarli',
    },
    {
      _id: '60ab6e9486ed1c1a3559df00',
      name: 'Koloriang',
    },
  ],
  Leparada: [
    {
      _id: '60ab6e9486ed1c1a3559deff',
      name: 'Basar',
    },
    {
      _id: '60ab6e9486ed1c1a3559df01',
      name: 'Daring',
    },
    {
      _id: '60ab6e9486ed1c1a3559df03',
      name: 'Tirbin',
    },
  ],
  Lohit: [
    {
      _id: '60ab6e9486ed1c1a3559df02',
      name: 'Tezu',
    },
    {
      _id: '60ab6e9486ed1c1a3559df04',
      name: 'Wakro',
    },
  ],
  Longding: [
    {
      _id: '60ab6e9486ed1c1a3559df05',
      name: 'Kanubari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df06',
      name: 'Niausa',
    },
    {
      _id: '60ab6e9486ed1c1a3559df07',
      name: 'Pongchau',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0a',
      name: 'Wakka',
    },
  ],
  'Lower Dibang Valley': [
    {
      _id: '60ab6e9486ed1c1a3559df08',
      name: 'Dambuk',
    },
    {
      _id: '60ab6e9486ed1c1a3559df09',
      name: 'Hunli-Kronli',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0b',
      name: 'Roing',
    },
  ],
  'Lower Siang': [
    {
      _id: '60ab6e9486ed1c1a3559df0c',
      name: 'Gensi',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0d',
      name: 'Likabali',
    },
    {
      _id: '60ab6e9486ed1c1a3559df0e',
      name: 'Ramle Bango',
    },
  ],
  'Lower Subansiri': [
    {
      _id: '60ab6e9486ed1c1a3559df0f',
      name: 'Hong-Hari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df10',
      name: 'Pistana',
    },
    {
      _id: '60ab6e9486ed1c1a3559df11',
      name: 'Ziro-I',
    },
    {
      _id: '60ab6e9486ed1c1a3559df12',
      name: 'Ziro-Ii',
    },
  ],
  Namsai: [
    {
      _id: '60ab6e9486ed1c1a3559df13',
      name: 'Chowkham',
    },
    {
      _id: '60ab6e9486ed1c1a3559df14',
      name: 'Namsai',
    },
    {
      _id: '60ab6e9486ed1c1a3559df15',
      name: 'Lekang',
    },
  ],
  'Pakke Kessang': [
    {
      _id: '60ab6e9486ed1c1a3559df16',
      name: 'Pakkekessang',
    },
    {
      _id: '60ab6e9486ed1c1a3559df17',
      name: 'Seijosa',
    },
  ],
  'Papum Pare': [
    {
      _id: '60ab6e9486ed1c1a3559df18',
      name: 'Balijan',
    },
    {
      _id: '60ab6e9486ed1c1a3559df19',
      name: 'Borum',
    },
    {
      _id: '60ab6e9486ed1c1a3559df1a',
      name: 'Doimukh',
    },
    {
      _id: '60ab6e9486ed1c1a3559df1b',
      name: 'Mengio',
    },
    {
      _id: '60ab6e9486ed1c1a3559df1c',
      name: 'Sagalee',
    },
    {
      _id: '60ab6e9486ed1c1a3559df1d',
      name: 'Kimin',
    },
  ],
  'Shi Yomi': [
    {
      _id: '60ab6e9486ed1c1a3559df1e',
      name: 'Manigoan',
    },
    {
      _id: '60ab6e9486ed1c1a3559df1f',
      name: 'Mechuka-Tato',
    },
  ],
  Siang: [
    {
      _id: '60ab6e9486ed1c1a3559df20',
      name: 'Boleng',
    },
    {
      _id: '60ab6e9486ed1c1a3559df21',
      name: 'Kaying Payum',
    },
    {
      _id: '60ab6e9486ed1c1a3559df22',
      name: 'Rebo Parging',
    },
    {
      _id: '60ab6e9486ed1c1a3559df23',
      name: 'Riga',
    },
    {
      _id: '60ab6e9486ed1c1a3559df24',
      name: 'Pangin',
    },
    {
      _id: '60ab6e9486ed1c1a3559df31',
      name: 'Rumgong',
    },
  ],
  Tawang: [
    {
      _id: '60ab6e9486ed1c1a3559df25',
      name: 'Jang-Thingbu',
    },
    {
      _id: '60ab6e9486ed1c1a3559df26',
      name: 'Kitpi',
    },
    {
      _id: '60ab6e9486ed1c1a3559df27',
      name: 'Lumla',
    },
    {
      _id: '60ab6e9486ed1c1a3559df28',
      name: 'Mukto Bongkhar',
    },
    {
      _id: '60ab6e9486ed1c1a3559df29',
      name: 'Tawang',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2a',
      name: 'Zemithang Dudunghar',
    },
  ],
  Tirap: [
    {
      _id: '60ab6e9486ed1c1a3559df2b',
      name: 'Borduria',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2c',
      name: 'Dadam',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2d',
      name: 'Khonsa',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2e',
      name: 'Lazu',
    },
    {
      _id: '60ab6e9486ed1c1a3559df2f',
      name: 'Namsang',
    },
  ],
  'Upper Siang': [
    {
      _id: '60ab6e9486ed1c1a3559df30',
      name: 'Geku',
    },
    {
      _id: '60ab6e9486ed1c1a3559df32',
      name: 'Jengging',
    },
    {
      _id: '60ab6e9486ed1c1a3559df33',
      name: 'Singa Gelling',
    },
    {
      _id: '60ab6e9486ed1c1a3559df34',
      name: 'Mariyang',
    },
    {
      _id: '60ab6e9486ed1c1a3559df35',
      name: 'Tuting',
    },
    {
      _id: '60ab6e9486ed1c1a3559df3b',
      name: 'Yingkiong',
    },
  ],
  'Upper Subansiri': [
    {
      _id: '60ab6e9486ed1c1a3559df36',
      name: 'Baririjo',
    },
    {
      _id: '60ab6e9486ed1c1a3559df37',
      name: 'Chetam',
    },
    {
      _id: '60ab6e9486ed1c1a3559df38',
      name: 'Daporijo',
    },
    {
      _id: '60ab6e9486ed1c1a3559df39',
      name: 'Dumporijo',
    },
    {
      _id: '60ab6e9486ed1c1a3559df3a',
      name: 'Giba',
    },
    {
      _id: '60ab6e9486ed1c1a3559df3c',
      name: 'Limeking',
    },
    {
      _id: '60ab6e9486ed1c1a3559df3d',
      name: 'Nacho',
    },
    {
      _id: '60ab6e9486ed1c1a3559df3e',
      name: 'Payeng',
    },
    {
      _id: '60ab6e9486ed1c1a3559df3f',
      name: 'Taliha',
    },
    {
      _id: '60ab6e9486ed1c1a3559df40',
      name: 'Siyum',
    },
  ],
  'West Kameng': [
    {
      _id: '60ab6e9486ed1c1a3559df41',
      name: 'Kalaktang',
    },
    {
      _id: '60ab6e9486ed1c1a3559df42',
      name: 'Dirang',
    },
    {
      _id: '60ab6e9486ed1c1a3559df43',
      name: 'Nafra',
    },
    {
      _id: '60ab6e9486ed1c1a3559df44',
      name: 'Thrizino',
    },
    {
      _id: '60ab6e9486ed1c1a3559df46',
      name: 'Singchung',
    },
  ],
  'West Siang': [
    {
      _id: '60ab6e9486ed1c1a3559df45',
      name: 'Along East',
    },
    {
      _id: '60ab6e9486ed1c1a3559df47',
      name: 'Along West',
    },
    {
      _id: '60ab6e9486ed1c1a3559df48',
      name: 'Darak',
    },
    {
      _id: '60ab6e9486ed1c1a3559df49',
      name: 'Liromoba-Yomcha',
    },
  ],
  Baksa: [
    {
      _id: '60ab6e9486ed1c1a3559df4a',
      name: 'Baska',
    },
    {
      _id: '60ab6e9486ed1c1a3559df4b',
      name: 'Dhamdhama',
    },
    {
      _id: '60ab6e9486ed1c1a3559df4c',
      name: 'Gobardhana',
    },
    {
      _id: '60ab6e9486ed1c1a3559df4d',
      name: 'Barama',
    },
    {
      _id: '60ab6e9486ed1c1a3559df4e',
      name: 'Goreswar',
    },
    {
      _id: '60ab6e9486ed1c1a3559df4f',
      name: 'Nagrijuli',
    },
    {
      _id: '60ab6e9486ed1c1a3559df50',
      name: 'Jalah',
    },
    {
      _id: '60ab6e9486ed1c1a3559df51',
      name: 'Tamulpur',
    },
  ],
  Barpeta: [
    {
      _id: '60ab6e9486ed1c1a3559df52',
      name: 'Bajali',
    },
    {
      _id: '60ab6e9486ed1c1a3559df53',
      name: 'Barpeta',
    },
    {
      _id: '60ab6e9486ed1c1a3559df54',
      name: 'Bhabanipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559df55',
      name: 'Chakchaka',
    },
    {
      _id: '60ab6e9486ed1c1a3559df56',
      name: 'Chenga',
    },
    {
      _id: '60ab6e9486ed1c1a3559df57',
      name: 'Gomaphulbari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df58',
      name: 'Gobardhana',
    },
    {
      _id: '60ab6e9486ed1c1a3559df59',
      name: 'Pakabetbari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df5a',
      name: 'Ruposhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559df5b',
      name: 'Sarukhetri',
    },
    {
      _id: '60ab6e9486ed1c1a3559df5c',
      name: 'Mandia',
    },
  ],
  Biswanath: [
    {
      _id: '60ab6e9486ed1c1a3559df5d',
      name: 'Baghmara',
    },
    {
      _id: '60ab6e9486ed1c1a3559df5e',
      name: 'Biswanath',
    },
    {
      _id: '60ab6e9486ed1c1a3559df5f',
      name: 'Behali',
    },
    {
      _id: '60ab6e9486ed1c1a3559df60',
      name: 'Chaiduar',
    },
    {
      _id: '60ab6e9486ed1c1a3559df61',
      name: 'Pub Chaiduar',
    },
    {
      _id: '60ab6e9486ed1c1a3559df62',
      name: 'Sakomatha',
    },
    {
      _id: '60ab6e9486ed1c1a3559df63',
      name: 'Sootea',
    },
  ],
  Bongaigaon: [
    {
      _id: '60ab6e9486ed1c1a3559df64',
      name: 'Boitamari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df65',
      name: 'Dangtol',
    },
    {
      _id: '60ab6e9486ed1c1a3559df66',
      name: 'Manikpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559df67',
      name: 'Srijangram',
    },
    {
      _id: '60ab6e9486ed1c1a3559df68',
      name: 'Tapattary',
    },
  ],
  Cachar: [
    {
      _id: '60ab6e9486ed1c1a3559df69',
      name: 'Barjalenga',
    },
    {
      _id: '60ab6e9486ed1c1a3559df6a',
      name: 'Banskandi',
    },
    {
      _id: '60ab6e9486ed1c1a3559df6b',
      name: 'Borkhola',
    },
    {
      _id: '60ab6e9486ed1c1a3559df6c',
      name: 'Binnakandi',
    },
    {
      _id: '60ab6e9486ed1c1a3559df6d',
      name: 'Kalain',
    },
    {
      _id: '60ab6e9486ed1c1a3559df6e',
      name: 'Katigorah',
    },
    {
      _id: '60ab6e9486ed1c1a3559df6f',
      name: 'Lakhipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559df70',
      name: 'Narsingpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559df71',
      name: 'Palonghat',
    },
    {
      _id: '60ab6e9486ed1c1a3559df72',
      name: 'Salchapra',
    },
    {
      _id: '60ab6e9486ed1c1a3559df73',
      name: 'Rajabazar',
    },
    {
      _id: '60ab6e9486ed1c1a3559df74',
      name: 'Silchar',
    },
    {
      _id: '60ab6e9486ed1c1a3559df75',
      name: 'Tapang',
    },
    {
      _id: '60ab6e9486ed1c1a3559df76',
      name: 'Sonai',
    },
    {
      _id: '60ab6e9486ed1c1a3559df7a',
      name: 'Udharbond',
    },
  ],
  Charaideo: [
    {
      _id: '60ab6e9486ed1c1a3559df77',
      name: 'Lakuwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559df78',
      name: 'Sapekhati',
    },
    {
      _id: '60ab6e9486ed1c1a3559df79',
      name: 'Sonari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df7d',
      name: 'West Abhaipur',
    },
  ],
  Chirang: [
    {
      _id: '60ab6e9486ed1c1a3559df7b',
      name: 'Borobazar',
    },
    {
      _id: '60ab6e9486ed1c1a3559df7c',
      name: 'Manikpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559df7e',
      name: 'Manikpur Part',
    },
    {
      _id: '60ab6e9486ed1c1a3559df7f',
      name: 'Sidli-Chirang',
    },
  ],
  Darrang: [
    {
      _id: '60ab6e9486ed1c1a3559df80',
      name: 'Bechimari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df81',
      name: 'Dalgaon-Sialmari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df82',
      name: 'Kalaigaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559df83',
      name: 'Khoirabari',
    },
    {
      _id: '60ab6e9486ed1c1a3559df84',
      name: 'Pachim-Mangaldai',
    },
    {
      _id: '60ab6e9486ed1c1a3559df85',
      name: 'Pub-Mangaldai',
    },
    {
      _id: '60ab6e9486ed1c1a3559df88',
      name: 'Sipajhar',
    },
  ],
  Dhemaji: [
    {
      _id: '60ab6e9486ed1c1a3559df86',
      name: 'Bordoloni',
    },
    {
      _id: '60ab6e9486ed1c1a3559df87',
      name: 'Dhemaji',
    },
    {
      _id: '60ab6e9486ed1c1a3559df89',
      name: 'Murkongselek',
    },
    {
      _id: '60ab6e9486ed1c1a3559df8a',
      name: 'Machkhowa',
    },
    {
      _id: '60ab6e9486ed1c1a3559df8c',
      name: 'Sissiborgaon',
    },
  ],
  Dhubri: [
    {
      _id: '60ab6e9486ed1c1a3559df8b',
      name: 'Agomani',
    },
    {
      _id: '60ab6e9486ed1c1a3559df8d',
      name: 'Bilasipara',
    },
    {
      _id: '60ab6e9486ed1c1a3559df8e',
      name: 'Birshing-Jarua',
    },
    {
      _id: '60ab6e9486ed1c1a3559df8f',
      name: 'Chapar Salkocha',
    },
    {
      _id: '60ab6e9486ed1c1a3559df90',
      name: 'Debitola',
    },
    {
      _id: '60ab6e9486ed1c1a3559df91',
      name: 'Gauripur',
    },
    {
      _id: '60ab6e9486ed1c1a3559df92',
      name: 'Golakganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559df93',
      name: 'Hatidhura',
    },
    {
      _id: '60ab6e9486ed1c1a3559df95',
      name: 'Mahamaya',
    },
    {
      _id: '60ab6e9486ed1c1a3559df96',
      name: 'Nayeralga',
    },
    {
      _id: '60ab6e9486ed1c1a3559df97',
      name: 'Rupshi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa7',
      name: 'Jamadarhat',
    },
  ],
  Dibrugarh: [
    {
      _id: '60ab6e9486ed1c1a3559df98',
      name: 'Barbaruah',
    },
    {
      _id: '60ab6e9486ed1c1a3559df99',
      name: 'Joypur',
    },
    {
      _id: '60ab6e9486ed1c1a3559df9a',
      name: 'Khowang',
    },
    {
      _id: '60ab6e9486ed1c1a3559df9b',
      name: 'Lahoal',
    },
    {
      _id: '60ab6e9486ed1c1a3559df9c',
      name: 'Panitola',
    },
    {
      _id: '60ab6e9486ed1c1a3559df9d',
      name: 'Tengakhat',
    },
    {
      _id: '60ab6e9486ed1c1a3559df9e',
      name: 'Tingkhong',
    },
  ],
  'Dima Hasao': [
    {
      _id: '60ab6e9486ed1c1a3559df9f',
      name: 'Diyang Valley',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa0',
      name: 'Diyungbra',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa1',
      name: 'Harangajao',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa2',
      name: 'Jatinga Valley',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa3',
      name: 'New Sangbar',
    },
  ],
  Goalpara: [
    {
      _id: '60ab6e9486ed1c1a3559dfa4',
      name: 'Balijana',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa5',
      name: 'Jaleswar',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa6',
      name: 'Kharmuza',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa8',
      name: 'Krishnai',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfa9',
      name: 'Kuchdhowa',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfaa',
      name: 'Lakhipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfab',
      name: 'Rongjuli',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfbd',
      name: 'Matia',
    },
  ],
  Golaghat: [
    {
      _id: '60ab6e9486ed1c1a3559dfac',
      name: 'Golaghat Central',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfad',
      name: 'Golaghat East',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfae',
      name: 'Golaghat North',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfaf',
      name: 'Golaghat South',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfb0',
      name: 'Golaghat West',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfb1',
      name: 'Gomariguri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfb2',
      name: 'Kakodonga',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfb3',
      name: 'Morongi',
    },
  ],
  Hailakandi: [
    {
      _id: '60ab6e9486ed1c1a3559dfb4',
      name: 'Algapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfb5',
      name: 'Hailakandi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfb6',
      name: 'Katlicherra',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfb7',
      name: 'Lala',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfb8',
      name: 'South Hailakandi',
    },
  ],
  Hojai: [
    {
      _id: '60ab6e9486ed1c1a3559dfb9',
      name: 'Binakandi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfba',
      name: 'Dhalpukhuri',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfbb',
      name: 'Jugijan',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfbc',
      name: 'Lumding',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfbe',
      name: 'Udali',
    },
  ],
  Jorhat: [
    {
      _id: '60ab6e9486ed1c1a3559dfbf',
      name: 'Jorhat',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc0',
      name: 'Jorhat Central',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc1',
      name: 'Kaliapani',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc2',
      name: 'North West Jorhat',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc3',
      name: 'Titabor',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfd3',
      name: 'Jorhat East',
    },
  ],
  Kamrup: [
    {
      _id: '60ab6e9486ed1c1a3559dfc4',
      name: 'Bezera',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc5',
      name: 'Bihdia -Jajikona',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc6',
      name: 'Boko',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc7',
      name: 'Bongaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc8',
      name: 'Chamaria',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfc9',
      name: 'Chayani',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfca',
      name: 'Chaygaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfcb',
      name: 'Goroimari',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfcc',
      name: 'Hajo',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfcd',
      name: 'Kamalpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfce',
      name: 'Rampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfcf',
      name: 'Rangia',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfd0',
      name: 'Rani',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfd1',
      name: 'Sualkuchi',
    },
  ],
  'Kamrup Metro': [
    {
      _id: '60ab6e9486ed1c1a3559dfd2',
      name: 'Bezera (Pt)',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfd4',
      name: 'Chandrapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfd5',
      name: 'Dimoria',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfd6',
      name: 'Rani (Pt)',
    },
  ],
  'Karbi Anglong': [
    {
      _id: '60ab6e9486ed1c1a3559dfd7',
      name: 'Howraghat',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfd8',
      name: 'Langsomepi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfd9',
      name: 'Lumbajong',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfda',
      name: 'Nilip',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfdb',
      name: 'Rongmongwe',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfdc',
      name: 'Samelangso',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe9',
      name: 'Bokajan',
    },
  ],
  Karimganj: [
    {
      _id: '60ab6e9486ed1c1a3559dfdd',
      name: 'Badarpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfde',
      name: 'Dullavcherra',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfdf',
      name: 'Lowairpoa',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe0',
      name: 'North Karimganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe1',
      name: 'Patharkandi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe2',
      name: 'Ramkrishna Nagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe3',
      name: 'South Karimganj',
    },
  ],
  Kokrajhar: [
    {
      _id: '60ab6e9486ed1c1a3559dfe4',
      name: 'Bilashipara-Btc',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe5',
      name: 'Bilasipara',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe6',
      name: 'Chapar Salkocha',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe7',
      name: 'Chapor-Salkocha-Btc',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfe8',
      name: 'Debitola',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfea',
      name: 'Debitola-Btc',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfeb',
      name: 'Dotma',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfec',
      name: 'Golakganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfed',
      name: 'Gossaigaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfee',
      name: 'Hatidhura',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfef',
      name: 'Kachugaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff0',
      name: 'Kokrajhar',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff1',
      name: 'Mahamaya',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff2',
      name: 'Mahamaya-Btc',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff3',
      name: 'Rupshi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff4',
      name: 'Rupshi-Btc',
    },
    {
      _id: '60ab6e9486ed1c1a3559dfff',
      name: 'Golakganj-Btc',
    },
  ],
  Lakhimpur: [
    {
      _id: '60ab6e9486ed1c1a3559dff5',
      name: 'Bihpuria',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff6',
      name: 'Boginadi',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff7',
      name: 'Dhakuakhana',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff8',
      name: 'Ghilamara',
    },
    {
      _id: '60ab6e9486ed1c1a3559dff9',
      name: 'Karunabari',
    },
    {
      _id: '60ab6e9486ed1c1a3559dffa',
      name: 'Lakhimpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dffb',
      name: 'Narayanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559dffc',
      name: 'Nowboicha',
    },
    {
      _id: '60ab6e9486ed1c1a3559dffd',
      name: 'Telahi',
    },
  ],
  Majuli: [
    {
      _id: '60ab6e9486ed1c1a3559dffe',
      name: 'Majuli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e000',
      name: 'Ujani Majuli',
    },
  ],
  Marigaon: [
    {
      _id: '60ab6e9486ed1c1a3559e001',
      name: 'Batabraba (Part)',
    },
    {
      _id: '60ab6e9486ed1c1a3559e002',
      name: 'Bhurbandha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e003',
      name: 'Kapili',
    },
    {
      _id: '60ab6e9486ed1c1a3559e004',
      name: 'Laharighat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e005',
      name: 'Mayang',
    },
    {
      _id: '60ab6e9486ed1c1a3559e006',
      name: 'Moirabari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e015',
      name: 'Dolongghat (Part)',
    },
  ],
  Nagaon: [
    {
      _id: '60ab6e9486ed1c1a3559e007',
      name: 'Bajiagaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e008',
      name: 'Barhampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e009',
      name: 'Batadrava',
    },
    {
      _id: '60ab6e9486ed1c1a3559e00a',
      name: 'Dolongghat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e00b',
      name: 'Juria',
    },
    {
      _id: '60ab6e9486ed1c1a3559e00c',
      name: 'Kaliabor',
    },
    {
      _id: '60ab6e9486ed1c1a3559e00d',
      name: 'Kapili Pt.I',
    },
    {
      _id: '60ab6e9486ed1c1a3559e00e',
      name: 'Kathiatoli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e00f',
      name: 'Khagarijan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e010',
      name: 'Laokhowa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e011',
      name: 'Moirabari Part',
    },
    {
      _id: '60ab6e9486ed1c1a3559e012',
      name: 'Pachim Kaliabor',
    },
    {
      _id: '60ab6e9486ed1c1a3559e013',
      name: 'Pakhimoria',
    },
    {
      _id: '60ab6e9486ed1c1a3559e014',
      name: 'Raha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e016',
      name: 'Rupahi',
    },
  ],
  Nalbari: [
    {
      _id: '60ab6e9486ed1c1a3559e017',
      name: 'Barigog Banbhag',
    },
    {
      _id: '60ab6e9486ed1c1a3559e018',
      name: 'Barkhetri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e019',
      name: 'Madhupur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e01a',
      name: 'Paschim Nalbari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e01c',
      name: 'Pub Nalbari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e01d',
      name: 'Tihu',
    },
    {
      _id: '60ab6e9486ed1c1a3559e02c',
      name: 'Borbhag',
    },
  ],
  Sivasagar: [
    {
      _id: '60ab6e9486ed1c1a3559e01e',
      name: 'Amguri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e01f',
      name: 'Demow',
    },
    {
      _id: '60ab6e9486ed1c1a3559e020',
      name: 'Gaurisagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e021',
      name: 'Nazira',
    },
    {
      _id: '60ab6e9486ed1c1a3559e022',
      name: 'Sivasagar',
    },
  ],
  Sonitpur: [
    {
      _id: '60ab6e9486ed1c1a3559e023',
      name: 'Balipara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e024',
      name: 'Bihaguri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e025',
      name: 'Borchala',
    },
    {
      _id: '60ab6e9486ed1c1a3559e026',
      name: 'Dhekiajuli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e027',
      name: 'Gabhoru',
    },
    {
      _id: '60ab6e9486ed1c1a3559e028',
      name: 'Naduar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e029',
      name: 'Rangapara',
    },
  ],
  'South Salmara Mancachar': [
    {
      _id: '60ab6e9486ed1c1a3559e02a',
      name: 'Fekamari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e02b',
      name: 'Mankachar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e02d',
      name: 'South Salmara',
    },
  ],
  Tinsukia: [
    {
      _id: '60ab6e9486ed1c1a3559e02e',
      name: 'Guijan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e02f',
      name: 'Hapjan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e030',
      name: 'Itakhuli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e031',
      name: 'Kakopathar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e032',
      name: 'Sadiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e033',
      name: 'Saikhowa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e036',
      name: 'Margherita',
    },
  ],
  Udalguri: [
    {
      _id: '60ab6e9486ed1c1a3559e034',
      name: 'Bechimari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e035',
      name: 'Bhergaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e037',
      name: 'Dalgaon-Sialmari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e038',
      name: 'Borsola',
    },
    {
      _id: '60ab6e9486ed1c1a3559e039',
      name: 'Kalaigaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e03a',
      name: 'Khoirabari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e03b',
      name: 'Odalguri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e03c',
      name: 'Paschim-Mangaldai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e03d',
      name: 'Mazbat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e03e',
      name: 'Pub-Mangaldai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e040',
      name: 'Rowta',
    },
  ],
  'West Karbi Anglong': [
    {
      _id: '60ab6e9486ed1c1a3559e03f',
      name: 'Amri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e041',
      name: 'Chinthong',
    },
    {
      _id: '60ab6e9486ed1c1a3559e042',
      name: 'Rongkhang',
    },
    {
      _id: '60ab6e9486ed1c1a3559e043',
      name: 'Socheng',
    },
  ],
  Araria: [
    {
      _id: '60ab6e9486ed1c1a3559e044',
      name: 'Araria',
    },
    {
      _id: '60ab6e9486ed1c1a3559e045',
      name: 'Bhargama',
    },
    {
      _id: '60ab6e9486ed1c1a3559e046',
      name: 'Forbesganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e047',
      name: 'Kursakanta',
    },
    {
      _id: '60ab6e9486ed1c1a3559e048',
      name: 'Narpatganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e049',
      name: 'Palasi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e04a',
      name: 'Raniganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e04b',
      name: 'Sikty',
    },
    {
      _id: '60ab6e9486ed1c1a3559e050',
      name: 'Jokihat',
    },
  ],
  Arwal: [
    {
      _id: '60ab6e9486ed1c1a3559e04c',
      name: 'Arwal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e04d',
      name: 'Kaler',
    },
    {
      _id: '60ab6e9486ed1c1a3559e04e',
      name: 'Kapri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e04f',
      name: 'Kurtha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e051',
      name: 'Sonbhadra-Bansi-Surajpur',
    },
  ],
  Aurangabad: [
    {
      _id: '60ab6e9486ed1c1a3559e052',
      name: 'Barun',
    },
    {
      _id: '60ab6e9486ed1c1a3559e053',
      name: 'Aurangabad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e054',
      name: 'Daudnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e055',
      name: 'Deo',
    },
    {
      _id: '60ab6e9486ed1c1a3559e056',
      name: 'Goh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e057',
      name: 'Kutumba',
    },
    {
      _id: '60ab6e9486ed1c1a3559e058',
      name: 'Haspura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e059',
      name: 'Madanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e05a',
      name: 'Obra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e05b',
      name: 'Rafiganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e05c',
      name: 'Nabinagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9fc',
      name: 'Kanand',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9fd',
      name: 'Gangapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9fe',
      name: 'Khultabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ff',
      name: 'Paithan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea00',
      name: 'Phulambri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea01',
      name: 'Sillod',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea02',
      name: 'Soegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea03',
      name: 'Vaijapur',
    },
  ],
  Banka: [
    {
      _id: '60ab6e9486ed1c1a3559e05d',
      name: 'Banka',
    },
    {
      _id: '60ab6e9486ed1c1a3559e05e',
      name: 'Amarpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e05f',
      name: 'Bausi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e060',
      name: 'Barahat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e061',
      name: 'Belhar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e062',
      name: 'Chandan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e063',
      name: 'Dhuraiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e064',
      name: 'Katoria',
    },
    {
      _id: '60ab6e9486ed1c1a3559e065',
      name: 'Rajaun',
    },
    {
      _id: '60ab6e9486ed1c1a3559e066',
      name: 'Shambhuganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e067',
      name: 'Fullidumar',
    },
  ],
  Begusarai: [
    {
      _id: '60ab6e9486ed1c1a3559e068',
      name: 'Bachhwara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e069',
      name: 'Ballia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e06a',
      name: 'Barauni',
    },
    {
      _id: '60ab6e9486ed1c1a3559e06b',
      name: 'Begusarai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e06c',
      name: 'Bhagwanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e06d',
      name: 'Birpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e06e',
      name: 'Cheria Bariarpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e06f',
      name: 'Chhaurahi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e070',
      name: 'Dandari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e071',
      name: 'Bakhri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e072',
      name: 'Khodawandpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e073',
      name: 'Gadhpura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e074',
      name: 'Mansurchak',
    },
    {
      _id: '60ab6e9486ed1c1a3559e075',
      name: 'Nawkothi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e076',
      name: 'Matihani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e077',
      name: 'Sahebpur Kamal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e078',
      name: 'Teghra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e084',
      name: 'Samho Akha Kurha',
    },
  ],
  Bhagalpur: [
    {
      _id: '60ab6e9486ed1c1a3559e079',
      name: 'Bihpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e07a',
      name: 'Gopalpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e07b',
      name: 'Goradih',
    },
    {
      _id: '60ab6e9486ed1c1a3559e07c',
      name: 'Ismailpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e07d',
      name: 'Jagdishpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e07e',
      name: 'Kahalgaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e07f',
      name: 'Kharik',
    },
    {
      _id: '60ab6e9486ed1c1a3559e080',
      name: 'Narayanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e081',
      name: 'Nathnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e082',
      name: 'Naugachhia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e083',
      name: 'Pirpainti',
    },
    {
      _id: '60ab6e9486ed1c1a3559e085',
      name: 'Rangrachowk',
    },
    {
      _id: '60ab6e9486ed1c1a3559e086',
      name: 'Shahkund',
    },
    {
      _id: '60ab6e9486ed1c1a3559e087',
      name: 'Sonhaula',
    },
    {
      _id: '60ab6e9486ed1c1a3559e088',
      name: 'Sultanganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e08a',
      name: 'Sabour',
    },
  ],
  Bhojpur: [
    {
      _id: '60ab6e9486ed1c1a3559e089',
      name: 'Agiaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e08b',
      name: 'Barhara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e08c',
      name: 'Ara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e08d',
      name: 'Behea',
    },
    {
      _id: '60ab6e9486ed1c1a3559e08e',
      name: 'Charpokhari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e08f',
      name: 'Jagdishpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e090',
      name: 'Koilwar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e091',
      name: 'Piro',
    },
    {
      _id: '60ab6e9486ed1c1a3559e092',
      name: 'Sahar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e093',
      name: 'Sandesh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e094',
      name: 'Garhani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e095',
      name: 'Shahpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e096',
      name: 'Udwantnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e097',
      name: 'Tarari',
    },
  ],
  Buxar: [
    {
      _id: '60ab6e9486ed1c1a3559e098',
      name: 'Brahmpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e099',
      name: 'Buxar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e09a',
      name: 'Chakki',
    },
    {
      _id: '60ab6e9486ed1c1a3559e09b',
      name: 'Chausa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e09c',
      name: 'Chougain',
    },
    {
      _id: '60ab6e9486ed1c1a3559e09d',
      name: 'Itarhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e09e',
      name: 'Kesath',
    },
    {
      _id: '60ab6e9486ed1c1a3559e09f',
      name: 'Dumraon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a0',
      name: 'Rajpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a1',
      name: 'Simri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a9',
      name: 'Nawanagar',
    },
  ],
  Darbhanga: [
    {
      _id: '60ab6e9486ed1c1a3559e0a2',
      name: 'Alinagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a3',
      name: 'Bahadurpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a4',
      name: 'Baheri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a5',
      name: 'Benipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a6',
      name: 'Biraul',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a7',
      name: 'Darbhanga',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0a8',
      name: 'Gaurabauram',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0aa',
      name: 'Ghanshyampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ab',
      name: 'Hanuman Nagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ac',
      name: 'Hayaghat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ad',
      name: 'Keotirunway',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ae',
      name: 'Kiratpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0af',
      name: 'Kusheshwar Asthan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b0',
      name: 'Kusheswar Asthan East',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b1',
      name: 'Jale',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b2',
      name: 'Singhwara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b3',
      name: 'Tardih',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c4',
      name: 'Manigachhi',
    },
  ],
  Gaya: [
    {
      _id: '60ab6e9486ed1c1a3559e0b4',
      name: 'Amas',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b5',
      name: 'Atri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b6',
      name: 'Bankey Bazar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b7',
      name: 'Barachatti',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b8',
      name: 'Belaganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0b9',
      name: 'Bodhgaya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ba',
      name: 'Dobhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0bb',
      name: 'Dumaria',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0bc',
      name: 'Fatehpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0bd',
      name: 'Gaya Town',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0be',
      name: 'Guraru',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0bf',
      name: 'Gurua',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c0',
      name: 'Imamganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c1',
      name: 'Khizarsarai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c2',
      name: 'Konch',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c3',
      name: 'Manpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c5',
      name: 'Mohanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c6',
      name: 'Mohra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c7',
      name: 'Neemchak Bathani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c8',
      name: 'Paraiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0c9',
      name: 'Sherghatty',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ca',
      name: 'Tankuppa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0cb',
      name: 'Wazirganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0cc',
      name: 'Tekari',
    },
  ],
  Gopalganj: [
    {
      _id: '60ab6e9486ed1c1a3559e0cd',
      name: 'Barauli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ce',
      name: 'Baikunthpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0cf',
      name: 'Bhorey',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d0',
      name: 'Bijaipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d1',
      name: 'Gopalganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d2',
      name: 'Kataiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d3',
      name: 'Hathua',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d4',
      name: 'Kuchaikote',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d5',
      name: 'Manjha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d6',
      name: 'Panchdeori',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d7',
      name: 'Sidhwaliya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d8',
      name: 'Phulwariya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0d9',
      name: 'Thawe',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0da',
      name: 'Uchkagaon',
    },
  ],
  Jamui: [
    {
      _id: '60ab6e9486ed1c1a3559e0db',
      name: 'Barhat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0dc',
      name: 'Gidhor',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0dd',
      name: 'Chakai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0de',
      name: 'Islamnagar Aliganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0df',
      name: 'Jamui',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e0',
      name: 'Jhajha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e1',
      name: 'Laxmipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e2',
      name: 'Sikandra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e3',
      name: 'Sono',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ed',
      name: 'Khaira',
    },
  ],
  Jehanabad: [
    {
      _id: '60ab6e9486ed1c1a3559e0e4',
      name: 'Ghoshi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e5',
      name: 'Hulasganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e6',
      name: 'Jehanabad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e7',
      name: 'Kako',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e8',
      name: 'Makhdumpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0e9',
      name: 'Modanganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ea',
      name: 'Ratni Faridpur',
    },
  ],
  Kaimur: [
    {
      _id: '60ab6e9486ed1c1a3559e0eb',
      name: 'Adhaura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ec',
      name: 'Bhabua',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ee',
      name: 'Chainpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ef',
      name: 'Chand',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f0',
      name: 'Bhagwanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f1',
      name: 'Kudra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f2',
      name: 'Durgawati',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f3',
      name: 'Nuaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f4',
      name: 'Ramgarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f5',
      name: 'Rampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f6',
      name: 'Mohania',
    },
  ],
  Katihar: [
    {
      _id: '60ab6e9486ed1c1a3559e0f7',
      name: 'Amdabad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f8',
      name: 'Balrampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0f9',
      name: 'Barari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0fa',
      name: 'Barsoi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0fb',
      name: 'Dandkhora',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0fc',
      name: 'Falka',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0fd',
      name: 'Hasanganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0fe',
      name: 'Azamnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e0ff',
      name: 'Kadwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e100',
      name: 'Katihar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e101',
      name: 'Kursela',
    },
    {
      _id: '60ab6e9486ed1c1a3559e102',
      name: 'Korha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e103',
      name: 'Manihari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e104',
      name: 'Mansahi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e105',
      name: 'Pranpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e10a',
      name: 'Sameli',
    },
  ],
  Khagaria: [
    {
      _id: '60ab6e9486ed1c1a3559e106',
      name: 'Alauli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e107',
      name: 'Beldaur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e108',
      name: 'Chautham',
    },
    {
      _id: '60ab6e9486ed1c1a3559e109',
      name: 'Gogri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e10b',
      name: 'Khagaria',
    },
    {
      _id: '60ab6e9486ed1c1a3559e10c',
      name: 'Mansi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e10d',
      name: 'Parbatta',
    },
  ],
  Kishanganj: [
    {
      _id: '60ab6e9486ed1c1a3559e10e',
      name: 'Bahadurganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e10f',
      name: 'Dighalbank',
    },
    {
      _id: '60ab6e9486ed1c1a3559e110',
      name: 'Kishanganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e111',
      name: 'Kochadhaman',
    },
    {
      _id: '60ab6e9486ed1c1a3559e112',
      name: 'Terhagachh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e113',
      name: 'Pothia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e114',
      name: 'Thakurganj',
    },
  ],
  Lakhisarai: [
    {
      _id: '60ab6e9486ed1c1a3559e115',
      name: 'Barahiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e116',
      name: 'Channan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e117',
      name: 'Halsi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e118',
      name: 'Lakhisarai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e119',
      name: 'Ramgarh Chowk',
    },
    {
      _id: '60ab6e9486ed1c1a3559e11a',
      name: 'Surajgarha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e12a',
      name: 'Pipariya',
    },
  ],
  Madhepura: [
    {
      _id: '60ab6e9486ed1c1a3559e11b',
      name: 'Alamnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e11c',
      name: 'Bihariganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e11d',
      name: 'Chausa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e11e',
      name: 'Gamhariya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e11f',
      name: 'Ghelarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e120',
      name: 'Gwalpara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e121',
      name: 'Kumarkhand',
    },
    {
      _id: '60ab6e9486ed1c1a3559e122',
      name: 'Madhepura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e123',
      name: 'Murliganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e124',
      name: 'Purani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e125',
      name: 'Shankarpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e126',
      name: 'Singheshwar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e127',
      name: 'Udakishunganj',
    },
  ],
  Madhubani: [
    {
      _id: '60ab6e9486ed1c1a3559e128',
      name: 'Andhratharhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e129',
      name: 'Babu Barhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e12b',
      name: 'Basopatti',
    },
    {
      _id: '60ab6e9486ed1c1a3559e12c',
      name: 'Benipatti',
    },
    {
      _id: '60ab6e9486ed1c1a3559e12d',
      name: 'Bisfi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e12e',
      name: 'Ghoghardiha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e12f',
      name: 'Jainagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e130',
      name: 'Jhanjharpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e131',
      name: 'Kaluahi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e132',
      name: 'Khajauli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e133',
      name: 'Harlakhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e134',
      name: 'Ladania',
    },
    {
      _id: '60ab6e9486ed1c1a3559e135',
      name: 'Lakhnaur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e136',
      name: 'Laukaha (Khutauna)',
    },
    {
      _id: '60ab6e9486ed1c1a3559e137',
      name: 'Laukahi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e138',
      name: 'Madhepur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e139',
      name: 'Madhwapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e13a',
      name: 'Pandaul',
    },
    {
      _id: '60ab6e9486ed1c1a3559e13b',
      name: 'Phulparas',
    },
    {
      _id: '60ab6e9486ed1c1a3559e13c',
      name: 'Rahika',
    },
    {
      _id: '60ab6e9486ed1c1a3559e13d',
      name: 'Rajnagar',
    },
  ],
  Munger: [
    {
      _id: '60ab6e9486ed1c1a3559e13e',
      name: 'Asarganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e13f',
      name: 'Dharhara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e140',
      name: 'Bariyarpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e141',
      name: 'Jamalpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e142',
      name: 'Kharagpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e143',
      name: 'Sangrampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e144',
      name: 'Tarapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e145',
      name: 'Munger Sadar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e146',
      name: 'Tetiabambar',
    },
  ],
  Muzaffarpur: [
    {
      _id: '60ab6e9486ed1c1a3559e147',
      name: 'Aurai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e148',
      name: 'Bochahan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e149',
      name: 'Bandra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e14a',
      name: 'Gaighat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e14b',
      name: 'Kanti',
    },
    {
      _id: '60ab6e9486ed1c1a3559e14c',
      name: 'Katra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e14d',
      name: 'Kurhani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e14e',
      name: 'Marwan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e14f',
      name: 'Minapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e150',
      name: 'Muraul',
    },
    {
      _id: '60ab6e9486ed1c1a3559e151',
      name: 'Mushahari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e152',
      name: 'Paroo',
    },
    {
      _id: '60ab6e9486ed1c1a3559e153',
      name: 'Motipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e154',
      name: 'Sahebganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e155',
      name: 'Sakra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e15a',
      name: 'Saraiya',
    },
  ],
  Nalanda: [
    {
      _id: '60ab6e9486ed1c1a3559e156',
      name: 'Asthawan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e157',
      name: 'Ben',
    },
    {
      _id: '60ab6e9486ed1c1a3559e158',
      name: 'Biharsharif',
    },
    {
      _id: '60ab6e9486ed1c1a3559e159',
      name: 'Bind',
    },
    {
      _id: '60ab6e9486ed1c1a3559e15b',
      name: 'Chandi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e15c',
      name: 'Ekangarsarai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e15d',
      name: 'Harnaut',
    },
    {
      _id: '60ab6e9486ed1c1a3559e15e',
      name: 'Giriak',
    },
    {
      _id: '60ab6e9486ed1c1a3559e15f',
      name: 'Hilsa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e160',
      name: 'Islampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e161',
      name: 'Karai Parsurai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e162',
      name: 'Katrisarai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e163',
      name: 'Noorsarai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e164',
      name: 'Parbalpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e165',
      name: 'Nagar Nausa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e166',
      name: 'Rahui',
    },
    {
      _id: '60ab6e9486ed1c1a3559e167',
      name: 'Rajgir',
    },
    {
      _id: '60ab6e9486ed1c1a3559e168',
      name: 'Silao',
    },
    {
      _id: '60ab6e9486ed1c1a3559e169',
      name: 'Tharthari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e16a',
      name: 'Sarmera',
    },
  ],
  Nawada: [
    {
      _id: '60ab6e9486ed1c1a3559e16b',
      name: 'Gobindpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e16c',
      name: 'Hisua',
    },
    {
      _id: '60ab6e9486ed1c1a3559e16d',
      name: 'Akbarpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e16e',
      name: 'Kashichak',
    },
    {
      _id: '60ab6e9486ed1c1a3559e16f',
      name: 'Kawakole',
    },
    {
      _id: '60ab6e9486ed1c1a3559e170',
      name: 'Mescaur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e171',
      name: 'Nardiganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e172',
      name: 'Narhat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e173',
      name: 'Nawada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e174',
      name: 'Pakri Barawan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e175',
      name: 'Rajauli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e176',
      name: 'Roh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e177',
      name: 'Sirdala',
    },
    {
      _id: '60ab6e9486ed1c1a3559e178',
      name: 'Warisaliganj',
    },
  ],
  'Pashchim Champaran': [
    {
      _id: '60ab6e9486ed1c1a3559e179',
      name: 'Bagaha-I',
    },
    {
      _id: '60ab6e9486ed1c1a3559e17a',
      name: 'Bairia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e17b',
      name: 'Bettiah',
    },
    {
      _id: '60ab6e9486ed1c1a3559e17c',
      name: 'Bhitaha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e17d',
      name: 'Chanpatia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e17e',
      name: 'Gaunaha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e17f',
      name: 'Jogapatti',
    },
    {
      _id: '60ab6e9486ed1c1a3559e180',
      name: 'Lauriya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e181',
      name: 'Madhubani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e182',
      name: 'Mainatand',
    },
    {
      _id: '60ab6e9486ed1c1a3559e183',
      name: 'Majhaulia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e184',
      name: 'Narkatiaganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e185',
      name: 'Nautan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e186',
      name: 'Piprasi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e187',
      name: 'Ramnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e188',
      name: 'Sikta',
    },
    {
      _id: '60ab6e9486ed1c1a3559e189',
      name: 'Thakrahan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e18b',
      name: 'Bagaha-Ii',
    },
  ],
  Patna: [
    {
      _id: '60ab6e9486ed1c1a3559e18a',
      name: 'Athamalgola',
    },
    {
      _id: '60ab6e9486ed1c1a3559e18c',
      name: 'Bakhtiarpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e18d',
      name: 'Barh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e18e',
      name: 'Belchchi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e18f',
      name: 'Bihta',
    },
    {
      _id: '60ab6e9486ed1c1a3559e190',
      name: 'Bikram',
    },
    {
      _id: '60ab6e9486ed1c1a3559e191',
      name: 'Dhanarua',
    },
    {
      _id: '60ab6e9486ed1c1a3559e192',
      name: 'Daniyawan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e193',
      name: 'Dulhin Bazar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e194',
      name: 'Dinapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e195',
      name: 'Fatuha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e196',
      name: 'Ghoswari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e197',
      name: 'Khusrupur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e198',
      name: 'Maner',
    },
    {
      _id: '60ab6e9486ed1c1a3559e199',
      name: 'Mokama',
    },
    {
      _id: '60ab6e9486ed1c1a3559e19a',
      name: 'Naubatpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e19b',
      name: 'Paliganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e19c',
      name: 'Pandarak',
    },
    {
      _id: '60ab6e9486ed1c1a3559e19d',
      name: 'Masaurhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e19e',
      name: 'Patna Sadar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e19f',
      name: 'Phulwari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a0',
      name: 'Punpun',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a4',
      name: 'Sampatchak',
    },
  ],
  'Purvi Champaran': [
    {
      _id: '60ab6e9486ed1c1a3559e1a1',
      name: 'Adapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a2',
      name: 'Areraj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a3',
      name: 'Banjariya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a5',
      name: 'Bankatwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a6',
      name: 'Chakia (Pipra)',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a7',
      name: 'Chiraiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a8',
      name: 'Chawradano',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1a9',
      name: 'Dhaka',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1aa',
      name: 'Ghorasahan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ab',
      name: 'Harsidhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ac',
      name: 'Kesaria',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ad',
      name: 'Kotwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ae',
      name: 'Madhuban',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1af',
      name: 'Mehsi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b0',
      name: 'Motihari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b1',
      name: 'Paharpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b2',
      name: 'Pakridayal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b3',
      name: 'Kalyanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b4',
      name: 'Phenhara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b5',
      name: 'Patahi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b6',
      name: 'Ramgarhwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b7',
      name: 'Pipra Kothi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b8',
      name: 'Sangrampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1b9',
      name: 'Sugauli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ba',
      name: 'Raxaul',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1bb',
      name: 'Tetariya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1bc',
      name: 'Turkaulia',
    },
  ],
  Purnia: [
    {
      _id: '60ab6e9486ed1c1a3559e1bd',
      name: 'Amour',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1be',
      name: 'Baisi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1bf',
      name: 'Banmankhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c0',
      name: 'Barhara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c1',
      name: 'Baisa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c2',
      name: 'Dagraua',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c3',
      name: 'Dhamdaha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c4',
      name: 'Bhawanipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c5',
      name: 'Jalalgarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c6',
      name: 'Kasba',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c7',
      name: 'Purnia East',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c8',
      name: 'Rupouli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1c9',
      name: 'Srinagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d0',
      name: 'Krityanand Nagar',
    },
  ],
  Rohtas: [
    {
      _id: '60ab6e9486ed1c1a3559e1ca',
      name: 'Akorhigola',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1cb',
      name: 'Bikramganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1cc',
      name: 'Chenari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1cd',
      name: 'Dawath',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ce',
      name: 'Dehri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1cf',
      name: 'Dinara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d1',
      name: 'Kargahar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d2',
      name: 'Karakat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d3',
      name: 'Kochas',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d4',
      name: 'Nasriganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d5',
      name: 'Nokha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d6',
      name: 'Nawhatta',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d7',
      name: 'Rohtas',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d8',
      name: 'Rajpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1d9',
      name: 'Sasaram',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1da',
      name: 'Sheosagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1db',
      name: 'Surajpura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1dc',
      name: 'Tilouthu',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e0',
      name: 'Sanjhouli',
    },
  ],
  Saharsa: [
    {
      _id: '60ab6e9486ed1c1a3559e1dd',
      name: 'Banma Itahari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1de',
      name: 'Kahara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1df',
      name: 'Mahishi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e1',
      name: 'Nauhatta',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e2',
      name: 'Salkhua',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e3',
      name: 'Sattar Kattaiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e4',
      name: 'Simri Bakhtiarpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e5',
      name: 'Sonbarsa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e6',
      name: 'Sour Bazar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ee',
      name: 'Patarghat',
    },
  ],
  Samastipur: [
    {
      _id: '60ab6e9486ed1c1a3559e1e7',
      name: 'Bibhutpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e8',
      name: 'Bithan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1e9',
      name: 'Dalsinghsarai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ea',
      name: 'Hasanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1eb',
      name: 'Kalyanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ec',
      name: 'Khanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ed',
      name: 'Mohanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ef',
      name: 'Mohiuddinagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f0',
      name: 'Morwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f1',
      name: 'Pusa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f2',
      name: 'Patori',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f3',
      name: 'Rosera',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f4',
      name: 'Samastipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f5',
      name: 'Sarairanjan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f6',
      name: 'Shivaji Nagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f7',
      name: 'Singhia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f8',
      name: 'Tajpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1f9',
      name: 'Vidyapati Nagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1fa',
      name: 'Warisnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e202',
      name: 'Ujiarpur',
    },
  ],
  Saran: [
    {
      _id: '60ab6e9486ed1c1a3559e1fb',
      name: 'Amnour',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1fc',
      name: 'Baniapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1fd',
      name: 'Chhapra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1fe',
      name: 'Dariapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e1ff',
      name: 'Dighwara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e200',
      name: 'Ekma',
    },
    {
      _id: '60ab6e9486ed1c1a3559e201',
      name: 'Garkha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e203',
      name: 'Jalalpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e204',
      name: 'Isuapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e205',
      name: 'Lahladpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e206',
      name: 'Manjhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e207',
      name: 'Marhaurah',
    },
    {
      _id: '60ab6e9486ed1c1a3559e208',
      name: 'Mashrakh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e209',
      name: 'Nagra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e20a',
      name: 'Maker',
    },
    {
      _id: '60ab6e9486ed1c1a3559e20b',
      name: 'Panapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e20c',
      name: 'Parsa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e20d',
      name: 'Revelganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e20e',
      name: 'Sonepur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e20f',
      name: 'Taraiya',
    },
  ],
  Sheikhpura: [
    {
      _id: '60ab6e9486ed1c1a3559e210',
      name: 'Barbigha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e211',
      name: 'Ariari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e212',
      name: 'Chewara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e213',
      name: 'Ghatkusumbha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e214',
      name: 'Shekhopur Sarai',
    },
    {
      _id: '60ab6e9486ed1c1a3559e218',
      name: 'Sheikhpura',
    },
  ],
  Sheohar: [
    {
      _id: '60ab6e9486ed1c1a3559e215',
      name: 'Dumari Katsari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e216',
      name: 'Piprahi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e217',
      name: 'Purnahiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e219',
      name: 'Tariyani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e22a',
      name: 'Sheohar',
    },
  ],
  Sitamarhi: [
    {
      _id: '60ab6e9486ed1c1a3559e21a',
      name: 'Bairgania',
    },
    {
      _id: '60ab6e9486ed1c1a3559e21b',
      name: 'Bajpatti',
    },
    {
      _id: '60ab6e9486ed1c1a3559e21c',
      name: 'Bathanaha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e21d',
      name: 'Belsand',
    },
    {
      _id: '60ab6e9486ed1c1a3559e21e',
      name: 'Bokhra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e21f',
      name: 'Choraut',
    },
    {
      _id: '60ab6e9486ed1c1a3559e220',
      name: 'Dumra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e221',
      name: 'Majorganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e222',
      name: 'Nanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e223',
      name: 'Parihar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e224',
      name: 'Parsauni',
    },
    {
      _id: '60ab6e9486ed1c1a3559e225',
      name: 'Pupri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e226',
      name: 'Riga',
    },
    {
      _id: '60ab6e9486ed1c1a3559e227',
      name: 'Runnisaidpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e228',
      name: 'Sonbarsa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e229',
      name: 'Suppi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e22b',
      name: 'Sursand',
    },
  ],
  Siwan: [
    {
      _id: '60ab6e9486ed1c1a3559e22c',
      name: 'Andar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e22d',
      name: 'Barharia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e22e',
      name: 'Bhagwanpur Hat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e22f',
      name: 'Darauli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e230',
      name: 'Daraundha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e231',
      name: 'Goriakothi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e232',
      name: 'Guthani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e233',
      name: 'Hasan Pura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e234',
      name: 'Hussainganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e235',
      name: 'Lakri Nabiganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e236',
      name: 'Maharajganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e237',
      name: 'Mairwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e238',
      name: 'Nautan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e239',
      name: 'Pachrukhi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e23a',
      name: 'Raghunathpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e23b',
      name: 'Siswan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e23c',
      name: 'Siwan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e23d',
      name: 'Ziradei',
    },
    {
      _id: '60ab6e9486ed1c1a3559e240',
      name: 'Basantpur',
    },
  ],
  Supaul: [
    {
      _id: '60ab6e9486ed1c1a3559e23e',
      name: 'Basantpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e23f',
      name: 'Chhatapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e241',
      name: 'Marauna',
    },
    {
      _id: '60ab6e9486ed1c1a3559e242',
      name: 'Kishanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e243',
      name: 'Nirmali',
    },
    {
      _id: '60ab6e9486ed1c1a3559e244',
      name: 'Pipra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e245',
      name: 'Pratapganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e246',
      name: 'Raghopur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e247',
      name: 'Saraigarh Bhaptiyahi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e248',
      name: 'Supaul',
    },
    {
      _id: '60ab6e9486ed1c1a3559e249',
      name: 'Tribeniganj',
    },
  ],
  Vaishali: [
    {
      _id: '60ab6e9486ed1c1a3559e24a',
      name: 'Bidupur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e24b',
      name: 'Chehrakala',
    },
    {
      _id: '60ab6e9486ed1c1a3559e24c',
      name: 'Desri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e24d',
      name: 'Garaul',
    },
    {
      _id: '60ab6e9486ed1c1a3559e24e',
      name: 'Hajipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e24f',
      name: 'Jandaha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e250',
      name: 'Lalganj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e251',
      name: 'Mahnar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e252',
      name: 'Mahua',
    },
    {
      _id: '60ab6e9486ed1c1a3559e253',
      name: 'Patedhi Belsar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e254',
      name: 'Patepur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e255',
      name: 'Raghopur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e256',
      name: 'Rajapakar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e257',
      name: 'Sahdei Buzurg',
    },
    {
      _id: '60ab6e9486ed1c1a3559e258',
      name: 'Vaishali',
    },
    {
      _id: '60ab6e9486ed1c1a3559e25a',
      name: 'Bhagwanpur',
    },
  ],
  Chandigarh: [
    {
      _id: '60ab6e9486ed1c1a3559e259',
      name: 'Chandigarh',
    },
  ],
  Balod: [
    {
      _id: '60ab6e9486ed1c1a3559e25b',
      name: 'Dondi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e25c',
      name: 'Dondilohara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e25d',
      name: 'Gunderdehi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e25e',
      name: 'Gurur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e25f',
      name: 'Balod',
    },
  ],
  'Baloda Bazar': [
    {
      _id: '60ab6e9486ed1c1a3559e260',
      name: 'Baloda Bazar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e261',
      name: 'Bhatapara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e262',
      name: 'Bilaigarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e263',
      name: 'Kasdol',
    },
    {
      _id: '60ab6e9486ed1c1a3559e264',
      name: 'Palari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e266',
      name: 'Simga',
    },
  ],
  Balrampur: [
    {
      _id: '60ab6e9486ed1c1a3559e265',
      name: 'Balrampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e267',
      name: 'Kusmi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e268',
      name: 'Rajpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e269',
      name: 'Ramchandrapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e26a',
      name: 'Shankargarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e26b',
      name: 'Wadrafnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f460',
      name: 'Gaisri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f461',
      name: 'Gaindas Bujurg',
    },
    {
      _id: '60ab6e9586ed1c1a3559f462',
      name: 'Pachpedwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f463',
      name: 'Harriya Satgharwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f464',
      name: 'Rehera Bazaar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f465',
      name: 'Tulsipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f466',
      name: 'Shriduttganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f467',
      name: 'Utraula',
    },
  ],
  Bastar: [
    {
      _id: '60ab6e9486ed1c1a3559e26c',
      name: 'Bakawand',
    },
    {
      _id: '60ab6e9486ed1c1a3559e26d',
      name: 'Bastanar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e26e',
      name: 'Bastar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e26f',
      name: 'Darbha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e270',
      name: 'Jagdalpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e271',
      name: 'Lohandiguda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e272',
      name: 'Tokapal',
    },
  ],
  Bemetara: [
    {
      _id: '60ab6e9486ed1c1a3559e273',
      name: 'Berla',
    },
    {
      _id: '60ab6e9486ed1c1a3559e274',
      name: 'Bemetara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e275',
      name: 'Saja',
    },
    {
      _id: '60ab6e9486ed1c1a3559e276',
      name: 'Nawagarh',
    },
  ],
  Bijapur: [
    {
      _id: '60ab6e9486ed1c1a3559e277',
      name: 'Bhairamgarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e278',
      name: 'Bhopal Patnam',
    },
    {
      _id: '60ab6e9486ed1c1a3559e279',
      name: 'Bijapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e27a',
      name: 'Usoor',
    },
  ],
  Bilaspur: [
    {
      _id: '60ab6e9486ed1c1a3559e27b',
      name: 'Belha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e27c',
      name: 'Kota',
    },
    {
      _id: '60ab6e9486ed1c1a3559e27d',
      name: 'Masturi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e27e',
      name: 'Takhatpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e481',
      name: 'Bilaspur Sadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e482',
      name: 'Ghumarwin',
    },
    {
      _id: '60ab6e9586ed1c1a3559e483',
      name: 'Jhandutta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e484',
      name: 'Shree Naina Devi',
    },
  ],
  Dantewada: [
  {
    _id: '6964883110b85d002e29d59b',
    name: 'Bade Paneda',
  },

    {
      _id: '60ab6e9486ed1c1a3559e27f',
      name: 'Dantewada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e280',
      name: 'Geedam',
    },
    {
      _id: '60ab6e9486ed1c1a3559e281',
      name: 'Katekalyan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e282',
      name: 'Kuwakonda',
    },
  ],
  Dhamtari: [
    {
      _id: '60ab6e9486ed1c1a3559e283',
      name: 'Dhamtari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e284',
      name: 'Kurud',
    },
    {
      _id: '60ab6e9486ed1c1a3559e285',
      name: 'Magarlod',
    },
    {
      _id: '60ab6e9486ed1c1a3559e286',
      name: 'Nagari',
    },
  ],
  Durg: [
    {
      _id: '60ab6e9486ed1c1a3559e287',
      name: 'Dhamdha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e288',
      name: 'Durg',
    },
    {
      _id: '60ab6e9486ed1c1a3559e28f',
      name: 'Patan',
    },
  ],
  Gariyaband: [
    {
      _id: '60ab6e9486ed1c1a3559e289',
      name: 'Chhurra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e28a',
      name: 'Deobhog',
    },
    {
      _id: '60ab6e9486ed1c1a3559e28b',
      name: 'Fingeshwar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e28c',
      name: 'Gariyaband',
    },
    {
      _id: '60ab6e9486ed1c1a3559e28d',
      name: 'Mainpur',
    },
  ],
  'Gaurella Pendra Marwahi': [
    {
      _id: '60ab6e9486ed1c1a3559e28e',
      name: 'Gaurella-1',
    },
    {
      _id: '60ab6e9486ed1c1a3559e290',
      name: 'Gaurella-2',
    },
    {
      _id: '60ab6e9486ed1c1a3559e291',
      name: 'Marwahi',
    },
  ],
  'Janjgir-Champa': [
    {
      _id: '60ab6e9486ed1c1a3559e292',
      name: 'Baloda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e293',
      name: 'Bamhindih',
    },
    {
      _id: '60ab6e9486ed1c1a3559e294',
      name: 'Dabhara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e295',
      name: 'Akaltara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e296',
      name: 'Jaijaipur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e297',
      name: 'Malkharoda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e298',
      name: 'Nawagarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e299',
      name: 'Pamgarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e29a',
      name: 'Sakti',
    },
  ],
  Jashpur: [
    {
      _id: '60ab6e9486ed1c1a3559e29b',
      name: 'Bagicha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e29c',
      name: 'Duldula',
    },
    {
      _id: '60ab6e9486ed1c1a3559e29d',
      name: 'Jashpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e29e',
      name: 'Kansabel',
    },
    {
      _id: '60ab6e9486ed1c1a3559e29f',
      name: 'Kunkuri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2a0',
      name: 'Manora',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2a1',
      name: 'Pharsabahar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2af',
      name: 'Patthalgaon',
    },
  ],
  Kabirdham: [
    {
      _id: '60ab6e9486ed1c1a3559e2a2',
      name: 'Bodla',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2a3',
      name: 'Kawardha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2a4',
      name: 'Pandariya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2a5',
      name: 'S.Lohara',
    },
  ],
  Kanker: [
    {
      _id: '60ab6e9486ed1c1a3559e2a6',
      name: 'Antagarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2a7',
      name: 'Bhanupratappur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2a8',
      name: 'Charama',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2a9',
      name: 'Durgukondal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2aa',
      name: 'Kanker',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ab',
      name: 'Koilebeda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ac',
      name: 'Narharpur',
    },
  ],
  Kondagaon: [
    {
      _id: '60ab6e9486ed1c1a3559e2ad',
      name: 'Baderajpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ae',
      name: 'Keshkal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2b0',
      name: 'Kondagaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2b1',
      name: 'Makdi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2b7',
      name: 'Pharasgaon',
    },
  ],
  Korba: [
    {
      _id: '60ab6e9486ed1c1a3559e2b2',
      name: 'Kartala',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2b3',
      name: 'Katghora',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2b4',
      name: 'Korba',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2b5',
      name: 'Pali',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2b6',
      name: 'Podi Uparoda',
    },
  ],
  Korea: [
    {
      _id: '60ab6e9486ed1c1a3559e2b8',
      name: 'Baikunthpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2b9',
      name: 'Bharatpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ba',
      name: 'Khadgawana',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2bb',
      name: 'Sonhat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2bd',
      name: 'Manendragarh',
    },
  ],
  Mahasamund: [
    {
      _id: '60ab6e9486ed1c1a3559e2bc',
      name: 'Bagbahara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2be',
      name: 'Basna',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2bf',
      name: 'Mahasamund',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2c0',
      name: 'Saraipali',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2cc',
      name: 'Pithora',
    },
  ],
  Mungeli: [
    {
      _id: '60ab6e9486ed1c1a3559e2c1',
      name: 'Lormi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2c2',
      name: 'Mungeli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2c3',
      name: 'Pathariya',
    },
  ],
  Narayanpur: [
    {
      _id: '60ab6e9486ed1c1a3559e2c4',
      name: 'Narayanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2c5',
      name: 'Orchha(Abhujmad)',
    },
  ],
  Raigarh: [
    {
      _id: '60ab6e9486ed1c1a3559e2c6',
      name: 'Baramkela',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2c7',
      name: 'Dharamjaigarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2c8',
      name: 'Gharghoda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2c9',
      name: 'Kharsia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ca',
      name: 'Lailunga',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2cb',
      name: 'Pussore',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2cd',
      name: 'Sarangarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ce',
      name: 'Tamnar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d1',
      name: 'Raigarh',
    },
  ],
  Raipur: [
    {
      _id: '60ab6e9486ed1c1a3559e2cf',
      name: 'Abhanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d0',
      name: 'Arang',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d2',
      name: 'Dharsiwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d3',
      name: 'Tilda',
    },
  ],
  Rajnandgaon: [
    {
      _id: '60ab6e9486ed1c1a3559e2d4',
      name: 'A.Chowki (Td)',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d5',
      name: 'Chhuikhadan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d6',
      name: 'Chhuriya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d7',
      name: 'Dongargaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d8',
      name: 'Dongarghar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2d9',
      name: 'Khairagarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2da',
      name: 'Manpur (Td)',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2db',
      name: 'Mohala (Td)',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2dc',
      name: 'Rajnandgaon',
    },
  ],
  Sukma: [
    {
      _id: '60ab6e9486ed1c1a3559e2dd',
      name: 'Chhindgarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2de',
      name: 'Konta',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2df',
      name: 'Sukma',
    },
  ],
  Surajpur: [
    {
      _id: '60ab6e9486ed1c1a3559e2e0',
      name: 'Odagi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2e1',
      name: 'Pratappur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2e2',
      name: 'Premnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2e3',
      name: 'Ramanujnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2e4',
      name: 'Surajpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2f0',
      name: 'Bhaiyathan',
    },
  ],
  Surguja: [
    {
      _id: '60ab6e9486ed1c1a3559e2e5',
      name: 'Ambikapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2e6',
      name: 'Batauli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2e7',
      name: 'Lakhanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2e8',
      name: 'Lundra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2e9',
      name: 'Mainpat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ea',
      name: 'Sitapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2eb',
      name: 'Udaipur',
    },
  ],
  'North Goa': [
    {
      _id: '60ab6e9486ed1c1a3559e2ec',
      name: 'Bardez',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ed',
      name: 'Bicholim',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ee',
      name: 'Pernem',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ef',
      name: 'Satari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2f7',
      name: 'Tiswadi',
    },
  ],
  'South Goa': [
    {
      _id: '60ab6e9486ed1c1a3559e2f1',
      name: 'Canacona',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2f2',
      name: 'Dharbandora',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2f3',
      name: 'Mormugao',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2f4',
      name: 'Ponda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2f5',
      name: 'Quepem',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2f6',
      name: 'Salcete',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2f8',
      name: 'Sanguem',
    },
  ],
  Ahmadabad: [
    {
      _id: '60ab6e9486ed1c1a3559e2f9',
      name: 'Ahmadabad City',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2fa',
      name: 'Bavla',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2fb',
      name: 'Detroj Rampura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2fc',
      name: 'Dhandhuka',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2fd',
      name: 'Dholera',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2fe',
      name: 'Daskroi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e2ff',
      name: 'Dholka',
    },
    {
      _id: '60ab6e9486ed1c1a3559e300',
      name: 'Mandal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e301',
      name: 'Sanand',
    },
    {
      _id: '60ab6e9486ed1c1a3559e302',
      name: 'Viramgam',
    },
  ],
  Amreli: [
    {
      _id: '60ab6e9486ed1c1a3559e303',
      name: 'Babra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e304',
      name: 'Bagasara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e305',
      name: 'Dhari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e306',
      name: 'Amreli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e307',
      name: 'Jafrabad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e308',
      name: 'Kunkavav -Vadia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e309',
      name: 'Lathi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e30a',
      name: 'Lilia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e30b',
      name: 'Rajula',
    },
    {
      _id: '60ab6e9486ed1c1a3559e30c',
      name: 'Saverkundla',
    },
    {
      _id: '60ab6e9486ed1c1a3559e312',
      name: 'Khambha',
    },
  ],
  Anand: [
    {
      _id: '60ab6e9486ed1c1a3559e30d',
      name: 'Anand',
    },
    {
      _id: '60ab6e9486ed1c1a3559e30e',
      name: 'Anklav',
    },
    {
      _id: '60ab6e9486ed1c1a3559e30f',
      name: 'Borsad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e310',
      name: 'Khambhat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e311',
      name: 'Petlad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e313',
      name: 'Tarapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e314',
      name: 'Sojitra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e316',
      name: 'Umreth',
    },
  ],
  Arvalli: [
    {
      _id: '60ab6e9486ed1c1a3559e315',
      name: 'Bayad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e317',
      name: 'Bhiloda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e318',
      name: 'Dhansura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e319',
      name: 'Malpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e31a',
      name: 'Meghraj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e31b',
      name: 'Modasa',
    },
  ],
  'Banas Kantha': [
    {
      _id: '60ab6e9486ed1c1a3559e31c',
      name: 'Amirgadh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e31d',
      name: 'Bhabhar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e31e',
      name: 'Danta',
    },
    {
      _id: '60ab6e9486ed1c1a3559e31f',
      name: 'Dantivada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e320',
      name: 'Deesa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e321',
      name: 'Dhanera',
    },
    {
      _id: '60ab6e9486ed1c1a3559e322',
      name: 'Kankrej',
    },
    {
      _id: '60ab6e9486ed1c1a3559e323',
      name: 'Deodar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e324',
      name: 'Palanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e325',
      name: 'Suigam',
    },
    {
      _id: '60ab6e9486ed1c1a3559e326',
      name: 'Tharad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e327',
      name: 'Vadgam',
    },
    {
      _id: '60ab6e9486ed1c1a3559e328',
      name: 'Vav',
    },
    {
      _id: '60ab6e9486ed1c1a3559e32f',
      name: 'Lakhani',
    },
  ],
  Bharuch: [
    {
      _id: '60ab6e9486ed1c1a3559e329',
      name: 'Amod',
    },
    {
      _id: '60ab6e9486ed1c1a3559e32a',
      name: 'Anklesvar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e32b',
      name: 'Bharuch',
    },
    {
      _id: '60ab6e9486ed1c1a3559e32c',
      name: 'Hansot',
    },
    {
      _id: '60ab6e9486ed1c1a3559e32d',
      name: 'Jambusar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e32e',
      name: 'Jhagadia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e330',
      name: 'Netrang',
    },
    {
      _id: '60ab6e9486ed1c1a3559e331',
      name: 'Vagra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e332',
      name: 'Valia',
    },
  ],
  Bhavnagar: [
    {
      _id: '60ab6e9486ed1c1a3559e333',
      name: 'Gariadhar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e334',
      name: 'Ghogha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e335',
      name: 'Jesar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e336',
      name: 'Mahuva',
    },
    {
      _id: '60ab6e9486ed1c1a3559e337',
      name: 'Bhavnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e338',
      name: 'Palitana',
    },
    {
      _id: '60ab6e9486ed1c1a3559e339',
      name: 'Talaja',
    },
    {
      _id: '60ab6e9486ed1c1a3559e33a',
      name: 'Sihor',
    },
    {
      _id: '60ab6e9486ed1c1a3559e33b',
      name: 'Umrala',
    },
    {
      _id: '60ab6e9486ed1c1a3559e33e',
      name: 'Vallabhipur',
    },
  ],
  Botad: [
    {
      _id: '60ab6e9486ed1c1a3559e33c',
      name: 'Barvala',
    },
    {
      _id: '60ab6e9486ed1c1a3559e33d',
      name: 'Botad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e33f',
      name: 'Gadhada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e340',
      name: 'Ranpur',
    },
  ],
  Chhotaudepur: [
    {
      _id: '60ab6e9486ed1c1a3559e341',
      name: 'Chhota Udepur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e342',
      name: 'Jetpur Pavi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e343',
      name: 'Kawant',
    },
    {
      _id: '60ab6e9486ed1c1a3559e344',
      name: 'Bodeli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e345',
      name: 'Naswadi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e346',
      name: 'Sankheda',
    },
  ],
  Dang: [
    {
      _id: '60ab6e9486ed1c1a3559e347',
      name: 'Ahwa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e348',
      name: 'Subir',
    },
    {
      _id: '60ab6e9486ed1c1a3559e349',
      name: 'Waghai',
    },
  ],
  'Devbhumi Dwarka': [
    {
      _id: '60ab6e9486ed1c1a3559e34a',
      name: 'Bhanvad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e34b',
      name: 'Kalyanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e34c',
      name: 'Okhamandal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e354',
      name: 'Khambhalia',
    },
  ],
  Dohad: [
    {
      _id: '60ab6e9486ed1c1a3559e34d',
      name: 'Dahod',
    },
    {
      _id: '60ab6e9486ed1c1a3559e34e',
      name: 'Devgad Bariya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e34f',
      name: 'Dhanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e350',
      name: 'Fatepura',
    },
    {
      _id: '60ab6e9486ed1c1a3559e351',
      name: 'Garbada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e352',
      name: 'Jhalod',
    },
    {
      _id: '60ab6e9486ed1c1a3559e353',
      name: 'Limkheda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e355',
      name: 'Singvad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e356',
      name: 'Sanjeli',
    },
  ],
  Gandhinagar: [
    {
      _id: '60ab6e9486ed1c1a3559e357',
      name: 'Dehgam',
    },
    {
      _id: '60ab6e9486ed1c1a3559e358',
      name: 'Gandhinagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e359',
      name: 'Kalol',
    },
    {
      _id: '60ab6e9486ed1c1a3559e35a',
      name: 'Mansa',
    },
  ],
  'Gir Somnath': [
    {
      _id: '60ab6e9486ed1c1a3559e35b',
      name: 'Kodinar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e35c',
      name: 'Girgadhda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e35d',
      name: 'Patan Veraval',
    },
    {
      _id: '60ab6e9486ed1c1a3559e35e',
      name: 'Sutrapada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e35f',
      name: 'Talala',
    },
    {
      _id: '60ab6e9486ed1c1a3559e360',
      name: 'Una',
    },
  ],
  Jamnagar: [
    {
      _id: '60ab6e9486ed1c1a3559e361',
      name: 'Dhrol',
    },
    {
      _id: '60ab6e9486ed1c1a3559e362',
      name: 'Jamjodhpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e363',
      name: 'Jamnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e364',
      name: 'Jodiya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e365',
      name: 'Kalavad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e366',
      name: 'Lalpur',
    },
  ],
  Junagadh: [
    {
      _id: '60ab6e9486ed1c1a3559e367',
      name: 'Bhesan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e368',
      name: 'Junagadh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e369',
      name: 'Keshod',
    },
    {
      _id: '60ab6e9486ed1c1a3559e36a',
      name: 'Malia',
    },
    {
      _id: '60ab6e9486ed1c1a3559e36b',
      name: 'Mangrol',
    },
    {
      _id: '60ab6e9486ed1c1a3559e36c',
      name: 'Mendarda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e36d',
      name: 'Vanthali',
    },
    {
      _id: '60ab6e9486ed1c1a3559e36e',
      name: 'Visavadar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e36f',
      name: 'Manavadar',
    },
  ],
  Kachchh: [
    {
      _id: '60ab6e9486ed1c1a3559e370',
      name: 'Anjar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e371',
      name: 'Abdasa',
    },
    {
      _id: '60ab6e9486ed1c1a3559e372',
      name: 'Bhachau',
    },
    {
      _id: '60ab6e9486ed1c1a3559e373',
      name: 'Bhuj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e374',
      name: 'Lakhpat',
    },
    {
      _id: '60ab6e9486ed1c1a3559e375',
      name: 'Gandhidham',
    },
    {
      _id: '60ab6e9486ed1c1a3559e376',
      name: 'Mandvi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e377',
      name: 'Mundra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e378',
      name: 'Nakhatrana',
    },
    {
      _id: '60ab6e9486ed1c1a3559e379',
      name: 'Rapar',
    },
  ],
  Kheda: [
    {
      _id: '60ab6e9486ed1c1a3559e37a',
      name: 'Galteshwar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e37b',
      name: 'Kapadvanj',
    },
    {
      _id: '60ab6e9486ed1c1a3559e37c',
      name: 'Kathlal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e37d',
      name: 'Kheda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e37e',
      name: 'Matar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e37f',
      name: 'Mehmedabad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e380',
      name: 'Nadiad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e381',
      name: 'Thasra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e382',
      name: 'Vaso',
    },
    {
      _id: '60ab6e9486ed1c1a3559e388',
      name: 'Mahudha',
    },
  ],
  Mahesana: [
    {
      _id: '60ab6e9486ed1c1a3559e383',
      name: 'Bechraji',
    },
    {
      _id: '60ab6e9486ed1c1a3559e384',
      name: 'Jotana',
    },
    {
      _id: '60ab6e9486ed1c1a3559e385',
      name: 'Kadi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e386',
      name: 'Kheralu',
    },
    {
      _id: '60ab6e9486ed1c1a3559e387',
      name: 'Mahesana',
    },
    {
      _id: '60ab6e9486ed1c1a3559e389',
      name: 'Satlasna',
    },
    {
      _id: '60ab6e9486ed1c1a3559e38a',
      name: 'Unjha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e38b',
      name: 'Vijapur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e38c',
      name: 'Vadnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e38d',
      name: 'Visnagar',
    },
  ],
  Mahisagar: [
    {
      _id: '60ab6e9486ed1c1a3559e38e',
      name: 'Kadana',
    },
    {
      _id: '60ab6e9486ed1c1a3559e38f',
      name: 'Balasinor',
    },
    {
      _id: '60ab6e9486ed1c1a3559e390',
      name: 'Khanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e391',
      name: 'Lunawada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e392',
      name: 'Santrampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e393',
      name: 'Virpur',
    },
  ],
  Morbi: [
    {
      _id: '60ab6e9486ed1c1a3559e394',
      name: 'Maliya',
    },
    {
      _id: '60ab6e9486ed1c1a3559e395',
      name: 'Morvi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e396',
      name: 'Tankara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e397',
      name: 'Wankaner',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a4',
      name: 'Halvad',
    },
  ],
  Narmada: [
    {
      _id: '60ab6e9486ed1c1a3559e398',
      name: 'Dediyapada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e399',
      name: 'Garudeshwar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e39a',
      name: 'Nandod',
    },
    {
      _id: '60ab6e9486ed1c1a3559e39b',
      name: 'Sagbara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e39c',
      name: 'Tilakwada',
    },
  ],
  Navsari: [
    {
      _id: '60ab6e9486ed1c1a3559e39d',
      name: 'Chikhali',
    },
    {
      _id: '60ab6e9486ed1c1a3559e39e',
      name: 'Gandevi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e39f',
      name: 'Jalalpore',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a0',
      name: 'Khergam',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a1',
      name: 'Navsari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a2',
      name: 'Vansda',
    },
  ],
  'Panch Mahals': [
    {
      _id: '60ab6e9486ed1c1a3559e3a3',
      name: 'Ghoghamba',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a5',
      name: 'Godhra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a6',
      name: 'Halol',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a7',
      name: 'Jambughoda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a8',
      name: 'Morvahadaf',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3a9',
      name: 'Shehera',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ac',
      name: 'Kalol',
    },
  ],
  Patan: [
    {
      _id: '60ab6e9486ed1c1a3559e3aa',
      name: 'Chanasma',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ab',
      name: 'Harij',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ad',
      name: 'Patan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ae',
      name: 'Sami',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3af',
      name: 'Radhanpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3b0',
      name: 'Sankheshwar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3b1',
      name: 'Santalpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3b2',
      name: 'Sidhpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3b5',
      name: 'Saraswati',
    },
  ],
  Porbandar: [
    {
      _id: '60ab6e9486ed1c1a3559e3b3',
      name: 'Kutiyana',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3b4',
      name: 'Porbandar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3b6',
      name: 'Ranavav',
    },
  ],
  Rajkot: [
    {
      _id: '60ab6e9486ed1c1a3559e3b7',
      name: 'Dhoraji',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3b8',
      name: 'Gondal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3b9',
      name: 'Jasdan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ba',
      name: 'Jetpur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3bb',
      name: 'Kotda Sangani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3bc',
      name: 'Lodhika',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3bd',
      name: 'Jamkandorna',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3be',
      name: 'Paddhari',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3bf',
      name: 'Rajkot',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3c0',
      name: 'Upleta',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3c1',
      name: 'Vinchhiya',
    },
  ],
  'Sabar Kantha': [
    {
      _id: '60ab6e9486ed1c1a3559e3c2',
      name: 'Himatnagar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3c3',
      name: 'Idar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3c4',
      name: 'Khedbrahma',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3c5',
      name: 'Poshina',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3c6',
      name: 'Prantij',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3c7',
      name: 'Talod',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3c8',
      name: 'Vadali',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3cb',
      name: 'Vijaynagar',
    },
  ],
  Surat: [
    {
      _id: '60ab6e9486ed1c1a3559e3c9',
      name: 'Bardoli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ca',
      name: 'Chorasi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3cc',
      name: 'Mahuva',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3cd',
      name: 'Mandvi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ce',
      name: 'Mangrol',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3cf',
      name: 'Olpad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d0',
      name: 'Palsana',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d1',
      name: 'Suratcity',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d2',
      name: 'Umarpada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d8',
      name: 'Kamrej',
    },
  ],
  Surendranagar: [
    {
      _id: '60ab6e9486ed1c1a3559e3d3',
      name: 'Chotila',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d4',
      name: 'Chuda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d5',
      name: 'Dasada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d6',
      name: 'Dhrangadhra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d7',
      name: 'Lakhtar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3d9',
      name: 'Limbdi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3da',
      name: 'Muli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3db',
      name: 'Sayla',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3dc',
      name: 'Thangadh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e1',
      name: 'Wadhwan',
    },
  ],
  Tapi: [
    {
      _id: '60ab6e9486ed1c1a3559e3dd',
      name: 'Dolvan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3de',
      name: 'Kukarmunda',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3df',
      name: 'Nizar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e0',
      name: 'Songadh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e2',
      name: 'Uchchhal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e3',
      name: 'Valod',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e4',
      name: 'Vyara',
    },
  ],
  Vadodara: [
    {
      _id: '60ab6e9486ed1c1a3559e3e5',
      name: 'Dabhoi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e6',
      name: 'Karjan',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e7',
      name: 'Padra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e8',
      name: 'Savli',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3e9',
      name: 'Shinor',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ea',
      name: 'Desar',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3eb',
      name: 'Vadodara(City And Rural)',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ec',
      name: 'Waghodia',
    },
  ],
  Valsad: [
    {
      _id: '60ab6e9486ed1c1a3559e3ed',
      name: 'Dharampur',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ee',
      name: 'Kaprada',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3ef',
      name: 'Pardi',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3f0',
      name: 'Umbergaon',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3f1',
      name: 'Valsad',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3f2',
      name: 'Vapi',
    },
  ],
  Ambala: [
    {
      _id: '60ab6e9486ed1c1a3559e3f3',
      name: 'Ambala-I',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3f4',
      name: 'Ambala-Ii',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3f5',
      name: 'Barara',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3f6',
      name: 'Naraingarh',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3f7',
      name: 'Saha',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3f8',
      name: 'Shahzadpur',
    },
  ],
  Bhiwani: [
    {
      _id: '60ab6e9486ed1c1a3559e3f9',
      name: 'Behal',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3fa',
      name: 'Bhiwani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3fb',
      name: 'Kairu',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3fc',
      name: 'Loharu',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3fd',
      name: 'Siwani',
    },
    {
      _id: '60ab6e9486ed1c1a3559e3fe',
      name: 'Tosham',
    },
    {
      _id: '60ab6e9586ed1c1a3559e405',
      name: 'Bawani Khera',
    },
  ],
  'Charki Dadri': [
    {
      _id: '60ab6e9486ed1c1a3559e3ff',
      name: 'Badhra',
    },
    {
      _id: '60ab6e9486ed1c1a3559e400',
      name: 'Baund',
    },
    {
      _id: '60ab6e9486ed1c1a3559e401',
      name: 'Charkhi Dadri',
    },
    {
      _id: '60ab6e9486ed1c1a3559e402',
      name: 'Jhojhu',
    },
  ],
  Faridabad: [
    {
      _id: '60ab6e9486ed1c1a3559e403',
      name: 'Ballabgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e406',
      name: 'Faridabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e407',
      name: 'Tigaon',
    },
  ],
  Fatehabad: [
    {
      _id: '60ab6e9586ed1c1a3559e408',
      name: 'Bhattu Kalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e409',
      name: 'Bhuna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e40a',
      name: 'Jakhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e40b',
      name: 'Nagpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e40c',
      name: 'Ratia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e40d',
      name: 'Tohana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e417',
      name: 'Fatehabad',
    },
  ],
  Gurugram: [
    {
      _id: '60ab6e9586ed1c1a3559e40e',
      name: 'Farrukh Nagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e40f',
      name: 'Gurgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e410',
      name: 'Pataudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e411',
      name: 'Sohna',
    },
  ],
  Hisar: [
    {
      _id: '60ab6e9586ed1c1a3559e412',
      name: 'Adampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e413',
      name: 'Agroha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e414',
      name: 'Barwala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e415',
      name: 'Hansi-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559e416',
      name: 'Hansi-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559e418',
      name: 'Hisar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559e419',
      name: 'Hisar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559e41a',
      name: 'Narnaund',
    },
    {
      _id: '60ab6e9586ed1c1a3559e42d',
      name: 'Uklana',
    },
  ],
  Jhajjar: [
    {
      _id: '60ab6e9586ed1c1a3559e41b',
      name: 'Badli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e41c',
      name: 'Bahadurgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e41d',
      name: 'Beri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e41e',
      name: 'Jhajjar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e41f',
      name: 'Machhrauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e420',
      name: 'Matannail',
    },
    {
      _id: '60ab6e9586ed1c1a3559e421',
      name: 'Salhawas',
    },
  ],
  Jind: [
    {
      _id: '60ab6e9586ed1c1a3559e422',
      name: 'Alewa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e423',
      name: 'Jind',
    },
    {
      _id: '60ab6e9586ed1c1a3559e424',
      name: 'Julana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e425',
      name: 'Narwana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e426',
      name: 'Pillukhera',
    },
    {
      _id: '60ab6e9586ed1c1a3559e427',
      name: 'Safidon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e428',
      name: 'Uchana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e429',
      name: 'Ujhana',
    },
  ],
  Kaithal: [
    {
      _id: '60ab6e9586ed1c1a3559e42a',
      name: 'Dhand',
    },
    {
      _id: '60ab6e9586ed1c1a3559e42b',
      name: 'Guhla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e42c',
      name: 'Kaithal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e42e',
      name: 'Kalayat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e42f',
      name: 'Pundri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e430',
      name: 'Rajound',
    },
    {
      _id: '60ab6e9586ed1c1a3559e443',
      name: 'Siwan',
    },
  ],
  Karnal: [
    {
      _id: '60ab6e9586ed1c1a3559e431',
      name: 'Assandh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e432',
      name: 'Gharaunda (Part)',
    },
    {
      _id: '60ab6e9586ed1c1a3559e433',
      name: 'Indri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e434',
      name: 'Karnal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e435',
      name: 'Kunjpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e436',
      name: 'Munak',
    },
    {
      _id: '60ab6e9586ed1c1a3559e437',
      name: 'Nilokheri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e438',
      name: 'Nissing At Chirao',
    },
  ],
  Kurukshetra: [
    {
      _id: '60ab6e9586ed1c1a3559e439',
      name: 'Babain',
    },
    {
      _id: '60ab6e9586ed1c1a3559e43a',
      name: 'Ismailabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e43b',
      name: 'Ladwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e43c',
      name: 'Pehowa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e43d',
      name: 'Pipli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e43e',
      name: 'Shahbad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e43f',
      name: 'Thanesar',
    },
  ],
  Mahendragarh: [
    {
      _id: '60ab6e9586ed1c1a3559e440',
      name: 'Ateli Nangal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e441',
      name: 'Kanina',
    },
    {
      _id: '60ab6e9586ed1c1a3559e442',
      name: 'Mahendragarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e444',
      name: 'Nangal Chaudhry',
    },
    {
      _id: '60ab6e9586ed1c1a3559e445',
      name: 'Narnaul',
    },
    {
      _id: '60ab6e9586ed1c1a3559e446',
      name: 'Nizampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e447',
      name: 'Sihma',
    },
    {
      _id: '60ab6e9586ed1c1a3559e459',
      name: 'Satnali',
    },
  ],
  Nuh: [
    {
      _id: '60ab6e9586ed1c1a3559e448',
      name: 'Ferozepur Jhirka',
    },
    {
      _id: '60ab6e9586ed1c1a3559e449',
      name: 'Indri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e44a',
      name: 'Nagina',
    },
    {
      _id: '60ab6e9586ed1c1a3559e44b',
      name: 'Nuh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e44c',
      name: 'Pingwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e44d',
      name: 'Punahana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e44e',
      name: 'Taoru',
    },
  ],
  Palwal: [
    {
      _id: '60ab6e9586ed1c1a3559e44f',
      name: 'Badoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e450',
      name: 'Hassanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e451',
      name: 'Hathin',
    },
    {
      _id: '60ab6e9586ed1c1a3559e452',
      name: 'Hodal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e453',
      name: 'Palwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e454',
      name: 'Prithla',
    },
  ],
  Panchkula: [
    {
      _id: '60ab6e9586ed1c1a3559e455',
      name: 'Barwala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e456',
      name: 'Morni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e457',
      name: 'Pinjore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e458',
      name: 'Raipur Rani',
    },
  ],
  Panipat: [
    {
      _id: '60ab6e9586ed1c1a3559e45a',
      name: 'Bapoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e45b',
      name: 'Israna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e45c',
      name: 'Madlauda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e45d',
      name: 'Samalkha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e45e',
      name: 'Sanauli Khurd',
    },
    {
      _id: '60ab6e9586ed1c1a3559e46f',
      name: 'Panipat',
    },
  ],
  Rewari: [
    {
      _id: '60ab6e9586ed1c1a3559e45f',
      name: 'Bawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e460',
      name: 'Dahina',
    },
    {
      _id: '60ab6e9586ed1c1a3559e461',
      name: 'Dharuhera',
    },
    {
      _id: '60ab6e9586ed1c1a3559e462',
      name: 'Jatusana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e463',
      name: 'Khol At Rewari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e464',
      name: 'Nahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e465',
      name: 'Rewari',
    },
  ],
  Rohtak: [
    {
      _id: '60ab6e9586ed1c1a3559e466',
      name: 'Kalanaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e467',
      name: 'Lakhan Majra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e468',
      name: 'Maham',
    },
    {
      _id: '60ab6e9586ed1c1a3559e469',
      name: 'Rohtak',
    },
    {
      _id: '60ab6e9586ed1c1a3559e46a',
      name: 'Sampla',
    },
  ],
  Sirsa: [
    {
      _id: '60ab6e9586ed1c1a3559e46b',
      name: 'Baragudha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e46c',
      name: 'Dabwali',
    },
    {
      _id: '60ab6e9586ed1c1a3559e46d',
      name: 'Ellenabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e46e',
      name: 'Nathusari Chopta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e470',
      name: 'Odhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e471',
      name: 'Rania',
    },
    {
      _id: '60ab6e9586ed1c1a3559e472',
      name: 'Sirsa',
    },
  ],
  Sonipat: [
    {
      _id: '60ab6e9586ed1c1a3559e473',
      name: 'Gohana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e474',
      name: 'Kathura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e475',
      name: 'Kharkhoda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e476',
      name: 'Mundlana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e477',
      name: 'Murthal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e478',
      name: 'Rai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e479',
      name: 'Sonipat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e485',
      name: 'Ganaur',
    },
  ],
  Yamunanagar: [
    {
      _id: '60ab6e9586ed1c1a3559e47a',
      name: 'Bilaspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e47b',
      name: 'Chhachhrauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e47c',
      name: 'Jagadhri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e47d',
      name: 'Partap Nagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e47e',
      name: 'Radaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e47f',
      name: 'Sadaura (Part)',
    },
    {
      _id: '60ab6e9586ed1c1a3559e480',
      name: 'Saraswati Nagar',
    },
  ],
  Chamba: [
    {
      _id: '60ab6e9586ed1c1a3559e486',
      name: 'Bharmour',
    },
    {
      _id: '60ab6e9586ed1c1a3559e487',
      name: 'Bhattiyat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e488',
      name: 'Chamba',
    },
    {
      _id: '60ab6e9586ed1c1a3559e489',
      name: 'Pangi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e48a',
      name: 'Saluni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e48b',
      name: 'Tisa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e49b',
      name: 'Mehla',
    },
  ],
  Hamirpur: [
    {
      _id: '60ab6e9586ed1c1a3559e48c',
      name: 'Bamson',
    },
    {
      _id: '60ab6e9586ed1c1a3559e48d',
      name: 'Bhoranj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e48e',
      name: 'Bijhri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e48f',
      name: 'Hamirpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e490',
      name: 'Nadaun',
    },
    {
      _id: '60ab6e9586ed1c1a3559e491',
      name: 'Tira Sujanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f553',
      name: 'Gohand',
    },
    {
      _id: '60ab6e9586ed1c1a3559f554',
      name: 'Maudaha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f555',
      name: 'Muskara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f556',
      name: 'Kurara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f557',
      name: 'Rath',
    },
    {
      _id: '60ab6e9586ed1c1a3559f558',
      name: 'Sarila',
    },
    {
      _id: '60ab6e9586ed1c1a3559f55a',
      name: 'Sumerpur',
    },
  ],
  Kangra: [
    {
      _id: '60ab6e9586ed1c1a3559e492',
      name: 'Baijnath',
    },
    {
      _id: '60ab6e9586ed1c1a3559e493',
      name: 'Bhawarna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e494',
      name: 'Dehra Gopipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e495',
      name: 'Dharamshala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e496',
      name: 'Fatehpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e497',
      name: 'Indora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e498',
      name: 'Kangra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e499',
      name: 'Lambagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e49a',
      name: 'Nagrota Bagwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e49c',
      name: 'Nagrota Surian',
    },
    {
      _id: '60ab6e9586ed1c1a3559e49d',
      name: 'Nurpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e49e',
      name: 'Panchrukhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e49f',
      name: 'Rait',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4a0',
      name: 'Sulah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b1',
      name: 'Pragpur',
    },
  ],
  Kinnaur: [
    {
      _id: '60ab6e9586ed1c1a3559e4a1',
      name: 'Kalpa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4a2',
      name: 'Nichar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4a3',
      name: 'Pooh',
    },
  ],
  Kullu: [
    {
      _id: '60ab6e9586ed1c1a3559e4a4',
      name: 'Anni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4a5',
      name: 'Banjar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4a6',
      name: 'Kullu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4a7',
      name: 'Naggar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4a8',
      name: 'Nirmand',
    },
  ],
  'Lahul And Spiti': [
    {
      _id: '60ab6e9586ed1c1a3559e4a9',
      name: 'Lahul',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4aa',
      name: 'Spiti',
    },
  ],
  Mandi: [
    {
      _id: '60ab6e9586ed1c1a3559e4ab',
      name: 'Balh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ac',
      name: 'Bali Chowki',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ad',
      name: 'Chauntra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ae',
      name: 'Dharmpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4af',
      name: 'Drang',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b0',
      name: 'Gohar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b2',
      name: 'Gopalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b3',
      name: 'Karsog',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b4',
      name: 'Mandi Sadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b5',
      name: 'Sundarnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4c7',
      name: 'Seraj',
    },
  ],
  Shimla: [
    {
      _id: '60ab6e9586ed1c1a3559e4b6',
      name: 'Basantpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b7',
      name: 'Chauhara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b8',
      name: 'Chaupal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4b9',
      name: 'Jubbal Kotkhai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ba',
      name: 'Kupvi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4bb',
      name: 'Mashobra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4bc',
      name: 'Nankhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4bd',
      name: 'Narkanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4be',
      name: 'Rampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4bf',
      name: 'Rohru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4c0',
      name: 'Theog',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4c1',
      name: 'Totu',
    },
  ],
  Sirmaur: [
    {
      _id: '60ab6e9586ed1c1a3559e4c2',
      name: 'Nahan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4c3',
      name: 'Pachhad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4c4',
      name: 'Paonta Sahib',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4c5',
      name: 'Rajgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4c6',
      name: 'Sangrah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4c8',
      name: 'Shillai',
    },
  ],
  Solan: [
    {
      _id: '60ab6e9586ed1c1a3559e4c9',
      name: 'Dharampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ca',
      name: 'Kandaghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4cb',
      name: 'Nalagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4cc',
      name: 'Solan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4dd',
      name: 'Kunihar',
    },
  ],
  Una: [
    {
      _id: '60ab6e9586ed1c1a3559e4cd',
      name: 'Amb',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ce',
      name: 'Bangana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4cf',
      name: 'Gagret',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d0',
      name: 'Haroli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d1',
      name: 'Una',
    },
  ],
  Anantnag: [
    {
      _id: '60ab6e9586ed1c1a3559e4d2',
      name: 'Achabal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d3',
      name: 'Anantnag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d4',
      name: 'Bijibehara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d5',
      name: 'Breng',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d6',
      name: 'Chathergul',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d7',
      name: 'Dachnipora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d8',
      name: 'Hiller Shahabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4d9',
      name: 'Khoveripora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4da',
      name: 'Larnoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4db',
      name: 'Pahalgam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4dc',
      name: 'Qazigund (Partly)',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4de',
      name: 'Quimoh Anantnag District Part',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4df',
      name: 'Sagam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e0',
      name: 'Shahabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e1',
      name: 'Verinag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e2',
      name: 'Vessu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f3',
      name: 'Shangus',
    },
  ],
  Bandipora: [
    {
      _id: '60ab6e9586ed1c1a3559e4e3',
      name: 'Aloosa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e4',
      name: 'Arin',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e5',
      name: 'Baktoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e6',
      name: 'Bandipora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e7',
      name: 'Bonkoot',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e8',
      name: 'Ganstan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4e9',
      name: 'Gurez',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ea',
      name: 'Hajin',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4eb',
      name: 'Naidkhay',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ec',
      name: 'Nowgam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ed',
      name: 'Sumbal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ee',
      name: 'Tulail',
    },
  ],
  Baramulla: [
    {
      _id: '60ab6e9586ed1c1a3559e4ef',
      name: 'Baramulla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f0',
      name: 'Bijhama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f1',
      name: 'Boniyar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f2',
      name: 'Chandil Wangam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f4',
      name: 'Hardaboora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f5',
      name: 'Kandi Rafiabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f6',
      name: 'Khaipora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f7',
      name: 'Lalpora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f8',
      name: 'Nadihal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4f9',
      name: 'Narwah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4fa',
      name: 'Noorkah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4fb',
      name: 'Paranpeela',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4fc',
      name: 'Pattan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4fd',
      name: 'Rafiabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4fe',
      name: 'Rohama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e4ff',
      name: 'Sangrama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e500',
      name: 'Sherabad Khore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e501',
      name: 'Singhpora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e502',
      name: 'Sopore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e503',
      name: 'Tangmarag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e504',
      name: 'Tujjar Sharief',
    },
    {
      _id: '60ab6e9586ed1c1a3559e505',
      name: 'Uri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e506',
      name: 'Wagoora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e507',
      name: 'Wailoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e508',
      name: 'Zaingeer',
    },
    {
      _id: '60ab6e9586ed1c1a3559e509',
      name: 'Kunzer',
    },
  ],
  Budgam: [
    {
      _id: '60ab6e9586ed1c1a3559e50a',
      name: 'Badgam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e50b',
      name: 'Beerwah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e50c',
      name: 'B.K.Pora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e50d',
      name: 'Charisharief',
    },
    {
      _id: '60ab6e9586ed1c1a3559e50e',
      name: 'Khag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e50f',
      name: 'Khan-Sahib',
    },
    {
      _id: '60ab6e9586ed1c1a3559e510',
      name: 'Nagam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e511',
      name: 'Narbal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e512',
      name: 'Pakherpora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e513',
      name: 'Parnewa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e514',
      name: 'Rathsun',
    },
    {
      _id: '60ab6e9586ed1c1a3559e515',
      name: 'S K Pora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e516',
      name: 'Soibugh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e517',
      name: 'Sukhnag Hard Panzoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e518',
      name: 'Surasyar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e519',
      name: 'Waterhail',
    },
    {
      _id: '60ab6e9586ed1c1a3559e51f',
      name: 'Chadoora',
    },
  ],
  Doda: [
    {
      _id: '60ab6e9586ed1c1a3559e51a',
      name: 'Assar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e51b',
      name: 'Bhaderwah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e51c',
      name: 'Bhagwah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e51d',
      name: 'Bhalessa(Gandoh)',
    },
    {
      _id: '60ab6e9586ed1c1a3559e51e',
      name: 'Bhalla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e520',
      name: 'Changa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e521',
      name: 'Chilli Pingal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e522',
      name: 'Chiralla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e523',
      name: 'Doda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e524',
      name: 'Gundana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e525',
      name: 'Jakyas',
    },
    {
      _id: '60ab6e9586ed1c1a3559e526',
      name: 'Kahara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e527',
      name: 'Kastigarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e528',
      name: 'Khellani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e529',
      name: 'Marmat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e52a',
      name: 'Thathri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e535',
      name: 'Dali Udhyanpur',
    },
  ],
  Ganderbal: [
    {
      _id: '60ab6e9586ed1c1a3559e52b',
      name: 'Ganderbal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e52c',
      name: 'Gund',
    },
    {
      _id: '60ab6e9586ed1c1a3559e52d',
      name: 'Kangan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e52e',
      name: 'Lar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e52f',
      name: 'Safapora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e530',
      name: 'Sherpathri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e531',
      name: 'Wakoora',
    },
  ],
  Jammu: [
    {
      _id: '60ab6e9586ed1c1a3559e532',
      name: 'Akhnoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e533',
      name: 'Arnia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e534',
      name: 'Bhalwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e536',
      name: 'Bhalwal Brahmana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e537',
      name: 'Bishnah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e538',
      name: 'Chowki Choura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e539',
      name: 'Kharah Balli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e53a',
      name: 'Khour',
    },
    {
      _id: '60ab6e9586ed1c1a3559e53b',
      name: 'Maira Mandrian',
    },
    {
      _id: '60ab6e9586ed1c1a3559e53c',
      name: 'Mandal Phallain',
    },
    {
      _id: '60ab6e9586ed1c1a3559e53d',
      name: 'Marh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e53e',
      name: 'Mathwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e53f',
      name: 'Miran Sahib',
    },
    {
      _id: '60ab6e9586ed1c1a3559e540',
      name: 'Nagrota',
    },
    {
      _id: '60ab6e9586ed1c1a3559e541',
      name: 'Pragwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e542',
      name: 'R.S.Pura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e543',
      name: 'Samwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e544',
      name: 'Satwari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e545',
      name: 'Suchetgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e54b',
      name: 'Dansal',
    },
  ],
  Kathua: [
    {
      _id: '60ab6e9586ed1c1a3559e546',
      name: 'Baggan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e547',
      name: 'Bani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e548',
      name: 'Barnoti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e549',
      name: 'Basohli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e54a',
      name: 'Bhoond',
    },
    {
      _id: '60ab6e9586ed1c1a3559e54c',
      name: 'Billawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e54d',
      name: 'Dhar Mahanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e54e',
      name: 'Dinga Amb',
    },
    {
      _id: '60ab6e9586ed1c1a3559e54f',
      name: 'Duggan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e550',
      name: 'Hiranagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e551',
      name: 'Kathua',
    },
    {
      _id: '60ab6e9586ed1c1a3559e552',
      name: 'Keerian Gangyal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e553',
      name: 'Lohai-Malhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e554',
      name: 'Mahanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e555',
      name: 'Mandli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e556',
      name: 'Marheen',
    },
    {
      _id: '60ab6e9586ed1c1a3559e557',
      name: 'Nagri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e558',
      name: 'Nagrota Gujroo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e561',
      name: 'Duggain',
    },
  ],
  Kishtwar: [
    {
      _id: '60ab6e9586ed1c1a3559e559',
      name: 'Bunjwah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e55a',
      name: 'Dachhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e55b',
      name: 'Drabshalla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e55c',
      name: 'Inderwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e55d',
      name: 'Kishtwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e55e',
      name: 'Marwah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e55f',
      name: 'Mughalmaidan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e560',
      name: 'Nagseni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e562',
      name: 'Padder',
    },
    {
      _id: '60ab6e9586ed1c1a3559e563',
      name: 'Palmar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e564',
      name: 'Thakraie',
    },
    {
      _id: '60ab6e9586ed1c1a3559e565',
      name: 'Warwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e577',
      name: 'Trigam',
    },
  ],
  Kulgam: [
    {
      _id: '60ab6e9586ed1c1a3559e566',
      name: 'Behibag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e567',
      name: 'Devsar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e568',
      name: 'D.H. Pora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e569',
      name: 'D K Marg',
    },
    {
      _id: '60ab6e9586ed1c1a3559e56a',
      name: 'Frisal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e56b',
      name: 'Kulgam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e56c',
      name: 'Kund',
    },
    {
      _id: '60ab6e9586ed1c1a3559e56d',
      name: 'Manzgam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e56e',
      name: 'Pahloo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e56f',
      name: 'Pombay',
    },
    {
      _id: '60ab6e9586ed1c1a3559e570',
      name: 'Qaimoh',
    },
  ],
  Kupwara: [
    {
      _id: '60ab6e9586ed1c1a3559e571',
      name: 'Drugmulla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e572',
      name: 'Handwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e573',
      name: 'Hayhama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e574',
      name: 'Kalarooch',
    },
    {
      _id: '60ab6e9586ed1c1a3559e575',
      name: 'Keran',
    },
    {
      _id: '60ab6e9586ed1c1a3559e576',
      name: 'Kralpora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e578',
      name: 'Kupwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e579',
      name: 'Langate',
    },
    {
      _id: '60ab6e9586ed1c1a3559e57a',
      name: 'Machil',
    },
    {
      _id: '60ab6e9586ed1c1a3559e57b',
      name: 'Mawar Kalamabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e57c',
      name: 'Meliyal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e57d',
      name: 'Nutnoosa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e57e',
      name: 'Qadirabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e57f',
      name: 'Qaziabad Supernagama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e580',
      name: 'Rajwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e581',
      name: 'Ramhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e582',
      name: 'Reddi Chowkibal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e583',
      name: 'Sogam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e584',
      name: 'Tangdar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e585',
      name: 'Tarathpora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e586',
      name: 'Teetwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e587',
      name: 'Trehgam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e588',
      name: 'Wavoora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e58d',
      name: 'Magam',
    },
  ],
  Poonch: [
    {
      _id: '60ab6e9586ed1c1a3559e589',
      name: 'Balakote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e58a',
      name: 'Bufliaz',
    },
    {
      _id: '60ab6e9586ed1c1a3559e58b',
      name: 'Lassana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e58c',
      name: 'Loran',
    },
    {
      _id: '60ab6e9586ed1c1a3559e58e',
      name: 'Mandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e58f',
      name: 'Mankote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e590',
      name: 'Mendhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e591',
      name: 'Poonch',
    },
    {
      _id: '60ab6e9586ed1c1a3559e592',
      name: 'Sathra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e593',
      name: 'Surankote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a3',
      name: 'Nangali Sahib Sain Baba',
    },
  ],
  Pulwama: [
    {
      _id: '60ab6e9586ed1c1a3559e594',
      name: 'Aripal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e595',
      name: 'Awantipora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e596',
      name: 'Dadsara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e597',
      name: 'Ichegoza',
    },
    {
      _id: '60ab6e9586ed1c1a3559e598',
      name: 'Kakapora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e599',
      name: 'Litter',
    },
    {
      _id: '60ab6e9586ed1c1a3559e59a',
      name: 'Newa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e59b',
      name: 'Pampore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e59c',
      name: 'Pulwama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e59d',
      name: 'Shadimarg',
    },
    {
      _id: '60ab6e9586ed1c1a3559e59e',
      name: 'Tral',
    },
  ],
  Rajouri: [
    {
      _id: '60ab6e9586ed1c1a3559e59f',
      name: 'Budhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a0',
      name: 'Budhal New',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a1',
      name: 'Darhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a2',
      name: 'Dhangri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a4',
      name: 'Doongi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a5',
      name: 'Kalakote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a6',
      name: 'Khawas',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a7',
      name: 'Manjakote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a8',
      name: 'Moughla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5a9',
      name: 'Nowshera',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5aa',
      name: 'Panjgrian',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ab',
      name: 'Planger',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ac',
      name: 'Qila Darhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ad',
      name: 'Rajouri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ae',
      name: 'Seri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5af',
      name: 'Siot',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b0',
      name: 'Sunderbani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b1',
      name: 'Thana Mandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b9',
      name: 'Lamberi',
    },
  ],
  Ramban: [
    {
      _id: '60ab6e9586ed1c1a3559e5b2',
      name: 'Banihal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b3',
      name: 'Batote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b4',
      name: 'Gandhri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b5',
      name: 'Gool',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b6',
      name: 'Gundi Dharam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b7',
      name: 'Khari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5b8',
      name: 'Rajgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ba',
      name: 'Ramban',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5bb',
      name: 'Ramsoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5bc',
      name: 'Sangaldan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5cf',
      name: 'Ukhral',
    },
  ],
  Reasi: [
    {
      _id: '60ab6e9586ed1c1a3559e5bd',
      name: 'Arnas',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5be',
      name: 'Bamagh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5bf',
      name: 'Chassana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c0',
      name: 'Gulab Garh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c1',
      name: 'Jig Bagli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c2',
      name: 'Katra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c3',
      name: 'Mahore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c4',
      name: 'Panthal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c5',
      name: 'Pouni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c6',
      name: 'Reasi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c7',
      name: 'Thakrakote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5c8',
      name: 'Thuroo',
    },
  ],
  Samba: [
    {
      _id: '60ab6e9586ed1c1a3559e5c9',
      name: 'Ghagwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ca',
      name: 'Nud',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5cb',
      name: 'Purmandal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5cc',
      name: 'Purmandal Bari Brahamna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5cd',
      name: 'Rajpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ce',
      name: 'Ramgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d0',
      name: 'Samba',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d1',
      name: 'Sumb',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d2',
      name: 'Vijaypur',
    },
  ],
  Shopian: [
    {
      _id: '60ab6e9586ed1c1a3559e5d3',
      name: 'Harman',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d4',
      name: 'Imamsahib',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d5',
      name: 'Kanji Ullar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d6',
      name: 'Kaprin',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d7',
      name: 'Keller',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d8',
      name: 'Ramnagri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5d9',
      name: 'Shopian',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5da',
      name: 'Zainpora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e5',
      name: 'Chitragam',
    },
  ],
  Srinagar: [
    {
      _id: '60ab6e9586ed1c1a3559e5db',
      name: 'Eidgah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5dc',
      name: 'Harwan Rural Area Dara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5dd',
      name: 'Khanmoh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5de',
      name: 'Qamarwari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5df',
      name: 'Srinagar',
    },
  ],
  Udhampur: [
    {
      _id: '60ab6e9586ed1c1a3559e5e0',
      name: 'Chanunta Dalsar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e1',
      name: 'Chenani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e2',
      name: 'Dudu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e3',
      name: 'Ghordi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e4',
      name: 'Jaganoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e6',
      name: 'Khoon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e7',
      name: 'Kulwanta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e8',
      name: 'Latti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5e9',
      name: 'Moungri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ea',
      name: 'Narsoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5eb',
      name: 'Panchari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ec',
      name: 'Parli Dhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ed',
      name: 'Ramnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ee',
      name: 'Sewna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ef',
      name: 'Tikri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f0',
      name: 'Udhampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5fb',
      name: 'Majalta',
    },
  ],
  Bokaro: [
    {
      _id: '60ab6e9586ed1c1a3559e5f1',
      name: 'Bermo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f2',
      name: 'Chandankiyari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f3',
      name: 'Chandrapura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f4',
      name: 'Chas',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f5',
      name: 'Gomia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f6',
      name: 'Jaridih',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f7',
      name: 'Kasmar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f8',
      name: 'Nawadih',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5f9',
      name: 'Peterwar',
    },
  ],
  Chatra: [
    {
      _id: '60ab6e9586ed1c1a3559e5fa',
      name: 'Chatra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5fc',
      name: 'Giddhor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5fd',
      name: 'Itkhori',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5fe',
      name: 'Kanhachatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e5ff',
      name: 'Lawalong',
    },
    {
      _id: '60ab6e9586ed1c1a3559e600',
      name: 'Mayurhand',
    },
    {
      _id: '60ab6e9586ed1c1a3559e601',
      name: 'Pathalgada',
    },
    {
      _id: '60ab6e9586ed1c1a3559e602',
      name: 'Pratappur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e603',
      name: 'Shaligram Ram Narayanpur Alias Hunterganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e604',
      name: 'Simaria',
    },
    {
      _id: '60ab6e9586ed1c1a3559e605',
      name: 'Tandwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e611',
      name: 'Kunda',
    },
  ],
  Deoghar: [
    {
      _id: '60ab6e9586ed1c1a3559e606',
      name: 'Deoghar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e607',
      name: 'Devipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e608',
      name: 'Karown',
    },
    {
      _id: '60ab6e9586ed1c1a3559e609',
      name: 'Madhupur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e60a',
      name: 'Margomunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e60b',
      name: 'Mohanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e60c',
      name: 'Palojori',
    },
    {
      _id: '60ab6e9586ed1c1a3559e60d',
      name: 'Sarath',
    },
    {
      _id: '60ab6e9586ed1c1a3559e60e',
      name: 'Sarwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e60f',
      name: 'Sonaraithari',
    },
  ],
  Dhanbad: [
    {
      _id: '60ab6e9586ed1c1a3559e610',
      name: 'Baghmara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e612',
      name: 'Baliapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e613',
      name: 'Dhanbad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e614',
      name: 'Egarkund',
    },
    {
      _id: '60ab6e9586ed1c1a3559e615',
      name: 'Kaliasol',
    },
    {
      _id: '60ab6e9586ed1c1a3559e616',
      name: 'Nirsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e617',
      name: 'Purvi Tundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e618',
      name: 'Topchanchi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e619',
      name: 'Tundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e627',
      name: 'Govindpur',
    },
  ],
  Dumka: [
    {
      _id: '60ab6e9586ed1c1a3559e61a',
      name: 'Dumka',
    },
    {
      _id: '60ab6e9586ed1c1a3559e61b',
      name: 'Gopikander',
    },
    {
      _id: '60ab6e9586ed1c1a3559e61c',
      name: 'Jama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e61d',
      name: 'Jarmundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e61e',
      name: 'Kathikund',
    },
    {
      _id: '60ab6e9586ed1c1a3559e61f',
      name: 'Masaliya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e620',
      name: 'Ramgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e621',
      name: 'Ranishwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e622',
      name: 'Saraiyahat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e623',
      name: 'Sikaripara',
    },
  ],
  'East Singhbhum': [
    {
      _id: '60ab6e9586ed1c1a3559e624',
      name: 'Bahragora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e625',
      name: 'Boram',
    },
    {
      _id: '60ab6e9586ed1c1a3559e626',
      name: 'Chakulia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e628',
      name: 'Dhalbhumgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e629',
      name: 'Dumaria',
    },
    {
      _id: '60ab6e9586ed1c1a3559e62a',
      name: 'Ghatshila',
    },
    {
      _id: '60ab6e9586ed1c1a3559e62b',
      name: 'Gurabanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e62c',
      name: 'Musabani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e62d',
      name: 'Patamda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e62e',
      name: 'Potka',
    },
    {
      _id: '60ab6e9586ed1c1a3559e63d',
      name: 'Golmuri Cum Jugsalai',
    },
  ],
  Garhwa: [
    {
      _id: '60ab6e9586ed1c1a3559e62f',
      name: 'Bardiha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e630',
      name: 'Bargad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e631',
      name: 'Bhandaria',
    },
    {
      _id: '60ab6e9586ed1c1a3559e632',
      name: 'Bhawnathpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e633',
      name: 'Bishunpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e634',
      name: 'Chinia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e635',
      name: 'Danda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e636',
      name: 'Dandai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e637',
      name: 'Dhurki',
    },
    {
      _id: '60ab6e9586ed1c1a3559e638',
      name: 'Garhwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e639',
      name: 'Kandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e63a',
      name: 'Ketar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e63b',
      name: 'Kharaundhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e63c',
      name: 'Manjhiaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e63e',
      name: 'Meral',
    },
    {
      _id: '60ab6e9586ed1c1a3559e63f',
      name: 'Nagar Untari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e640',
      name: 'Ramkanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e641',
      name: 'Ranka',
    },
    {
      _id: '60ab6e9586ed1c1a3559e642',
      name: 'Sagma',
    },
    {
      _id: '60ab6e9586ed1c1a3559e653',
      name: 'Ramna',
    },
  ],
  Giridih: [
    {
      _id: '60ab6e9586ed1c1a3559e643',
      name: 'Bagodar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e644',
      name: 'Bengabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e645',
      name: 'Birni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e646',
      name: 'Deori',
    },
    {
      _id: '60ab6e9586ed1c1a3559e647',
      name: 'Dhanwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e648',
      name: 'Dumri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e649',
      name: 'Gandey',
    },
    {
      _id: '60ab6e9586ed1c1a3559e64a',
      name: 'Gawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e64b',
      name: 'Giridih',
    },
    {
      _id: '60ab6e9586ed1c1a3559e64c',
      name: 'Jamua',
    },
    {
      _id: '60ab6e9586ed1c1a3559e64d',
      name: 'Pirtand',
    },
    {
      _id: '60ab6e9586ed1c1a3559e64e',
      name: 'Suriya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e64f',
      name: 'Tisri',
    },
  ],
  Godda: [
    {
      _id: '60ab6e9586ed1c1a3559e650',
      name: 'Basantray',
    },
    {
      _id: '60ab6e9586ed1c1a3559e651',
      name: 'Boarijor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e652',
      name: 'Godda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e654',
      name: 'Mahagama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e655',
      name: 'Meharma',
    },
    {
      _id: '60ab6e9586ed1c1a3559e656',
      name: 'Pathargama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e657',
      name: 'Sundarpahari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e658',
      name: 'Thakurgangti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e669',
      name: 'Poraiyahat',
    },
  ],
  Gumla: [
    {
      _id: '60ab6e9586ed1c1a3559e659',
      name: 'Albert Ekka',
    },
    {
      _id: '60ab6e9586ed1c1a3559e65a',
      name: 'Basia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e65b',
      name: 'Bharno',
    },
    {
      _id: '60ab6e9586ed1c1a3559e65c',
      name: 'Bishunpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e65d',
      name: 'Chainpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e65e',
      name: 'Dumri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e65f',
      name: 'Ghaghra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e660',
      name: 'Gumla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e661',
      name: 'Kamdara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e662',
      name: 'Palkot',
    },
    {
      _id: '60ab6e9586ed1c1a3559e663',
      name: 'Raidih',
    },
    {
      _id: '60ab6e9586ed1c1a3559e664',
      name: 'Sisai',
    },
  ],
  Hazaribagh: [
    {
      _id: '60ab6e9586ed1c1a3559e665',
      name: 'Barhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e666',
      name: 'Barkagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e667',
      name: 'Barkatha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e668',
      name: 'Bishnugarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e66a',
      name: 'Chalkusha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e66b',
      name: 'Chouparan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e66c',
      name: 'Churchu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e66d',
      name: 'Daru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e66e',
      name: 'Ichak',
    },
    {
      _id: '60ab6e9586ed1c1a3559e66f',
      name: 'Katkamdag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e670',
      name: 'Katkamsandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e671',
      name: 'Keredari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e672',
      name: 'Padma',
    },
    {
      _id: '60ab6e9586ed1c1a3559e673',
      name: 'Sadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e674',
      name: 'Tatijhariya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e67f',
      name: 'Dadi',
    },
  ],
  Jamtara: [
    {
      _id: '60ab6e9586ed1c1a3559e675',
      name: 'Fatehpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e676',
      name: 'Jamtara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e677',
      name: 'Karmatanr Vidyasagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e678',
      name: 'Kundhit',
    },
    {
      _id: '60ab6e9586ed1c1a3559e679',
      name: 'Nala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e67a',
      name: 'Narayanpur',
    },
  ],
  Khunti: [
    {
      _id: '60ab6e9586ed1c1a3559e67b',
      name: 'Arki',
    },
    {
      _id: '60ab6e9586ed1c1a3559e67c',
      name: 'Karra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e67d',
      name: 'Khunti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e67e',
      name: 'Murhu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e680',
      name: 'Rania',
    },
    {
      _id: '60ab6e9586ed1c1a3559e681',
      name: 'Torpa',
    },
  ],
  Koderma: [
    {
      _id: '60ab6e9586ed1c1a3559e682',
      name: 'Chandwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e683',
      name: 'Jainagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e684',
      name: 'Koderma',
    },
    {
      _id: '60ab6e9586ed1c1a3559e685',
      name: 'Markacho',
    },
    {
      _id: '60ab6e9586ed1c1a3559e686',
      name: 'Satgawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e695',
      name: 'Domchanch',
    },
  ],
  Latehar: [
    {
      _id: '60ab6e9586ed1c1a3559e687',
      name: 'Balumath',
    },
    {
      _id: '60ab6e9586ed1c1a3559e688',
      name: 'Bariyatu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e689',
      name: 'Barwadih',
    },
    {
      _id: '60ab6e9586ed1c1a3559e68a',
      name: 'Chandwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e68b',
      name: 'Garu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e68c',
      name: 'Herhanj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e68d',
      name: 'Latehar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e68e',
      name: 'Mahuadanr',
    },
    {
      _id: '60ab6e9586ed1c1a3559e68f',
      name: 'Manika',
    },
    {
      _id: '60ab6e9586ed1c1a3559e690',
      name: 'Saryu',
    },
  ],
  Lohardaga: [
    {
      _id: '60ab6e9586ed1c1a3559e691',
      name: 'Bhandra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e692',
      name: 'Kairo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e693',
      name: 'Kisko',
    },
    {
      _id: '60ab6e9586ed1c1a3559e694',
      name: 'Kuru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e696',
      name: 'Lohardaga',
    },
    {
      _id: '60ab6e9586ed1c1a3559e697',
      name: 'Peshrar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e698',
      name: 'Senha',
    },
  ],
  Pakur: [
    {
      _id: '60ab6e9586ed1c1a3559e699',
      name: 'Hiranpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e69a',
      name: 'Littipara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e69b',
      name: 'Maheshpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e69c',
      name: 'Pakur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e69d',
      name: 'Pakuria',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ab',
      name: 'Amrapara',
    },
  ],
  Palamu: [
    {
      _id: '60ab6e9586ed1c1a3559e69e',
      name: 'Bishrampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e69f',
      name: 'Chainpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a0',
      name: 'Chhatarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a1',
      name: 'Haidernagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a2',
      name: 'Hariharganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a3',
      name: 'Hussainabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a4',
      name: 'Lesliganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a5',
      name: 'Manatu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a6',
      name: 'Medininagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a7',
      name: 'Mohamadganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a8',
      name: 'Nawa Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6a9',
      name: 'Nawdiha Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6aa',
      name: 'Padwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ac',
      name: 'Pandu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ad',
      name: 'Panki',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ae',
      name: 'Patan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6af',
      name: 'Ramgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6b0',
      name: 'Satbarwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6b1',
      name: 'Tarhasi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6b2',
      name: 'Untari Road',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c1',
      name: 'Pipra',
    },
  ],
  Ramgarh: [
    {
      _id: '60ab6e9586ed1c1a3559e6b3',
      name: 'Chitarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6b4',
      name: 'Dulmi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6b5',
      name: 'Gola',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6b6',
      name: 'Mandu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6b7',
      name: 'Patratu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6b8',
      name: 'Ramgarh',
    },
  ],
  Ranchi: [
    {
      _id: '60ab6e9586ed1c1a3559e6b9',
      name: 'Angara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ba',
      name: 'Bero',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6bb',
      name: 'Bundu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6bc',
      name: 'Burmu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6bd',
      name: 'Chanho',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6be',
      name: 'Itki',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6bf',
      name: 'Kanke',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c0',
      name: 'Khelari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c2',
      name: 'Lapung',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c3',
      name: 'Mandar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c4',
      name: 'Nagri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c5',
      name: 'Ormanjhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c6',
      name: 'Rahe',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c7',
      name: 'Ratu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c8',
      name: 'Silli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6c9',
      name: 'Sonahatu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ca',
      name: 'Tamar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d7',
      name: 'Namkum',
    },
  ],
  Sahibganj: [
    {
      _id: '60ab6e9586ed1c1a3559e6cb',
      name: 'Barhait',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6cc',
      name: 'Barharwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6cd',
      name: 'Borio',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ce',
      name: 'Mandro',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6cf',
      name: 'Pathna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d0',
      name: 'Rajmahal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d1',
      name: 'Sahibganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d2',
      name: 'Taljhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d3',
      name: 'Udhwa',
    },
  ],
  'Seraikela-Kharsawan': [
    {
      _id: '60ab6e9586ed1c1a3559e6d4',
      name: 'Chandil',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d5',
      name: 'Gamharia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d6',
      name: 'Ichagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d8',
      name: 'Kharsawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6d9',
      name: 'Kuchai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6da',
      name: 'Kukru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6db',
      name: 'Rajnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6dc',
      name: 'Seraikella',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ed',
      name: 'Nimdih',
    },
  ],
  Simdega: [
    {
      _id: '60ab6e9586ed1c1a3559e6dd',
      name: 'Bano',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6de',
      name: 'Bansjore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6df',
      name: 'Bolba',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e0',
      name: 'Jaldega',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e1',
      name: 'Kersai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e2',
      name: 'Kolebira',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e3',
      name: 'Kurdeg',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e4',
      name: 'Pakartanr',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e5',
      name: 'Simdega',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e6',
      name: 'Thethaitanger',
    },
  ],
  'West Singhbhum': [
    {
      _id: '60ab6e9586ed1c1a3559e6e7',
      name: 'Anandpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e8',
      name: 'Bandgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6e9',
      name: 'Chaibasa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ea',
      name: 'Chakradharpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6eb',
      name: 'Goelkera',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ec',
      name: 'Gudri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ee',
      name: 'Hatgamharia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ef',
      name: 'Jagannathpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f0',
      name: 'Jhinkpani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f1',
      name: 'Kumardungi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f2',
      name: 'Manjhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f3',
      name: 'Manjhgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f4',
      name: 'Manoharpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f5',
      name: 'Noamundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f6',
      name: 'Sonua',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f7',
      name: 'Tantnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6f8',
      name: 'Tonto',
    },
    {
      _id: '60ab6e9586ed1c1a3559e703',
      name: 'Khuntpani',
    },
  ],
  Bagalkote: [
    {
      _id: '60ab6e9586ed1c1a3559e6f9',
      name: 'Badami',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6fa',
      name: 'Bagalkot',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6fb',
      name: 'Bilagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6fc',
      name: 'Guledagudda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6fd',
      name: 'Hungund',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6fe',
      name: 'Ilkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e6ff',
      name: 'Jamkhandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e700',
      name: 'Mudhol',
    },
    {
      _id: '60ab6e9586ed1c1a3559e701',
      name: 'Rabakavi Banahatti',
    },
  ],
  Ballari: [
    {
      _id: '60ab6e9586ed1c1a3559e702',
      name: 'Ballari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e704',
      name: 'Hadagalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e705',
      name: 'Hagaribommanahalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e706',
      name: 'Harappanahalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e707',
      name: 'Kampli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e708',
      name: 'Kottur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e709',
      name: 'Kudligi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e70a',
      name: 'Kurugodu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e70b',
      name: 'Sandur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e70c',
      name: 'Siruguppa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e719',
      name: 'Hosapete',
    },
  ],
  Belagavi: [
    {
      _id: '60ab6e9586ed1c1a3559e70d',
      name: 'Athni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e70e',
      name: 'Belagavi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e70f',
      name: 'Bylahongal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e710',
      name: 'Chikodi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e711',
      name: 'Gokak',
    },
    {
      _id: '60ab6e9586ed1c1a3559e712',
      name: 'Hukeri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e713',
      name: 'Kagawada',
    },
    {
      _id: '60ab6e9586ed1c1a3559e714',
      name: 'Khanapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e715',
      name: 'Kittur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e716',
      name: 'Mudalagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e717',
      name: 'Nippani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e718',
      name: 'Ramdurg',
    },
    {
      _id: '60ab6e9586ed1c1a3559e71a',
      name: 'Raybag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e71b',
      name: 'Savadathi',
    },
  ],
  'Bengaluru Rural': [
    {
      _id: '60ab6e9586ed1c1a3559e71c',
      name: 'Devanhalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e71d',
      name: 'Hoskote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e71e',
      name: 'Nelamangala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e72f',
      name: 'Dodballapur',
    },
  ],
  'Bengaluru Urban': [
    {
      _id: '60ab6e9586ed1c1a3559e71f',
      name: 'Anekal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e720',
      name: 'Bengaluru East',
    },
    {
      _id: '60ab6e9586ed1c1a3559e721',
      name: 'Bengaluru North',
    },
    {
      _id: '60ab6e9586ed1c1a3559e722',
      name: 'Bengaluru South',
    },
    {
      _id: '60ab6e9586ed1c1a3559e723',
      name: 'Yelahanka',
    },
  ],
  Bidar: [
    {
      _id: '60ab6e9586ed1c1a3559e724',
      name: 'Aurad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e725',
      name: 'Basavakalyan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e726',
      name: 'Bhalki',
    },
    {
      _id: '60ab6e9586ed1c1a3559e727',
      name: 'Bidar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e728',
      name: 'Chittaguppa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e729',
      name: 'Hulasuru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e72a',
      name: 'Humnabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e72b',
      name: 'Kamalanagara',
    },
  ],
  Chamarajanagara: [
    {
      _id: '60ab6e9586ed1c1a3559e72c',
      name: 'Chamarajanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e72d',
      name: 'Gundlupet',
    },
    {
      _id: '60ab6e9586ed1c1a3559e72e',
      name: 'Hanuru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e730',
      name: 'Kollegala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e731',
      name: 'Yelandur',
    },
  ],
  Chikkaballapura: [
    {
      _id: '60ab6e9586ed1c1a3559e732',
      name: 'Bagepalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e733',
      name: 'Chintamani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e734',
      name: 'Gauribidanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e735',
      name: 'Gudibanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e736',
      name: 'Sidlaghatta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e745',
      name: 'Chikballapur',
    },
  ],
  Chikkamagaluru: [
    {
      _id: '60ab6e9586ed1c1a3559e737',
      name: 'Ajjampura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e738',
      name: 'Chikkamagaluru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e739',
      name: 'Kadur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e73a',
      name: 'Koppa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e73b',
      name: 'Mudigere',
    },
    {
      _id: '60ab6e9586ed1c1a3559e73c',
      name: 'Narasimharajapura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e73d',
      name: 'Sringeri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e73e',
      name: 'Tarikere',
    },
  ],
  Chitradurga: [
    {
      _id: '60ab6e9586ed1c1a3559e73f',
      name: 'Challakere',
    },
    {
      _id: '60ab6e9586ed1c1a3559e740',
      name: 'Chitradurga',
    },
    {
      _id: '60ab6e9586ed1c1a3559e741',
      name: 'Hiriyur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e742',
      name: 'Holalkere',
    },
    {
      _id: '60ab6e9586ed1c1a3559e743',
      name: 'Hosdurga',
    },
    {
      _id: '60ab6e9586ed1c1a3559e744',
      name: 'Molakalmuru',
    },
  ],
  'Dakshina Kannada': [
    {
      _id: '60ab6e9586ed1c1a3559e746',
      name: 'Bantval',
    },
    {
      _id: '60ab6e9586ed1c1a3559e747',
      name: 'Beltangadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e748',
      name: 'Kadaba',
    },
    {
      _id: '60ab6e9586ed1c1a3559e749',
      name: 'Mudubidare',
    },
    {
      _id: '60ab6e9586ed1c1a3559e74a',
      name: 'Puttur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e74b',
      name: 'Sulya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e75b',
      name: 'Mangaluru',
    },
  ],
  Davangere: [
    {
      _id: '60ab6e9586ed1c1a3559e74c',
      name: 'Channagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e74d',
      name: 'Davanagere',
    },
    {
      _id: '60ab6e9586ed1c1a3559e74e',
      name: 'Harihara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e74f',
      name: 'Honnali',
    },
    {
      _id: '60ab6e9586ed1c1a3559e750',
      name: 'Jagalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e751',
      name: 'Nyamathi',
    },
  ],
  Dharwad: [
    {
      _id: '60ab6e9586ed1c1a3559e752',
      name: 'Alnavar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e753',
      name: 'Annigeri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e754',
      name: 'Dharwad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e755',
      name: 'Hubali Urban',
    },
    {
      _id: '60ab6e9586ed1c1a3559e756',
      name: 'Hubballi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e757',
      name: 'Kalghatgi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e758',
      name: 'Kundgol',
    },
    {
      _id: '60ab6e9586ed1c1a3559e759',
      name: 'Navalgund',
    },
  ],
  Gadag: [
    {
      _id: '60ab6e9586ed1c1a3559e75a',
      name: 'Gadag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e75c',
      name: 'Gajendragad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e75d',
      name: 'Laxmeshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e75e',
      name: 'Mundaragi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e75f',
      name: 'Ron',
    },
    {
      _id: '60ab6e9586ed1c1a3559e760',
      name: 'Shirahatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e771',
      name: 'Naragund',
    },
  ],
  Hassan: [
    {
      _id: '60ab6e9586ed1c1a3559e761',
      name: 'Alur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e762',
      name: 'Arkalgud',
    },
    {
      _id: '60ab6e9586ed1c1a3559e763',
      name: 'Arsikere',
    },
    {
      _id: '60ab6e9586ed1c1a3559e764',
      name: 'Belur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e765',
      name: 'Channarayapatna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e766',
      name: 'Hassan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e767',
      name: 'Holenarsipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e768',
      name: 'Sakaleshpur',
    },
  ],
  Haveri: [
    {
      _id: '60ab6e9586ed1c1a3559e769',
      name: 'Byadgi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e76a',
      name: 'Hanagal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e76b',
      name: 'Haveri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e76c',
      name: 'Hirekerur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e76d',
      name: 'Ranebennur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e76e',
      name: 'Rattihalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e76f',
      name: 'Savanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e770',
      name: 'Shiggaon',
    },
  ],
  Kalaburagi: [
    {
      _id: '60ab6e9586ed1c1a3559e772',
      name: 'Afzalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e773',
      name: 'Aland',
    },
    {
      _id: '60ab6e9586ed1c1a3559e774',
      name: 'Chincholi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e775',
      name: 'Jevargi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e776',
      name: 'Kalaburagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e777',
      name: 'Kalagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e778',
      name: 'Kamalapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e779',
      name: 'Sedam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e77a',
      name: 'Shabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e77b',
      name: 'Yadrami',
    },
    {
      _id: '60ab6e9586ed1c1a3559e787',
      name: 'Chitapur',
    },
  ],
  Kodagu: [
    {
      _id: '60ab6e9586ed1c1a3559e77c',
      name: 'Madikeri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e77d',
      name: 'Somvarpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559e77e',
      name: 'Virajpet',
    },
  ],
  Kolar: [
    {
      _id: '60ab6e9586ed1c1a3559e77f',
      name: 'Bangarapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559e780',
      name: 'K G F',
    },
    {
      _id: '60ab6e9586ed1c1a3559e781',
      name: 'Kolar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e782',
      name: 'Malur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e783',
      name: 'Mulbagal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e784',
      name: 'Srinivaspur',
    },
  ],
  Koppal: [
    {
      _id: '60ab6e9586ed1c1a3559e785',
      name: 'Gangavathi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e786',
      name: 'Kanakagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e788',
      name: 'Karatagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e789',
      name: 'Koppal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e78a',
      name: 'Kukunoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e78b',
      name: 'Yelburga',
    },
    {
      _id: '60ab6e9586ed1c1a3559e79d',
      name: 'Kushtagi',
    },
  ],
  Mandya: [
    {
      _id: '60ab6e9586ed1c1a3559e78c',
      name: 'Krishnarajpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559e78d',
      name: 'Maddur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e78e',
      name: 'Malvalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e78f',
      name: 'Mandya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e790',
      name: 'Nagamangala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e791',
      name: 'Pandavapura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e792',
      name: 'Shrirangapattana',
    },
  ],
  Mysuru: [
    {
      _id: '60ab6e9586ed1c1a3559e793',
      name: 'Heggadadevankote',
    },
    {
      _id: '60ab6e9586ed1c1a3559e794',
      name: 'Hunsur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e795',
      name: 'Krishnarajanagara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e796',
      name: 'Mysuru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e797',
      name: 'Nanjangud',
    },
    {
      _id: '60ab6e9586ed1c1a3559e798',
      name: 'Piriyapatna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e799',
      name: 'Saraguru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e79a',
      name: 'Tirumakudal-Narsipur',
    },
  ],
  Raichur: [
    {
      _id: '60ab6e9586ed1c1a3559e79b',
      name: 'Devadurga',
    },
    {
      _id: '60ab6e9586ed1c1a3559e79c',
      name: 'Lingsugur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e79e',
      name: 'Manvi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e79f',
      name: 'Maski',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7a0',
      name: 'Raichur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7a1',
      name: 'Sirawara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b3',
      name: 'Sindhanur',
    },
  ],
  Ramanagara: [
    {
      _id: '60ab6e9586ed1c1a3559e7a2',
      name: 'Channapatna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7a3',
      name: 'Kanakapura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7a4',
      name: 'Magadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7a5',
      name: 'Ramanagara',
    },
  ],
  Shivamogga: [
    {
      _id: '60ab6e9586ed1c1a3559e7a6',
      name: 'Bhadravati',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7a7',
      name: 'Hosanagara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7a8',
      name: 'Sagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7a9',
      name: 'Shikarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7aa',
      name: 'Shivamogga',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ab',
      name: 'Sorab',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ac',
      name: 'Tirthahalli',
    },
  ],
  Tumakuru: [
    {
      _id: '60ab6e9586ed1c1a3559e7ad',
      name: 'Chiknayakanhalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ae',
      name: 'Gubbi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7af',
      name: 'Koratagere',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b0',
      name: 'Kunigal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b1',
      name: 'Madhugiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b2',
      name: 'Pavagada',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b4',
      name: 'Sira',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b5',
      name: 'Tiptur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b6',
      name: 'Tumakuru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c9',
      name: 'Turuvekere',
    },
  ],
  Udupi: [
    {
      _id: '60ab6e9586ed1c1a3559e7b7',
      name: 'Bainduru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b8',
      name: 'Brahmavara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7b9',
      name: 'Hebri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ba',
      name: 'Kapu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7bb',
      name: 'Karkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7bc',
      name: 'Kundapura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7bd',
      name: 'Udupi',
    },
  ],
  'Uttara Kannada': [
    {
      _id: '60ab6e9586ed1c1a3559e7be',
      name: 'Ankola',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7bf',
      name: 'Bhatkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c0',
      name: 'Dandeli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c1',
      name: 'Haliyal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c2',
      name: 'Honavar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c3',
      name: 'Karwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c4',
      name: 'Kumta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c5',
      name: 'Mundgod',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c6',
      name: 'Siddapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c7',
      name: 'Sirsi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7c8',
      name: 'Supa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ca',
      name: 'Yellapur',
    },
  ],
  Vijayapura: [
    {
      _id: '60ab6e9586ed1c1a3559e7cb',
      name: 'Babaleshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7cc',
      name: 'Basavana Bagewadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7cd',
      name: 'Devara Hipparagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ce',
      name: 'Indi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7cf',
      name: 'Kolhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d0',
      name: 'Muddebihal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d1',
      name: 'Nidagundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d2',
      name: 'Sindagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d3',
      name: 'Thalikoti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d4',
      name: 'Thikota',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d5',
      name: 'Vijayapura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7df',
      name: 'Chadachan',
    },
  ],
  Yadgir: [
    {
      _id: '60ab6e9586ed1c1a3559e7d6',
      name: 'Gurumitkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d7',
      name: 'Hunasagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d8',
      name: 'Shahapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7d9',
      name: 'Shorapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7da',
      name: 'Wadagera',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7db',
      name: 'Yadgir',
    },
  ],
  Alappuzha: [
    {
      _id: '60ab6e9586ed1c1a3559e7dc',
      name: 'Ambalappuzha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7dd',
      name: 'Aryad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7de',
      name: 'Bharanicavu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e0',
      name: 'Champakulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e1',
      name: 'Chengannur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e2',
      name: 'Harippad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e3',
      name: 'Mavelikkara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e4',
      name: 'Muthukulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e5',
      name: 'Pattanakkad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e6',
      name: 'Thycattussery',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e7',
      name: 'Veliyanad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f6',
      name: 'Kanjikkuzhy',
    },
  ],
  Ernakulam: [
    {
      _id: '60ab6e9586ed1c1a3559e7e8',
      name: 'Alangad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7e9',
      name: 'Angamali',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ea',
      name: 'Edappally',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7eb',
      name: 'Koovappady',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ec',
      name: 'Kothamangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ee',
      name: 'Mulanthuruthy',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ef',
      name: 'Muvattupuzha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f0',
      name: 'Palluruthy',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f1',
      name: 'Pampakuda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f2',
      name: 'Parakkadav',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f3',
      name: 'Paravur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f4',
      name: 'Vadavucode',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f5',
      name: 'Vazhakkulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f7',
      name: 'Vypeen',
    },
  ],
  Idukki: [
    {
      _id: '60ab6e9586ed1c1a3559e7f8',
      name: 'Adimaly',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7f9',
      name: 'Azhutha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7fa',
      name: 'Devikulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7fb',
      name: 'Elemdesam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7fc',
      name: 'Idukki',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7fd',
      name: 'Kattappana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7fe',
      name: 'Nedumkandom',
    },
    {
      _id: '60ab6e9586ed1c1a3559e7ff',
      name: 'Thodupuzha',
    },
  ],
  Kannur: [
    {
      _id: '60ab6e9586ed1c1a3559e800',
      name: 'Edakkad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e801',
      name: 'Irikkur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e802',
      name: 'Iritty',
    },
    {
      _id: '60ab6e9586ed1c1a3559e803',
      name: 'Kalliasseri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e804',
      name: 'Kuthuparamba',
    },
    {
      _id: '60ab6e9586ed1c1a3559e805',
      name: 'Kannur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e806',
      name: 'Panoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e807',
      name: 'Payyannur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e808',
      name: 'Peravoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e809',
      name: 'Thalassery',
    },
    {
      _id: '60ab6e9586ed1c1a3559e80c',
      name: 'Taliparamba',
    },
  ],
  Kasaragod: [
    {
      _id: '60ab6e9586ed1c1a3559e80a',
      name: 'Kanhangad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e80b',
      name: 'Karadka',
    },
    {
      _id: '60ab6e9586ed1c1a3559e80d',
      name: 'Kasargod',
    },
    {
      _id: '60ab6e9586ed1c1a3559e80e',
      name: 'Manjeshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e80f',
      name: 'Parappa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e811',
      name: 'Nileshwar',
    },
  ],
  Kollam: [
    {
      _id: '60ab6e9586ed1c1a3559e810',
      name: 'Anchal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e812',
      name: 'Chadayamangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e813',
      name: 'Chavara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e814',
      name: 'Ithikkara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e815',
      name: 'Kottarakkara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e816',
      name: 'Chittumala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e817',
      name: 'Mukhathala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e818',
      name: 'Oachira',
    },
    {
      _id: '60ab6e9586ed1c1a3559e819',
      name: 'Sasthamcottah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e81a',
      name: 'Vettikkavala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e81c',
      name: 'Pathanapuram',
    },
  ],
  Kottayam: [
    {
      _id: '60ab6e9586ed1c1a3559e81b',
      name: 'Erattupetta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e81d',
      name: 'Ettumanoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e81e',
      name: 'Kanjirappally',
    },
    {
      _id: '60ab6e9586ed1c1a3559e81f',
      name: 'Lalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e820',
      name: 'Madappally',
    },
    {
      _id: '60ab6e9586ed1c1a3559e821',
      name: 'Pallom',
    },
    {
      _id: '60ab6e9586ed1c1a3559e822',
      name: 'Pampady',
    },
    {
      _id: '60ab6e9586ed1c1a3559e823',
      name: 'Uzhavoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e824',
      name: 'Vaikom',
    },
    {
      _id: '60ab6e9586ed1c1a3559e825',
      name: 'Vazhoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e82d',
      name: 'Kaduthuruthy',
    },
  ],
  Kozhikode: [
    {
      _id: '60ab6e9586ed1c1a3559e826',
      name: 'Balusseri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e827',
      name: 'Chelannur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e828',
      name: 'Koduvally',
    },
    {
      _id: '60ab6e9586ed1c1a3559e829',
      name: 'Kozhikode',
    },
    {
      _id: '60ab6e9586ed1c1a3559e82a',
      name: 'Kunnamangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e82b',
      name: 'Kunnummal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e82c',
      name: 'Melday',
    },
    {
      _id: '60ab6e9586ed1c1a3559e82e',
      name: 'Panthalayani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e82f',
      name: 'Perambra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e830',
      name: 'Thodannur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e831',
      name: 'Thuneri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e832',
      name: 'Vadakara',
    },
  ],
  Malappuram: [
    {
      _id: '60ab6e9586ed1c1a3559e833',
      name: 'Areakode',
    },
    {
      _id: '60ab6e9586ed1c1a3559e834',
      name: 'Kalikavu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e835',
      name: 'Kondotty',
    },
    {
      _id: '60ab6e9586ed1c1a3559e836',
      name: 'Kuttippuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559e837',
      name: 'Malappuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559e838',
      name: 'Mankada',
    },
    {
      _id: '60ab6e9586ed1c1a3559e839',
      name: 'Nilambur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e83a',
      name: 'Perinthalmanna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e83b',
      name: 'Perumpadappu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e83c',
      name: 'Tanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e83d',
      name: 'Tirur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e83e',
      name: 'Tirurangadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e83f',
      name: 'Vengara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e840',
      name: 'Wandoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e848',
      name: 'Ponnani',
    },
  ],
  Palakkad: [
    {
      _id: '60ab6e9586ed1c1a3559e841',
      name: 'Alathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e842',
      name: 'Attappadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e843',
      name: 'Chittur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e844',
      name: 'Kollengode',
    },
    {
      _id: '60ab6e9586ed1c1a3559e845',
      name: 'Kuzhalmannam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e846',
      name: 'Malampuzha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e847',
      name: 'Mannarkad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e849',
      name: 'Ottappalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e84a',
      name: 'Palakkad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e84b',
      name: 'Pattambi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e84c',
      name: 'Nemmara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e84d',
      name: 'Trithala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e84e',
      name: 'Sreekrishnapuram',
    },
  ],
  Pathanamthitta: [
    {
      _id: '60ab6e9586ed1c1a3559e84f',
      name: 'Elanthoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e850',
      name: 'Koipuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559e851',
      name: 'Konni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e852',
      name: 'Pandlam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e853',
      name: 'Parakode',
    },
    {
      _id: '60ab6e9586ed1c1a3559e854',
      name: 'Pulikeezhu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e855',
      name: 'Ranni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e856',
      name: 'Mallappally',
    },
  ],
  Thiruvananthapuram: [
    {
      _id: '60ab6e9586ed1c1a3559e857',
      name: 'Chirayinkeezhu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e858',
      name: 'Athiyannoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e859',
      name: 'Kilimanoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559e85a',
      name: 'Nedumangad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e85b',
      name: 'Nemom',
    },
    {
      _id: '60ab6e9586ed1c1a3559e85c',
      name: 'Parassala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e85d',
      name: 'Pothencode',
    },
    {
      _id: '60ab6e9586ed1c1a3559e85e',
      name: 'Perumkadavila',
    },
    {
      _id: '60ab6e9586ed1c1a3559e85f',
      name: 'Vamanapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559e860',
      name: 'Varkala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e861',
      name: 'Vellanad',
    },
  ],
  Thrissur: [
    {
      _id: '60ab6e9586ed1c1a3559e862',
      name: 'Chalakkudy',
    },
    {
      _id: '60ab6e9586ed1c1a3559e863',
      name: 'Anthikkad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e864',
      name: 'Cherpu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e865',
      name: 'Chavakkad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e866',
      name: 'Irinjalakkuda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e867',
      name: 'Chowannur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e868',
      name: 'Kodakara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e869',
      name: 'Mala',
    },
    {
      _id: '60ab6e9586ed1c1a3559e86a',
      name: 'Mathilakam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e86b',
      name: 'Mullassery',
    },
    {
      _id: '60ab6e9586ed1c1a3559e86c',
      name: 'Ollukkara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e86d',
      name: 'Pazhayannur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e86e',
      name: 'Puzhakkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e86f',
      name: 'Thalikkulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e870',
      name: 'Wadakkanchery',
    },
    {
      _id: '60ab6e9586ed1c1a3559e873',
      name: 'Vellangallur',
    },
  ],
  Wayanad: [
    {
      _id: '60ab6e9586ed1c1a3559e871',
      name: 'Kalpetta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e872',
      name: 'Mananthavady',
    },
    {
      _id: '60ab6e9586ed1c1a3559e874',
      name: 'Sulthan Bathery',
    },
    {
      _id: '60ab6e9586ed1c1a3559e878',
      name: 'Panamaram',
    },
  ],
  Kargil: [
    {
      _id: '60ab6e9586ed1c1a3559e875',
      name: 'Barsoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e876',
      name: 'Bhimbat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e877',
      name: 'Drass',
    },
    {
      _id: '60ab6e9586ed1c1a3559e879',
      name: 'Gm Pora (Trespone)',
    },
    {
      _id: '60ab6e9586ed1c1a3559e87a',
      name: 'Karsha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e87b',
      name: 'Lotsum',
    },
    {
      _id: '60ab6e9586ed1c1a3559e87c',
      name: 'Kargil',
    },
    {
      _id: '60ab6e9586ed1c1a3559e87d',
      name: 'Pashkum',
    },
    {
      _id: '60ab6e9586ed1c1a3559e87e',
      name: 'Sankoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e87f',
      name: 'Shaker Chaktan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e880',
      name: 'Lungnak',
    },
    {
      _id: '60ab6e9586ed1c1a3559e881',
      name: 'Shargol',
    },
    {
      _id: '60ab6e9586ed1c1a3559e882',
      name: 'Soudh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e883',
      name: 'Taisuru',
    },
    {
      _id: '60ab6e9586ed1c1a3559e886',
      name: 'Zansker',
    },
  ],
  'Leh Ladakh': [
    {
      _id: '60ab6e9586ed1c1a3559e884',
      name: 'Chuchot',
    },
    {
      _id: '60ab6e9586ed1c1a3559e885',
      name: 'Deskit',
    },
    {
      _id: '60ab6e9586ed1c1a3559e887',
      name: 'Khaltsi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e888',
      name: 'Kharu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e889',
      name: 'Leh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e88a',
      name: 'Nimoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559e88b',
      name: 'Nyoma',
    },
    {
      _id: '60ab6e9586ed1c1a3559e88c',
      name: 'Panamic',
    },
    {
      _id: '60ab6e9586ed1c1a3559e88d',
      name: 'Rong',
    },
    {
      _id: '60ab6e9586ed1c1a3559e88e',
      name: 'Rupsho',
    },
    {
      _id: '60ab6e9586ed1c1a3559e88f',
      name: 'Saspol',
    },
    {
      _id: '60ab6e9586ed1c1a3559e890',
      name: 'Durbuk',
    },
    {
      _id: '60ab6e9586ed1c1a3559e891',
      name: 'Singay Lalok Wanla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e892',
      name: 'Sukerbachan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e893',
      name: 'Thiksay',
    },
    {
      _id: '60ab6e9586ed1c1a3559e894',
      name: 'Turtuk',
    },
  ],
  'Lakshadweep District': [
    {
      _id: '60ab6e9586ed1c1a3559e895',
      name: 'Agatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e896',
      name: 'Andrott',
    },
    {
      _id: '60ab6e9586ed1c1a3559e897',
      name: 'Bitra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e898',
      name: 'Chetlat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e899',
      name: 'Kadmat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e89a',
      name: 'Amini',
    },
    {
      _id: '60ab6e9586ed1c1a3559e89b',
      name: 'Kalpeni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e89c',
      name: 'Kavaratti',
    },
    {
      _id: '60ab6e9586ed1c1a3559e89d',
      name: 'Kiltan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8a1',
      name: 'Minicoy',
    },
  ],
  'Agar Malwa': [
    {
      _id: '60ab6e9586ed1c1a3559e89e',
      name: 'Agar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e89f',
      name: 'Barod',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8a0',
      name: 'Nalkheda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8a2',
      name: 'Susner',
    },
  ],
  Alirajpur: [
    {
      _id: '60ab6e9586ed1c1a3559e8a3',
      name: 'Alirajpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8a4',
      name: 'Bhabra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8a5',
      name: 'Jobat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8a6',
      name: 'Katthiwada',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8a7',
      name: 'Sondwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8a9',
      name: 'Udaigarh',
    },
  ],
  Anuppur: [
    {
      _id: '60ab6e9586ed1c1a3559e8a8',
      name: 'Anuppur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8aa',
      name: 'Jaithari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ab',
      name: 'Kotma',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ac',
      name: 'Pushprajgarh',
    },
  ],
  Ashoknagar: [
    {
      _id: '60ab6e9586ed1c1a3559e8ad',
      name: 'Ashoknagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ae',
      name: 'Chanderi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8af',
      name: 'Isagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b0',
      name: 'Mungaoli',
    },
  ],
  Balaghat: [
    {
      _id: '60ab6e9586ed1c1a3559e8b1',
      name: 'Baihar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b2',
      name: 'Balaghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b3',
      name: 'Birsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b4',
      name: 'Katangi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b5',
      name: 'Khairlanji',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b6',
      name: 'Kirnapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b7',
      name: 'Lanji',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b8',
      name: 'Paraswada',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8b9',
      name: 'Waraseoni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8bb',
      name: 'Lalbarra',
    },
  ],
  Barwani: [
    {
      _id: '60ab6e9586ed1c1a3559e8ba',
      name: 'Barwani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8bc',
      name: 'Newali',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8bd',
      name: 'Pansemal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8be',
      name: 'Pati',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8bf',
      name: 'Rajpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c0',
      name: 'Thikri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c7',
      name: 'Sendhawa',
    },
  ],
  Betul: [
    {
      _id: '60ab6e9586ed1c1a3559e8c1',
      name: 'Amla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c2',
      name: 'Athner',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c3',
      name: 'Betul',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c4',
      name: 'Bhainsdehi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c5',
      name: 'Bhimpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c6',
      name: 'Chicholi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c8',
      name: 'Ghoradongri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8c9',
      name: 'Multai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ca',
      name: 'Shahpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ce',
      name: 'Prabhat Pattan',
    },
  ],
  Bhind: [
    {
      _id: '60ab6e9586ed1c1a3559e8cb',
      name: 'Ater',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8cc',
      name: 'Bhind',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8cd',
      name: 'Gohad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8cf',
      name: 'Lahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8d0',
      name: 'Mehgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8d1',
      name: 'Raon',
    },
  ],
  Bhopal: [
    {
      _id: '60ab6e9586ed1c1a3559e8d2',
      name: 'Berasia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8df',
      name: 'Phanda',
    },
  ],
  Burhanpur: [
    {
      _id: '60ab6e9586ed1c1a3559e8d3',
      name: 'Burhanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8d4',
      name: 'Khaknar',
    },
  ],
  Chhatarpur: [
    {
      _id: '60ab6e9586ed1c1a3559e8d5',
      name: 'Bada Malehara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8d6',
      name: 'Barigarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8d7',
      name: 'Bijawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8d8',
      name: 'Buxwaha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8d9',
      name: 'Chhatarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8da',
      name: 'Laundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8db',
      name: 'Nowgong',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8dc',
      name: 'Rajnagar',
    },
  ],
  Chhindwara: [
    {
      _id: '60ab6e9586ed1c1a3559e8dd',
      name: 'Amarwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8de',
      name: 'Bichhua',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e0',
      name: 'Chaurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e1',
      name: 'Chhindwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e2',
      name: 'Jamai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e3',
      name: 'Harrai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e4',
      name: 'Mohkhed',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e5',
      name: 'Parasia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e6',
      name: 'Pandhurna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e7',
      name: 'Sausar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8e8',
      name: 'Tamia',
    },
  ],
  Damoh: [
    {
      _id: '60ab6e9586ed1c1a3559e8e9',
      name: 'Damoh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ea',
      name: 'Hatta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8eb',
      name: 'Jabera',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ec',
      name: 'Patera',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ed',
      name: 'Pathariya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ee',
      name: 'Tendukheda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8fb',
      name: 'Batiyagarh',
    },
  ],
  Datia: [
    {
      _id: '60ab6e9586ed1c1a3559e8ef',
      name: 'Bhander',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8f0',
      name: 'Datia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8f1',
      name: 'Seondha',
    },
  ],
  Dewas: [
    {
      _id: '60ab6e9586ed1c1a3559e8f2',
      name: 'Bagli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8f3',
      name: 'Dewas',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8f4',
      name: 'Kannod',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8f5',
      name: 'Khategaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8f6',
      name: 'Sonkatch',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8f7',
      name: 'Tonk Khurd',
    },
  ],
  Dhar: [
    {
      _id: '60ab6e9586ed1c1a3559e8f8',
      name: 'Badnawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8f9',
      name: 'Bagh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8fa',
      name: 'Dahi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8fc',
      name: 'Dhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8fd',
      name: 'Dharampuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8fe',
      name: 'Gandhwani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e8ff',
      name: 'Manawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e900',
      name: 'Nalchha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e901',
      name: 'Nisarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e902',
      name: 'Sardarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e903',
      name: 'Kukshi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e904',
      name: 'Umarban',
    },
    {
      _id: '60ab6e9586ed1c1a3559e905',
      name: 'Tirla',
    },
  ],
  Dindori: [
    {
      _id: '60ab6e9586ed1c1a3559e906',
      name: 'Amarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e907',
      name: 'Bajag',
    },
    {
      _id: '60ab6e9586ed1c1a3559e908',
      name: 'Dindori',
    },
    {
      _id: '60ab6e9586ed1c1a3559e909',
      name: 'Mehandwani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e90a',
      name: 'Karanjiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e90b',
      name: 'Samnapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e90c',
      name: 'Shahpura',
    },
  ],
  'East Nimar': [
    {
      _id: '60ab6e9586ed1c1a3559e90d',
      name: 'Baladi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e90e',
      name: 'Chhaigaon Makhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e90f',
      name: 'Harsud',
    },
    {
      _id: '60ab6e9586ed1c1a3559e910',
      name: 'Khalwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e911',
      name: 'Khandwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e912',
      name: 'Pandhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e913',
      name: 'Punasa',
    },
  ],
  Guna: [
    {
      _id: '60ab6e9586ed1c1a3559e914',
      name: 'Aron',
    },
    {
      _id: '60ab6e9586ed1c1a3559e915',
      name: 'Bamori',
    },
    {
      _id: '60ab6e9586ed1c1a3559e916',
      name: 'Chanchoda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e917',
      name: 'Guna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e91d',
      name: 'Raghogarh',
    },
  ],
  Gwalior: [
    {
      _id: '60ab6e9586ed1c1a3559e918',
      name: 'Bhitarwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e919',
      name: 'Dabra',
    },
    {
      _id: '60ab6e9586ed1c1a3559e91a',
      name: 'Ghatigaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e91b',
      name: 'Morar',
    },
  ],
  Harda: [
    {
      _id: '60ab6e9586ed1c1a3559e91c',
      name: 'Harda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e91e',
      name: 'Khirkiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e91f',
      name: 'Timarni',
    },
  ],
  Hoshangabad: [
    {
      _id: '60ab6e9586ed1c1a3559e920',
      name: 'Babai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e921',
      name: 'Bankhedi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e922',
      name: 'Hoshangabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e923',
      name: 'Kesla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e924',
      name: 'Pipariya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e925',
      name: 'Seoni Malwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e926',
      name: 'Sohagpur',
    },
  ],
  Indore: [
    {
      _id: '60ab6e9586ed1c1a3559e927',
      name: 'Depalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e928',
      name: 'Indore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e929',
      name: 'Mhow',
    },
    {
      _id: '60ab6e9586ed1c1a3559e92a',
      name: 'Sanwer',
    },
  ],
  Jabalpur: [
    {
      _id: '60ab6e9586ed1c1a3559e92b',
      name: 'Kundam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e92c',
      name: 'Majhouli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e92d',
      name: 'Panagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e92e',
      name: 'Patan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e92f',
      name: 'Jabalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e930',
      name: 'Shahpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e931',
      name: 'Sihora',
    },
  ],
  Jhabua: [
    {
      _id: '60ab6e9586ed1c1a3559e932',
      name: 'Jhabua',
    },
    {
      _id: '60ab6e9586ed1c1a3559e933',
      name: 'Meghnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e934',
      name: 'Petlawad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e935',
      name: 'Rama',
    },
    {
      _id: '60ab6e9586ed1c1a3559e936',
      name: 'Ranapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e937',
      name: 'Thandla',
    },
  ],
  Katni: [
    {
      _id: '60ab6e9586ed1c1a3559e938',
      name: 'Badwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e939',
      name: 'Dheemerkheda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e93a',
      name: 'Katni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e93b',
      name: 'Rithi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e93c',
      name: 'Vijayraghavgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e93e',
      name: 'Bahoriband',
    },
  ],
  Khargone: [
    {
      _id: '60ab6e9586ed1c1a3559e93d',
      name: 'Barwah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e93f',
      name: 'Bhagvanpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e940',
      name: 'Bhikangaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e941',
      name: 'Gogawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e942',
      name: 'Khargone',
    },
    {
      _id: '60ab6e9586ed1c1a3559e943',
      name: 'Kasrawad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e944',
      name: 'Maheshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e945',
      name: 'Segaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e946',
      name: 'Ziranya',
    },
  ],
  Mandla: [
    {
      _id: '60ab6e9586ed1c1a3559e947',
      name: 'Bijadandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e948',
      name: 'Ghughri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e949',
      name: 'Mandla',
    },
    {
      _id: '60ab6e9586ed1c1a3559e94a',
      name: 'Mawai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e94b',
      name: 'Mohgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e94c',
      name: 'Nainpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e94d',
      name: 'Narayanganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e94e',
      name: 'Niwas',
    },
    {
      _id: '60ab6e9586ed1c1a3559e94f',
      name: 'Bichhiya',
    },
  ],
  Mandsaur: [
    {
      _id: '60ab6e9586ed1c1a3559e950',
      name: 'Garoth',
    },
    {
      _id: '60ab6e9586ed1c1a3559e951',
      name: 'Bhanpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e952',
      name: 'Malhargarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e953',
      name: 'Mandsaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e954',
      name: 'Sitamau',
    },
  ],
  Morena: [
    {
      _id: '60ab6e9586ed1c1a3559e955',
      name: 'Joura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e956',
      name: 'Kailaras',
    },
    {
      _id: '60ab6e9586ed1c1a3559e957',
      name: 'Morena',
    },
    {
      _id: '60ab6e9586ed1c1a3559e958',
      name: 'Ambah',
    },
    {
      _id: '60ab6e9586ed1c1a3559e959',
      name: 'Pahadgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e95a',
      name: 'Porsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e95e',
      name: 'Sabalgarh',
    },
  ],
  Narsinghpur: [
    {
      _id: '60ab6e9586ed1c1a3559e95b',
      name: 'Babai Chichali',
    },
    {
      _id: '60ab6e9586ed1c1a3559e95c',
      name: 'Chawarpatha',
    },
    {
      _id: '60ab6e9586ed1c1a3559e95d',
      name: 'Gotegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e95f',
      name: 'Kareli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e960',
      name: 'Narsimhapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e961',
      name: 'Sainkheda',
    },
  ],
  Neemuch: [
    {
      _id: '60ab6e9586ed1c1a3559e962',
      name: 'Jawad',
    },
    {
      _id: '60ab6e9586ed1c1a3559e963',
      name: 'Neemuch',
    },
    {
      _id: '60ab6e9586ed1c1a3559e965',
      name: 'Manasa',
    },
  ],
  Niwari: [
    {
      _id: '60ab6e9586ed1c1a3559e964',
      name: 'Niwari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e966',
      name: 'Prithvipur',
    },
  ],
  Panna: [
    {
      _id: '60ab6e9586ed1c1a3559e967',
      name: 'Ajaigarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e968',
      name: 'Panna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e969',
      name: 'Gunour',
    },
    {
      _id: '60ab6e9586ed1c1a3559e96a',
      name: 'Pawai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e96b',
      name: 'Shahnagar',
    },
  ],
  Raisen: [
    {
      _id: '60ab6e9586ed1c1a3559e96c',
      name: 'Badi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e96d',
      name: 'Begamganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e96e',
      name: 'Obaidallaganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e96f',
      name: 'Sanchi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e970',
      name: 'Silwani',
    },
    {
      _id: '60ab6e9586ed1c1a3559e971',
      name: 'Udaipura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e97a',
      name: 'Gairatganj',
    },
  ],
  Rajgarh: [
    {
      _id: '60ab6e9586ed1c1a3559e972',
      name: 'Biaora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e973',
      name: 'Khilchipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e974',
      name: 'Narsinghgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e975',
      name: 'Rajgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e976',
      name: 'Sarangpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e977',
      name: 'Zirapur',
    },
  ],
  Ratlam: [
    {
      _id: '60ab6e9586ed1c1a3559e978',
      name: 'Alot',
    },
    {
      _id: '60ab6e9586ed1c1a3559e979',
      name: 'Bajna',
    },
    {
      _id: '60ab6e9586ed1c1a3559e97b',
      name: 'Piploda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e97c',
      name: 'Ratlam',
    },
    {
      _id: '60ab6e9586ed1c1a3559e97d',
      name: 'Jaora',
    },
    {
      _id: '60ab6e9586ed1c1a3559e97e',
      name: 'Sailana',
    },
  ],
  Rewa: [
    {
      _id: '60ab6e9586ed1c1a3559e97f',
      name: 'Gangev',
    },
    {
      _id: '60ab6e9586ed1c1a3559e980',
      name: 'Hanumana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e981',
      name: 'Jawa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e982',
      name: 'Mauganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e983',
      name: 'Naigarhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e984',
      name: 'Raipur Karchuliyan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e985',
      name: 'Sirmour',
    },
    {
      _id: '60ab6e9586ed1c1a3559e986',
      name: 'Teonthar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e991',
      name: 'Rewa',
    },
  ],
  Sagar: [
    {
      _id: '60ab6e9586ed1c1a3559e987',
      name: 'Banda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e988',
      name: 'Bina',
    },
    {
      _id: '60ab6e9586ed1c1a3559e989',
      name: 'Deori',
    },
    {
      _id: '60ab6e9586ed1c1a3559e98a',
      name: 'Jaisinagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e98b',
      name: 'Kesli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e98c',
      name: 'Khurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e98d',
      name: 'Malthone',
    },
    {
      _id: '60ab6e9586ed1c1a3559e98e',
      name: 'Rahatgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e98f',
      name: 'Rehli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e990',
      name: 'Sagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e996',
      name: 'Shahgarh',
    },
  ],
  Satna: [
    {
      _id: '60ab6e9586ed1c1a3559e992',
      name: 'Amarpatan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e993',
      name: 'Maihar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e994',
      name: 'Majhgawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e995',
      name: 'Nagod',
    },
    {
      _id: '60ab6e9586ed1c1a3559e997',
      name: 'Ramnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e998',
      name: 'Sohawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e999',
      name: 'Rampur Baghelan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e99a',
      name: 'Unchahara',
    },
  ],
  Sehore: [
    {
      _id: '60ab6e9586ed1c1a3559e99b',
      name: 'Ashta',
    },
    {
      _id: '60ab6e9586ed1c1a3559e99c',
      name: 'Ichhawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e99d',
      name: 'Budni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e99e',
      name: 'Sehore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a0',
      name: 'Nasrullaganj',
    },
  ],
  Seoni: [
    {
      _id: '60ab6e9586ed1c1a3559e99f',
      name: 'Barghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a1',
      name: 'Dhanaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a2',
      name: 'Kahnapas(Ghansaur)',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a3',
      name: 'Keolari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a4',
      name: 'Kurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a5',
      name: 'Lakhnadon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a6',
      name: 'Seoni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ab',
      name: 'Chhapara',
    },
  ],
  Shahdol: [
    {
      _id: '60ab6e9586ed1c1a3559e9a7',
      name: 'Beohari',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a8',
      name: 'Burhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9a9',
      name: 'Gohparu',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9aa',
      name: 'Jaisinghnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ac',
      name: 'Sohagpur',
    },
  ],
  Shajapur: [
    {
      _id: '60ab6e9586ed1c1a3559e9ad',
      name: 'Kalapipal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ae',
      name: 'Moman Badodia',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9af',
      name: 'Shajapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9b4',
      name: 'Shujalpur',
    },
  ],
  Sheopur: [
    {
      _id: '60ab6e9586ed1c1a3559e9b0',
      name: 'Karahal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9b1',
      name: 'Sheopur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9b2',
      name: 'Vijaypur',
    },
  ],
  Shivpuri: [
    {
      _id: '60ab6e9586ed1c1a3559e9b3',
      name: 'Badarwas',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9b5',
      name: 'Karera',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9b6',
      name: 'Khaniadhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9b7',
      name: 'Kolaras',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9b8',
      name: 'Narwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9b9',
      name: 'Pichhore',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ba',
      name: 'Shivpuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9be',
      name: 'Pohri',
    },
  ],
  Sidhi: [
    {
      _id: '60ab6e9586ed1c1a3559e9bb',
      name: 'Kusmi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9bc',
      name: 'Majhauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9bd',
      name: 'Rampur Naikin',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9bf',
      name: 'Sihawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9c2',
      name: 'Sidhi',
    },
  ],
  Singrauli: [
    {
      _id: '60ab6e9586ed1c1a3559e9c0',
      name: 'Baidhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9c1',
      name: 'Chitrangi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9c3',
      name: 'Devsar',
    },
  ],
  Tikamgarh: [
    {
      _id: '60ab6e9586ed1c1a3559e9c4',
      name: 'Baldeogarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9c5',
      name: 'Jatara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9c6',
      name: 'Tikamgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9c9',
      name: 'Palera',
    },
  ],
  Ujjain: [
    {
      _id: '60ab6e9586ed1c1a3559e9c7',
      name: 'Badnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9c8',
      name: 'Ghatiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ca',
      name: 'Mahidpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9cb',
      name: 'Tarana',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9cc',
      name: 'Ujjain',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9cd',
      name: 'Khacharod',
    },
  ],
  Umaria: [
    {
      _id: '60ab6e9586ed1c1a3559e9ce',
      name: 'Karkeli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9cf',
      name: 'Pali',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9d0',
      name: 'Manpur',
    },
  ],
  Vidisha: [
    {
      _id: '60ab6e9586ed1c1a3559e9d1',
      name: 'Basoda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9d2',
      name: 'Gyaraspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9d3',
      name: 'Kurwai',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9d4',
      name: 'Lateri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9d5',
      name: 'Nateran',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9d6',
      name: 'Sironj',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9d7',
      name: 'Vidisha',
    },
  ],
  Ahmednagar: [
    {
      _id: '60ab6e9586ed1c1a3559e9d8',
      name: 'Akole',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9d9',
      name: 'Karjat',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9da',
      name: 'Jamkhed',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9db',
      name: 'Nagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9dc',
      name: 'Nevasa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9dd',
      name: 'Kopargaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9de',
      name: 'Pathardi',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9df',
      name: 'Rahata',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e0',
      name: 'Rahuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e1',
      name: 'Sangamner',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e2',
      name: 'Shevgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e3',
      name: 'Shrigonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e4',
      name: 'Shrirampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ea',
      name: 'Parner',
    },
  ],
  Akola: [
    {
      _id: '60ab6e9586ed1c1a3559e9e5',
      name: 'Akola',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e6',
      name: 'Akot',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e7',
      name: 'Balapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e8',
      name: 'Barshitakli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9e9',
      name: 'Murtijapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9eb',
      name: 'Patur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ec',
      name: 'Telhara',
    },
  ],
  Amravati: [
    {
      _id: '60ab6e9586ed1c1a3559e9ed',
      name: 'Achalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ee',
      name: 'Anjangaon S',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9ef',
      name: 'Bhatkuli',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f0',
      name: 'Chandur Bz',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f1',
      name: 'Chandur Ril',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f2',
      name: 'Chikhaldara',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f3',
      name: 'Daryapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f4',
      name: 'Amravati',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f5',
      name: 'Dhamangaon Ril',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f6',
      name: 'Dharni',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f7',
      name: 'Nandgaon Kh',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f8',
      name: 'Tiwsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9f9',
      name: 'Warud',
    },
    {
      _id: '60ab6e9586ed1c1a3559e9fb',
      name: 'Morshi',
    },
  ],
  Beed: [
    {
      _id: '60ab6e9586ed1c1a3559ea04',
      name: 'Ambajogai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea05',
      name: 'Beed',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea06',
      name: 'Dharur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea07',
      name: 'Georai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea08',
      name: 'Kaij',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea09',
      name: 'Ashti',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea0a',
      name: 'Parali V .',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea0b',
      name: 'Majalgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea0c',
      name: 'Patoda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea0d',
      name: 'Shirur ( Ka )',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea0e',
      name: 'Wadwani',
    },
  ],
  Bhandara: [
    {
      _id: '60ab6e9586ed1c1a3559ea0f',
      name: 'Bhandara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea10',
      name: 'Lakhandur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea11',
      name: 'Lakhani',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea12',
      name: 'Mohadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea13',
      name: 'Pauni',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea14',
      name: 'Sakoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea15',
      name: 'Tumsar',
    },
  ],
  Buldana: [
    {
      _id: '60ab6e9586ed1c1a3559ea16',
      name: 'Buldana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea17',
      name: 'Chikhli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea18',
      name: 'D. Raja',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea19',
      name: 'Khamgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea1a',
      name: 'Lonar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea1b',
      name: 'Malkapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea1c',
      name: 'Mehkar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea1d',
      name: 'Motala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea1e',
      name: 'Nandura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea1f',
      name: 'Sangrampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea20',
      name: 'Shegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea21',
      name: 'Sindkhedraja',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea23',
      name: 'Jalgaonjamod',
    },
  ],
  Chandrapur: [
    {
      _id: '60ab6e9586ed1c1a3559ea22',
      name: 'Ballarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea24',
      name: 'Bhadrawati',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea25',
      name: 'Brahmapuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea26',
      name: 'Chandrapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea27',
      name: 'Chimur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea28',
      name: 'Jiwati',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea29',
      name: 'Korpana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea2a',
      name: 'Mul',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea2b',
      name: 'Nagbhid',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea2c',
      name: 'Gondpipri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea2d',
      name: 'Rajura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea2e',
      name: 'Saoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea2f',
      name: 'Sindewahi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea30',
      name: 'Warora',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea35',
      name: 'Pombhurna',
    },
  ],
  Dhule: [
    {
      _id: '60ab6e9586ed1c1a3559ea31',
      name: 'Dhule',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea32',
      name: 'Sakri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea33',
      name: 'Shindkhede',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea34',
      name: 'Shirpur',
    },
  ],
  Gadchiroli: [
    {
      _id: '60ab6e9586ed1c1a3559ea36',
      name: 'Armori',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea37',
      name: 'Bhamaragad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea38',
      name: 'Aheri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea39',
      name: 'Chamorshi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea3a',
      name: 'Desaiganj (Wadsa)',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea3b',
      name: 'Etapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea3c',
      name: 'Gadchiroli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea3d',
      name: 'Korchi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea3e',
      name: 'Kurkheda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea3f',
      name: 'Mulchera',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea40',
      name: 'Sironcha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea41',
      name: 'Dhanora',
    },
  ],
  Gondia: [
    {
      _id: '60ab6e9586ed1c1a3559ea42',
      name: 'Amgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea43',
      name: 'Arjuni Morgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea44',
      name: 'Gondia',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea45',
      name: 'Goregaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea46',
      name: 'Sadak Arjuni',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea47',
      name: 'Salekasa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea48',
      name: 'Deori',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea50',
      name: 'Tirora',
    },
  ],
  Hingoli: [
    {
      _id: '60ab6e9586ed1c1a3559ea49',
      name: 'Aundha Nagnath',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea4a',
      name: 'Basmat',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea4b',
      name: 'Hingoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea4c',
      name: 'Kalamnuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea4d',
      name: 'Sengaon',
    },
  ],
  Jalgaon: [
    {
      _id: '60ab6e9586ed1c1a3559ea4e',
      name: 'Amalner',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea4f',
      name: 'Bhadgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea51',
      name: 'Bhusawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea52',
      name: 'Chalisgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea53',
      name: 'Bodwad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea54',
      name: 'Chopda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea55',
      name: 'Dharangaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea56',
      name: 'Erandol',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea57',
      name: 'Jalgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea58',
      name: 'Jamner',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea59',
      name: 'Muktainagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea5a',
      name: 'Pachora',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea5b',
      name: 'Parola',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea5c',
      name: 'Raver',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea60',
      name: 'Yawal',
    },
  ],
  Jalna: [
    {
      _id: '60ab6e9586ed1c1a3559ea5d',
      name: 'Ambad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea5e',
      name: 'Badnapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea5f',
      name: 'Bhokardan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea61',
      name: 'Ghansawangi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea62',
      name: 'Jafrabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea63',
      name: 'Jalna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea64',
      name: 'Mantha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea66',
      name: 'Partur',
    },
  ],
  Kolhapur: [
    {
      _id: '60ab6e9586ed1c1a3559ea65',
      name: 'Ajara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea67',
      name: 'Bhudargad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea68',
      name: 'Gadhinglaj',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea69',
      name: 'Chandgad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea6a',
      name: 'Hatkanangale',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea6b',
      name: 'Gagan Bavada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea6c',
      name: 'Kagal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea6d',
      name: 'Karveer',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea6e',
      name: 'Panhala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea6f',
      name: 'Shahuwadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea70',
      name: 'Radhanagari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea72',
      name: 'Shirol',
    },
  ],
  Latur: [
    {
      _id: '60ab6e9586ed1c1a3559ea71',
      name: 'Ahemadpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea73',
      name: 'Ausa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea74',
      name: 'Deoni',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea75',
      name: 'Jalkot',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea76',
      name: 'Chakur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea77',
      name: 'Nilanga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea78',
      name: 'Latur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea79',
      name: 'Renapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea7a',
      name: 'Shirur Anantpal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea7b',
      name: 'Udgir',
    },
  ],
  'Mumbai City': [
    {
      _id: '60ab6e9586ed1c1a3559ea7c',
      name: 'Mumbai City',
    },
  ],
  'Mumbai Suburban': [
    {
      _id: '60ab6e9586ed1c1a3559ea7d',
      name: 'Andheri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea7e',
      name: 'Borivali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea7f',
      name: 'Kurla',
    },
  ],
  Nagpur: [
    {
      _id: '60ab6e9586ed1c1a3559ea80',
      name: 'Bhivapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea81',
      name: 'Hingna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea82',
      name: 'Kamptee',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea83',
      name: 'Katol',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea84',
      name: 'Kuhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea85',
      name: 'Mouda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea86',
      name: 'Kalmeshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea87',
      name: 'Narkhed',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea88',
      name: 'Nagpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea89',
      name: 'Parseoni',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea8a',
      name: 'Ramtek',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea8b',
      name: 'Saoner',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea8d',
      name: 'Umred',
    },
  ],
  Nanded: [
    {
      _id: '60ab6e9586ed1c1a3559ea8c',
      name: 'Ardhapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea8e',
      name: 'Bhokar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea8f',
      name: 'Biloli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea90',
      name: 'Deglur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea91',
      name: 'Dharmabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea92',
      name: 'Hadgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea93',
      name: 'Himayatnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea94',
      name: 'Kandhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea95',
      name: 'Kinwat',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea96',
      name: 'Mahur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea97',
      name: 'Modkhed',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea98',
      name: 'Mokhed',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea99',
      name: 'Naigaon (Kh)',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea9a',
      name: 'Nanded',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea9b',
      name: 'Umri',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa1',
      name: 'Loha',
    },
  ],
  Nandurbar: [
    {
      _id: '60ab6e9586ed1c1a3559ea9c',
      name: 'Akarani',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea9d',
      name: 'Akkalkuwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea9e',
      name: 'Nandurbar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ea9f',
      name: 'Navapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa0',
      name: 'Shahada',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa3',
      name: 'Taloda',
    },
  ],
  Nashik: [
    {
      _id: '60ab6e9586ed1c1a3559eaa2',
      name: 'Baglan',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa4',
      name: 'Chandwad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa5',
      name: 'Dindori',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa6',
      name: 'Igatpuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa7',
      name: 'Kalwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa8',
      name: 'Malegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaa9',
      name: 'Deola',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaaa',
      name: 'Nandgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaab',
      name: 'Nashik',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaac',
      name: 'Niphad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaad',
      name: 'Peth',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaae',
      name: 'Sinnar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaaf',
      name: 'Trimbak',
    },
    {
      _id: '60ab6e9586ed1c1a3559eab0',
      name: 'Yeola',
    },
    {
      _id: '60ab6e9586ed1c1a3559eabb',
      name: 'Surgana',
    },
  ],
  Osmanabad: [
    {
      _id: '60ab6e9586ed1c1a3559eab1',
      name: 'Bhoom',
    },
    {
      _id: '60ab6e9586ed1c1a3559eab2',
      name: 'Kalamb',
    },
    {
      _id: '60ab6e9586ed1c1a3559eab3',
      name: 'Lohara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eab4',
      name: 'Omerga',
    },
    {
      _id: '60ab6e9586ed1c1a3559eab5',
      name: 'Osmanabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eab6',
      name: 'Paranda',
    },
    {
      _id: '60ab6e9586ed1c1a3559eab7',
      name: 'Tuljapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eab8',
      name: 'Washi',
    },
  ],
  Palghar: [
    {
      _id: '60ab6e9586ed1c1a3559eab9',
      name: 'Dahanu',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaba',
      name: 'Jawhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eabc',
      name: 'Palghar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eabd',
      name: 'Talasari',
    },
    {
      _id: '60ab6e9586ed1c1a3559eabe',
      name: 'Vasai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eabf',
      name: 'Vikramgad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac0',
      name: 'Mokhada',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac1',
      name: 'Wada',
    },
  ],
  Parbhani: [
    {
      _id: '60ab6e9586ed1c1a3559eac2',
      name: 'Gangakhed',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac3',
      name: 'Jintur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac4',
      name: 'Manwat',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac5',
      name: 'Palam',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac6',
      name: 'Parbhani',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac7',
      name: 'Purna',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac8',
      name: 'Sailu',
    },
    {
      _id: '60ab6e9586ed1c1a3559eac9',
      name: 'Pathri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead5',
      name: 'Sonpeth',
    },
  ],
  Pune: [
    {
      _id: '60ab6e9586ed1c1a3559eaca',
      name: 'Ambegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eacb',
      name: 'Baramati',
    },
    {
      _id: '60ab6e9586ed1c1a3559eacc',
      name: 'Bhor',
    },
    {
      _id: '60ab6e9586ed1c1a3559eacd',
      name: 'Daund',
    },
    {
      _id: '60ab6e9586ed1c1a3559eace',
      name: 'Haveli',
    },
    {
      _id: '60ab6e9586ed1c1a3559eacf',
      name: 'Indapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead0',
      name: 'Junnar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead1',
      name: 'Khed',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead2',
      name: 'Maval',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead3',
      name: 'Mulshi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead4',
      name: 'Pune City',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead6',
      name: 'Purandar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead7',
      name: 'Shirur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ead8',
      name: 'Velhe',
    },
  ],
  Raigad: [
    {
      _id: '60ab6e9586ed1c1a3559ead9',
      name: 'Karjat',
    },
    {
      _id: '60ab6e9586ed1c1a3559eada',
      name: 'Khalapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eadb',
      name: 'Mahad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eadc',
      name: 'Mangaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eadd',
      name: 'Alibag',
    },
    {
      _id: '60ab6e9586ed1c1a3559eade',
      name: 'Mhasala',
    },
    {
      _id: '60ab6e9586ed1c1a3559eadf',
      name: 'Murud',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae0',
      name: 'Panvel',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae1',
      name: 'Pen',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae2',
      name: 'Poladpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae3',
      name: 'Shrivardhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae4',
      name: 'Sudhagad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae5',
      name: 'Tala',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae6',
      name: 'Uran',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae7',
      name: 'Roha',
    },
  ],
  Ratnagiri: [
    {
      _id: '60ab6e9586ed1c1a3559eae8',
      name: 'Chipalun',
    },
    {
      _id: '60ab6e9586ed1c1a3559eae9',
      name: 'Dapoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaea',
      name: 'Guhagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaeb',
      name: 'Khed',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaec',
      name: 'Lanja',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaed',
      name: 'Mandangad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaee',
      name: 'Rajapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaef',
      name: 'Ratnagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf0',
      name: 'Sangmeshwar',
    },
  ],
  Sangli: [
    {
      _id: '60ab6e9586ed1c1a3559eaf1',
      name: 'Atpadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf2',
      name: 'Jath',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf3',
      name: 'Kavathemahankal',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf4',
      name: 'Khanapur-Vita',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf5',
      name: 'Kadegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf6',
      name: 'Palus',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf7',
      name: 'Shirala',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf8',
      name: 'Tasgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaf9',
      name: 'Valva-Islampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb02',
      name: 'Miraj',
    },
  ],
  Satara: [
    {
      _id: '60ab6e9586ed1c1a3559eafa',
      name: 'Jawali',
    },
    {
      _id: '60ab6e9586ed1c1a3559eafb',
      name: 'Karad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eafc',
      name: 'Khandala',
    },
    {
      _id: '60ab6e9586ed1c1a3559eafd',
      name: 'Khatav',
    },
    {
      _id: '60ab6e9586ed1c1a3559eafe',
      name: 'Koregaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eaff',
      name: 'Mahabaleshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb00',
      name: 'Man',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb01',
      name: 'Patan',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb03',
      name: 'Satara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb04',
      name: 'Wai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb06',
      name: 'Phaltan',
    },
  ],
  Sindhudurg: [
    {
      _id: '60ab6e9586ed1c1a3559eb05',
      name: 'Deogad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb07',
      name: 'Dodamarg',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb08',
      name: 'Kankavali',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb09',
      name: 'Kudal',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb0a',
      name: 'Malvan',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb0b',
      name: 'Sawantwadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb0c',
      name: 'Vaibhavawadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb0f',
      name: 'Vengurla',
    },
  ],
  Solapur: [
    {
      _id: '60ab6e9586ed1c1a3559eb0d',
      name: 'Akkalkot',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb0e',
      name: 'Barshi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb10',
      name: 'Karmala',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb11',
      name: 'Madha',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb12',
      name: 'Malshiras',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb13',
      name: 'Mangalvedhe',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb14',
      name: 'Mohol',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb15',
      name: 'Pandharpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb16',
      name: 'Sangola',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb17',
      name: 'Solapur North',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb19',
      name: 'South Solapur',
    },
  ],
  Thane: [
    {
      _id: '60ab6e9586ed1c1a3559eb18',
      name: 'Ambernath',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb1a',
      name: 'Kalyan',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb1b',
      name: 'Murbad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb1c',
      name: 'Shahapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb1d',
      name: 'Bhiwandi',
    },
  ],
  Wardha: [
    {
      _id: '60ab6e9586ed1c1a3559eb1e',
      name: 'Arvi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb1f',
      name: 'Deoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb20',
      name: 'Ashti',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb21',
      name: 'Hinganghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb22',
      name: 'Karanja',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb23',
      name: 'Samudrapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb24',
      name: 'Seloo',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb25',
      name: 'Wardha',
    },
  ],
  Washim: [
    {
      _id: '60ab6e9586ed1c1a3559eb26',
      name: 'Karanja',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb27',
      name: 'Malegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb28',
      name: 'Mangrulpir',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb29',
      name: 'Manora',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb2a',
      name: 'Risod',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb2b',
      name: 'Washim',
    },
  ],
  Yavatmal: [
    {
      _id: '60ab6e9586ed1c1a3559eb2c',
      name: 'Babhulgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb2d',
      name: 'Darwha',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb2e',
      name: 'Arni',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb2f',
      name: 'Digras',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb30',
      name: 'Ghatanji',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb31',
      name: 'Kalamb',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb32',
      name: 'Mahagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb33',
      name: 'Maregaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb34',
      name: 'Kelapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb35',
      name: 'Ner',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb36',
      name: 'Pusad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb37',
      name: 'Ralegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb38',
      name: 'Umarkhed',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb39',
      name: 'Wani',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb3a',
      name: 'Yavatmal',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb3b',
      name: 'Zari Jamni',
    },
  ],
  Bishnupur: [
    {
      _id: '60ab6e9586ed1c1a3559eb3c',
      name: 'Moirang',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb3d',
      name: 'Nambol',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb40',
      name: 'Bishnupur',
    },
  ],
  Chandel: [
    {
      _id: '60ab6e9586ed1c1a3559eb3e',
      name: 'Chakpikarong',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb3f',
      name: 'Chandel',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb41',
      name: 'Khengjoy',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb42',
      name: 'Khangbarol',
    },
  ],
  Churachandpur: [
    {
      _id: '60ab6e9586ed1c1a3559eb43',
      name: 'Henglep',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb44',
      name: 'Kangvai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb45',
      name: 'Lamka',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb46',
      name: 'Lanva',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb47',
      name: 'Mualnuam',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb48',
      name: 'Saikot',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb49',
      name: 'Samulamlan',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb4a',
      name: 'Sangaikot',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb4b',
      name: 'Singngat',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb4c',
      name: 'Suangdoh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb4d',
      name: 'Tuibong',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb52',
      name: 'Lamka South',
    },
  ],
  'Imphal East': [
    {
      _id: '60ab6e9586ed1c1a3559eb4e',
      name: 'Heingang Cd Block',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb4f',
      name: 'Keirao Cd Block',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb50',
      name: 'Kshetrigao Cd Block',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb51',
      name: 'Sawombung Cd Block',
    },
  ],
  'Imphal West': [
    {
      _id: '60ab6e9586ed1c1a3559eb53',
      name: 'Hiyangthang',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb54',
      name: 'Patsoi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb55',
      name: 'Wangoi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb57',
      name: 'Haorangsabal',
    },
  ],
  Jiribam: [
    {
      _id: '60ab6e9586ed1c1a3559eb56',
      name: 'Borobekra Cd Block',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb61',
      name: 'Jiribam C D Block',
    },
  ],
  Kakching: [
    {
      _id: '60ab6e9586ed1c1a3559eb58',
      name: 'Kakching',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb59',
      name: 'Langmeidong',
    },
  ],
  Kamjong: [
    {
      _id: '60ab6e9586ed1c1a3559eb5a',
      name: 'Kamjong',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb5b',
      name: 'Kasom Khullen',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb5c',
      name: 'Phungyar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb5d',
      name: 'Sahamphung Td Block',
    },
  ],
  Kangpokpi: [
    {
      _id: '60ab6e9586ed1c1a3559eb5e',
      name: 'Bungte Chiru',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb5f',
      name: 'Champhai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb60',
      name: 'Island',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb62',
      name: 'Kangchup Geljang',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb63',
      name: 'Kangpokpi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb64',
      name: 'Lhungtin',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb65',
      name: 'Saitu Gamphazol',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb66',
      name: 'T Vaichong',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb69',
      name: 'Saikul',
    },
  ],
  Noney: [
    {
      _id: '60ab6e9586ed1c1a3559eb67',
      name: 'Haochong',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb68',
      name: 'Khoupum',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb6a',
      name: 'Longmai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb6b',
      name: 'Nungba',
    },
  ],
  Pherzawl: [
    {
      _id: '60ab6e9586ed1c1a3559eb6c',
      name: 'Thanlon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb6d',
      name: 'Tipaimukh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb6e',
      name: 'Vangai Range',
    },
  ],
  Senapati: [
    {
      _id: '60ab6e9586ed1c1a3559eb6f',
      name: 'Phaibung Khullen',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb70',
      name: 'Paomata',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb71',
      name: 'Purul',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb72',
      name: 'Song Song',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb73',
      name: 'Tadubi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb75',
      name: 'Willong',
    },
  ],
  Tamenglong: [
    {
      _id: '60ab6e9586ed1c1a3559eb74',
      name: 'Tamei',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb76',
      name: 'Tousem',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb78',
      name: 'Tamenglong',
    },
  ],
  Tengnoupal: [
    {
      _id: '60ab6e9586ed1c1a3559eb77',
      name: 'Machi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb79',
      name: 'Tengnoupal',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb85',
      name: 'Moreh',
    },
  ],
  Thoubal: [
    {
      _id: '60ab6e9586ed1c1a3559eb7a',
      name: 'Lilong Cd Block',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb7b',
      name: 'Thoubal',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb7c',
      name: 'Wangjing Cd Block',
    },
  ],
  Ukhrul: [
    {
      _id: '60ab6e9586ed1c1a3559eb7d',
      name: 'Chingai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb7e',
      name: 'Jessami Td',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb7f',
      name: 'Lungchong Meiphai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb80',
      name: 'Ukhrul',
    },
  ],
  'East Garo Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eb81',
      name: 'Dambo Rongjeng',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb82',
      name: 'Samanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb83',
      name: 'Songsak',
    },
  ],
  'East Jaintia Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eb84',
      name: 'Khliehriat',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb8a',
      name: 'Saipung',
    },
  ],
  'East Khasi Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eb86',
      name: 'Khadarshnong-Laitkroh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb87',
      name: 'Mawkynrew',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb88',
      name: 'Mawlai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb89',
      name: 'Mawpat',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb8b',
      name: 'Mawphlang',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb8c',
      name: 'Mawryngkneng',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb8d',
      name: 'Mawsynram',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb8e',
      name: 'Mylliem',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb8f',
      name: 'Pynursla',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb90',
      name: 'Sohiong',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb93',
      name: 'Shella Bholaganj',
    },
  ],
  'North Garo Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eb91',
      name: 'Bajengdoba',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb92',
      name: 'Kharkutta',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb95',
      name: 'Resubelpara',
    },
  ],
  'Ri Bhoi': [
    {
      _id: '60ab6e9586ed1c1a3559eb94',
      name: 'Bhoirymbong',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb96',
      name: 'Jirang',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb97',
      name: 'Umling',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb98',
      name: 'Umsning',
    },
  ],
  'South Garo Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eb99',
      name: 'Chokpot',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb9a',
      name: 'Gasuapara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb9b',
      name: 'Baghmara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb9c',
      name: 'Rongara',
    },
  ],
  'South West Garo Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eb9d',
      name: 'Betasing',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb9e',
      name: 'Damalgre',
    },
    {
      _id: '60ab6e9586ed1c1a3559eb9f',
      name: 'Zikzak',
    },
  ],
  'South West Khasi Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eba0',
      name: 'Mawkyrwat',
    },
    {
      _id: '60ab6e9586ed1c1a3559eba1',
      name: 'Ranikor',
    },
  ],
  'West Garo Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eba2',
      name: 'Dadenggiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559eba3',
      name: 'Dalu',
    },
    {
      _id: '60ab6e9586ed1c1a3559eba4',
      name: 'Demdema',
    },
    {
      _id: '60ab6e9586ed1c1a3559eba5',
      name: 'Gambegre',
    },
    {
      _id: '60ab6e9586ed1c1a3559eba6',
      name: 'Salsella',
    },
    {
      _id: '60ab6e9586ed1c1a3559eba7',
      name: 'Tikrikilla',
    },
    {
      _id: '60ab6e9586ed1c1a3559eba9',
      name: 'Rongram',
    },
  ],
  'West Jaintia Hills': [
    {
      _id: '60ab6e9586ed1c1a3559eba8',
      name: 'Amlarem',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebaa',
      name: 'Laskein',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebab',
      name: 'Thadlaskein',
    },
  ],
  'West Khasi Hills': [
    {
      _id: '60ab6e9586ed1c1a3559ebac',
      name: 'Mawshynrut',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebad',
      name: 'Mawthadraishan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebae',
      name: 'Nongstoin',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebaf',
      name: 'Mairang',
    },
  ],
  Aizawl: [
    {
      _id: '60ab6e9586ed1c1a3559ebb0',
      name: 'Aibawk',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebb1',
      name: 'Thingsulthliah',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebb2',
      name: 'Darlawn',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebb3',
      name: 'Tlangnuam',
    },
  ],
  Champhai: [
    {
      _id: '60ab6e9586ed1c1a3559ebb4',
      name: 'Champhai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebb5',
      name: 'Khawbung',
    },
  ],
  Hnahthial: [
    {
      _id: '60ab6e9586ed1c1a3559ebb6',
      name: 'Hnahthial',
    },
  ],
  Khawzawl: [
    {
      _id: '60ab6e9586ed1c1a3559ebb7',
      name: 'Khawzawl',
    },
  ],
  Kolasib: [
    {
      _id: '60ab6e9586ed1c1a3559ebb8',
      name: 'Thingdawl',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebb9',
      name: 'Bilkhawthlir',
    },
  ],
  Lawngtlai: [
    {
      _id: '60ab6e9586ed1c1a3559ebba',
      name: 'Bungtlang South',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebbb',
      name: 'Chawngte',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebbc',
      name: 'Sangau',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebbf',
      name: 'Lawngtlai',
    },
  ],
  Lunglei: [
    {
      _id: '60ab6e9586ed1c1a3559ebbd',
      name: 'Bunghmun',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebbe',
      name: 'Lunglei',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebc5',
      name: 'Lungsen',
    },
  ],
  Mamit: [
    {
      _id: '60ab6e9586ed1c1a3559ebc0',
      name: 'Reiek',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebc1',
      name: 'West Phaileng',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebc2',
      name: 'Zawlnuam',
    },
  ],
  Saiha: [
    {
      _id: '60ab6e9586ed1c1a3559ebc3',
      name: 'Saiha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebc4',
      name: 'Tuipang',
    },
  ],
  Saitual: [
    {
      _id: '60ab6e9586ed1c1a3559ebc6',
      name: 'Ngopa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebc7',
      name: 'Phullen',
    },
  ],
  Serchhip: [
    {
      _id: '60ab6e9586ed1c1a3559ebc8',
      name: 'East Lungdar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebc9',
      name: 'Serchhip',
    },
  ],
  Dimapur: [
    {
      _id: '60ab6e9586ed1c1a3559ebca',
      name: 'Chumukedima',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebcb',
      name: 'Dhansiripar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebcc',
      name: 'Kuhuboto',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebcd',
      name: 'Medziphema',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebce',
      name: 'Niuland',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebd3',
      name: 'Aghunaqa',
    },
  ],
  Kiphire: [
    {
      _id: '60ab6e9586ed1c1a3559ebcf',
      name: 'Khonsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebd0',
      name: 'Kiphire',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebd1',
      name: 'Longmatra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebd2',
      name: 'Pungro',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebd4',
      name: 'Sitimi',
    },
  ],
  Kohima: [
    {
      _id: '60ab6e9586ed1c1a3559ebd5',
      name: 'Botsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebd7',
      name: 'Chiephobozou',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebd8',
      name: 'Jakhama',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebd9',
      name: 'Kohima',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebda',
      name: 'Sechu Zubza',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebdb',
      name: 'Tseminyu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe9',
      name: 'Chunlikha',
    },
  ],
  Longleng: [
    {
      _id: '60ab6e9586ed1c1a3559ebdc',
      name: 'Longleng',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebdd',
      name: 'Sakshi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebde',
      name: 'Tamlu',
    },
  ],
  Mokokchung: [
    {
      _id: '60ab6e9586ed1c1a3559ebdf',
      name: 'Changtongya',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe0',
      name: 'Chuchuyimlang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe1',
      name: 'Kubolong',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe2',
      name: 'Longchem',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe3',
      name: 'Mangkolemba',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe4',
      name: 'Ongpangkong(North)',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe5',
      name: 'Ongpangkong(South)',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe6',
      name: 'Tsurangkong',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebe7',
      name: 'Tuli',
    },
  ],
  Mon: [
    {
      _id: '60ab6e9586ed1c1a3559ebe8',
      name: 'Aboi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebea',
      name: 'Chen',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebeb',
      name: 'Mon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebec',
      name: 'Angjangyang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebed',
      name: 'Tizit',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebee',
      name: 'Tobu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebef',
      name: 'Wakching',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebf4',
      name: 'Phomching',
    },
  ],
  Peren: [
    {
      _id: '60ab6e9586ed1c1a3559ebf0',
      name: 'Athibung',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebf1',
      name: 'Jalukie',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebf2',
      name: 'Peren',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebf3',
      name: 'Tenning',
    },
  ],
  Phek: [
    {
      _id: '60ab6e9586ed1c1a3559ebf5',
      name: 'Chetheba',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebf6',
      name: 'Kikruma',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebf7',
      name: 'Meluri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebf8',
      name: 'Chizami',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebf9',
      name: 'Pfutsero',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebfa',
      name: 'Phek',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebfb',
      name: 'Weziho',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec01',
      name: 'Sekruzu',
    },
  ],
  Tuensang: [
    {
      _id: '60ab6e9586ed1c1a3559ebfc',
      name: 'Chare',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebfd',
      name: 'Chessore',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebfe',
      name: 'Longkhim',
    },
    {
      _id: '60ab6e9586ed1c1a3559ebff',
      name: 'Noklak',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec00',
      name: 'Noksen',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec02',
      name: 'Panso',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec03',
      name: 'Sangsangyu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec04',
      name: 'Thonoknyu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec0d',
      name: 'Shamator',
    },
  ],
  Wokha: [
    {
      _id: '60ab6e9586ed1c1a3559ec05',
      name: 'Bhandari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec06',
      name: 'Changpang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec07',
      name: 'Chukitong',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec08',
      name: 'Ralan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec09',
      name: 'Sanis',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec0a',
      name: 'Wokha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec0b',
      name: 'Wozhuro-Ralan',
    },
  ],
  Zunheboto: [
    {
      _id: '60ab6e9586ed1c1a3559ec0c',
      name: 'Akuhaito',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec0e',
      name: 'Akuluto',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec0f',
      name: 'Ghathashi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec10',
      name: 'Satakha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec11',
      name: 'Suruhoto',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec12',
      name: 'Tokiye',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec13',
      name: 'Zunheboto',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec14',
      name: 'Satoi',
    },
  ],
  Anugul: [
    {
      _id: '60ab6e9586ed1c1a3559ec15',
      name: 'Anugul',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec16',
      name: 'Athmallik',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec17',
      name: 'Banarpal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec18',
      name: 'Kaniha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec19',
      name: 'Chhendipada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec1a',
      name: 'Kishorenagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec1b',
      name: 'Palalahada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec1d',
      name: 'Talacher',
    },
  ],
  Balangir: [
    {
      _id: '60ab6e9586ed1c1a3559ec1c',
      name: 'Agalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec1e',
      name: 'Balangir',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec1f',
      name: 'Bangomunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec20',
      name: 'Deogaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec21',
      name: 'Gudvella',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec22',
      name: 'Khaprakhol',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec23',
      name: 'Loisinga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec24',
      name: 'Belpara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec25',
      name: 'Muribahal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec26',
      name: 'Patnagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec27',
      name: 'Puintala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec28',
      name: 'Titlagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec29',
      name: 'Saintala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec2b',
      name: 'Turekela',
    },
  ],
  Baleshwar: [
    {
      _id: '60ab6e9586ed1c1a3559ec2a',
      name: 'Bahanaga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec2c',
      name: 'Baleshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec2d',
      name: 'Baliapal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec2e',
      name: 'Basta',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec2f',
      name: 'Bhograi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec30',
      name: 'Khaira',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec31',
      name: 'Nilgiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec32',
      name: 'Jaleswar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec33',
      name: 'Oupada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec34',
      name: 'Simulia',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec35',
      name: 'Remuna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec38',
      name: 'Soro',
    },
  ],
  Bargarh: [
    {
      _id: '60ab6e9586ed1c1a3559ec36',
      name: 'Ambabhona',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec37',
      name: 'Attabira',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec39',
      name: 'Bargarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec3a',
      name: 'Barpali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec3b',
      name: 'Bheden',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec3c',
      name: 'Bijepur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec3d',
      name: 'Gaisilet',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec3e',
      name: 'Jharbandh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec3f',
      name: 'Padampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec40',
      name: 'Paikmal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec41',
      name: 'Sohella',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec4a',
      name: 'Bhatli',
    },
  ],
  Bhadrak: [
    {
      _id: '60ab6e9586ed1c1a3559ec42',
      name: 'Basudevpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec43',
      name: 'Bhadrak',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec44',
      name: 'Bhandaripokhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec45',
      name: 'Bonth',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec46',
      name: 'Chandabali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec47',
      name: 'Dhamanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec48',
      name: 'Tihidi',
    },
  ],
  Baudh: [
    {
      _id: '60ab6e9586ed1c1a3559ec49',
      name: 'Boudh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec4b',
      name: 'Harabhanga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec50',
      name: 'Kantamal',
    },
  ],
  Cuttack: [
    {
      _id: '60ab6e9586ed1c1a3559ec4c',
      name: 'Athagad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec4d',
      name: 'Badamba',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec4e',
      name: 'Banki',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec4f',
      name: 'Banki- Dampara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec51',
      name: 'Baranga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec52',
      name: 'Kantapada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec53',
      name: 'Cuttacksadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec54',
      name: 'Mahanga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec55',
      name: 'Niali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec56',
      name: 'Narasinghpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec57',
      name: 'Nischinta Koili',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec58',
      name: 'Salepur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec59',
      name: 'Tangi Choudwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec5b',
      name: 'Tigiria',
    },
  ],
  Debagarh: [
    {
      _id: '60ab6e9586ed1c1a3559ec5a',
      name: 'Barkote',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec5c',
      name: 'Reamal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec5d',
      name: 'Tileibani',
    },
  ],
  Dhenkanal: [
    {
      _id: '60ab6e9586ed1c1a3559ec5e',
      name: 'Bhuban',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec5f',
      name: 'Dhenkanal Sadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec60',
      name: 'Gondia',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec61',
      name: 'Hindol',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec62',
      name: 'Kamakhyanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec63',
      name: 'Kankada Had',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec64',
      name: 'Parjang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec73',
      name: 'Odapada',
    },
  ],
  Gajapati: [
    {
      _id: '60ab6e9586ed1c1a3559ec65',
      name: 'Gosani',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec66',
      name: 'Gumma',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec67',
      name: 'Kasinagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec68',
      name: 'Mohana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec69',
      name: 'Nuagada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec6a',
      name: 'Rayagada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec6b',
      name: 'R.Udayagiri',
    },
  ],
  Ganjam: [
    {
      _id: '60ab6e9586ed1c1a3559ec6c',
      name: 'Aska',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec6d',
      name: 'Beguniapada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec6e',
      name: 'Bellaguntha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec6f',
      name: 'Bhanjanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec70',
      name: 'Buguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec71',
      name: 'Chatrapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec72',
      name: 'Chikiti',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec74',
      name: 'Dharakote',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec75',
      name: 'Ganjam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec76',
      name: 'Hinjilicut',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec77',
      name: 'Jagannathprasad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec78',
      name: 'Kabisuryanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec79',
      name: 'Khallikote',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec7a',
      name: 'Digapahandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec7b',
      name: 'Kukudakhandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec7c',
      name: 'Patrapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec7d',
      name: 'Polosara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec7e',
      name: 'Purushottampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec7f',
      name: 'Rangeilunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec80',
      name: 'Sanakhemundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec81',
      name: 'Sheragada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec82',
      name: 'Surada',
    },
  ],
  Jagatsinghpur: [
    {
      _id: '60ab6e9586ed1c1a3559ec83',
      name: 'Balikuda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec84',
      name: 'Biridi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec85',
      name: 'Erasama',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec86',
      name: 'Jagatsinghpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec87',
      name: 'Kujang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec88',
      name: 'Naugaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec89',
      name: 'Raghunathpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec8a',
      name: 'Tirtol',
    },
  ],
  Jajapur: [
    {
      _id: '60ab6e9586ed1c1a3559ec8b',
      name: 'Badchana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec8c',
      name: 'Bari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec8d',
      name: 'Binjharpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec8e',
      name: 'Dahrmasala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec8f',
      name: 'Danagadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec90',
      name: 'Dasarathapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec91',
      name: 'Jajpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec92',
      name: 'Korei',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec93',
      name: 'Rasulpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec94',
      name: 'Sukinda',
    },
  ],
  Jharsuguda: [
    {
      _id: '60ab6e9586ed1c1a3559ec95',
      name: 'Jharsuguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec96',
      name: 'Kirmira',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec97',
      name: 'Kolabira',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec98',
      name: 'Laikera',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec99',
      name: 'Lakhanpur',
    },
  ],
  Kalahandi: [
    {
      _id: '60ab6e9586ed1c1a3559ec9a',
      name: 'Bhawanipatna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec9b',
      name: 'Dharamagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec9c',
      name: 'Golamunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec9d',
      name: 'Jayapatna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec9e',
      name: 'Junagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ec9f',
      name: 'Kalampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca0',
      name: 'Karlamunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca1',
      name: 'Kesinga',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca2',
      name: 'Kokasara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca3',
      name: 'Lanjigarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca4',
      name: 'Madanpur Rampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca5',
      name: 'Narala',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca6',
      name: 'Thuamul Ram Pur',
    },
  ],
  Kandhamal: [
    {
      _id: '60ab6e9586ed1c1a3559eca7',
      name: 'Baliguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca8',
      name: 'Chakapad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eca9',
      name: 'Daringibadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecaa',
      name: 'G.Udayagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecab',
      name: 'Khajuripada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecac',
      name: 'Kotagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecad',
      name: 'K.Nuagan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecae',
      name: 'Phiringia',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecaf',
      name: 'Phulbani',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb0',
      name: 'Raikia',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb1',
      name: 'Tikabali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb3',
      name: 'Tumudibandh',
    },
  ],
  Kendrapara: [
    {
      _id: '60ab6e9586ed1c1a3559ecb2',
      name: 'Aul',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb4',
      name: 'Derabish',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb5',
      name: 'Garadapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb6',
      name: 'Kendrapada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb7',
      name: 'Mahakalapada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb8',
      name: 'Marsaghai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecb9',
      name: 'Pattamundai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecba',
      name: 'Rajkanika',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecbb',
      name: 'Rajnagar',
    },
  ],
  Kendujhar: [
    {
      _id: '60ab6e9586ed1c1a3559ecbc',
      name: 'Bansapal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecbd',
      name: 'Champua',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecbe',
      name: 'Ghasipura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecbf',
      name: 'Ghatgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc0',
      name: 'Harichadanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc1',
      name: 'Hatadihi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc2',
      name: 'Jhumpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc3',
      name: 'Joda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc4',
      name: 'Kendujhar Sadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc5',
      name: 'Patana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc6',
      name: 'Saharapada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc7',
      name: 'Telkoi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eccd',
      name: 'Anandapur',
    },
  ],
  Khordha: [
    {
      _id: '60ab6e9586ed1c1a3559ecc8',
      name: 'Balianta',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecc9',
      name: 'Balipatna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecca',
      name: 'Banapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eccb',
      name: 'Begunia',
    },
    {
      _id: '60ab6e9586ed1c1a3559eccc',
      name: 'Bhubaneswar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecce',
      name: 'Bolagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eccf',
      name: 'Chilika',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd0',
      name: 'Jatni',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd1',
      name: 'Khordha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd2',
      name: 'Tangi',
    },
  ],
  Koraput: [
    {
      _id: '60ab6e9586ed1c1a3559ecd3',
      name: 'Bandhugaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd4',
      name: 'Boipariguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd5',
      name: 'Borigumma',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd6',
      name: 'Dasamantapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd7',
      name: 'Koraput',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd8',
      name: 'Kotpad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecd9',
      name: 'Kundura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecda',
      name: 'Jeypore',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecdb',
      name: 'Laxmipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecdc',
      name: 'Nandapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecdd',
      name: 'Lamtaput',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecde',
      name: 'Narayan Patana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecdf',
      name: 'Pottangi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf0',
      name: 'Semiliguda',
    },
  ],
  Malkangiri: [
    {
      _id: '60ab6e9586ed1c1a3559ece0',
      name: 'Chitrakonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ece1',
      name: 'Kalimela',
    },
    {
      _id: '60ab6e9586ed1c1a3559ece2',
      name: 'Khairaput',
    },
    {
      _id: '60ab6e9586ed1c1a3559ece3',
      name: 'Korukonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ece4',
      name: 'Malkangiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ece5',
      name: 'Mathili',
    },
    {
      _id: '60ab6e9586ed1c1a3559ece6',
      name: 'Podia',
    },
  ],
  Mayurbhanj: [
    {
      _id: '60ab6e9586ed1c1a3559ece7',
      name: 'Badasahi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ece8',
      name: 'Bahalda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ece9',
      name: 'Bangriposi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecea',
      name: 'Baripada',
    },
    {
      _id: '60ab6e9586ed1c1a3559eceb',
      name: 'Betnoti',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecec',
      name: 'Bijatala',
    },
    {
      _id: '60ab6e9586ed1c1a3559eced',
      name: 'Bisoi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecee',
      name: 'Gopabandhunagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecef',
      name: 'Jamda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf1',
      name: 'Kaptipada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf2',
      name: 'Karanjia',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf3',
      name: 'Khunta',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf4',
      name: 'Kuliana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf5',
      name: 'Kusumi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf6',
      name: 'Joshipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf7',
      name: 'Morada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf8',
      name: 'Rairangpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecf9',
      name: 'Raruan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecfa',
      name: 'Rasgovindpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecfb',
      name: 'Samakhunta',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecfc',
      name: 'Saraskana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecfd',
      name: 'Sukruli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecfe',
      name: 'Suliapada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ecff',
      name: 'Thakurmunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed00',
      name: 'Tiring',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed01',
      name: 'Udala',
    },
  ],
  Nabarangapur: [
    {
      _id: '60ab6e9586ed1c1a3559ed02',
      name: 'Chandahandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed03',
      name: 'Dabugam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed04',
      name: 'Jharigam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed05',
      name: 'Nabarangpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed06',
      name: 'Kosagumuda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed07',
      name: 'Nandahandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed08',
      name: 'Papadahandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed09',
      name: 'Tentulikhunti',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed0a',
      name: 'Raighar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed0b',
      name: 'Umerkote',
    },
  ],
  Nayagarh: [
    {
      _id: '60ab6e9586ed1c1a3559ed0c',
      name: 'Bhapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed0d',
      name: 'Dasapalla',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed0e',
      name: 'Gania',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed0f',
      name: 'Khandapara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed10',
      name: 'Nayagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed11',
      name: 'Nuagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed12',
      name: 'Odagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed22',
      name: 'Ranapur',
    },
  ],
  Nuapada: [
    {
      _id: '60ab6e9586ed1c1a3559ed13',
      name: 'Boden',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed14',
      name: 'Khariar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed15',
      name: 'Komna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed16',
      name: 'Nuapada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed17',
      name: 'Sinapali',
    },
  ],
  Puri: [
    {
      _id: '60ab6e9586ed1c1a3559ed18',
      name: 'Astaranga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed19',
      name: 'Brahmagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed1a',
      name: 'Delanga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed1b',
      name: 'Gop',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed1c',
      name: 'Kakat Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed1d',
      name: 'Kanas',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed1e',
      name: 'Krushnaprasad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed1f',
      name: 'Nimapada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed20',
      name: 'Pipili',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed21',
      name: 'Sadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed23',
      name: 'Satyabadi',
    },
  ],
  Rayagada: [
    {
      _id: '60ab6e9586ed1c1a3559ed24',
      name: 'Chandrapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed25',
      name: 'Gudari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed26',
      name: 'Gunupur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed27',
      name: 'Kalyansingpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed28',
      name: 'Kasipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed29',
      name: 'Kolnara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed2a',
      name: 'Muniguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed2b',
      name: 'Padmapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed2c',
      name: 'Bissamcuttack',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed2d',
      name: 'Ramanaguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed2e',
      name: 'Rayagada',
    },
  ],
  Sambalpur: [
    {
      _id: '60ab6e9586ed1c1a3559ed2f',
      name: 'Bamra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed30',
      name: 'Dhankauda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed31',
      name: 'Jujomura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed32',
      name: 'Kuchinda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed33',
      name: 'Maneswar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed34',
      name: 'Jamankira',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed35',
      name: 'Naktideul',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed36',
      name: 'Rairakhol',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed37',
      name: 'Rengali',
    },
  ],
  Subarnapur: [
    {
      _id: '60ab6e9586ed1c1a3559ed38',
      name: 'Binika',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed39',
      name: 'Birmaharajpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed3a',
      name: 'Dunguripali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed3b',
      name: 'Tarbha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed3c',
      name: 'Ullunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed49',
      name: 'Sonepur',
    },
  ],
  Sundargarh: [
    {
      _id: '60ab6e9586ed1c1a3559ed3d',
      name: 'Balisankara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed3e',
      name: 'Bargaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed3f',
      name: 'Bisra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed40',
      name: 'Bonaigarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed41',
      name: 'Gurundia',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed42',
      name: 'Hemgir',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed43',
      name: 'Koida',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed44',
      name: 'Kuarmunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed45',
      name: 'Kutra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed46',
      name: 'Lahunipara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed47',
      name: 'Lathikata',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed48',
      name: 'Lephripara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed4a',
      name: 'Nuagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed4b',
      name: 'Rajgangpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed4c',
      name: 'Sundargarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed4d',
      name: 'Tangarpali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed51',
      name: 'Subdega',
    },
  ],
  Karaikal: [
    {
      _id: '60ab6e9586ed1c1a3559ed4e',
      name: 'Karaikal',
    },
  ],
  Mahe: [
    {
      _id: '60ab6e9586ed1c1a3559ed4f',
      name: 'Mahe',
    },
  ],
  Pondicherry: [
    {
      _id: '60ab6e9586ed1c1a3559ed50',
      name: 'Ariankuppam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed52',
      name: 'Ozhukarai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed53',
      name: 'Villianur',
    },
  ],
  Yanam: [
    {
      _id: '60ab6e9586ed1c1a3559ed54',
      name: 'Yanam',
    },
  ],
  Amritsar: [
    {
      _id: '60ab6e9586ed1c1a3559ed55',
      name: 'Ajnala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed56',
      name: 'Chogawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed57',
      name: 'Attari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed58',
      name: 'Harshe Chhina',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed59',
      name: 'Jandiala Guru',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed5a',
      name: 'Rayya',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed5b',
      name: 'Majitha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed5c',
      name: 'Tarsikka',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed5d',
      name: 'Verka',
    },
  ],
  Barnala: [
    {
      _id: '60ab6e9586ed1c1a3559ed5e',
      name: 'Barnala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed5f',
      name: 'Mehal Kalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed60',
      name: 'Sehna',
    },
  ],
  Bathinda: [
    {
      _id: '60ab6e9586ed1c1a3559ed61',
      name: 'Bathinda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed62',
      name: 'Bhagta Bhaika',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed63',
      name: 'Goniana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed64',
      name: 'Maur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed65',
      name: 'Nathana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed66',
      name: 'Phul',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed67',
      name: 'Rampura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed68',
      name: 'Sangat',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed69',
      name: 'Talwandi Sabo',
    },
  ],
  Faridkot: [
    {
      _id: '60ab6e9586ed1c1a3559ed6a',
      name: 'Faridkot',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed6b',
      name: 'Jaitu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed6c',
      name: 'Kot Kapura',
    },
  ],
  'Fatehgarh Sahib': [
    {
      _id: '60ab6e9586ed1c1a3559ed6d',
      name: 'Amloh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed6e',
      name: 'Bassi Pathana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed6f',
      name: 'Khamano',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed70',
      name: 'Khera',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed71',
      name: 'Sirhind',
    },
  ],
  Fazilka: [
    {
      _id: '60ab6e9586ed1c1a3559ed72',
      name: 'Abohar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed73',
      name: 'Arniwala Shiekh Subhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed74',
      name: 'Fazilka',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed75',
      name: 'Jalalabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed76',
      name: 'Khuian Sarwar',
    },
  ],
  Firozepur: [
    {
      _id: '60ab6e9586ed1c1a3559ed77',
      name: 'Firozpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed78',
      name: 'Ghall Khurd',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed79',
      name: 'Guru Har Sahai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed7a',
      name: 'Makhu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed7b',
      name: 'Mamdot',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed7c',
      name: 'Zira',
    },
  ],
  Gurdaspur: [
    {
      _id: '60ab6e9586ed1c1a3559ed7d',
      name: 'Dera Baba Nanak',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed7e',
      name: 'Batala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed7f',
      name: 'Dhariwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed80',
      name: 'Dinanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed81',
      name: 'Dorangla',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed82',
      name: 'Fatehgarh Churian',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed83',
      name: 'Kahnuwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed84',
      name: 'Gurdaspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed85',
      name: 'Kalanaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed86',
      name: 'Qadian',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed88',
      name: 'Sri Hargobindpur',
    },
  ],
  Hoshiarpur: [
    {
      _id: '60ab6e9586ed1c1a3559ed87',
      name: 'Bhunga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed89',
      name: 'Dasuya',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed8a',
      name: 'Garhshankar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed8b',
      name: 'Hajipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed8c',
      name: 'Hoshiarpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed8d',
      name: 'Mahilpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed8e',
      name: 'Mukerian',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed8f',
      name: 'Talwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed90',
      name: 'Tanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed9c',
      name: 'Hoshiarpur-I',
    },
  ],
  Jalandhar: [
    {
      _id: '60ab6e9586ed1c1a3559ed91',
      name: 'Adampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed92',
      name: 'Bhogpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed93',
      name: 'Jalandhar-East',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed94',
      name: 'Jalandhar - West',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed95',
      name: 'Lohian',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed96',
      name: 'Mehatpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed97',
      name: 'Nakodar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed98',
      name: 'Nurmahal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed99',
      name: 'Phillaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed9a',
      name: 'Rurka Kalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed9b',
      name: 'Shahkot',
    },
  ],
  Kapurthala: [
    {
      _id: '60ab6e9586ed1c1a3559ed9d',
      name: 'Kapurthala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed9e',
      name: 'Dhilwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ed9f',
      name: 'Nadala',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda0',
      name: 'Phagwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda1',
      name: 'Sultanpur Lodhi',
    },
  ],
  Ludhiana: [
    {
      _id: '60ab6e9586ed1c1a3559eda2',
      name: 'Doraha',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda3',
      name: 'Jagraon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda4',
      name: 'Khanna',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda5',
      name: 'Ludhiana-1',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda6',
      name: 'Ludhiana-2',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda7',
      name: 'Dehlon',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda8',
      name: 'Machhiwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eda9',
      name: 'Maloud',
    },
    {
      _id: '60ab6e9586ed1c1a3559edaa',
      name: 'Pakhowal',
    },
    {
      _id: '60ab6e9586ed1c1a3559edab',
      name: 'Samrala',
    },
    {
      _id: '60ab6e9586ed1c1a3559edac',
      name: 'Sidhwan Bet',
    },
    {
      _id: '60ab6e9586ed1c1a3559edad',
      name: 'Raikot',
    },
    {
      _id: '60ab6e9586ed1c1a3559edae',
      name: 'Sudhar',
    },
  ],
  Mansa: [
    {
      _id: '60ab6e9586ed1c1a3559edaf',
      name: 'Bhikhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559edb0',
      name: 'Budhlada',
    },
    {
      _id: '60ab6e9586ed1c1a3559edb1',
      name: 'Jhunir',
    },
    {
      _id: '60ab6e9586ed1c1a3559edb2',
      name: 'Mansa',
    },
    {
      _id: '60ab6e9586ed1c1a3559edb3',
      name: 'Sardulgarh',
    },
  ],
  Moga: [
    {
      _id: '60ab6e9586ed1c1a3559edb4',
      name: 'Baghapurana',
    },
    {
      _id: '60ab6e9586ed1c1a3559edb5',
      name: 'Moga-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559edb6',
      name: 'Moga-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559edb7',
      name: 'Nihal Singh Wala',
    },
    {
      _id: '60ab6e9586ed1c1a3559edb8',
      name: 'Kot-Ise-Khan',
    },
  ],
  Pathankot: [
    {
      _id: '60ab6e9586ed1c1a3559edb9',
      name: 'Bamial',
    },
    {
      _id: '60ab6e9586ed1c1a3559edba',
      name: 'Dharkalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559edbb',
      name: 'Gharota',
    },
    {
      _id: '60ab6e9586ed1c1a3559edbc',
      name: 'Narot Jaimal Singh',
    },
    {
      _id: '60ab6e9586ed1c1a3559edbd',
      name: 'Pathankot',
    },
    {
      _id: '60ab6e9586ed1c1a3559edbe',
      name: 'Sujanpur',
    },
  ],
  Patiala: [
    {
      _id: '60ab6e9586ed1c1a3559edbf',
      name: 'Bhuner Heri',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc0',
      name: 'Ghanaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc1',
      name: 'Nabha',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc2',
      name: 'Patiala',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc3',
      name: 'Patiala Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc4',
      name: 'Patran',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc5',
      name: 'Rajpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc6',
      name: 'Sanour',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc7',
      name: 'Shambu Kalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559edc8',
      name: 'Samana',
    },
  ],
  Rupnagar: [
    {
      _id: '60ab6e9586ed1c1a3559edc9',
      name: 'Chamkaur Sahib',
    },
    {
      _id: '60ab6e9586ed1c1a3559edca',
      name: 'Morinda',
    },
    {
      _id: '60ab6e9586ed1c1a3559edcb',
      name: 'Nurpur Bedi',
    },
    {
      _id: '60ab6e9586ed1c1a3559edcc',
      name: 'Rupnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd3',
      name: 'Anandpur Sahib',
    },
  ],
  Sangrur: [
    {
      _id: '60ab6e9586ed1c1a3559edcd',
      name: 'Ahmedgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559edce',
      name: 'Andana',
    },
    {
      _id: '60ab6e9586ed1c1a3559edcf',
      name: 'Bhawani Garh',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd0',
      name: 'Dhuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd1',
      name: 'Dirba',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd2',
      name: 'Lehragaga',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd4',
      name: 'Sangrur',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd5',
      name: 'Malerkotla',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd6',
      name: 'Sherpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd7',
      name: 'Sunam',
    },
  ],
  'S.A.S Nagar': [
    {
      _id: '60ab6e9586ed1c1a3559edd8',
      name: 'Kharar',
    },
    {
      _id: '60ab6e9586ed1c1a3559edd9',
      name: 'Majri',
    },
    {
      _id: '60ab6e9586ed1c1a3559eddc',
      name: 'Dera Bassi',
    },
  ],
  'Shahid Bhagat Singh Nagar': [
    {
      _id: '60ab6e9586ed1c1a3559edda',
      name: 'Aur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eddb',
      name: 'Balachaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eddd',
      name: 'Banga',
    },
    {
      _id: '60ab6e9586ed1c1a3559edde',
      name: 'Nawanshahr',
    },
    {
      _id: '60ab6e9586ed1c1a3559eddf',
      name: 'Saroya',
    },
  ],
  'Sri Muktsar Sahib': [
    {
      _id: '60ab6e9586ed1c1a3559ede0',
      name: 'Gidderbaha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ede1',
      name: 'Malout',
    },
    {
      _id: '60ab6e9586ed1c1a3559ede2',
      name: 'Muktsar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eded',
      name: 'Lambi',
    },
  ],
  'Tarn Taran': [
    {
      _id: '60ab6e9586ed1c1a3559ede3',
      name: 'Bhikhi Wind-13',
    },
    {
      _id: '60ab6e9586ed1c1a3559ede4',
      name: 'Chohla Sahib-8',
    },
    {
      _id: '60ab6e9586ed1c1a3559ede5',
      name: 'Gandiwind-9',
    },
    {
      _id: '60ab6e9586ed1c1a3559ede6',
      name: 'Khadur-Sahib-10',
    },
    {
      _id: '60ab6e9586ed1c1a3559ede7',
      name: 'Naushehra Pannuan-11',
    },
    {
      _id: '60ab6e9586ed1c1a3559ede8',
      name: 'Patti-14',
    },
    {
      _id: '60ab6e9586ed1c1a3559ede9',
      name: 'Tarn Taran-12',
    },
    {
      _id: '60ab6e9586ed1c1a3559edea',
      name: 'Valtoha-15',
    },
  ],
  Ajmer: [
    {
      _id: '60ab6e9586ed1c1a3559edeb',
      name: 'Ajmer Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559edec',
      name: 'Arain',
    },
    {
      _id: '60ab6e9586ed1c1a3559edee',
      name: 'Jawaja',
    },
    {
      _id: '60ab6e9586ed1c1a3559edef',
      name: 'Kekri',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf0',
      name: 'Kishangarh Silora',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf1',
      name: 'Masooda',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf2',
      name: 'Pisangan',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf3',
      name: 'Sarwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf4',
      name: 'Bhinay',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf5',
      name: 'Sawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf6',
      name: 'Srinagar',
    },
  ],
  Alwar: [
    {
      _id: '60ab6e9586ed1c1a3559edf7',
      name: 'Bansur',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf8',
      name: 'Govindgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559edf9',
      name: 'Behror',
    },
    {
      _id: '60ab6e9586ed1c1a3559edfa',
      name: 'Kishangarh Bas',
    },
    {
      _id: '60ab6e9586ed1c1a3559edfb',
      name: 'Kathumar',
    },
    {
      _id: '60ab6e9586ed1c1a3559edfc',
      name: 'Kotkasim',
    },
    {
      _id: '60ab6e9586ed1c1a3559edfd',
      name: 'Malkheda',
    },
    {
      _id: '60ab6e9586ed1c1a3559edfe',
      name: 'Mandawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559edff',
      name: 'Laxmangarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee00',
      name: 'Neemrana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee01',
      name: 'Rajgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee02',
      name: 'Ramgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee03',
      name: 'Thanagazi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee04',
      name: 'Tijara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee05',
      name: 'Reni',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee06',
      name: 'Umren',
    },
  ],
  Banswara: [
    {
      _id: '60ab6e9586ed1c1a3559ee07',
      name: 'Anandpuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee08',
      name: 'Arthuna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee09',
      name: 'Bagidora',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee0a',
      name: 'Banswara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee0b',
      name: 'Chhoti Sarwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee0c',
      name: 'Gangar Talai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee0d',
      name: 'Ghatol',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee0e',
      name: 'Garhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee0f',
      name: 'Kushalgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee10',
      name: 'Sajjangarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee11',
      name: 'Talwara',
    },
  ],
  Baran: [
    {
      _id: '60ab6e9586ed1c1a3559ee12',
      name: 'Anta',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee13',
      name: 'Baran (Full)',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee14',
      name: 'Atru',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee15',
      name: 'Chhabra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee16',
      name: 'Chhipabarod',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee17',
      name: 'Kishanganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee18',
      name: 'Mangrol',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee2b',
      name: 'Shahbad',
    },
  ],
  Barmer: [
    {
      _id: '60ab6e9586ed1c1a3559ee19',
      name: 'Aadel',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee1a',
      name: 'Baltora',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee1b',
      name: 'Barmer',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee1c',
      name: 'Barmer Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee1d',
      name: 'Baytoo',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee1e',
      name: 'Chohtan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee1f',
      name: 'Dhanau',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee20',
      name: 'Dhorimanna',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee21',
      name: 'Fagliya',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee22',
      name: 'Gadra Road',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee23',
      name: 'Gira',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee24',
      name: 'Gudhamalani',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee25',
      name: 'Kalyanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee26',
      name: 'Panyla Kla',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee27',
      name: 'Patodi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee28',
      name: 'Ramsar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee29',
      name: 'Samdari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee2a',
      name: 'Sedwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee2c',
      name: 'Sindhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee2d',
      name: 'Sheo',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee2e',
      name: 'Siwana',
    },
  ],
  Bharatpur: [
    {
      _id: '60ab6e9586ed1c1a3559ee2f',
      name: 'Bayana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee30',
      name: 'Bhusawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee31',
      name: 'Kaman',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee32',
      name: 'Kumher',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee33',
      name: 'Nadbai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee34',
      name: 'Nagar Pahari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee35',
      name: 'Pahari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee36',
      name: 'Deeg',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee37',
      name: 'Rupbas',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee38',
      name: 'Sewar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee39',
      name: 'Uchain',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee3c',
      name: 'Weir',
    },
  ],
  Bhilwara: [
    {
      _id: '60ab6e9586ed1c1a3559ee3a',
      name: 'Asind',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee3b',
      name: 'Badnor',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee3d',
      name: 'Banera',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee3e',
      name: 'Bijoliya',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee3f',
      name: 'Jahazpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee40',
      name: 'Hurda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee41',
      name: 'Kareda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee42',
      name: 'Kotri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee43',
      name: 'Mandal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee44',
      name: 'Raipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee45',
      name: 'Mandalgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee46',
      name: 'Sahara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee47',
      name: 'Shahpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee48',
      name: 'Suwana',
    },
  ],
  Bikaner: [
    {
      _id: '60ab6e9586ed1c1a3559ee49',
      name: 'Bikaner',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee4a',
      name: 'Bajju Khalsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee4b',
      name: 'Khajuwala',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee4c',
      name: 'Kolayat',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee4d',
      name: 'Lunkaransar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee4e',
      name: 'Nokha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee4f',
      name: 'Poogal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee50',
      name: 'Sri Dungargarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee51',
      name: 'Panchoo',
    },
  ],
  Bundi: [
    {
      _id: '60ab6e9586ed1c1a3559ee52',
      name: 'Hindoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee53',
      name: 'Bundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee54',
      name: 'Keshoraipatan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee55',
      name: 'Nainwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee56',
      name: 'Talera',
    },
  ],
  Chittorgarh: [
    {
      _id: '60ab6e9586ed1c1a3559ee57',
      name: 'Bari Sadri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee58',
      name: 'Begun',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee59',
      name: 'Bhadesar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee5a',
      name: 'Bhainsrorgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee5b',
      name: 'Bhopalsagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee5c',
      name: 'Chittorgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee5d',
      name: 'Gangrar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee5e',
      name: 'Dungla',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee5f',
      name: 'Kapasan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee60',
      name: 'Nimbahera',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee61',
      name: 'Rashmi',
    },
  ],
  Churu: [
    {
      _id: '60ab6e9586ed1c1a3559ee62',
      name: 'Bidasar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee63',
      name: 'Rajgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee64',
      name: 'Churu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee65',
      name: 'Ratangarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee66',
      name: 'Sujangarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee67',
      name: 'Sardarshahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee68',
      name: 'Taranagar',
    },
  ],
  Dausa: [
    {
      _id: '60ab6e9586ed1c1a3559ee69',
      name: 'Baijupada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee6a',
      name: 'Bandikui',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee6b',
      name: 'Baswa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee6c',
      name: 'Lalsot',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee6d',
      name: 'Lawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee6e',
      name: 'Mahwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee6f',
      name: 'Dausa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee70',
      name: 'Ramgarh Pachwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee71',
      name: 'Nangal Rajawatan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee72',
      name: 'Sikandara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee73',
      name: 'Sikrai',
    },
  ],
  Dholpur: [
    {
      _id: '60ab6e9586ed1c1a3559ee74',
      name: 'Bari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee75',
      name: 'Baseri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee76',
      name: 'Dhaulpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee77',
      name: 'Rajakhera',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee78',
      name: 'Saipau',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee79',
      name: 'Sarmathura',
    },
  ],
  Dungarpur: [
    {
      _id: '60ab6e9586ed1c1a3559ee7a',
      name: 'Aspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee7b',
      name: 'Bichiwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee7c',
      name: 'Chikhali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee7d',
      name: 'Dovada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee7e',
      name: 'Dungarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee7f',
      name: 'Jothari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee80',
      name: 'Sabla',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee81',
      name: 'Galiyakoat',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee82',
      name: 'Sagwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee83',
      name: 'Simalwara',
    },
  ],
  Ganganagar: [
    {
      _id: '60ab6e9586ed1c1a3559ee84',
      name: 'Anupgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee85',
      name: 'Ganganagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee86',
      name: 'Gharsana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee87',
      name: 'Karanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee88',
      name: 'Padampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee89',
      name: 'Raisinghnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee8a',
      name: 'Sadulshahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee8b',
      name: 'Suratgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee8c',
      name: 'Vijainagar',
    },
  ],
  Hanumangarh: [
    {
      _id: '60ab6e9586ed1c1a3559ee8d',
      name: 'Bhadra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee8e',
      name: 'Nohar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee8f',
      name: 'Pilibanga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee90',
      name: 'Rawatsar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee91',
      name: 'Sangaria',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee92',
      name: 'Tibbi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee98',
      name: 'Hanumangarh',
    },
  ],
  Jaipur: [
    {
      _id: '60ab6e9586ed1c1a3559ee93',
      name: 'Amber',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee94',
      name: 'Andhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee95',
      name: 'Bassi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee96',
      name: 'Chaksu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee97',
      name: 'Dudu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee99',
      name: 'Govindgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee9a',
      name: 'Jalsu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee9b',
      name: 'Jamwa Ramgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee9c',
      name: 'Jhotwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee9d',
      name: 'Kishangarh Renwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee9e',
      name: 'Kotkhawda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ee9f',
      name: 'Kotputli',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea0',
      name: 'Madhorajpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea1',
      name: 'Jobner',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea2',
      name: 'Mauzamabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea3',
      name: 'Phagi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea4',
      name: 'Sambhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea5',
      name: 'Sanganer',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea6',
      name: 'Shahpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea7',
      name: 'Tunga',
    },
    {
      _id: '60ab6e9586ed1c1a3559eea8',
      name: 'Viratnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeab',
      name: 'Paota',
    },
  ],
  Jaisalmer: [
    {
      _id: '60ab6e9586ed1c1a3559eea9',
      name: 'Bhaniyana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeaa',
      name: 'Fatehgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeac',
      name: 'Mohangarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eead',
      name: 'Jaisalmer',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeae',
      name: 'Nachana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeaf',
      name: 'Sam',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb0',
      name: 'Sankra',
    },
  ],
  Jalore: [
    {
      _id: '60ab6e9586ed1c1a3559eeb1',
      name: 'Bagoda',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb2',
      name: 'Bhinmal',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb3',
      name: 'Chitalwana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb4',
      name: 'Ahore',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb5',
      name: 'Jalore',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb6',
      name: 'Raniwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb7',
      name: 'Sanchore',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb8',
      name: 'Sarnau',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeb9',
      name: 'Sayla',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeba',
      name: 'Jaswantpura',
    },
  ],
  Jhalawar: [
    {
      _id: '60ab6e9586ed1c1a3559eebb',
      name: 'Aklera',
    },
    {
      _id: '60ab6e9586ed1c1a3559eebc',
      name: 'Bakani',
    },
    {
      _id: '60ab6e9586ed1c1a3559eebd',
      name: 'Bhawani Mandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eebe',
      name: 'Dag',
    },
    {
      _id: '60ab6e9586ed1c1a3559eebf',
      name: 'Khanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec0',
      name: 'Jhalrapatan',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec1',
      name: 'Manoharthana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec2',
      name: 'Pirawa (Sunel)',
    },
  ],
  Jhunjhunu: [
    {
      _id: '60ab6e9586ed1c1a3559eec3',
      name: 'Alsisar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec4',
      name: 'Buhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec5',
      name: 'Chirawa',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec6',
      name: 'Jhunjhunu',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec7',
      name: 'Khetri',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec8',
      name: 'Mandawa',
    },
    {
      _id: '60ab6e9586ed1c1a3559eec9',
      name: 'Pilani',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeca',
      name: 'Singhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eecb',
      name: 'Surajgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eecc',
      name: 'Udaipurwati',
    },
    {
      _id: '60ab6e9586ed1c1a3559eecd',
      name: 'Nawalgarh',
    },
  ],
  Jodhpur: [
    {
      _id: '60ab6e9586ed1c1a3559eece',
      name: 'Aau',
    },
    {
      _id: '60ab6e9586ed1c1a3559eecf',
      name: 'Balesar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed0',
      name: 'Bap',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed1',
      name: 'Bapini',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed2',
      name: 'Bawadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed3',
      name: 'Bhopalgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed4',
      name: 'Bilara',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed5',
      name: 'Chamu',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed6',
      name: 'Dechu',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed7',
      name: 'Ghantiyali',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed8',
      name: 'Keru',
    },
    {
      _id: '60ab6e9586ed1c1a3559eed9',
      name: 'Lohawat',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeda',
      name: 'Luni',
    },
    {
      _id: '60ab6e9586ed1c1a3559eedb',
      name: 'Mandor',
    },
    {
      _id: '60ab6e9586ed1c1a3559eedc',
      name: 'Osian',
    },
    {
      _id: '60ab6e9586ed1c1a3559eedd',
      name: 'Peepad Sahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eede',
      name: 'Phalodi',
    },
    {
      _id: '60ab6e9586ed1c1a3559eedf',
      name: 'Dhawa',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee0',
      name: 'Shergarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee1',
      name: 'Tinwari',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee2',
      name: 'Sekhala',
    },
  ],
  Karauli: [
    {
      _id: '60ab6e9586ed1c1a3559eee3',
      name: 'Hindaun',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee4',
      name: 'Karauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee5',
      name: 'Masalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee6',
      name: 'Nadauti',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee7',
      name: 'Mandrayal',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee8',
      name: 'Sri Mahaveer Ji',
    },
    {
      _id: '60ab6e9586ed1c1a3559eee9',
      name: 'Sapotra',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef5',
      name: 'Todabhim',
    },
  ],
  Kota: [
    {
      _id: '60ab6e9586ed1c1a3559eeea',
      name: 'Itawa',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeeb',
      name: 'Khairabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeec',
      name: 'Ladpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeed',
      name: 'Sangod',
    },
    {
      _id: '60ab6e9586ed1c1a3559eeee',
      name: 'Sultanpur',
    },
  ],
  Nagaur: [
    {
      _id: '60ab6e9586ed1c1a3559eeef',
      name: 'Bherunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef0',
      name: 'Degana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef1',
      name: 'Didwana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef2',
      name: 'Jayal',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef3',
      name: 'Khinvsar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef4',
      name: 'Kuchaman',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef6',
      name: 'Ladnu',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef7',
      name: 'Makrana',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef8',
      name: 'Merta',
    },
    {
      _id: '60ab6e9586ed1c1a3559eef9',
      name: 'Mundwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559eefa',
      name: 'Nagaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eefb',
      name: 'Nawa',
    },
    {
      _id: '60ab6e9586ed1c1a3559eefc',
      name: 'Parbatsar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eefd',
      name: 'Molasar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eefe',
      name: 'Riyan Badi',
    },
  ],
  Pali: [
    {
      _id: '60ab6e9586ed1c1a3559eeff',
      name: 'Bali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef00',
      name: 'Desuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef01',
      name: 'Jaitaran',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef02',
      name: 'Kharchi(Mar.Jun)',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef03',
      name: 'Raipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef04',
      name: 'Rani Station',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef05',
      name: 'Rohat',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef06',
      name: 'Sojat',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef07',
      name: 'Pali',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef08',
      name: 'Sumerpur',
    },
  ],
  Pratapgarh: [
    {
      _id: '60ab6e9586ed1c1a3559ef09',
      name: 'Arnod',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef0a',
      name: 'Chhoti Sadri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef0b',
      name: 'Dalot',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef0c',
      name: 'Dhamotar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef0d',
      name: 'Dhariawad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef0e',
      name: 'Peepal Khoont',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef0f',
      name: 'Pratapgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef10',
      name: 'Suhagpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f651',
      name: 'Aspur Deosara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f652',
      name: 'Baba Belkharnath Dham',
    },
    {
      _id: '60ab6e9586ed1c1a3559f653',
      name: 'Babaganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f654',
      name: 'Bihar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f655',
      name: 'Gaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f656',
      name: 'Kalakankar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f657',
      name: 'Lakshamanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f658',
      name: 'Kunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f659',
      name: 'Magraura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f65a',
      name: 'Lalganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f65b',
      name: 'Mandhata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f65c',
      name: 'Pratapgarh (Sadar)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f65d',
      name: 'Patti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f65e',
      name: 'Rampur Sanramgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f65f',
      name: 'Sandwa Chandrika',
    },
    {
      _id: '60ab6e9586ed1c1a3559f660',
      name: 'Sangipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f661',
      name: 'Shivgarh',
    },
  ],
  Rajsamand: [
    {
      _id: '60ab6e9586ed1c1a3559ef11',
      name: 'Amet',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef12',
      name: 'Bhim',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef13',
      name: 'Delwada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef14',
      name: 'Deogarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef15',
      name: 'Khamnor',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef16',
      name: 'Railmagra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef17',
      name: 'Rajsamand',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef20',
      name: 'Kumbhalgarh',
    },
  ],
  'Sawai Madhopur': [
    {
      _id: '60ab6e9586ed1c1a3559ef18',
      name: 'Bamanwas',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef19',
      name: 'Bonli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef1a',
      name: 'Chauth Ka Barwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef1b',
      name: 'Gangapur City',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef1c',
      name: 'Khandar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef1d',
      name: 'Malarna Doongar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef1e',
      name: 'Sawai Madhopur',
    },
  ],
  Sikar: [
    {
      _id: '60ab6e9586ed1c1a3559ef1f',
      name: 'Ajeetgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef21',
      name: 'Danta Ramgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef22',
      name: 'Dhod',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef23',
      name: 'Fatehpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef24',
      name: 'Khandela',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef25',
      name: 'Nechwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef26',
      name: 'Neem Ka Thana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef27',
      name: 'Palsana',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef28',
      name: 'Patan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef29',
      name: 'Lachhmangarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef2a',
      name: 'Sri Madhopur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef33',
      name: 'Piprali',
    },
  ],
  Sirohi: [
    {
      _id: '60ab6e9586ed1c1a3559ef2b',
      name: 'Abu Road',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef2c',
      name: 'Pindwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef2d',
      name: 'Reodar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef2e',
      name: 'Sheoganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef2f',
      name: 'Sirohi',
    },
  ],
  Tonk: [
    {
      _id: '60ab6e9586ed1c1a3559ef30',
      name: 'Deoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef31',
      name: 'Malpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef32',
      name: 'Newai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef34',
      name: 'Peeplu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef35',
      name: 'Todaraisingh',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef36',
      name: 'Tonk',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef3b',
      name: 'Uniara',
    },
  ],
  Udaipur: [
    {
      _id: '60ab6e9586ed1c1a3559ef37',
      name: 'Bargaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef38',
      name: 'Bhinder',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef39',
      name: 'Girwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef3a',
      name: 'Gogunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef3c',
      name: 'Jaisamand',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef3d',
      name: 'Jhadol',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef3e',
      name: 'Jhallara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef3f',
      name: 'Kherwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef40',
      name: 'Kotra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef41',
      name: 'Kurabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef42',
      name: 'Mavli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef43',
      name: 'Nayagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef44',
      name: 'Phalasiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef45',
      name: 'Rishbhdeo',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef46',
      name: 'Salumbar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef47',
      name: 'Sarada',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef48',
      name: 'Sayra',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef49',
      name: 'Semari',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef4a',
      name: 'Vallabhnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef4d',
      name: 'Lasadiya',
    },
  ],
  'East District': [
    {
      _id: '60ab6e9586ed1c1a3559ef4b',
      name: 'Duga',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef4c',
      name: 'Khamdong',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef4e',
      name: 'Martam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef4f',
      name: 'Pakyong',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef50',
      name: 'Parkha',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef51',
      name: 'Nandok',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef52',
      name: 'Rakdong Tintek',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef53',
      name: 'Ranka',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef54',
      name: 'Rhenock',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef5f',
      name: 'Reghu',
    },
  ],
  'North District': [
    {
      _id: '60ab6e9586ed1c1a3559ef55',
      name: 'Chungthang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef56',
      name: 'Kabi Tingda',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef57',
      name: 'Mangan',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef58',
      name: 'Passingdang',
    },
  ],
  'South District': [
    {
      _id: '60ab6e9586ed1c1a3559ef59',
      name: 'Jorethang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef5a',
      name: 'Namchi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef5b',
      name: 'Namthang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef5c',
      name: 'Ravangla',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef5d',
      name: 'Sumbuk',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef5e',
      name: 'Temi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef60',
      name: 'Wok',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef64',
      name: 'Yangang',
    },
  ],
  'West District': [
    {
      _id: '60ab6e9586ed1c1a3559ef61',
      name: 'Arithang Chongrang',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef62',
      name: 'Chumbong Chakung',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef63',
      name: 'Daramdin',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef65',
      name: 'Dentam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef66',
      name: 'Gyalshing',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef67',
      name: 'Kaluk',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef68',
      name: 'Hee Martam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef69',
      name: 'Soreng',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef6a',
      name: 'Mangalbarey',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef6f',
      name: 'Yuksom',
    },
  ],
  Ariyalur: [
    {
      _id: '60ab6e9586ed1c1a3559ef6b',
      name: 'Andimadam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef6c',
      name: 'Ariyalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef6d',
      name: 'Jayamkondam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef6e',
      name: 'Sendurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef70',
      name: 'Thirumanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef71',
      name: 'T. Palur',
    },
  ],
  Chengalpattu: [
    {
      _id: '60ab6e9586ed1c1a3559ef72',
      name: 'Acharapakkam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef73',
      name: 'Chithamur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef74',
      name: 'Kattankolathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef75',
      name: 'Lathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef76',
      name: 'Madurantakam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef77',
      name: 'St.Thomas Mount',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef78',
      name: 'Thiruporur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef79',
      name: 'Tirukkalukunram',
    },
  ],
  Coimbatore: [
    {
      _id: '60ab6e9586ed1c1a3559ef7a',
      name: 'Anamalai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef7b',
      name: 'Karamadai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef7c',
      name: 'Kinathukadavu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef7d',
      name: 'Annur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef7e',
      name: 'Periyanayakkanpalayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef7f',
      name: 'Pollachi North',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef80',
      name: 'Pollachi South',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef81',
      name: 'Sarcarsamakulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef82',
      name: 'Sultanpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef83',
      name: 'Sulur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef84',
      name: 'Thondamuthur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef8b',
      name: 'Madukkarai',
    },
  ],
  Cuddalore: [
    {
      _id: '60ab6e9586ed1c1a3559ef85',
      name: 'Annagramam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef86',
      name: 'Cuddalore',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef87',
      name: 'Kammapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef88',
      name: 'Kattumannarkoil',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef89',
      name: 'Keerapalayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef8a',
      name: 'Komaratchi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef8c',
      name: 'Kurinjipadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef8d',
      name: 'Mangalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef8e',
      name: 'Melbhuvanagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef8f',
      name: 'Panruti',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef90',
      name: 'Parangipettai',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef91',
      name: 'Srimushnam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef92',
      name: 'Vriddhachalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef93',
      name: 'Nallur',
    },
  ],
  Dharmapuri: [
    {
      _id: '60ab6e9586ed1c1a3559ef94',
      name: 'Dharmapuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef95',
      name: 'Eriyur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef96',
      name: 'Harur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef97',
      name: 'Kadathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef98',
      name: 'Karimangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef99',
      name: 'Nallampalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef9a',
      name: 'Palakkodu',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef9b',
      name: 'Pappireddipatty',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef9c',
      name: 'Pennagaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa4',
      name: 'Morappur',
    },
  ],
  Dindigul: [
    {
      _id: '60ab6e9586ed1c1a3559ef9d',
      name: 'Athoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef9e',
      name: 'Dindigul',
    },
    {
      _id: '60ab6e9586ed1c1a3559ef9f',
      name: 'Guziliamparai',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa0',
      name: 'Kodaikanal',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa1',
      name: 'Nattam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa2',
      name: 'Nilakottai',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa3',
      name: 'Oddanchatram',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa5',
      name: 'Palani',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa6',
      name: 'Shanarpatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa7',
      name: 'Reddiyarchatiram',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa8',
      name: 'Thoppampatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559efa9',
      name: 'Vadamadurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559efaa',
      name: 'Vattalkundu',
    },
    {
      _id: '60ab6e9586ed1c1a3559efab',
      name: 'Vedasandur',
    },
  ],
  Erode: [
    {
      _id: '60ab6e9586ed1c1a3559efac',
      name: 'Ammapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559efad',
      name: 'Andiyur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efae',
      name: 'Bhavani',
    },
    {
      _id: '60ab6e9586ed1c1a3559efaf',
      name: 'Bhavanisagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb0',
      name: 'Erode',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb1',
      name: 'Chennimalai',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb2',
      name: 'Gopichettipalaiyam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb3',
      name: 'Modakurichi',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb4',
      name: 'Nambiyur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb5',
      name: 'Kodumudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb6',
      name: 'Perundurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb7',
      name: 'Satyamangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efb8',
      name: 'Talavadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559efbb',
      name: 'Thoockanaickenpalaiyam',
    },
  ],
  Kallakurichi: [
    {
      _id: '60ab6e9586ed1c1a3559efb9',
      name: 'Chinnasalem',
    },
    {
      _id: '60ab6e9586ed1c1a3559efba',
      name: 'Kallakkurichi',
    },
    {
      _id: '60ab6e9586ed1c1a3559efbc',
      name: 'Kalrayanhills',
    },
    {
      _id: '60ab6e9586ed1c1a3559efbd',
      name: 'Rishivandiam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efbe',
      name: 'Thiagadurgam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efc0',
      name: 'Sankarapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559efc1',
      name: 'Tirukkoyilur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efc2',
      name: 'Tirunavalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efc3',
      name: 'Ulundurpet',
    },
  ],
  Kanchipuram: [
    {
      _id: '60ab6e9586ed1c1a3559efc4',
      name: 'Kunnattur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efc5',
      name: 'Sriperumbudur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efc6',
      name: 'Uttiramerur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efc7',
      name: 'Walajabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd2',
      name: 'Kanchipuram',
    },
  ],
  Kanniyakumari: [
    {
      _id: '60ab6e9586ed1c1a3559efc8',
      name: 'Agastiswaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559efc9',
      name: 'Killiyoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559efca',
      name: 'Kurunthancode',
    },
    {
      _id: '60ab6e9586ed1c1a3559efcb',
      name: 'Melpuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559efcc',
      name: 'Munchira',
    },
    {
      _id: '60ab6e9586ed1c1a3559efcd',
      name: 'Rajakkamangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efce',
      name: 'Thackalai',
    },
    {
      _id: '60ab6e9586ed1c1a3559efcf',
      name: 'Thiruvattar',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd0',
      name: 'Thovala',
    },
  ],
  Karur: [
    {
      _id: '60ab6e9586ed1c1a3559efd1',
      name: 'Aravakurichi',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd3',
      name: 'Kadavur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd4',
      name: 'Karur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd5',
      name: 'K.Paramathy',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd6',
      name: 'Krishnarayapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd7',
      name: 'Kulittalai',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd8',
      name: 'Thanthoni',
    },
    {
      _id: '60ab6e9586ed1c1a3559efd9',
      name: 'Thogaimalai',
    },
  ],
  Krishnagiri: [
    {
      _id: '60ab6e9586ed1c1a3559efda',
      name: 'Bargur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efdb',
      name: 'Kaveripattinam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efdc',
      name: 'Kelamangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efdd',
      name: 'Krishnagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559efde',
      name: 'Mathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efdf',
      name: 'Shoolagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe0',
      name: 'Thally',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe1',
      name: 'Uthangarai',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe2',
      name: 'Veppanapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe4',
      name: 'Hosur',
    },
  ],
  Madurai: [
    {
      _id: '60ab6e9586ed1c1a3559efe3',
      name: 'Alanganallur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe5',
      name: 'Kallikudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe6',
      name: 'Kottampatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe7',
      name: 'Chellampatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe8',
      name: 'Madurai West',
    },
    {
      _id: '60ab6e9586ed1c1a3559efe9',
      name: 'Melur',
    },
    {
      _id: '60ab6e9586ed1c1a3559efea',
      name: 'Madurai East',
    },
    {
      _id: '60ab6e9586ed1c1a3559efeb',
      name: 'Sedapatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559efec',
      name: 'Tirumangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559efed',
      name: 'T.Kallupatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559efee',
      name: 'Usilampatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559efef',
      name: 'Vadipatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff7',
      name: 'Tirupparangunram',
    },
  ],
  Nagapattinam: [
    {
      _id: '60ab6e9586ed1c1a3559eff0',
      name: 'Keelaiyur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff1',
      name: 'Kilvelur',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff2',
      name: 'Kollidam',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff3',
      name: 'Kuttalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff4',
      name: 'Mayiladuthurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff5',
      name: 'Nagappattinam',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff6',
      name: 'Sembanar Koil',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff8',
      name: 'Thalanayar',
    },
    {
      _id: '60ab6e9586ed1c1a3559eff9',
      name: 'Sirkazhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559effa',
      name: 'Vedaranyam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f002',
      name: 'Thirumarugal',
    },
  ],
  Namakkal: [
    {
      _id: '60ab6e9586ed1c1a3559effb',
      name: 'Elacipalayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559effc',
      name: 'Erumapatty',
    },
    {
      _id: '60ab6e9586ed1c1a3559effd',
      name: 'Kabilamalai',
    },
    {
      _id: '60ab6e9586ed1c1a3559effe',
      name: 'Kolli Hills',
    },
    {
      _id: '60ab6e9586ed1c1a3559efff',
      name: 'Mallasamudram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f000',
      name: 'Mohanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f001',
      name: 'Namagiripet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f003',
      name: 'Pallipalayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f004',
      name: 'Namakkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f005',
      name: 'Paramathy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f006',
      name: 'Puduchatram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f007',
      name: 'Rasipuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f008',
      name: 'Tiruchengodu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f009',
      name: 'Vennandur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f00c',
      name: 'Sendamangalam',
    },
  ],
  Perambalur: [
    {
      _id: '60ab6e9586ed1c1a3559f00a',
      name: 'Alathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f00b',
      name: 'Perambalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f00d',
      name: 'Veppanthattai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f010',
      name: 'Veppur',
    },
  ],
  Pudukkottai: [
    {
      _id: '60ab6e9586ed1c1a3559f00e',
      name: 'Annavasal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f00f',
      name: 'Arantangi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f011',
      name: 'Avadaiyarkovil',
    },
    {
      _id: '60ab6e9586ed1c1a3559f012',
      name: 'Gandaravakottai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f013',
      name: 'Karambakudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f014',
      name: 'Kunnandarkoil',
    },
    {
      _id: '60ab6e9586ed1c1a3559f015',
      name: 'Manalmelkudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f016',
      name: 'Ponnamaravati',
    },
    {
      _id: '60ab6e9586ed1c1a3559f017',
      name: 'Pudukkottai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f018',
      name: 'Thiruvarankulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f019',
      name: 'Tirumayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f01a',
      name: 'Viralimalai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f01d',
      name: 'Arimalam',
    },
  ],
  Ramanathapuram: [
    {
      _id: '60ab6e9586ed1c1a3559f01b',
      name: 'Bogalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f01c',
      name: 'Kadaladi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f01e',
      name: 'Mandapam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f01f',
      name: 'Mudukulathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f020',
      name: 'Nainarkoil',
    },
    {
      _id: '60ab6e9586ed1c1a3559f021',
      name: 'Paramakkudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f022',
      name: 'Kamudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f023',
      name: 'Ramanathapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f024',
      name: 'Tiruppullani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f025',
      name: 'Tiruvadanai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f02b',
      name: 'Rajasingamangalam',
    },
  ],
  Ranipet: [
    {
      _id: '60ab6e9586ed1c1a3559f026',
      name: 'Arakkonam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f027',
      name: 'Arcot',
    },
    {
      _id: '60ab6e9586ed1c1a3559f028',
      name: 'Kaveripakkam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f029',
      name: 'Nemili',
    },
    {
      _id: '60ab6e9586ed1c1a3559f02a',
      name: 'Sholinghur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f02c',
      name: 'Timiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f02d',
      name: 'Walajapet',
    },
  ],
  Salem: [
    {
      _id: '60ab6e9586ed1c1a3559f02e',
      name: 'Attur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f02f',
      name: 'Ayodhiyapattinam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f030',
      name: 'Idappadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f031',
      name: 'Kadaiyampatty',
    },
    {
      _id: '60ab6e9586ed1c1a3559f032',
      name: 'Gangavalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f033',
      name: 'Konganapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f034',
      name: 'Kolathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f035',
      name: 'Mecheri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f036',
      name: 'Nangavalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f037',
      name: 'Omalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f038',
      name: 'Panamarathupatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f039',
      name: 'Macdonalds Choultry',
    },
    {
      _id: '60ab6e9586ed1c1a3559f03a',
      name: 'Salem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f03b',
      name: 'Peddanaickenpalayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f03c',
      name: 'Sankari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f03d',
      name: 'Talavasal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f03e',
      name: 'Valapady',
    },
    {
      _id: '60ab6e9586ed1c1a3559f03f',
      name: 'Veerapandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f040',
      name: 'Taramangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f041',
      name: 'Yercaud',
    },
  ],
  Sivaganga: [
    {
      _id: '60ab6e9586ed1c1a3559f042',
      name: 'Devakottai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f043',
      name: 'Kalaiyarkoil',
    },
    {
      _id: '60ab6e9586ed1c1a3559f044',
      name: 'Kallal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f045',
      name: 'Kannankudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f046',
      name: 'Manamadurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f047',
      name: 'Ilayankudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f048',
      name: 'Singampunari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f049',
      name: 'Sivaganga',
    },
    {
      _id: '60ab6e9586ed1c1a3559f04a',
      name: 'S. Pudur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f04b',
      name: 'Tiruppathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f04c',
      name: 'Tiruppuvanam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f056',
      name: 'Sakkottai',
    },
  ],
  Tenkasi: [
    {
      _id: '60ab6e9586ed1c1a3559f04d',
      name: 'Alangulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f04e',
      name: 'Kadaiyanallur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f04f',
      name: 'Kadayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f050',
      name: 'Keelapavoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f051',
      name: 'Kuruvikulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f052',
      name: 'Melaneelithanallur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f053',
      name: 'Sankarankovil',
    },
    {
      _id: '60ab6e9586ed1c1a3559f054',
      name: 'Shencottah',
    },
    {
      _id: '60ab6e9586ed1c1a3559f055',
      name: 'Tenkasi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f057',
      name: 'Vasudevanallur',
    },
  ],
  Thanjavur: [
    {
      _id: '60ab6e9586ed1c1a3559f058',
      name: 'Ammapettai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f059',
      name: 'Budalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f05a',
      name: 'Madukkur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f05b',
      name: 'Orattanadu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f05c',
      name: 'Papanasam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f05d',
      name: 'Pattukkottai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f05e',
      name: 'Kumbakonam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f05f',
      name: 'Sethubhavachatram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f060',
      name: 'Thanjavur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f061',
      name: 'Thiruppanandal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f062',
      name: 'Thiruvaiyaru',
    },
    {
      _id: '60ab6e9586ed1c1a3559f063',
      name: 'Thiruvonam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f064',
      name: 'Tiruvidaimarudur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f06f',
      name: 'Peravurani',
    },
  ],
  Theni: [
    {
      _id: '60ab6e9586ed1c1a3559f065',
      name: 'Andipatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f066',
      name: 'Bodinayakkanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f067',
      name: 'Chinnamanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f068',
      name: 'Kadamalaikundru Myladumparai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f069',
      name: 'Kambam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f06a',
      name: 'Periyakulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f06b',
      name: 'Theni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f06c',
      name: 'Uttamapalaiyam',
    },
  ],
  'The Nilgiris': [
    {
      _id: '60ab6e9586ed1c1a3559f06d',
      name: 'Coonoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f06e',
      name: 'Gudalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f070',
      name: 'Udhagamandalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f074',
      name: 'Kotagiri',
    },
  ],
  Thiruvallur: [
    {
      _id: '60ab6e9586ed1c1a3559f071',
      name: 'Ellapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f072',
      name: 'Gummidipundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f073',
      name: 'Kadambathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f075',
      name: 'Minjur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f076',
      name: 'Pallipattu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f077',
      name: 'Poonamallee',
    },
    {
      _id: '60ab6e9586ed1c1a3559f078',
      name: 'Poondi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f079',
      name: 'Puzhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f07a',
      name: 'R.K.Pet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f07b',
      name: 'Sholavaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f07c',
      name: 'Tiruttani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f07d',
      name: 'Tiruvallur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f07e',
      name: 'Tiruvelangadu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f07f',
      name: 'Villivakkam',
    },
  ],
  Thiruvarur: [
    {
      _id: '60ab6e9586ed1c1a3559f080',
      name: 'Kodavasal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f081',
      name: 'Koradacherry',
    },
    {
      _id: '60ab6e9586ed1c1a3559f082',
      name: 'Kottur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f083',
      name: 'Mannargudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f084',
      name: 'Muthupettai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f085',
      name: 'Nannilam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f086',
      name: 'Nidamangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f087',
      name: 'Thiruvarur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f088',
      name: 'Tirutturaippundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f089',
      name: 'Valangaiman',
    },
  ],
  Tiruchirappalli: [
    {
      _id: '60ab6e9586ed1c1a3559f08a',
      name: 'Andanallur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f08b',
      name: 'Lalgudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f08c',
      name: 'Manachanellur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f08d',
      name: 'Manapparai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f08e',
      name: 'Manikandam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f08f',
      name: 'Marungapuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f090',
      name: 'Musiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f091',
      name: 'Pullambadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f092',
      name: 'Tattayyangarpettai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f093',
      name: 'Thiruverambur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f094',
      name: 'Thottiam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f095',
      name: 'Turaiyur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f096',
      name: 'Uppiliapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f097',
      name: 'Vaiyampatti',
    },
  ],
  Tirunelveli: [
    {
      _id: '60ab6e9586ed1c1a3559f098',
      name: 'Ambasamudram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f099',
      name: 'Cheranmahadevi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f09a',
      name: 'Kalakadu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f09b',
      name: 'Manur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f09c',
      name: 'Nanguneri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f09d',
      name: 'Palayamkottai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f09e',
      name: 'Pappakudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f09f',
      name: 'Radhapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0a0',
      name: 'Valliyoor',
    },
  ],
  Tirupathur: [
    {
      _id: '60ab6e9586ed1c1a3559f0a1',
      name: 'Alangayan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0a2',
      name: 'Jolarpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0a3',
      name: 'Kandili',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0a4',
      name: 'Madhanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0a5',
      name: 'Natrampalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0a6',
      name: 'Tiruppattur',
    },
  ],
  Tiruppur: [
    {
      _id: '60ab6e9586ed1c1a3559f0a7',
      name: 'Avanashi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0a8',
      name: 'Dharapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0a9',
      name: 'Gudimangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0aa',
      name: 'Kangayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ab',
      name: 'Kundadam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ac',
      name: 'Madathukulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ad',
      name: 'Mulanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ae',
      name: 'Palladam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0af',
      name: 'Pongalur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b0',
      name: 'Tiruppur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b1',
      name: 'Uttukkuli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b2',
      name: 'Vellakoil',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c1',
      name: 'Udumalpet',
    },
  ],
  Tiruvannamalai: [
    {
      _id: '60ab6e9586ed1c1a3559f0b3',
      name: 'Anakkavur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b4',
      name: 'Arani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b5',
      name: 'Chengam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b6',
      name: 'Chetput',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b7',
      name: 'Cheyyar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b8',
      name: 'Jawathu Hills',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0b9',
      name: 'Kalasapakkam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ba',
      name: 'Keelpennathur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0bb',
      name: 'Pernamallur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0bc',
      name: 'Polur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0bd',
      name: 'Pudupalayam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0be',
      name: 'Thandrampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0bf',
      name: 'Thellar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c0',
      name: 'Thurinjapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c2',
      name: 'Vandavasi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c3',
      name: 'Vembakkam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c4',
      name: 'West Arani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c7',
      name: 'Tiruvannamalai',
    },
  ],
  Tuticorin: [
    {
      _id: '60ab6e9586ed1c1a3559f0c5',
      name: 'Alwarthirunagari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c6',
      name: 'Karungulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c8',
      name: 'Kayathar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0c9',
      name: 'Kovilpatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ca',
      name: 'Ottapidaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0cb',
      name: 'Sattankulam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0cc',
      name: 'Pudur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0cd',
      name: 'Srivaikundam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ce',
      name: 'Thoothukkudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0cf',
      name: 'Tiruchendur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0d0',
      name: 'Udangudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0d1',
      name: 'Vilathikulam',
    },
  ],
  Vellore: [
    {
      _id: '60ab6e9586ed1c1a3559f0d2',
      name: 'Anaicut',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0d3',
      name: 'Gudiyattam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0d4',
      name: 'Kaniyambadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0d5',
      name: 'Katpadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0d6',
      name: 'K.V.Kuppam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0d7',
      name: 'Peranambattu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0d8',
      name: 'Vellore',
    },
  ],
  Villupuram: [
    {
      _id: '60ab6e9586ed1c1a3559f0d9',
      name: 'Gingee',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0da',
      name: 'Kanai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0db',
      name: 'Kandamangalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0dc',
      name: 'Koliyanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0dd',
      name: 'Marakkanam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0de',
      name: 'Mailam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0df',
      name: 'Mugaiyur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e0',
      name: 'Melmalayanur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e1',
      name: 'Thiruvennainallur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e2',
      name: 'Olakkur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e3',
      name: 'Vallam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e4',
      name: 'Vikravandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e5',
      name: 'Vanur',
    },
  ],
  Virudhunagar: [
    {
      _id: '60ab6e9586ed1c1a3559f0e6',
      name: 'Aruppukottai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e7',
      name: 'Kariapatti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e8',
      name: 'Narikudi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0e9',
      name: 'Rajapalaiyam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ea',
      name: 'Sattur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0eb',
      name: 'Sivakasi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ec',
      name: 'Srivilliputtur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ed',
      name: 'Tiruchuli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ee',
      name: 'Vembakottai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ef',
      name: 'Virudhunagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f0',
      name: 'Watrap',
    },
  ],
  Adilabad: [
    {
      _id: '60ab6e9586ed1c1a3559f0f1',
      name: 'Adilabad Urban',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f2',
      name: 'Aidilabad Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f3',
      name: 'Bazarhatnoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f4',
      name: 'Bela',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f5',
      name: 'Bheempur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f6',
      name: 'Boath',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f7',
      name: 'Gadiguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f8',
      name: 'Gudihatnur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0f9',
      name: 'Ichoda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0fa',
      name: 'Jainath',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0fb',
      name: 'Indervelly',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0fc',
      name: 'Mavala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0fd',
      name: 'Neradigonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0fe',
      name: 'Narnoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f0ff',
      name: 'Sirikonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f100',
      name: 'Talamadugu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f101',
      name: 'Tamsi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f102',
      name: 'Utnoor',
    },
  ],
  'Bhadradri Kothagudem': [
    {
      _id: '60ab6e9586ed1c1a3559f103',
      name: 'Allapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f104',
      name: 'Annapureddypalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f105',
      name: 'Aswapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f106',
      name: 'Aswaraopeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f107',
      name: 'Bhadrachalam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f108',
      name: 'Chandrugonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f109',
      name: 'Burgampahad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f10a',
      name: 'Cherla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f10b',
      name: 'Chunchupalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f10c',
      name: 'Dammapeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f10d',
      name: 'Dummugudem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f10e',
      name: 'Gundala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f10f',
      name: 'Julurupadu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f110',
      name: 'Karakagudem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f111',
      name: 'Kothagudem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f112',
      name: 'Laxmidevipalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f113',
      name: 'Manugur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f114',
      name: 'Mulakalapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f115',
      name: 'Palwancha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f116',
      name: 'Pinapaka',
    },
    {
      _id: '60ab6e9586ed1c1a3559f117',
      name: 'Sujathanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f118',
      name: 'Tekulapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f119',
      name: 'Yellandu',
    },
  ],
  Hyderabad: [
    {
      _id: '60ab6e9586ed1c1a3559f11a',
      name: 'Amberpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f11b',
      name: 'Asifnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f11c',
      name: 'Bahadurpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f11d',
      name: 'Bandlaguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f11e',
      name: 'Charminar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f11f',
      name: 'Golconda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f120',
      name: 'Himayathnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f121',
      name: 'Khairthabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f122',
      name: 'Marredpally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f123',
      name: 'Musheerabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f124',
      name: 'Nampally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f125',
      name: 'Saidabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f126',
      name: 'Secunderabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f127',
      name: 'Shaikpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f128',
      name: 'Tirumalagiry',
    },
    {
      _id: '60ab6e9586ed1c1a3559f12c',
      name: 'Ameerpet',
    },
    {
      _id: '61d585a6c9658483bfa263e5',
      name: 'Alwal',
    },
    {
      _id: '61d585a6c9658483bfa263e6',
      name: 'Begampet',
    },
    {
      _id: '61d585a6c9658483bfa263e7',
      name: 'Chandanagar',
    },
    {
      _id: '61d585a6c9658483bfa263e8',
      name: 'Chandrayangutta',
    },
    {
      _id: '61d585a6c9658483bfa263e9',
      name: 'Falaknuma',
    },
    {
      _id: '61d585a6c9658483bfa263ea',
      name: 'Gachibowli',
    },
    {
      _id: '61d585a6c9658483bfa263eb',
      name: 'Gajularamaram',
    },
    {
      _id: '61d585a6c9658483bfa263ec',
      name: 'Goshamahal',
    },
    {
      _id: '61d585a6c9658483bfa263ed',
      name: 'Hayathnagar',
    },
    {
      _id: '61d585a6c9658483bfa263ee',
      name: 'Jubilee Hills',
    },
    {
      _id: '61d585a6c9658483bfa263ef',
      name: 'Kapra',
    },
    {
      _id: '61d585a6c9658483bfa263f0',
      name: 'Karwan',
    },
    {
      _id: '61d585a6c9658483bfa263f1',
      name: 'Kukatpally',
    },
    {
      _id: '61d585a6c9658483bfa263f2',
      name: 'LB Nagar',
    },
    {
      _id: '61d585a6c9658483bfa263f3',
      name: 'Malakpet',
    },
    {
      _id: '61d585a6c9658483bfa263f4',
      name: 'Malkajgiri',
    },
    {
      _id: '61d585a6c9658483bfa263f5',
      name: 'Mehidipatnam',
    },
    {
      _id: '61d585a6c9658483bfa263f6',
      name: 'Moosapet',
    },
    {
      _id: '61d585a6c9658483bfa263f7',
      name: 'Quthbullapur',
    },
    {
      _id: '61d585a6c9658483bfa263f8',
      name: 'Rajendranagar',
    },
    {
      _id: '61d585a6c9658483bfa263f9',
      name: 'RC Puram',
    },
    {
      _id: '61d585a6c9658483bfa263fa',
      name: 'Santosh Nagar',
    },
    {
      _id: '61d585a6c9658483bfa263fb',
      name: 'Uppal',
    },
    {
      _id: '61d585a6c9658483bfa263fc',
      name: 'Yousufguda',
    },
    {
      _id: '61d585a6c9658483bfa2640d',
      name: 'Saroornagar',
    },
  ],
  Jagitial: [
    {
      _id: '60ab6e9586ed1c1a3559f129',
      name: 'Beerpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f12a',
      name: 'Buggaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f12b',
      name: 'Dharmapuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f12d',
      name: 'Gollapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f12e',
      name: 'Ibrahimpatnam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f12f',
      name: 'Jagitial Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559f130',
      name: 'Jagtial',
    },
    {
      _id: '60ab6e9586ed1c1a3559f131',
      name: 'Kodimial',
    },
    {
      _id: '60ab6e9586ed1c1a3559f132',
      name: 'Korutla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f133',
      name: 'Mallapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f134',
      name: 'Mallial',
    },
    {
      _id: '60ab6e9586ed1c1a3559f135',
      name: 'Kathalapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f136',
      name: 'Metpalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f137',
      name: 'Medipalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f138',
      name: 'Pegadapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f139',
      name: 'Raikal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f13a',
      name: 'Sarangapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f13b',
      name: 'Velgatoor',
    },
  ],
  Jangaon: [
    {
      _id: '60ab6e9586ed1c1a3559f13c',
      name: 'Bachannapeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f13d',
      name: 'Chilpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f13e',
      name: 'Devaruppula',
    },
    {
      _id: '60ab6e9586ed1c1a3559f13f',
      name: 'Ghanpur(Station)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f140',
      name: 'Jangaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f141',
      name: 'Kodakandla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f142',
      name: 'Lingalaghanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f143',
      name: 'Palakurthi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f144',
      name: 'Raghunathpalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f145',
      name: 'Tharigoppula',
    },
    {
      _id: '60ab6e9586ed1c1a3559f146',
      name: 'Zaffergadh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f148',
      name: 'Narmetta',
    },
  ],
  'Jayashankar Bhupalapally': [
    {
      _id: '60ab6e9586ed1c1a3559f147',
      name: 'Bhupalpalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f149',
      name: 'Ghanapur (Mulug)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f14a',
      name: 'Kataram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f14b',
      name: 'Chityal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f14c',
      name: 'Mahadevpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f14d',
      name: 'Malhar Rao',
    },
    {
      _id: '60ab6e9586ed1c1a3559f14e',
      name: 'Mogullapalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f14f',
      name: 'Palimela',
    },
    {
      _id: '60ab6e9586ed1c1a3559f150',
      name: 'Regonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f151',
      name: 'Tekumatla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f153',
      name: 'Mutharam (Mahadevpur)',
    },
  ],
  'Jogulamba Gadwal': [
    {
      _id: '60ab6e9586ed1c1a3559f152',
      name: 'Alampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f154',
      name: 'Gadwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f155',
      name: 'Ghattu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f156',
      name: 'Ieeja',
    },
    {
      _id: '60ab6e9586ed1c1a3559f157',
      name: 'Itikyal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f158',
      name: 'Kaloor Thimmandoddi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f159',
      name: 'Maldakal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f15a',
      name: 'Manopadu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f15b',
      name: 'Rajoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f15c',
      name: 'Undavelly',
    },
    {
      _id: '60ab6e9586ed1c1a3559f15d',
      name: 'Waddepalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f15f',
      name: 'Dharur',
    },
  ],
  Kamareddy: [
    {
      _id: '60ab6e9586ed1c1a3559f15e',
      name: 'Banswada',
    },
    {
      _id: '60ab6e9586ed1c1a3559f160',
      name: 'Bhiknur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f161',
      name: 'Bichkunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f162',
      name: 'Birkoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f163',
      name: 'Domakonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f164',
      name: 'Gandhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f165',
      name: 'Jukkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f166',
      name: 'Kamareddy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f167',
      name: 'Lingampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f168',
      name: 'Machareddy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f169',
      name: 'Madnur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f16a',
      name: 'Nagireddypet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f16b',
      name: 'Nasurullabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f16c',
      name: 'Nizamsagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f16d',
      name: 'Pedda Kodapgal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f16e',
      name: 'Pitlam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f16f',
      name: 'Bibipet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f170',
      name: 'Rajampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f171',
      name: 'Ramareddy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f172',
      name: 'Tadwai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f173',
      name: 'Yellareddy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f176',
      name: 'Sadasivanagar',
    },
  ],
  Karimnagar: [
    {
      _id: '60ab6e9586ed1c1a3559f174',
      name: 'Chigurumamidi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f175',
      name: 'Choppadandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f177',
      name: 'Ellandakunta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f178',
      name: 'Gangadhara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f179',
      name: 'Ganneruvaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f17a',
      name: 'Huzurabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f17b',
      name: 'Karimnagar Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559f17c',
      name: 'Jammikunta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f17d',
      name: 'Karimnagar Rural I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f17e',
      name: 'Kothapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f17f',
      name: 'Manakondur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f180',
      name: 'Ramadugu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f181',
      name: 'Shankarapatnam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f182',
      name: 'Thimmapur (L.M.D.)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f183',
      name: 'Veenavanka',
    },
    {
      _id: '60ab6e9586ed1c1a3559f184',
      name: 'V. Saidapur',
    },
    {
      _id: '61d585a6c9658483bfa263fd',
      name: 'Karimnagar',
    },
  ],
  Khammam: [
    {
      _id: '60ab6e9586ed1c1a3559f185',
      name: 'Bonakal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f186',
      name: 'Enkoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f187',
      name: 'Chinthakani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f188',
      name: 'Kallur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f189',
      name: 'Kamepally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f18a',
      name: 'Khammam (Rural)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f18b',
      name: 'Khammam (Urban)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f18c',
      name: 'Konijerla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f18d',
      name: 'Kusumanchi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f18e',
      name: 'Madhira',
    },
    {
      _id: '60ab6e9586ed1c1a3559f18f',
      name: 'Mudigonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f190',
      name: 'Nelakondapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f191',
      name: 'Penubally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f192',
      name: 'Raghunadhapalem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f193',
      name: 'Sathupally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f194',
      name: 'Singareni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f195',
      name: 'Thallada',
    },
    {
      _id: '60ab6e9586ed1c1a3559f196',
      name: 'Thirumalayapalem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f197',
      name: 'Vemsoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f198',
      name: 'Wyra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f199',
      name: 'Yerrupalem',
    },
  ],
  'Kumuram Bheem Asifabad': [
    {
      _id: '60ab6e9586ed1c1a3559f19a',
      name: 'Asifabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f19b',
      name: 'Bejjur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f19c',
      name: 'Chintalamanepally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f19d',
      name: 'Dahegaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f19e',
      name: 'Jainoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f19f',
      name: 'Kagaznagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a0',
      name: 'Kouthala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a1',
      name: 'Kerameri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a2',
      name: 'Lingapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a3',
      name: 'Penchicalpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a4',
      name: 'Sirpur (T)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a5',
      name: 'Rebbena',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a6',
      name: 'Sirpur (U)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a7',
      name: 'Tiryani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1a8',
      name: 'Wankidi',
    },
  ],
  Mahabubabad: [
    {
      _id: '60ab6e9586ed1c1a3559f1a9',
      name: 'Bayyaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1aa',
      name: 'Chinnagudur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ab',
      name: 'Danthalapalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ac',
      name: 'Dornakal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ad',
      name: 'Gangaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ae',
      name: 'Garla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1af',
      name: 'Gudur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b0',
      name: 'Kesamudram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b1',
      name: 'Kothagudem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b2',
      name: 'Kuravi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b3',
      name: 'Mahbubabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b4',
      name: 'Nallikudur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b5',
      name: 'Maripeda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b6',
      name: 'Narsimhulapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b7',
      name: 'Peddavangara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1b9',
      name: 'Thorrur',
    },
    {
      _id: '61d585a6c9658483bfa263fe',
      name: 'Mahabubabad',
    },
  ],
  Mahbubnagar: [
    {
      _id: '60ab6e9586ed1c1a3559f1b8',
      name: 'Addakal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ba',
      name: 'Balanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1bb',
      name: 'Bhoothpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1bc',
      name: 'Chinnachintakunta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1bd',
      name: 'Devarakadara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1be',
      name: 'Gandeed',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1bf',
      name: 'Hanwada',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c0',
      name: 'Jadcherla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c1',
      name: 'Koilkonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c2',
      name: 'Mahbubnagar Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c3',
      name: 'Mahabubnagar Urban',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c4',
      name: 'Midjil',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c5',
      name: 'Moosapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c6',
      name: 'Nawabpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c7',
      name: 'Rajapur',
    },
  ],
  Mancherial: [
    {
      _id: '60ab6e9586ed1c1a3559f1c8',
      name: 'Bellampally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1c9',
      name: 'Bheemini',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ca',
      name: 'Chennur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1cb',
      name: 'Bheemaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1cc',
      name: 'Hajipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1cd',
      name: 'Jaipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ce',
      name: 'Jannaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1cf',
      name: 'Kannepally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d0',
      name: 'Kasipet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d1',
      name: 'Kotapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d2',
      name: 'Luxettipet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d3',
      name: 'Mancherial',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d4',
      name: 'Mandamarri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d5',
      name: 'Dandepally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d6',
      name: 'Naspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d7',
      name: 'Nennel',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1d8',
      name: 'Tandur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1dc',
      name: 'Vemanpally',
    },
  ],
  Medak: [
    {
      _id: '60ab6e9586ed1c1a3559f1d9',
      name: 'Alladurg',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1da',
      name: 'Chegunta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1db',
      name: 'Chilpched',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1dd',
      name: 'Havelighanapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1de',
      name: 'Kowdipalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1df',
      name: 'Kulcharam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e0',
      name: 'Medak',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e1',
      name: 'Manoharabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e2',
      name: 'Narsapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e3',
      name: 'Nizampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e4',
      name: 'Papannapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e5',
      name: 'Narsingi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e6',
      name: 'Ramayampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e7',
      name: 'Regode',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e8',
      name: 'Shankarampet[A]',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1e9',
      name: 'Shivampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ea',
      name: 'Tekmal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1eb',
      name: 'Shankarampet[R]',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ec',
      name: 'Tupran',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ed',
      name: 'Yeldurthy',
    },
  ],
  Medchal: [
    {
      _id: '60ab6e9586ed1c1a3559f1ee',
      name: 'Alwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ef',
      name: 'Balanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f0',
      name: 'Bachupally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f1',
      name: 'Dundigal Gandimaisamma',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f2',
      name: 'Ghatkesar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f3',
      name: 'Kapra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f4',
      name: 'Keesara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f5',
      name: 'Kukatpally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f6',
      name: 'Malkajgiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f7',
      name: 'Medchal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f8',
      name: 'Medipally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1f9',
      name: 'Quthbullapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1fa',
      name: 'Muduchinthalapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1fb',
      name: 'Shamirpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1fc',
      name: 'Uppal',
    },
    {
      _id: '61d585a6c9658483bfa263ff',
      name: 'Boduppal',
    },
    {
      _id: '61d585a6c9658483bfa26400',
      name: 'Dammaiguda',
    },
    {
      _id: '61d585a6c9658483bfa26401',
      name: 'Gundlapochampally',
    },
    {
      _id: '61d585a6c9658483bfa26402',
      name: 'Jawaharnagar',
    },
    {
      _id: '61d585a6c9658483bfa26403',
      name: 'Komapally',
    },
    {
      _id: '61d585a6c9658483bfa26404',
      name: 'Nagaram',
    },
    {
      _id: '61d585a6c9658483bfa26405',
      name: 'Nizampet',
    },
    {
      _id: '61d585a6c9658483bfa26406',
      name: 'Peerjadiguda',
    },
    {
      _id: '61d585a6c9658483bfa26407',
      name: 'Pocharam',
    },
    {
      _id: '61d585a6c9658483bfa26408',
      name: 'Secunderabad',
    },
    {
      _id: '61d585a6c9658483bfa26409',
      name: 'Thumkunta',
    },
  ],
  Mulugu: [
  {
    _id: '6a04759cfdba9e4e4eaa3353',
    name: 'Mallampally',
  },

  {
    _id: '6a04753abf2a1d6ef8c6346b',
    name: 'Wazeedu',
  },

  {
    _id: '6a04750940a74c7b3dd90e63',
    name: 'Venkatpur',
  },

  {
    _id: '6a0474e1f7f6820de618eb1e',
    name: 'Mulugu',
  },

  {
    _id: '6a0474cd75a7d054ec53b3e3',
    name: 'S S Tadvai',
  },

    {
      _id: '60ab6e9586ed1c1a3559f1fd',
      name: 'Eturnagaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1fe',
      name: 'Govindaraopet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f1ff',
      name: 'Kannaigudem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f200',
      name: 'Mangapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f201',
      name: 'Mulug',
    },
    {
      _id: '60ab6e9586ed1c1a3559f202',
      name: 'Tadvai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f203',
      name: 'Venkatapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f204',
      name: 'Wazeed',
    },
    {
      _id: '60ab6e9586ed1c1a3559f205',
      name: 'Venkatapuram',
    },
  ],
  Nagarkurnool: [
  {
    _id: '6a047f1923f533ca23e0b234',
    name: 'Achampet',
  },

  {
    _id: '6a047dd135210226e314b29c',
    name: 'Thimmajipet',
  },

  {
    _id: '6a047db65364d957ef868a0a',
    name: 'Telkapally',
  },

  {
    _id: '6a047d0d7ed668cca0485feb',
    name: 'Peddakothapally',
  },

  {
    _id: '6a047c5591e9ae0044017a47',
    name: 'Bijinapally',
  },

    {
      _id: '60ab6e9586ed1c1a3559f206',
      name: 'Achampeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f207',
      name: 'Amrabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f208',
      name: 'Balmoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f209',
      name: 'Bijinapalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f20a',
      name: 'Charakonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f20b',
      name: 'Kalwakurthy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f20c',
      name: 'Kodair',
    },
    {
      _id: '60ab6e9586ed1c1a3559f20d',
      name: 'Kollapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f20e',
      name: 'Lingal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f20f',
      name: 'Nagarkurnool',
    },
    {
      _id: '60ab6e9586ed1c1a3559f210',
      name: 'Padara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f211',
      name: 'Pentlavelli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f212',
      name: 'Peddakothapalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f213',
      name: 'Telkapalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f214',
      name: 'Tadoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f215',
      name: 'Thimmajipeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f216',
      name: 'Uppununthala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f217',
      name: 'Urkonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f218',
      name: 'Vangoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f219',
      name: 'Veldanda',
    },
  ],
  Nalgonda: [
    {
      _id: '60ab6e9586ed1c1a3559f21a',
      name: 'Adavidevulapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f21b',
      name: 'Anumula',
    },
    {
      _id: '60ab6e9586ed1c1a3559f21c',
      name: 'Chandampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f21d',
      name: 'Chandur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f21e',
      name: 'Chintha Pally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f21f',
      name: 'Chityala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f220',
      name: 'Dameracherla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f221',
      name: 'Devarakonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f222',
      name: 'Gundlapally (Dindi)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f223',
      name: 'Gurrampode',
    },
    {
      _id: '60ab6e9586ed1c1a3559f224',
      name: 'Kanagal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f225',
      name: 'Kattangoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f226',
      name: 'Kethe Pally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f227',
      name: 'Konda Mallepally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f228',
      name: 'Madugulapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f229',
      name: 'Marriguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f22a',
      name: 'Miryalaguda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f22b',
      name: 'Munugode',
    },
    {
      _id: '60ab6e9586ed1c1a3559f22c',
      name: 'Nakrekal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f22d',
      name: 'Nalgonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f22e',
      name: 'Nampally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f22f',
      name: 'Narketpally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f230',
      name: 'Neredugommu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f231',
      name: 'Nidamanoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f232',
      name: 'Pedda Adiserlapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f233',
      name: 'Peddavoora',
    },
    {
      _id: '60ab6e9586ed1c1a3559f234',
      name: 'Shali Gouraram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f235',
      name: 'Thipparthi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f236',
      name: 'Tirumalagiri Sagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f237',
      name: 'Tripuraram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f238',
      name: 'Vemula Pally',
    },
    {
      _id: '61d585a6c9658483bfa2640a',
      name: 'Haliya',
    },
    {
      _id: '61d585a6c9658483bfa2640b',
      name: 'Nandikonda',
    },
  ],
  Narayanpet: [
    {
      _id: '60ab6e9586ed1c1a3559f239',
      name: 'Damaragidda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f23a',
      name: 'Dhanwada',
    },
    {
      _id: '60ab6e9586ed1c1a3559f23b',
      name: 'Kosgi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f23c',
      name: 'Krishna',
    },
    {
      _id: '60ab6e9586ed1c1a3559f23d',
      name: 'Maddur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f23e',
      name: 'Maganoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f23f',
      name: 'Makthal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f240',
      name: 'Marikal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f241',
      name: 'Narayanpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f242',
      name: 'Narva',
    },
    {
      _id: '60ab6e9586ed1c1a3559f243',
      name: 'Utkoor',
    },
  ],
  Nirmal: [
    {
      _id: '60ab6e9586ed1c1a3559f244',
      name: 'Basar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f245',
      name: 'Dasturabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f246',
      name: 'Bhainsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f247',
      name: 'Dilawarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f248',
      name: 'Kaddam (Peddur)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f249',
      name: 'Khanapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f24a',
      name: 'Kubeer',
    },
    {
      _id: '60ab6e9586ed1c1a3559f24b',
      name: 'Kuntala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f24c',
      name: 'Laxmanchanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f24d',
      name: 'Lokeswaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f24e',
      name: 'Mamda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f24f',
      name: 'Mudhole',
    },
    {
      _id: '60ab6e9586ed1c1a3559f250',
      name: 'Narsapur G',
    },
    {
      _id: '60ab6e9586ed1c1a3559f251',
      name: 'Nirmal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f252',
      name: 'Nirmal Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559f253',
      name: 'Pembi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f254',
      name: 'Sarangapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f255',
      name: 'Soan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f256',
      name: 'Tanur',
    },
  ],
  Nizamabad: [
    {
      _id: '60ab6e9586ed1c1a3559f257',
      name: 'Armur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f258',
      name: 'Balkonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f259',
      name: 'Bheemgal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f25a',
      name: 'Bodhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f25b',
      name: 'Chandur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f25c',
      name: 'Dharpalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f25d',
      name: 'Dichpalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f25e',
      name: 'Jakranpalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f25f',
      name: 'Indalwai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f260',
      name: 'Kotgiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f261',
      name: 'Kammarapalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f262',
      name: 'Makloor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f263',
      name: 'Mortad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f264',
      name: 'Mendora',
    },
    {
      _id: '60ab6e9586ed1c1a3559f265',
      name: 'Mosara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f266',
      name: 'Mugpal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f267',
      name: 'Mupkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f268',
      name: 'Nandipet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f269',
      name: 'Navipet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f26a',
      name: 'Nizamabad North',
    },
    {
      _id: '60ab6e9586ed1c1a3559f26b',
      name: 'Nizamabad Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559f26c',
      name: 'Nizamabad South',
    },
    {
      _id: '60ab6e9586ed1c1a3559f26d',
      name: 'Renjal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f26e',
      name: 'Rudrur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f26f',
      name: 'Sirkonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f270',
      name: 'Varni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f271',
      name: 'Velpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f272',
      name: 'Yedapalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f273',
      name: 'Yergatla',
    },
  ],
  Peddapalli: [
    {
      _id: '60ab6e9586ed1c1a3559f274',
      name: 'Anthergaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f275',
      name: 'Dharmaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f276',
      name: 'Eligaid',
    },
    {
      _id: '60ab6e9586ed1c1a3559f277',
      name: 'Julapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f278',
      name: 'Kamanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f279',
      name: 'Manthani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f27a',
      name: 'Mutharam (Manthani)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f27b',
      name: 'Odela',
    },
    {
      _id: '60ab6e9586ed1c1a3559f27c',
      name: 'Peddapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f27d',
      name: 'Ramagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f27e',
      name: 'Ramagundam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f27f',
      name: 'Srirampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f280',
      name: 'Sulthanabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f28c',
      name: 'Palakurthy',
    },
  ],
  'Rajanna Sircilla': [
    {
      _id: '60ab6e9586ed1c1a3559f281',
      name: 'Boinpalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f282',
      name: 'Chandurthi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f283',
      name: 'Ellanthakunta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f284',
      name: 'Gambhiraopet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f285',
      name: 'Konaraopet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f286',
      name: 'Mustabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f287',
      name: 'Rudrangi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f288',
      name: 'Sircilla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f289',
      name: 'Thangallapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f28a',
      name: 'Veernapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f28b',
      name: 'Vemulawada',
    },
    {
      _id: '60ab6e9586ed1c1a3559f28d',
      name: 'Vemulawada Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559f28e',
      name: 'Yellareddipet',
    },
  ],
  Rangareddy: [
    {
      _id: '60ab6e9586ed1c1a3559f28f',
      name: 'Abdullapurmet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f290',
      name: 'Amangal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f291',
      name: 'Balapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f292',
      name: 'Chevella',
    },
    {
      _id: '60ab6e9586ed1c1a3559f293',
      name: 'Farooqnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f294',
      name: 'Gandipet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f295',
      name: 'Hayathnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f296',
      name: 'Jilled Chowdergudem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f297',
      name: 'Kadthal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f298',
      name: 'Kandukur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f299',
      name: 'Keshampeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f29a',
      name: 'Kondurg',
    },
    {
      _id: '60ab6e9586ed1c1a3559f29b',
      name: 'Kothur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f29c',
      name: 'Madgul',
    },
    {
      _id: '60ab6e9586ed1c1a3559f29d',
      name: 'Maheshwaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f29e',
      name: 'Manchal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f29f',
      name: 'Moinabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a0',
      name: 'Ibrahimpatnam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a1',
      name: 'Nandigama',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a2',
      name: 'Rajendranagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a3',
      name: 'Serilingampally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a4',
      name: 'Shabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a5',
      name: 'Shamshabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a6',
      name: 'Shankarpally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a7',
      name: 'Saroornagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a8',
      name: 'Talakondapalle',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2a9',
      name: 'Yacharam',
    },
    {
      _id: '61d585a6c9658483bfa2640c',
      name: 'Adibatla',
    },
    {
      _id: '61d585a6c9658483bfa2640e',
      name: 'Manikonda',
    },
    {
      _id: '61d585a6c9658483bfa2640f',
      name: 'Badangpet',
    },
    {
      _id: '61d585a6c9658483bfa26410',
      name: 'Bandlaguda Jagir',
    },
    {
      _id: '61d585a6c9658483bfa26411',
      name: 'Pedda Amberpet',
    },
    {
      _id: '61d585a6c9658483bfa26412',
      name: 'Shadnagar',
    },
    {
      _id: '61d585a6c9658483bfa26413',
      name: 'Thukkuguda',
    },
    {
      _id: '61d585a6c9658483bfa26414',
      name: 'Turkayamjal',
    },
    {
      _id: '61d585a6c9658483bfa26415',
      name: 'Narsingi',
    },
  ],
  Sangareddy: [
    {
      _id: '60ab6e9586ed1c1a3559f2aa',
      name: 'Ameenpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ab',
      name: 'Andole',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ac',
      name: 'Gummadidala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ad',
      name: 'Hathnoora',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ae',
      name: 'Jharasangam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2af',
      name: 'Jinnaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b0',
      name: 'Kalher',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b1',
      name: 'Kangti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b2',
      name: 'Kandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b3',
      name: 'Kondapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b4',
      name: 'Kohir',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b5',
      name: 'Manoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b6',
      name: 'Munipally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b7',
      name: 'Nagalgidda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b8',
      name: 'Narayankhed',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2b9',
      name: 'Nyalkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ba',
      name: 'Patancheru',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2bb',
      name: 'Pulkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2bc',
      name: 'Raikode',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2bd',
      name: 'Ramchandrapuram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2be',
      name: 'Mogudampally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2bf',
      name: 'Sadasivpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c0',
      name: 'Sangareddy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c1',
      name: 'Sirgapoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c2',
      name: 'Vatpally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c3',
      name: 'Zahirabad',
    },
    {
      _id: '61d585a6c9658483bfa26416',
      name: 'Bollaram',
    },
    {
      _id: '61d585a6c9658483bfa26417',
      name: 'Tellapur',
    },
    {
      _id: '61d585a6c9658483bfa26418',
      name: 'Andol Jogipet',
    },
  ],
  Siddipet: [
    {
      _id: '60ab6e9586ed1c1a3559f2c4',
      name: 'Akkannapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c5',
      name: 'Bejjanki',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c6',
      name: 'Cheriyal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c7',
      name: 'Chinnakodur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c8',
      name: 'Doultabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2c9',
      name: 'Gajwel',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ca',
      name: 'Husnabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2cb',
      name: 'Jagdevpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2cc',
      name: 'Koheda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2cd',
      name: 'Komuravelli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ce',
      name: 'Kondapak',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2cf',
      name: 'Dubbak',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d0',
      name: 'Maddur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d1',
      name: 'Markook',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d2',
      name: 'Mirdoddi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d3',
      name: 'Mulug',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d4',
      name: 'Nanganoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d5',
      name: 'Raipole',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d6',
      name: 'Narayanaraopet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d7',
      name: 'Siddipet Urban',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d8',
      name: 'Siddipet Rural',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2d9',
      name: 'Thoguta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2dc',
      name: 'Wargal',
    },
  ],
  Suryapet: [
    {
      _id: '60ab6e9586ed1c1a3559f2da',
      name: 'Ananthagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2db',
      name: 'Atmakur(S)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2dd',
      name: 'Chilkur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2de',
      name: 'Chinthalapalem Mallareddygudem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2df',
      name: 'Chivvemla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e0',
      name: 'Huzurnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e1',
      name: 'Jaji Reddi Gudem (Arvapally)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e2',
      name: 'Kodad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e3',
      name: 'Maddirala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e4',
      name: 'Mattam Pally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e5',
      name: 'Mella Chervu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e6',
      name: 'Mothey',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e7',
      name: 'Munagala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e8',
      name: 'Garide Pally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2e9',
      name: 'Nagaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ea',
      name: 'Nadigudem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2eb',
      name: 'Nereducherla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ec',
      name: 'Nuthankal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ed',
      name: 'Palakeedu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ee',
      name: 'Penpahad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ef',
      name: 'Suryapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f0',
      name: 'Thirumalagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f1',
      name: 'Thungathurthi',
    },
  ],
  Vikarabad: [
    {
      _id: '60ab6e9586ed1c1a3559f2f2',
      name: 'Bantwaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f3',
      name: 'Basheerabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f4',
      name: 'Bomraspeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f5',
      name: 'Dharur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f6',
      name: 'Doma',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f7',
      name: 'Doulatabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f8',
      name: 'Kotepally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2f9',
      name: 'Kodangal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2fa',
      name: 'Kulkacharla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2fb',
      name: 'Marpally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2fc',
      name: 'Mominpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2fd',
      name: 'Nawabpet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2fe',
      name: 'Peddemul',
    },
    {
      _id: '60ab6e9586ed1c1a3559f2ff',
      name: 'Pargi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f300',
      name: 'Pudur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f301',
      name: 'Tandur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f302',
      name: 'Vikarabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f308',
      name: 'Yalal',
    },
  ],
  Wanaparthy: [
    {
      _id: '60ab6e9586ed1c1a3559f303',
      name: 'Amarachintha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f304',
      name: 'Atmakur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f305',
      name: 'Chinnambavi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f306',
      name: 'Ghanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f307',
      name: 'Gopalpeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f309',
      name: 'Madanapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f30a',
      name: 'Kothakota',
    },
    {
      _id: '60ab6e9586ed1c1a3559f30b',
      name: 'Pangal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f30c',
      name: 'Peddamandadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f30d',
      name: 'Pebbair',
    },
    {
      _id: '60ab6e9586ed1c1a3559f30e',
      name: 'Revally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f30f',
      name: 'Srirangapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f310',
      name: 'Wanaparthy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f311',
      name: 'Weepangandla',
    },
  ],
  'Warangal Rural': [
    {
      _id: '60ab6e9586ed1c1a3559f312',
      name: 'Atmakur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f313',
      name: 'Damera',
    },
    {
      _id: '60ab6e9586ed1c1a3559f314',
      name: 'Duggondi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f315',
      name: 'Chennaraopet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f316',
      name: 'Khanapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f317',
      name: 'Nadikuda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f318',
      name: 'Nalla Belli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f319',
      name: 'Narsampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f31a',
      name: 'Nekkonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f31b',
      name: 'Parkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f31c',
      name: 'Parvathagiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f31d',
      name: 'Raiparthy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f31e',
      name: 'Sangem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f31f',
      name: 'Shayampet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f320',
      name: 'Wardhanna Pet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f322',
      name: 'Geesugonda',
    },
  ],
  'Warangal Urban': [
    {
      _id: '60ab6e9586ed1c1a3559f321',
      name: 'Bheemadevarapalli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f323',
      name: 'Dharmasagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f324',
      name: 'Elkathurthi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f325',
      name: 'Hanamkonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f326',
      name: 'Hasanparthy',
    },
    {
      _id: '60ab6e9586ed1c1a3559f327',
      name: 'Kamalapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f328',
      name: 'Khazipet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f329',
      name: 'Khila Warangal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f32a',
      name: 'Velair',
    },
    {
      _id: '60ab6e9586ed1c1a3559f32b',
      name: 'Inavole',
    },
    {
      _id: '60ab6e9586ed1c1a3559f32c',
      name: 'Warangal',
    },
  ],
  'Yadadri Bhuvanagiri': [
    {
      _id: '60ab6e9586ed1c1a3559f32d',
      name: 'Addaguduru',
    },
    {
      _id: '60ab6e9586ed1c1a3559f32e',
      name: 'Atmakur(M)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f32f',
      name: 'Bhongir',
    },
    {
      _id: '60ab6e9586ed1c1a3559f330',
      name: 'Alair',
    },
    {
      _id: '60ab6e9586ed1c1a3559f331',
      name: 'Bibinagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f332',
      name: 'Bommala Ramaram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f333',
      name: 'B.Pochampally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f334',
      name: 'Gundala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f335',
      name: 'Motakonduru',
    },
    {
      _id: '60ab6e9586ed1c1a3559f336',
      name: 'Mothkur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f337',
      name: 'Choutuppal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f338',
      name: 'Narayanapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f339',
      name: 'Rajapet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f33a',
      name: 'Ramannapeta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f33b',
      name: 'Thurkapally',
    },
    {
      _id: '60ab6e9586ed1c1a3559f33c',
      name: 'Valigonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f33d',
      name: 'Yadagirigutta',
    },
  ],
  Daman: [
    {
      _id: '60ab6e9586ed1c1a3559f33e',
      name: 'Daman',
    },
  ],
  Diu: [
    {
      _id: '60ab6e9586ed1c1a3559f33f',
      name: 'Diu',
    },
  ],
  Dhalai: [
    {
      _id: '60ab6e9586ed1c1a3559f340',
      name: 'Ambassa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f341',
      name: 'Chawmanu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f343',
      name: 'Dumburnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f344',
      name: 'Durgachowmuhani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f345',
      name: 'Ganganagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f346',
      name: 'Manu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f347',
      name: 'Raishyabari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f348',
      name: 'Salema',
    },
  ],
  'Dadra And Nagar Haveli': [
    {
      _id: '60ab6e9586ed1c1a3559f342',
      name: 'Dadra Nagar Haveli',
    },
  ],
  Gomati: [
    {
      _id: '60ab6e9586ed1c1a3559f349',
      name: 'Amarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f34a',
      name: 'Kakraban',
    },
    {
      _id: '60ab6e9586ed1c1a3559f34b',
      name: 'Karbook',
    },
    {
      _id: '60ab6e9586ed1c1a3559f34c',
      name: 'Killa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f34d',
      name: 'Matabari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f34e',
      name: 'Ompi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f34f',
      name: 'Silachari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f350',
      name: 'Tepania',
    },
  ],
  Khowai: [
    {
      _id: '60ab6e9586ed1c1a3559f351',
      name: 'Khowai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f352',
      name: 'Mungiakami',
    },
    {
      _id: '60ab6e9586ed1c1a3559f353',
      name: 'Padmabil',
    },
    {
      _id: '60ab6e9586ed1c1a3559f354',
      name: 'Teliamura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f355',
      name: 'Tulashikhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f35c',
      name: 'Kalyanpur',
    },
  ],
  'North Tripura': [
    {
      _id: '60ab6e9586ed1c1a3559f356',
      name: 'Damcherra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f357',
      name: 'Dasda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f358',
      name: 'Jampui Hills',
    },
    {
      _id: '60ab6e9586ed1c1a3559f359',
      name: 'Jubarajnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f35a',
      name: 'Kadamtala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f35b',
      name: 'Kalacherra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f35d',
      name: 'Laljuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f35f',
      name: 'Panisagar',
    },
  ],
  Sepahijala: [
    {
      _id: '60ab6e9586ed1c1a3559f35e',
      name: 'Bishalgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f360',
      name: 'Boxanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f361',
      name: 'Jampuijala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f362',
      name: 'Kathalia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f363',
      name: 'Mohanbhog',
    },
    {
      _id: '60ab6e9586ed1c1a3559f364',
      name: 'Nalchar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f365',
      name: 'Charilam',
    },
  ],
  'South Tripura': [
    {
      _id: '60ab6e9586ed1c1a3559f366',
      name: 'Bharat Chandra Nagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f367',
      name: 'Bokafa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f368',
      name: 'Hrishyamukh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f369',
      name: 'Jolaibari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f36a',
      name: 'Rajnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f36b',
      name: 'Rupaichari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f36c',
      name: 'Satchand',
    },
    {
      _id: '60ab6e9586ed1c1a3559f375',
      name: 'Poangbari',
    },
  ],
  Unakoti: [
    {
      _id: '60ab6e9586ed1c1a3559f36d',
      name: 'Chandipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f36e',
      name: 'Gournagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f36f',
      name: 'Kumarghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f370',
      name: 'Pecharthal',
    },
  ],
  'West Tripura': [
    {
      _id: '60ab6e9586ed1c1a3559f371',
      name: 'Bamutia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f372',
      name: 'Belbari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f373',
      name: 'Dukli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f374',
      name: 'Hezamara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f376',
      name: 'Jirania',
    },
    {
      _id: '60ab6e9586ed1c1a3559f377',
      name: 'Mandwai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f378',
      name: 'Lefunga',
    },
    {
      _id: '60ab6e9586ed1c1a3559f379',
      name: 'Mohanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f37f',
      name: 'Old Agartala',
    },
  ],
  Almora: [
    {
      _id: '60ab6e9586ed1c1a3559f37a',
      name: 'Bhaisiya Chhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f37b',
      name: 'Bhikiyasain',
    },
    {
      _id: '60ab6e9586ed1c1a3559f37c',
      name: 'Chaukhutiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f37d',
      name: 'Dhauladevi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f37e',
      name: 'Dwarahat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f380',
      name: 'Hawalbag',
    },
    {
      _id: '60ab6e9586ed1c1a3559f381',
      name: 'Lamgara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f382',
      name: 'Sult',
    },
    {
      _id: '60ab6e9586ed1c1a3559f383',
      name: 'Takula',
    },
    {
      _id: '60ab6e9586ed1c1a3559f384',
      name: 'Tarikhet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f387',
      name: 'Syaldey',
    },
  ],
  Bageshwar: [
    {
      _id: '60ab6e9586ed1c1a3559f385',
      name: 'Bageshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f386',
      name: 'Garur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f388',
      name: 'Kapkote',
    },
  ],
  Chamoli: [
    {
      _id: '60ab6e9586ed1c1a3559f389',
      name: 'Dewal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f38a',
      name: 'Dasholi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f38b',
      name: 'Gairsain',
    },
    {
      _id: '60ab6e9586ed1c1a3559f38c',
      name: 'Joshimath',
    },
    {
      _id: '60ab6e9586ed1c1a3559f38d',
      name: 'Ghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f38e',
      name: 'Karnaprayag',
    },
    {
      _id: '60ab6e9586ed1c1a3559f38f',
      name: 'Narayanbagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f390',
      name: 'Pokhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f391',
      name: 'Tharali',
    },
  ],
  Champawat: [
    {
      _id: '60ab6e9586ed1c1a3559f392',
      name: 'Barakot',
    },
    {
      _id: '60ab6e9586ed1c1a3559f393',
      name: 'Champawat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f394',
      name: 'Lohaghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f395',
      name: 'Pati',
    },
  ],
  Dehradun: [
    {
      _id: '60ab6e9586ed1c1a3559f396',
      name: 'Doiwala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f397',
      name: 'Kalsi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f398',
      name: 'Raipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f399',
      name: 'Sahaspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f39a',
      name: 'Chakrata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f39c',
      name: 'Vikasnagar',
    },
  ],
  Haridwar: [
    {
      _id: '60ab6e9586ed1c1a3559f39b',
      name: 'Bahadrabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f39d',
      name: 'Bhagwanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f39e',
      name: 'Khanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f39f',
      name: 'Narsan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3a0',
      name: 'Laksar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3a1',
      name: 'Roorkee',
    },
  ],
  Nainital: [
    {
      _id: '60ab6e9586ed1c1a3559f3a2',
      name: 'Betalghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3a3',
      name: 'Bhimtal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3a4',
      name: 'Dhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3a5',
      name: 'Kotabag',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3a6',
      name: 'Okhalkanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3a7',
      name: 'Ramgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3a9',
      name: 'Haldwani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ab',
      name: 'Ramnagar',
    },
  ],
  'Pauri Garhwal': [
    {
      _id: '60ab6e9586ed1c1a3559f3aa',
      name: 'Bironkhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ac',
      name: 'Dwarikhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ad',
      name: 'Duggada',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ae',
      name: 'Kaljikhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3af',
      name: 'Khirsu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b0',
      name: 'Kot',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b1',
      name: 'Nainidanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b2',
      name: 'Pabau',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b3',
      name: 'Pauri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b4',
      name: 'Pokhra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b5',
      name: 'Rikhnikhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b6',
      name: 'Thalisain',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b7',
      name: 'Yamkeshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3b8',
      name: 'Zahrikhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3bb',
      name: 'Ekeshwar',
    },
  ],
  Pithoragarh: [
    {
      _id: '60ab6e9586ed1c1a3559f3b9',
      name: 'Berinag',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ba',
      name: 'Dharchula',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3bc',
      name: 'Didihat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3bd',
      name: 'Gangolihat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3be',
      name: 'Kanalichina',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3bf',
      name: 'Munakot',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3c0',
      name: 'Munsyari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3c1',
      name: 'Pithoragarh',
    },
  ],
  'Rudra Prayag': [
    {
      _id: '60ab6e9586ed1c1a3559f3c2',
      name: 'Augustmuni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3c3',
      name: 'Jakholi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3c4',
      name: 'Ukhimath',
    },
  ],
  'Tehri Garhwal': [
    {
      _id: '60ab6e9586ed1c1a3559f3c5',
      name: 'Bhilangna',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3c6',
      name: 'Chamba',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3c7',
      name: 'Jakhnidhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3c8',
      name: 'Jaunpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3c9',
      name: 'Kirtinagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ca',
      name: 'Deoprayag',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3cb',
      name: 'Narendra Nagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3cc',
      name: 'Pratapnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d1',
      name: 'Thauldhar',
    },
  ],
  'Udam Singh Nagar': [
    {
      _id: '60ab6e9586ed1c1a3559f3cd',
      name: 'Bajpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ce',
      name: 'Gadarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3cf',
      name: 'Jaspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d0',
      name: 'Kashipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d2',
      name: 'Khatima',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d3',
      name: 'Rudrapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d6',
      name: 'Sitarganj',
    },
  ],
  'Uttar Kashi': [
    {
      _id: '60ab6e9586ed1c1a3559f3d4',
      name: 'Bhatwari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d5',
      name: 'Chinyalisaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d7',
      name: 'Dunda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d8',
      name: 'Mori',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3d9',
      name: 'Naugaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3da',
      name: 'Purola',
    },
  ],
  Agra: [
    {
      _id: '60ab6e9586ed1c1a3559f3db',
      name: 'Achhnera',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3dc',
      name: 'Akola',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3dd',
      name: 'Bah',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3de',
      name: 'Barauli Ahir',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3df',
      name: 'Bichpuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e0',
      name: 'Etmadpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e1',
      name: 'Fatehpur Sikri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e2',
      name: 'Jagner',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e3',
      name: 'Jaitpur Kalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e4',
      name: 'Khandauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e5',
      name: 'Kheragarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e6',
      name: 'Fatehabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e7',
      name: 'Saiyan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e8',
      name: 'Shamsabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3e9',
      name: 'Pinahat',
    },
  ],
  Aligarh: [
    {
      _id: '60ab6e9586ed1c1a3559f3ea',
      name: 'Atrauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3eb',
      name: 'Akrabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ec',
      name: 'Bijauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ed',
      name: 'Chandaus',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ee',
      name: 'Dhanipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ef',
      name: 'Gangiri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f0',
      name: 'Gonda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f1',
      name: 'Jawan Sikanderpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f2',
      name: 'Khair',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f3',
      name: 'Iglas',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f4',
      name: 'Tappal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3fa',
      name: 'Lodha',
    },
  ],
  'Ambedkar Nagar': [
    {
      _id: '60ab6e9586ed1c1a3559f3f5',
      name: 'Akbarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f6',
      name: 'Baskhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f7',
      name: 'Bhiti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f8',
      name: 'Bhiyawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3f9',
      name: 'Jahangir Ganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3fb',
      name: 'Jalal Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3fc',
      name: 'Katehari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3fd',
      name: 'Tanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f3ff',
      name: 'Ram Nagar',
    },
  ],
  Amethi: [
    {
      _id: '60ab6e9586ed1c1a3559f3fe',
      name: 'Amethi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f400',
      name: 'Bahadurpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f401',
      name: 'Bhadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f402',
      name: 'Bhetua',
    },
    {
      _id: '60ab6e9586ed1c1a3559f403',
      name: 'Gauriganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f404',
      name: 'Jagdishpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f405',
      name: 'Jamo',
    },
    {
      _id: '60ab6e9586ed1c1a3559f406',
      name: 'Musafir Khana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f407',
      name: 'Shahgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f408',
      name: 'Shukul Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f409',
      name: 'Singhpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f40a',
      name: 'Tiloi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f40c',
      name: 'Sangrampur',
    },
  ],
  Amroha: [
    {
      _id: '60ab6e9586ed1c1a3559f40b',
      name: 'Amroha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f40d',
      name: 'Dhanaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f40e',
      name: 'Gajraula',
    },
    {
      _id: '60ab6e9586ed1c1a3559f40f',
      name: 'Gangeshwari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f410',
      name: 'Hasanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f411',
      name: 'Joya',
    },
  ],
  Auraiya: [
    {
      _id: '60ab6e9586ed1c1a3559f412',
      name: 'Achchalda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f413',
      name: 'Ajitmal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f414',
      name: 'Auraiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f415',
      name: 'Bhagyanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f416',
      name: 'Bidhuna',
    },
    {
      _id: '60ab6e9586ed1c1a3559f417',
      name: 'Erwa Katra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f418',
      name: 'Sahar',
    },
  ],
  Faizabad: [
    {
      _id: '60ab6e9586ed1c1a3559f419',
      name: 'Amaniganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f41a',
      name: 'Hariyangatanganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f41b',
      name: 'Masodha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f41c',
      name: 'Mawai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f41d',
      name: 'Bikapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f41e',
      name: 'Maya Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f41f',
      name: 'Milkipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f420',
      name: 'Pura Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f421',
      name: 'Rudauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f422',
      name: 'Sohawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f423',
      name: 'Tarun',
    },
  ],
  Azamgarh: [
    {
      _id: '60ab6e9586ed1c1a3559f424',
      name: 'Atraulia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f425',
      name: 'Azmatgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f426',
      name: 'Bilariyaganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f427',
      name: 'Haraiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f428',
      name: 'Jahanaganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f429',
      name: 'Koilsa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f42a',
      name: 'Lalganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f42b',
      name: 'Mahrajganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f42c',
      name: 'Martinganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f42d',
      name: 'Mehnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f42e',
      name: 'Ahiraula',
    },
    {
      _id: '60ab6e9586ed1c1a3559f42f',
      name: 'Mirzapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f430',
      name: 'Mohammadpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f431',
      name: 'Palhani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f432',
      name: 'Pawai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f433',
      name: 'Phulpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f434',
      name: 'Rani Ki Sarai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f435',
      name: 'Sathiyaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f436',
      name: 'Tahbarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f437',
      name: 'Tarwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f438',
      name: 'Thekma',
    },
    {
      _id: '60ab6e9586ed1c1a3559f439',
      name: 'Palhana',
    },
  ],
  Baghpat: [
    {
      _id: '60ab6e9586ed1c1a3559f43a',
      name: 'Baraut',
    },
    {
      _id: '60ab6e9586ed1c1a3559f43b',
      name: 'Binauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f43c',
      name: 'Chhaprauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f43d',
      name: 'Baghpat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f43e',
      name: 'Khekra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f43f',
      name: 'Pilana',
    },
  ],
  Bahraich: [
    {
      _id: '60ab6e9586ed1c1a3559f440',
      name: 'Chitaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f441',
      name: 'Huzoorpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f442',
      name: 'Jarwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f443',
      name: 'Balaha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f444',
      name: 'Mahasi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f445',
      name: 'Kaisarganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f446',
      name: 'Mihinpurwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f447',
      name: 'Nawabganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f448',
      name: 'Payagpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f449',
      name: 'Risia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f44a',
      name: 'Shivpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f44b',
      name: 'Phakharpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f44c',
      name: 'Tejwapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f44d',
      name: 'Visheshwarganj',
    },
  ],
  Ballia: [
    {
      _id: '60ab6e9586ed1c1a3559f44e',
      name: 'Bairia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f44f',
      name: 'Belhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f450',
      name: 'Bansdih',
    },
    {
      _id: '60ab6e9586ed1c1a3559f451',
      name: 'Beruarbari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f452',
      name: 'Chilkahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f453',
      name: 'Garwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f454',
      name: 'Hanumanganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f455',
      name: 'Maniar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f456',
      name: 'Murlichhapra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f457',
      name: 'Nagra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f458',
      name: 'Navanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f459',
      name: 'Pandah',
    },
    {
      _id: '60ab6e9586ed1c1a3559f45a',
      name: 'Rasra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f45b',
      name: 'Reoti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f45c',
      name: 'Siar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f45d',
      name: 'Sohanv',
    },
    {
      _id: '60ab6e9586ed1c1a3559f45f',
      name: 'Dubhar',
    },
  ],
  Banda: [
    {
      _id: '60ab6e9586ed1c1a3559f468',
      name: 'Badokhar Khurd',
    },
    {
      _id: '60ab6e9586ed1c1a3559f469',
      name: 'Bisanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f46a',
      name: 'Jaspura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f46b',
      name: 'Kamasin',
    },
    {
      _id: '60ab6e9586ed1c1a3559f46c',
      name: 'Baberu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f46d',
      name: 'Mahuva',
    },
    {
      _id: '60ab6e9586ed1c1a3559f46e',
      name: 'Tindwari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f471',
      name: 'Naraini',
    },
  ],
  'Bara Banki': [
    {
      _id: '60ab6e9586ed1c1a3559f46f',
      name: 'Bani Kodar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f470',
      name: 'Banki',
    },
    {
      _id: '60ab6e9586ed1c1a3559f472',
      name: 'Dariyabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f473',
      name: 'Dewa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f474',
      name: 'Fatehpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f475',
      name: 'Haidargarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f476',
      name: 'Harakh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f477',
      name: 'Masauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f478',
      name: 'Puredalai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f479',
      name: 'Ramnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f47a',
      name: 'Sidhaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f47b',
      name: 'Sirauli Gauspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f47c',
      name: 'Nindaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f47d',
      name: 'Suratganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f47e',
      name: 'Trivediganj',
    },
  ],
  Bareilly: [
    {
      _id: '60ab6e9586ed1c1a3559f47f',
      name: 'Aalampur Jafarabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f480',
      name: 'Baheri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f481',
      name: 'Bhojipura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f482',
      name: 'Bhadpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f483',
      name: 'Bhuta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f484',
      name: 'Bithiri Chainpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f485',
      name: 'Damkhauda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f486',
      name: 'Faridpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f487',
      name: 'Fatehganj West',
    },
    {
      _id: '60ab6e9586ed1c1a3559f488',
      name: 'Kyara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f489',
      name: 'Mirganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f48a',
      name: 'Nawabganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f48b',
      name: 'Ramnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f48c',
      name: 'Majhgawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f48e',
      name: 'Shergarh',
    },
  ],
  Basti: [
    {
      _id: '60ab6e9586ed1c1a3559f48d',
      name: 'Bahadurpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f48f',
      name: 'Basti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f490',
      name: 'Dubauliya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f491',
      name: 'Bankati',
    },
    {
      _id: '60ab6e9586ed1c1a3559f492',
      name: 'Gaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f493',
      name: 'Harraiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f494',
      name: 'Kaptanganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f495',
      name: 'Kudaraha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f496',
      name: 'Paras Rampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f497',
      name: 'Ramnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f498',
      name: 'Rudauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f499',
      name: 'Saltaua Gopal Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f49a',
      name: 'Vikram Jot',
    },
    {
      _id: '60ab6e9586ed1c1a3559f49b',
      name: 'Sau Ghat',
    },
  ],
  'Sant Ravidas Nagar': [
    {
      _id: '60ab6e9586ed1c1a3559f49c',
      name: 'Aurai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f49d',
      name: 'Abhauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f49e',
      name: 'Bhadohi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f49f',
      name: 'Deegh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a0',
      name: 'Gyanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a1',
      name: 'Suriyavan',
    },
  ],
  Bijnor: [
    {
      _id: '60ab6e9586ed1c1a3559f4a2',
      name: 'Afzalgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a3',
      name: 'Budhanpur Seohara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a4',
      name: 'Haldaur(Khari Jhalu)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a5',
      name: 'Jalilpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a6',
      name: 'Kiratpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a7',
      name: 'Kotwali',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a8',
      name: 'Mohammedpur Deomal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4a9',
      name: 'Najibabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4aa',
      name: 'Nehtaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ab',
      name: 'Noorpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b2',
      name: 'Dhampur',
    },
  ],
  Budaun: [
    {
      _id: '60ab6e9586ed1c1a3559f4ac',
      name: 'Ambiapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ad',
      name: 'Asafpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ae',
      name: 'Bisauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4af',
      name: 'Dahgavan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b0',
      name: 'Dataganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b1',
      name: 'Islamnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b3',
      name: 'Jagat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b4',
      name: 'Mion',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b5',
      name: 'Qadar Chowk',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b6',
      name: 'Sahaswan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b7',
      name: 'Samrer',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b8',
      name: 'Ujhani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4b9',
      name: 'Usawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ba',
      name: 'Wazirganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4bf',
      name: 'Salarpur',
    },
  ],
  Bulandshahr: [
    {
      _id: '60ab6e9586ed1c1a3559f4bb',
      name: 'Agauta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4bc',
      name: 'Anupshahr',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4bd',
      name: 'Araniya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4be',
      name: 'Bhawan Bahadur Nagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c0',
      name: 'Danpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c1',
      name: 'Bulandshahr',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c2',
      name: 'Dibai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c3',
      name: 'Gulaothi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c4',
      name: 'Jahangirabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c5',
      name: 'Khurja',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c6',
      name: 'Lakhaothi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c7',
      name: 'Shikarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c8',
      name: 'Sikandrabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4c9',
      name: 'Pahasu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ca',
      name: 'Unchagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d8',
      name: 'Syana',
    },
  ],
  Chandauli: [
    {
      _id: '60ab6e9586ed1c1a3559f4cb',
      name: 'Berahani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4cc',
      name: 'Chahniya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4cd',
      name: 'Chakiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ce',
      name: 'Chandauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4cf',
      name: 'Dhanapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d0',
      name: 'Naugarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d1',
      name: 'Niyamatabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d2',
      name: 'Sahabganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d3',
      name: 'Sakaldiha',
    },
  ],
  Chitrakoot: [
    {
      _id: '60ab6e9586ed1c1a3559f4d4',
      name: 'Karwi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d5',
      name: 'Manikpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d6',
      name: 'Mau',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d7',
      name: 'Pahari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4d9',
      name: 'Ramnagar',
    },
  ],
  Deoria: [
    {
      _id: '60ab6e9586ed1c1a3559f4da',
      name: 'Baitalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4db',
      name: 'Bankata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4dc',
      name: 'Barhaj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4dd',
      name: 'Bhagalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4de',
      name: 'Bhaluani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4df',
      name: 'Bhatni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e0',
      name: 'Bhatpar Rani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e1',
      name: 'Deoria Sadar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e2',
      name: 'Gauri Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e3',
      name: 'Desai Deoria',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e4',
      name: 'Lar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e5',
      name: 'Rampur Karkhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e6',
      name: 'Rudrapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e7',
      name: 'Salempur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4e8',
      name: 'Tarkalua',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ef',
      name: 'Pathar Dewa',
    },
  ],
  Etah: [
    {
      _id: '60ab6e9586ed1c1a3559f4e9',
      name: 'Aliganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ea',
      name: 'Awagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4eb',
      name: 'Jaithara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ec',
      name: 'Jalesar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ed',
      name: 'Marehra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ee',
      name: 'Nidhauli Kalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f0',
      name: 'Shitalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f1',
      name: 'Sakit',
    },
  ],
  Etawah: [
    {
      _id: '60ab6e9586ed1c1a3559f4f2',
      name: 'Basrehar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f3',
      name: 'Bharthana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f4',
      name: 'Chakarnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f5',
      name: 'Barhpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f6',
      name: 'Jaswantnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f7',
      name: 'Mahewa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f8',
      name: 'Sefai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4f9',
      name: 'Takha',
    },
  ],
  Farrukhabad: [
    {
      _id: '60ab6e9586ed1c1a3559f4fa',
      name: 'Barhpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4fb',
      name: 'Kaimganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4fc',
      name: 'Kamalganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4fd',
      name: 'Nawabganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4fe',
      name: 'Rajepur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f4ff',
      name: 'Shamsabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f500',
      name: 'Mohamdabad',
    },
  ],
  Fatehpur: [
    {
      _id: '60ab6e9586ed1c1a3559f501',
      name: 'Amauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f502',
      name: 'Airayan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f503',
      name: 'Asothar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f504',
      name: 'Bahua',
    },
    {
      _id: '60ab6e9586ed1c1a3559f505',
      name: 'Bhitaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f506',
      name: 'Devmai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f507',
      name: 'Dhata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f508',
      name: 'Haswa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f509',
      name: 'Hathgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f50a',
      name: 'Khajuha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f50b',
      name: 'Malwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f50c',
      name: 'Telyani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f50d',
      name: 'Vijayipur',
    },
  ],
  Firozabad: [
    {
      _id: '60ab6e9586ed1c1a3559f50e',
      name: 'Araon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f50f',
      name: 'Eka',
    },
    {
      _id: '60ab6e9586ed1c1a3559f510',
      name: 'Firozabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f511',
      name: 'Hathwant',
    },
    {
      _id: '60ab6e9586ed1c1a3559f512',
      name: 'Jasrana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f513',
      name: 'Madanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f514',
      name: 'Narkhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f515',
      name: 'Tundla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f516',
      name: 'Shikohabad',
    },
  ],
  'Gautam Buddha Nagar': [
    {
      _id: '60ab6e9586ed1c1a3559f517',
      name: 'Dadri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f518',
      name: 'Bisrakh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f519',
      name: 'Dankaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f51a',
      name: 'Jewar',
    },
  ],
  Ghaziabad: [
    {
      _id: '60ab6e9586ed1c1a3559f51b',
      name: 'Loni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f51c',
      name: 'Muradnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f51d',
      name: 'Bhojpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f51e',
      name: 'Rajapur',
    },
  ],
  Ghazipur: [
    {
      _id: '60ab6e9586ed1c1a3559f51f',
      name: 'Bhanwarkol',
    },
    {
      _id: '60ab6e9586ed1c1a3559f520',
      name: 'Devkali',
    },
    {
      _id: '60ab6e9586ed1c1a3559f521',
      name: 'Bhadaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f522',
      name: 'Ghazipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f523',
      name: 'Jakhania',
    },
    {
      _id: '60ab6e9586ed1c1a3559f524',
      name: 'Karanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f525',
      name: 'Kasimabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f526',
      name: 'Manihari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f527',
      name: 'Mardah',
    },
    {
      _id: '60ab6e9586ed1c1a3559f528',
      name: 'Revatipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f529',
      name: 'Mohammadabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f52a',
      name: 'Saidpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f52b',
      name: 'Varachakwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f52c',
      name: 'Virno',
    },
    {
      _id: '60ab6e9586ed1c1a3559f52d',
      name: 'Zamania',
    },
    {
      _id: '60ab6e9586ed1c1a3559f52f',
      name: 'Sadat',
    },
  ],
  Gonda: [
    {
      _id: '60ab6e9586ed1c1a3559f52e',
      name: 'Babhanjot',
    },
    {
      _id: '60ab6e9586ed1c1a3559f530',
      name: 'Belsar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f531',
      name: 'Chhapia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f532',
      name: 'Colonelganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f533',
      name: 'Haldharmau',
    },
    {
      _id: '60ab6e9586ed1c1a3559f534',
      name: 'Itiathok',
    },
    {
      _id: '60ab6e9586ed1c1a3559f535',
      name: 'Jhanjhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f536',
      name: 'Katra Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f537',
      name: 'Mankapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f538',
      name: 'Mujehana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f539',
      name: 'Nawabganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f53a',
      name: 'Pandri Kripal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f53b',
      name: 'Paraspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f53c',
      name: 'Rupaideeh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f53d',
      name: 'Wazirganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f541',
      name: 'Tarabganj',
    },
  ],
  Gorakhpur: [
    {
      _id: '60ab6e9586ed1c1a3559f53e',
      name: 'Bansgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f53f',
      name: 'Barhalganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f540',
      name: 'Belghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f542',
      name: 'Bharohiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f543',
      name: 'Bhathat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f544',
      name: 'Brahmpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f545',
      name: 'Campierganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f546',
      name: 'Chargawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f547',
      name: 'Gagaha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f548',
      name: 'Gola',
    },
    {
      _id: '60ab6e9586ed1c1a3559f549',
      name: 'Jangal Kaudia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f54a',
      name: 'Kauri Ram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f54b',
      name: 'Khajni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f54c',
      name: 'Khorabar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f54d',
      name: 'Pali',
    },
    {
      _id: '60ab6e9586ed1c1a3559f54e',
      name: 'Piprauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f54f',
      name: 'Sahjanawa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f550',
      name: 'Pipraich',
    },
    {
      _id: '60ab6e9586ed1c1a3559f551',
      name: 'Sardarnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f552',
      name: 'Uruwa',
    },
  ],
  Hapur: [
    {
      _id: '60ab6e9586ed1c1a3559f559',
      name: 'Dhaulana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f55b',
      name: 'Garh Mukteshwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f55c',
      name: 'Hapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f55d',
      name: 'Simbhawali',
    },
  ],
  Hardoi: [
    {
      _id: '60ab6e9586ed1c1a3559f55e',
      name: 'Bawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f55f',
      name: 'Behendar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f560',
      name: 'Bharawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f561',
      name: 'Ahirori',
    },
    {
      _id: '60ab6e9586ed1c1a3559f562',
      name: 'Bharkhani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f563',
      name: 'Bilgram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f564',
      name: 'Hariyawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f565',
      name: 'Harpalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f566',
      name: 'Kachauna',
    },
    {
      _id: '60ab6e9586ed1c1a3559f567',
      name: 'Kothawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f568',
      name: 'Mallawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f569',
      name: 'Madhoganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f56a',
      name: 'Pihani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f56b',
      name: 'Sandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f56c',
      name: 'Sandila',
    },
    {
      _id: '60ab6e9586ed1c1a3559f56d',
      name: 'Shahabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f56e',
      name: 'Tandiyawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f56f',
      name: 'Todarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f57e',
      name: 'Sursa',
    },
  ],
  Hathras: [
    {
      _id: '60ab6e9586ed1c1a3559f570',
      name: 'Hasayan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f571',
      name: 'Hathras',
    },
    {
      _id: '60ab6e9586ed1c1a3559f572',
      name: 'Mursan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f573',
      name: 'Sadabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f574',
      name: 'Sasni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f575',
      name: 'Sehpau',
    },
    {
      _id: '60ab6e9586ed1c1a3559f576',
      name: 'Sikandrarao',
    },
  ],
  Jalaun: [
    {
      _id: '60ab6e9586ed1c1a3559f577',
      name: 'Dakore',
    },
    {
      _id: '60ab6e9586ed1c1a3559f578',
      name: 'Jalaun',
    },
    {
      _id: '60ab6e9586ed1c1a3559f579',
      name: 'Kadaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f57a',
      name: 'Konch',
    },
    {
      _id: '60ab6e9586ed1c1a3559f57b',
      name: 'Kuthaund',
    },
    {
      _id: '60ab6e9586ed1c1a3559f57c',
      name: 'Madhogarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f57d',
      name: 'Maheva',
    },
    {
      _id: '60ab6e9586ed1c1a3559f57f',
      name: 'Nadigaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f580',
      name: 'Rampura',
    },
  ],
  Jaunpur: [
    {
      _id: '60ab6e9586ed1c1a3559f581',
      name: 'Baksha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f582',
      name: 'Barasathi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f583',
      name: 'Dharma Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f584',
      name: 'Dobhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f585',
      name: 'Jalal Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f586',
      name: 'Badla Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f587',
      name: 'Karanja Kala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f588',
      name: 'Kerakat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f589',
      name: 'Khuthan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f58a',
      name: 'Maharaj Ganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f58b',
      name: 'Mariyahu',
    },
    {
      _id: '60ab6e9586ed1c1a3559f58c',
      name: 'Mufti Ganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f58d',
      name: 'Mungra Badshah Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f58e',
      name: 'Machchali Shahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f58f',
      name: 'Ram Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f590',
      name: 'Ram Nagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f591',
      name: 'Shah Ganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f592',
      name: 'Sikrara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f593',
      name: 'Sirkoni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f594',
      name: 'Suitha Kala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f595',
      name: 'Sujan Ganj',
    },
  ],
  Jhansi: [
    {
      _id: '60ab6e9586ed1c1a3559f596',
      name: 'Babina',
    },
    {
      _id: '60ab6e9586ed1c1a3559f597',
      name: 'Badagaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f598',
      name: 'Bamaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f599',
      name: 'Bangra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f59a',
      name: 'Gursarai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f59b',
      name: 'Chirgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f59c',
      name: 'Mauranipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f59e',
      name: 'Moth',
    },
  ],
  Kannauj: [
    {
      _id: '60ab6e9586ed1c1a3559f59d',
      name: 'Chhibramau',
    },
    {
      _id: '60ab6e9586ed1c1a3559f59f',
      name: 'Gughrapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a0',
      name: 'Haseran',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a1',
      name: 'Jalalabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a2',
      name: 'Saurikh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a3',
      name: 'Talgram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a4',
      name: 'Kannauj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a5',
      name: 'Umarda',
    },
  ],
  'Kanpur Dehat': [
    {
      _id: '60ab6e9586ed1c1a3559f5a6',
      name: 'Akbarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a7',
      name: 'Derapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a8',
      name: 'Amrodha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5a9',
      name: 'Jhinjhak',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5aa',
      name: 'Maitha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ab',
      name: 'Malasa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ac',
      name: 'Rasulabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ad',
      name: 'Sandalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ae',
      name: 'Sarbankhera',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b6',
      name: 'Rajpur',
    },
  ],
  'Kanpur Nagar': [
    {
      _id: '60ab6e9586ed1c1a3559f5af',
      name: 'Bhitargaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b0',
      name: 'Bilhaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b1',
      name: 'Chaubeypur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b2',
      name: 'Ghatampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b3',
      name: 'Kakwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b4',
      name: 'Kalyanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b5',
      name: 'Patara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b7',
      name: 'Sarsol',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5b8',
      name: 'Shivrajpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5c5',
      name: 'Vidhunu',
    },
  ],
  Kasganj: [
    {
      _id: '60ab6e9586ed1c1a3559f5b9',
      name: 'Amanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ba',
      name: 'Ganj Dundwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5bb',
      name: 'Kasganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5bc',
      name: 'Patiyali',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5bd',
      name: 'Sahawar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5be',
      name: 'Sidhpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5bf',
      name: 'Soron',
    },
  ],
  Kaushambi: [
    {
      _id: '60ab6e9586ed1c1a3559f5c0',
      name: 'Chail',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5c1',
      name: 'Kara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5c2',
      name: 'Kaushambi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5c3',
      name: 'Manjhanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5c4',
      name: 'Mooratganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5c6',
      name: 'Sarsawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5c7',
      name: 'Nevada',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5c8',
      name: 'Sirathu',
    },
  ],
  'Lakhimpur Kheri': [
    {
      _id: '60ab6e9586ed1c1a3559f5c9',
      name: 'Bankeyganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ca',
      name: 'Behjam',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5cb',
      name: 'Bijuwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5cc',
      name: 'Dhaurhara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5cd',
      name: 'Isanagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ce',
      name: 'Kumbhigola',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5cf',
      name: 'Mitauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d0',
      name: 'Lakhimpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d1',
      name: 'Mohammadi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d2',
      name: 'Nakaha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d3',
      name: 'Nighasan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d4',
      name: 'Pasgawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d5',
      name: 'Phoolbehar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d6',
      name: 'Ramia Behar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5dd',
      name: 'Palia',
    },
  ],
  Kushinagar: [
    {
      _id: '60ab6e9586ed1c1a3559f5d7',
      name: 'Dudhahi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d8',
      name: 'Fazilnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5d9',
      name: 'Hata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5da',
      name: 'Kaptainganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5db',
      name: 'Kasaya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5dc',
      name: 'Khadda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5de',
      name: 'Motichak',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5df',
      name: 'Nebua Naurangia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e0',
      name: 'Kubernath',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e1',
      name: 'Padrauna',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e2',
      name: 'Seorahi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e3',
      name: 'Sukrauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e4',
      name: 'Tamkuhiraj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e5',
      name: 'Ramkola',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e6',
      name: 'Vishunpura',
    },
  ],
  Lalitpur: [
    {
      _id: '60ab6e9586ed1c1a3559f5e7',
      name: 'Birdha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e8',
      name: 'Bar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5e9',
      name: 'Jakhaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ea',
      name: 'Mandawara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5eb',
      name: 'Mehroni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ec',
      name: 'Talbehat',
    },
  ],
  Lucknow: [
    {
      _id: '60ab6e9586ed1c1a3559f5ed',
      name: 'Chinhat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ee',
      name: 'Gosaiganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ef',
      name: 'Kakori',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f0',
      name: 'Mal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f1',
      name: 'Malihabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f2',
      name: 'Mohanlalganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f3',
      name: 'Sarojaninagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5fa',
      name: 'Bakshi-Ka-Talab',
    },
  ],
  Maharajganj: [
    {
      _id: '60ab6e9586ed1c1a3559f5f4',
      name: 'Bridgemanganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f5',
      name: 'Dhani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f6',
      name: 'Ghughli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f7',
      name: 'Lakshmipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f8',
      name: 'Mahrajganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5f9',
      name: 'Mithaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5fb',
      name: 'Nichlaul',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5fc',
      name: 'Paniyara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5fd',
      name: 'Partawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5fe',
      name: 'Pharenda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f5ff',
      name: 'Nautanwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f600',
      name: 'Siswa',
    },
  ],
  Mahoba: [
    {
      _id: '60ab6e9586ed1c1a3559f601',
      name: 'Jaitpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f602',
      name: 'Charkhari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f603',
      name: 'Kabrai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f604',
      name: 'Panwari',
    },
  ],
  Mainpuri: [
    {
      _id: '60ab6e9586ed1c1a3559f605',
      name: 'Barnahal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f606',
      name: 'Ghiror',
    },
    {
      _id: '60ab6e9586ed1c1a3559f607',
      name: 'Jageer',
    },
    {
      _id: '60ab6e9586ed1c1a3559f608',
      name: 'Karhal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f609',
      name: 'Kishni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f60a',
      name: 'Bewar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f60b',
      name: 'Mainpuri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f60c',
      name: 'Kuraoli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f60d',
      name: 'Sultanganj',
    },
  ],
  Mathura: [
    {
      _id: '60ab6e9586ed1c1a3559f60e',
      name: 'Baldeo',
    },
    {
      _id: '60ab6e9586ed1c1a3559f60f',
      name: 'Chaumuha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f610',
      name: 'Chhata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f611',
      name: 'Farah',
    },
    {
      _id: '60ab6e9586ed1c1a3559f612',
      name: 'Govardhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f613',
      name: 'Mat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f614',
      name: 'Mathura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f615',
      name: 'Nandgaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f616',
      name: 'Raya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f61a',
      name: 'Nohjhil',
    },
  ],
  Mau: [
    {
      _id: '60ab6e9586ed1c1a3559f617',
      name: 'Badraon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f618',
      name: 'Dohri Ghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f619',
      name: 'Fatehpur Madaun',
    },
    {
      _id: '60ab6e9586ed1c1a3559f61b',
      name: 'Ghosi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f61c',
      name: 'Kopaganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f61d',
      name: 'Mohammadabad Gohana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f61e',
      name: 'Pardaha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f61f',
      name: 'Ratanpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f621',
      name: 'Ranipur',
    },
  ],
  Meerut: [
    {
      _id: '60ab6e9586ed1c1a3559f620',
      name: 'Daurala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f622',
      name: 'Hastinapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f623',
      name: 'Janikhurd',
    },
    {
      _id: '60ab6e9586ed1c1a3559f624',
      name: 'Kharkhoda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f625',
      name: 'Machra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f626',
      name: 'Mawana Kalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f627',
      name: 'Meerut',
    },
    {
      _id: '60ab6e9586ed1c1a3559f628',
      name: 'Parikshitgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f629',
      name: 'Rajpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f62a',
      name: 'Sardhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f62b',
      name: 'Sarurpur Khurd',
    },
    {
      _id: '60ab6e9586ed1c1a3559f62c',
      name: 'Rohta',
    },
  ],
  Mirzapur: [
    {
      _id: '60ab6e9586ed1c1a3559f62d',
      name: 'Hallia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f62e',
      name: 'Chhanvey',
    },
    {
      _id: '60ab6e9586ed1c1a3559f62f',
      name: 'Jamalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f630',
      name: 'Kon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f631',
      name: 'Lalganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f632',
      name: 'Majhawa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f633',
      name: 'Nagar (City)',
    },
    {
      _id: '60ab6e9586ed1c1a3559f634',
      name: 'Narainpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f635',
      name: 'Patehra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f636',
      name: 'Pahari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f637',
      name: 'Rajgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f638',
      name: 'Shikhar',
    },
  ],
  Moradabad: [
    {
      _id: '60ab6e9586ed1c1a3559f639',
      name: 'Bhagatpur Tanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f63a',
      name: 'Bilari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f63b',
      name: 'Chhajlet',
    },
    {
      _id: '60ab6e9586ed1c1a3559f63c',
      name: 'Kundarki',
    },
    {
      _id: '60ab6e9586ed1c1a3559f63d',
      name: 'Moradabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f63e',
      name: 'Munda Pandey',
    },
    {
      _id: '60ab6e9586ed1c1a3559f63f',
      name: 'Thakurdwara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f64c',
      name: 'Dilari',
    },
  ],
  Muzaffarnagar: [
    {
      _id: '60ab6e9586ed1c1a3559f640',
      name: 'Baghara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f641',
      name: 'Budhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f642',
      name: 'Charthawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f643',
      name: 'Jansath',
    },
    {
      _id: '60ab6e9586ed1c1a3559f644',
      name: 'Khatauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f645',
      name: 'Morna',
    },
    {
      _id: '60ab6e9586ed1c1a3559f646',
      name: 'Muzaffarnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f647',
      name: 'Purkaji',
    },
    {
      _id: '60ab6e9586ed1c1a3559f648',
      name: 'Shahpur',
    },
  ],
  Pilibhit: [
    {
      _id: '60ab6e9586ed1c1a3559f649',
      name: 'Amariya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f64a',
      name: 'Barkhera',
    },
    {
      _id: '60ab6e9586ed1c1a3559f64b',
      name: 'Bilsanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f64d',
      name: 'Bisalpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f64e',
      name: 'Lalaurikhera',
    },
    {
      _id: '60ab6e9586ed1c1a3559f64f',
      name: 'Marori',
    },
    {
      _id: '60ab6e9586ed1c1a3559f650',
      name: 'Puranpur',
    },
  ],
  Prayagraj: [
    {
      _id: '60ab6e9586ed1c1a3559f662',
      name: 'Bahadurpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f663',
      name: 'Bahria',
    },
    {
      _id: '60ab6e9586ed1c1a3559f664',
      name: 'Bhagwatpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f665',
      name: 'Chaka',
    },
    {
      _id: '60ab6e9586ed1c1a3559f666',
      name: 'Dhanupur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f667',
      name: 'Handia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f668',
      name: 'Holagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f669',
      name: 'Jasra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f66a',
      name: 'Karchhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f66b',
      name: 'Kaudhiyara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f66c',
      name: 'Kaurihar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f66d',
      name: 'Koraon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f66e',
      name: 'Manda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f66f',
      name: 'Mauaima',
    },
    {
      _id: '60ab6e9586ed1c1a3559f670',
      name: 'Meja',
    },
    {
      _id: '60ab6e9586ed1c1a3559f671',
      name: 'Phulpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f672',
      name: 'Pratappur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f673',
      name: 'Sahson',
    },
    {
      _id: '60ab6e9586ed1c1a3559f674',
      name: 'Saidabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f675',
      name: 'Shankargarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f676',
      name: 'Soraon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f677',
      name: 'Sringverpur Dham',
    },
    {
      _id: '60ab6e9586ed1c1a3559f678',
      name: 'Uruwan',
    },
  ],
  'Rae Bareli': [
    {
      _id: '60ab6e9586ed1c1a3559f679',
      name: 'Amawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f67a',
      name: 'Bachharawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f67b',
      name: 'Chhatoh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f67c',
      name: 'Dalmau',
    },
    {
      _id: '60ab6e9586ed1c1a3559f67d',
      name: 'Deenshah Gaura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f67e',
      name: 'Dih',
    },
    {
      _id: '60ab6e9586ed1c1a3559f67f',
      name: 'Harchandpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f680',
      name: 'Jagatpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f681',
      name: 'Khiron',
    },
    {
      _id: '60ab6e9586ed1c1a3559f682',
      name: 'Lalganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f683',
      name: 'Mahrajganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f684',
      name: 'Rahi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f685',
      name: 'Salon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f686',
      name: 'Rohania',
    },
    {
      _id: '60ab6e9586ed1c1a3559f687',
      name: 'Sareni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f688',
      name: 'Sataon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f689',
      name: 'Unchahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f68d',
      name: 'Shivgarh',
    },
  ],
  Rampur: [
    {
      _id: '60ab6e9586ed1c1a3559f68a',
      name: 'Bilaspur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f68b',
      name: 'Chamraon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f68c',
      name: 'Milak',
    },
    {
      _id: '60ab6e9586ed1c1a3559f68e',
      name: 'Shahabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f68f',
      name: 'Saidnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f690',
      name: 'Suar',
    },
  ],
  Saharanpur: [
    {
      _id: '60ab6e9586ed1c1a3559f691',
      name: 'Ballia Kheri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f692',
      name: 'Deoband',
    },
    {
      _id: '60ab6e9586ed1c1a3559f693',
      name: 'Muzaffarabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f694',
      name: 'Nagal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f695',
      name: 'Gangoh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f696',
      name: 'Nakur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f697',
      name: 'Nanauta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f698',
      name: 'Rampur Maniharan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f699',
      name: 'Sadauli Qadeem',
    },
    {
      _id: '60ab6e9586ed1c1a3559f69a',
      name: 'Sarsawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a7',
      name: 'Puwarka',
    },
  ],
  Sambhal: [
    {
      _id: '60ab6e9586ed1c1a3559f69b',
      name: 'Asmauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f69c',
      name: 'Bahjoi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f69d',
      name: 'Baniyakhera',
    },
    {
      _id: '60ab6e9586ed1c1a3559f69e',
      name: 'Gunnaur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f69f',
      name: 'Junawai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a0',
      name: 'Panwasa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a1',
      name: 'Rajpura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a2',
      name: 'Sambhal',
    },
  ],
  'Sant Kabir Nagar': [
    {
      _id: '60ab6e9586ed1c1a3559f6a3',
      name: 'Baghauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a4',
      name: 'Belhar Kala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a5',
      name: 'Hainsar Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a6',
      name: 'Khalilabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a8',
      name: 'Mehdawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6a9',
      name: 'Pauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6aa',
      name: 'Santha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ab',
      name: 'Semariyawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ad',
      name: 'Nath Nagar',
    },
  ],
  Shahjahanpur: [
    {
      _id: '60ab6e9586ed1c1a3559f6ac',
      name: 'Banda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ae',
      name: 'Bhawal Khera',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6af',
      name: 'Dadrol',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b0',
      name: 'Jalalabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b1',
      name: 'Jaitipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b2',
      name: 'Kanth',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b3',
      name: 'Kalan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b4',
      name: 'Khudaganj Katra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b5',
      name: 'Khutar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b6',
      name: 'Madnapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b7',
      name: 'Nigohi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b8',
      name: 'Powayan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6b9',
      name: 'Sindhauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ba',
      name: 'Tilhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6c7',
      name: 'Mirzapur',
    },
  ],
  Shamli: [
    {
      _id: '60ab6e9586ed1c1a3559f6bb',
      name: 'Kairana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6bc',
      name: 'Kandhla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6bd',
      name: 'Shamli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6be',
      name: 'Thana Bhawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6bf',
      name: 'Un',
    },
  ],
  Shrawasti: [
    {
      _id: '60ab6e9586ed1c1a3559f6c0',
      name: 'Ekona',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6c1',
      name: 'Gilaula',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6c2',
      name: 'Hariharpur Rani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6c3',
      name: 'Jamunaha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6c4',
      name: 'Sirsiya',
    },
  ],
  Siddharthnagar: [
    {
      _id: '60ab6e9586ed1c1a3559f6c5',
      name: 'Bansi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6c6',
      name: 'Barhni',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6c8',
      name: 'Bhanwapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6c9',
      name: 'Birdpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ca',
      name: 'Domariyaganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6cb',
      name: 'Itwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6cc',
      name: 'Jogia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6cd',
      name: 'Khesraha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ce',
      name: 'Khuniyaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6cf',
      name: 'Lotan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d0',
      name: 'Mithwal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d1',
      name: 'Naugarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d2',
      name: 'Shoharatgarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d3',
      name: 'Uska Bazar',
    },
  ],
  Sitapur: [
    {
      _id: '60ab6e9586ed1c1a3559f6d4',
      name: 'Ailiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d5',
      name: 'Behta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d6',
      name: 'Biswan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d7',
      name: 'Gondlamau',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d8',
      name: 'Hargaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6d9',
      name: 'Kasmanda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6da',
      name: 'Khairabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6db',
      name: 'Machhrehta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6dc',
      name: 'Laharpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6dd',
      name: 'Maholi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6de',
      name: 'Mahmudabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6df',
      name: 'Misrikh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e0',
      name: 'Parsendi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e1',
      name: 'Pahala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e2',
      name: 'Pisawan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e3',
      name: 'Rampur Mathura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e4',
      name: 'Reusa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e5',
      name: 'Sakran',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e6',
      name: 'Sidhauli',
    },
  ],
  Sonbhadra: [
    {
      _id: '60ab6e9586ed1c1a3559f6e7',
      name: 'Babhani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e8',
      name: 'Chatra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6e9',
      name: 'Chopan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ea',
      name: 'Dudhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6eb',
      name: 'Ghorawal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ec',
      name: 'Karma',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ed',
      name: 'Kone',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ee',
      name: 'Myorpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6ef',
      name: 'Nagwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f0',
      name: 'Robertsganj',
    },
  ],
  Sultanpur: [
    {
      _id: '60ab6e9586ed1c1a3559f6f1',
      name: 'Akhand Nagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f2',
      name: 'Baldirai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f3',
      name: 'Bhadaiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f4',
      name: 'Dhanpatganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f5',
      name: 'Dostpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f6',
      name: 'Dubepur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f7',
      name: 'Jaisinghpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f8',
      name: 'Kadipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6f9',
      name: 'Karaudikala',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6fa',
      name: 'Kurebhar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6fb',
      name: 'Kurwar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6fc',
      name: 'Lambhua',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6fd',
      name: 'Motigarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f6fe',
      name: 'P.P.Kamaicha',
    },
  ],
  Unnao: [
    {
      _id: '60ab6e9586ed1c1a3559f6ff',
      name: 'Asoha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f700',
      name: 'Auras',
    },
    {
      _id: '60ab6e9586ed1c1a3559f701',
      name: 'Bangarmau',
    },
    {
      _id: '60ab6e9586ed1c1a3559f702',
      name: 'Bichhiya',
    },
    {
      _id: '60ab6e9586ed1c1a3559f703',
      name: 'Bighapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f704',
      name: 'Fatehpur Chaurasi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f705',
      name: 'Ganj Moradabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f706',
      name: 'Hasanganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f707',
      name: 'Hilauli',
    },
    {
      _id: '60ab6e9586ed1c1a3559f708',
      name: 'Mianganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f709',
      name: 'Nawabganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f70a',
      name: 'Purwa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f70b',
      name: 'Safipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f70c',
      name: 'Sikandarpur Karan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f70d',
      name: 'Sikandarpur Sarausi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f70e',
      name: 'Sumerpur',
    },
  ],
  Varanasi: [
    {
      _id: '60ab6e9586ed1c1a3559f70f',
      name: 'Arajiline',
    },
    {
      _id: '60ab6e9586ed1c1a3559f710',
      name: 'Baragaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f711',
      name: 'Chiraigaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f712',
      name: 'Cholapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f713',
      name: 'Harahua',
    },
    {
      _id: '60ab6e9586ed1c1a3559f714',
      name: 'Kashi Vidyapeeth',
    },
    {
      _id: '60ab6e9586ed1c1a3559f715',
      name: 'Pindra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f716',
      name: 'Sevapuri',
    },
  ],
  '24 Paraganas North': [
    {
      _id: '60ab6e9586ed1c1a3559f717',
      name: 'Baduria',
    },
    {
      _id: '60ab6e9586ed1c1a3559f718',
      name: 'Amdanga',
    },
    {
      _id: '60ab6e9586ed1c1a3559f719',
      name: 'Bagda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f71a',
      name: 'Barasat-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f71b',
      name: 'Barasat-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f71c',
      name: 'Barrackpur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f71d',
      name: 'Barrackpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f71e',
      name: 'Basirhat-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f71f',
      name: 'Basirhat-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f720',
      name: 'Bongaon',
    },
    {
      _id: '60ab6e9586ed1c1a3559f721',
      name: 'Deganga',
    },
    {
      _id: '60ab6e9586ed1c1a3559f722',
      name: 'Gaighata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f723',
      name: 'Habra-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f724',
      name: 'Habra-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f725',
      name: 'Haroa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f726',
      name: 'Hasnabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f727',
      name: 'Hingalganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f728',
      name: 'Minakhan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f729',
      name: 'Rajarhat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f72a',
      name: 'Sandeshkhali-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f72b',
      name: 'Sandeshkhali-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f72c',
      name: 'Swarupnagar',
    },
  ],
  '24 Paraganas South': [
    {
      _id: '60ab6e9586ed1c1a3559f72d',
      name: 'Baruipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f72e',
      name: 'Basanti',
    },
    {
      _id: '60ab6e9586ed1c1a3559f72f',
      name: 'Bhangar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f730',
      name: 'Bhangar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f731',
      name: 'Bishnupur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f732',
      name: 'Bishnupur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f733',
      name: 'Budge Budge-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f734',
      name: 'Budge Budge-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f735',
      name: 'Canning-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f736',
      name: 'Canning-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f737',
      name: 'Diamond Harbour-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f738',
      name: 'Diamond Harbour-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f739',
      name: 'Falta',
    },
    {
      _id: '60ab6e9586ed1c1a3559f73a',
      name: 'Gosaba',
    },
    {
      _id: '60ab6e9586ed1c1a3559f73b',
      name: 'Jaynagar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f73c',
      name: 'Kak Dwip',
    },
    {
      _id: '60ab6e9586ed1c1a3559f73d',
      name: 'Jaynagar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f73e',
      name: 'Kulpi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f73f',
      name: 'Kultali',
    },
    {
      _id: '60ab6e9586ed1c1a3559f740',
      name: 'Magra Hat-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f741',
      name: 'Magra Hat-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f742',
      name: 'Mandirbazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f743',
      name: 'Mathurapur I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f744',
      name: 'Mathurapur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f745',
      name: 'Namkhana',
    },
    {
      _id: '60ab6e9586ed1c1a3559f746',
      name: 'Pathar Pratima',
    },
    {
      _id: '60ab6e9586ed1c1a3559f747',
      name: 'Sagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f748',
      name: 'Sonarpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f749',
      name: 'Thakurpukur Mahestola',
    },
  ],
  Alipurduar: [
    {
      _id: '60ab6e9586ed1c1a3559f74a',
      name: 'Alipurduar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f74b',
      name: 'Alipurduar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f74c',
      name: 'Falakata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f74d',
      name: 'Kalchini',
    },
    {
      _id: '60ab6e9586ed1c1a3559f74e',
      name: 'Kumargram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f74f',
      name: 'Madarihat',
    },
  ],
  Bankura: [
    {
      _id: '60ab6e9586ed1c1a3559f750',
      name: 'Bankura-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f751',
      name: 'Bankura-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f752',
      name: 'Barjora',
    },
    {
      _id: '60ab6e9586ed1c1a3559f753',
      name: 'Chhatna',
    },
    {
      _id: '60ab6e9586ed1c1a3559f754',
      name: 'Gangajal Ghati',
    },
    {
      _id: '60ab6e9586ed1c1a3559f755',
      name: 'Hirbandh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f756',
      name: 'Indpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f757',
      name: 'Indus',
    },
    {
      _id: '60ab6e9586ed1c1a3559f758',
      name: 'Jaypur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f759',
      name: 'Khatra-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f75a',
      name: 'Mejhia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f75b',
      name: 'Kotulpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f75c',
      name: 'Onda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f75d',
      name: 'Raipur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f75e',
      name: 'Patrasayer',
    },
    {
      _id: '60ab6e9586ed1c1a3559f75f',
      name: 'Ranibundh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f760',
      name: 'Saltora',
    },
    {
      _id: '60ab6e9586ed1c1a3559f761',
      name: 'Sarenga',
    },
    {
      _id: '60ab6e9586ed1c1a3559f762',
      name: 'Simlapal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f763',
      name: 'Sonamukhi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f764',
      name: 'Vishnupur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f765',
      name: 'Taldangra',
    },
  ],
  Birbhum: [
    {
      _id: '60ab6e9586ed1c1a3559f766',
      name: 'Bolpur-Sriniketan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f767',
      name: 'Illambazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f768',
      name: 'Dubrajpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f769',
      name: 'Khoyrasol',
    },
    {
      _id: '60ab6e9586ed1c1a3559f76a',
      name: 'Labpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f76b',
      name: 'Mayureswar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f76c',
      name: 'Mohammad Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f76d',
      name: 'Mayureswar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f76e',
      name: 'Murarai-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f76f',
      name: 'Murarai-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f770',
      name: 'Nalhati-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f771',
      name: 'Nalhati-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f772',
      name: 'Nanoor',
    },
    {
      _id: '60ab6e9586ed1c1a3559f773',
      name: 'Rajnagar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f774',
      name: 'Rampurhat-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f775',
      name: 'Rampurhat-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f776',
      name: 'Suri-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f777',
      name: 'Sainthia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f778',
      name: 'Suri-Ii',
    },
  ],
  Coochbehar: [
    {
      _id: '60ab6e9586ed1c1a3559f779',
      name: 'Cooch Behar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f77a',
      name: 'Cooch Behar Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f77b',
      name: 'Dinhata-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f77c',
      name: 'Haldibari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f77d',
      name: 'Dinhata-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f77e',
      name: 'Mathabhanga-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f77f',
      name: 'Mathabhanga Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f780',
      name: 'Mekliganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f781',
      name: 'Sitai',
    },
    {
      _id: '60ab6e9586ed1c1a3559f782',
      name: 'Sitalkuchi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f783',
      name: 'Tufanganj-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f784',
      name: 'Tufanganj-Ii',
    },
  ],
  Darjeeling: [
    {
      _id: '60ab6e9586ed1c1a3559f785',
      name: 'Darjeeling-Pulbazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f786',
      name: 'Jore Bunglow-Sukiapokhri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f787',
      name: 'Kharibari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f788',
      name: 'Kurseong',
    },
    {
      _id: '60ab6e9586ed1c1a3559f789',
      name: 'Matigara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f78a',
      name: 'Mirik',
    },
    {
      _id: '60ab6e9586ed1c1a3559f78b',
      name: 'Naxal Bari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f78c',
      name: 'Phansidewa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f78d',
      name: 'Rangli Rangliot',
    },
  ],
  'Dinajpur Dakshin': [
    {
      _id: '60ab6e9586ed1c1a3559f78e',
      name: 'Balurghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f78f',
      name: 'Bansihari',
    },
    {
      _id: '60ab6e9586ed1c1a3559f790',
      name: 'Gangarampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f792',
      name: 'Harirampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f793',
      name: 'Hili',
    },
    {
      _id: '60ab6e9586ed1c1a3559f794',
      name: 'Kumarganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f795',
      name: 'Kushmandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a4',
      name: 'Tapan',
    },
  ],
  'Dinajpur Uttar': [
    {
      _id: '60ab6e9586ed1c1a3559f796',
      name: 'Chopra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f797',
      name: 'Goalpokhar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f798',
      name: 'Goalpokhar Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f799',
      name: 'Hemtabad',
    },
    {
      _id: '60ab6e9586ed1c1a3559f79a',
      name: 'Islampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f79b',
      name: 'Itahar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f79c',
      name: 'Kaliaganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f79d',
      name: 'Karandighi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f79e',
      name: 'Raiganj',
    },
  ],
  Hooghly: [
    {
      _id: '60ab6e9586ed1c1a3559f79f',
      name: 'Arambagh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a0',
      name: 'Balagarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a1',
      name: 'Chanditala-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a2',
      name: 'Chanditala-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a3',
      name: 'Chinsurah-Magrah',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a5',
      name: 'Dhaniakhali',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a6',
      name: 'Goghat-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a7',
      name: 'Goghat-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a8',
      name: 'Haripal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7a9',
      name: 'Jangipara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7aa',
      name: 'Khanakul-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ab',
      name: 'Khanakul-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ac',
      name: 'Pandua',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ad',
      name: 'Pursurah',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ae',
      name: 'Singur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7af',
      name: 'Sirampur-Uttarpara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b0',
      name: 'Tarakeswar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b1',
      name: 'Polba-Dadpur',
    },
  ],
  Howrah: [
    {
      _id: '60ab6e9586ed1c1a3559f7b2',
      name: 'Amta-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b3',
      name: 'Amta-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b4',
      name: 'Bagnan-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b5',
      name: 'Bagnan-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b6',
      name: 'Bally-Jagacha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b7',
      name: 'Domjur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b8',
      name: 'Jagatballavpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7b9',
      name: 'Panchla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ba',
      name: 'Sankrail',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7bb',
      name: 'Shyampur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7bc',
      name: 'Shyampur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7bd',
      name: 'Uluberia-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7be',
      name: 'Uluberia-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c0',
      name: 'Udaynarayanpur',
    },
  ],
  Jalpaiguri: [
    {
      _id: '60ab6e9586ed1c1a3559f7bf',
      name: 'Dhupguri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c1',
      name: 'Mal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c2',
      name: 'Jalpaiguri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c3',
      name: 'Matiali',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c4',
      name: 'Maynaguri',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c5',
      name: 'Nagrakata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c8',
      name: 'Rajganj',
    },
  ],
  Jhargram: [
    {
      _id: '60ab6e9586ed1c1a3559f7c6',
      name: 'Binpur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c7',
      name: 'Binpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7c9',
      name: 'Gopiballavpur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ca',
      name: 'Gopiballav Pur -Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7cb',
      name: 'Jhargram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7cc',
      name: 'Nayagram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7cd',
      name: 'Sankrail',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d3',
      name: 'Jambani',
    },
  ],
  Kalimpong: [
    {
      _id: '60ab6e9586ed1c1a3559f7ce',
      name: 'Gorubathan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7cf',
      name: 'Kalimpong-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d0',
      name: 'Kalimpong-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d1',
      name: 'Lava',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d2',
      name: 'Pedong',
    },
  ],
  Maldah: [
    {
      _id: '60ab6e9586ed1c1a3559f7d4',
      name: 'Bamongola',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d5',
      name: 'Chanchal-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d6',
      name: 'Chanchal-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d7',
      name: 'English Bazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d8',
      name: 'Habibpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7d9',
      name: 'Harishchandrapur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7da',
      name: 'Harishchandrapur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7db',
      name: 'Kaliachak-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7dc',
      name: 'Gazole',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7dd',
      name: 'Kaliachak-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7de',
      name: 'Kaliachak-Iii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7df',
      name: 'Manikchak',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e0',
      name: 'Old Malda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e1',
      name: 'Ratua-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e5',
      name: 'Ratua-I',
    },
  ],
  'Medinipur East': [
    {
      _id: '60ab6e9586ed1c1a3559f7e2',
      name: 'Bhagawanpur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e3',
      name: 'Bhagawanpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e4',
      name: 'Chandipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e6',
      name: 'Contai-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e7',
      name: 'Contai-Iii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e8',
      name: 'Deshapran',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7e9',
      name: 'Egra-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ea',
      name: 'Egra-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7eb',
      name: 'Haldia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ec',
      name: 'Khejuri-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ed',
      name: 'Khejuri-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ee',
      name: 'Kolaghat',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ef',
      name: 'Moyna',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f0',
      name: 'Nandakumar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f1',
      name: 'Nandigram-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f2',
      name: 'Nandigram-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f3',
      name: 'Mahishadal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f4',
      name: 'Panskura-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f5',
      name: 'Patashpur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f6',
      name: 'Patashpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f7',
      name: 'Ramnagar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f8',
      name: 'Ramnagar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7f9',
      name: 'Shahid Matangini',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7fa',
      name: 'Sutahata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7fb',
      name: 'Tamluk',
    },
  ],
  'Medinipur West': [
    {
      _id: '60ab6e9586ed1c1a3559f7fc',
      name: 'Chandrakona-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7fd',
      name: 'Chandrakona-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7fe',
      name: 'Dantan-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f7ff',
      name: 'Dantan-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f800',
      name: 'Daspur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f801',
      name: 'Debra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f802',
      name: 'Garbeta-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f803',
      name: 'Daspur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f804',
      name: 'Garbeta-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f805',
      name: 'Garbeta-Iii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f806',
      name: 'Ghatal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f807',
      name: 'Keshpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f808',
      name: 'Keshiary',
    },
    {
      _id: '60ab6e9586ed1c1a3559f809',
      name: 'Kharagpur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f80a',
      name: 'Kharagpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f80b',
      name: 'Midnapore',
    },
    {
      _id: '60ab6e9586ed1c1a3559f80c',
      name: 'Mohanpur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f80d',
      name: 'Narayangarh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f80e',
      name: 'Pingla',
    },
    {
      _id: '60ab6e9586ed1c1a3559f80f',
      name: 'Sabang',
    },
    {
      _id: '60ab6e9586ed1c1a3559f810',
      name: 'Salbani',
    },
  ],
  Murshidabad: [
    {
      _id: '60ab6e9586ed1c1a3559f811',
      name: 'Beldanga-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f812',
      name: 'Berhampore',
    },
    {
      _id: '60ab6e9586ed1c1a3559f813',
      name: 'Bhagabangola-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f814',
      name: 'Bhagawangola-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f815',
      name: 'Bharatpur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f816',
      name: 'Bharatpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f817',
      name: 'Burwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f818',
      name: 'Domkal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f819',
      name: 'Farakka',
    },
    {
      _id: '60ab6e9586ed1c1a3559f81a',
      name: 'Hariharpara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f81b',
      name: 'Jalangi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f81c',
      name: 'Beldanga-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f81d',
      name: 'Kandi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f81e',
      name: 'Khargram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f81f',
      name: 'Lalgola',
    },
    {
      _id: '60ab6e9586ed1c1a3559f820',
      name: 'Murshidabad-Jiagunj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f821',
      name: 'Nabagram',
    },
    {
      _id: '60ab6e9586ed1c1a3559f822',
      name: 'Nawda',
    },
    {
      _id: '60ab6e9586ed1c1a3559f823',
      name: 'Raghunathganj-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f824',
      name: 'Raghunathganj-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f825',
      name: 'Raninagar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f826',
      name: 'Raninagar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f827',
      name: 'Sagardighi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f828',
      name: 'Shamsherganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f829',
      name: 'Suti-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f82a',
      name: 'Suti-Ii',
    },
  ],
  Nadia: [
    {
      _id: '60ab6e9586ed1c1a3559f82b',
      name: 'Chapra',
    },
    {
      _id: '60ab6e9586ed1c1a3559f82c',
      name: 'Chakdah',
    },
    {
      _id: '60ab6e9586ed1c1a3559f82d',
      name: 'Hanskhali',
    },
    {
      _id: '60ab6e9586ed1c1a3559f82e',
      name: 'Haringhata',
    },
    {
      _id: '60ab6e9586ed1c1a3559f82f',
      name: 'Kaliganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f830',
      name: 'Kalyani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f831',
      name: 'Karimpur-1',
    },
    {
      _id: '60ab6e9586ed1c1a3559f832',
      name: 'Karimpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f833',
      name: 'Krishnaganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f834',
      name: 'Krishnagar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f835',
      name: 'Krishnagar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f836',
      name: 'Nabadwip',
    },
    {
      _id: '60ab6e9586ed1c1a3559f837',
      name: 'Ranaghat-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f838',
      name: 'Nakashipara',
    },
    {
      _id: '60ab6e9586ed1c1a3559f839',
      name: 'Ranaghat-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f83a',
      name: 'Santipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f83b',
      name: 'Tehatta-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f83e',
      name: 'Tehatta-Ii',
    },
  ],
  'Paschim Bardhaman': [
    {
      _id: '60ab6e9586ed1c1a3559f83c',
      name: 'Barabani',
    },
    {
      _id: '60ab6e9586ed1c1a3559f83d',
      name: 'Faridpur - Durgapur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f83f',
      name: 'Jamuria',
    },
    {
      _id: '60ab6e9586ed1c1a3559f840',
      name: 'Kanksa',
    },
    {
      _id: '60ab6e9586ed1c1a3559f841',
      name: 'Ondal',
    },
    {
      _id: '60ab6e9586ed1c1a3559f842',
      name: 'Pandabeswar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f843',
      name: 'Raniganj',
    },
    {
      _id: '60ab6e9586ed1c1a3559f845',
      name: 'Salanpur',
    },
  ],
  'Purba Bardhaman': [
    {
      _id: '60ab6e9586ed1c1a3559f844',
      name: 'Ausgram-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f846',
      name: 'Ausgram-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f847',
      name: 'Bhatar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f848',
      name: 'Burdwan-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f849',
      name: 'Burdwan-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f84a',
      name: 'Galsi -I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f84b',
      name: 'Galsi-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f84c',
      name: 'Kalna-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f84d',
      name: 'Kalna Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f84e',
      name: 'Jamal Pur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f84f',
      name: 'Katwa-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f850',
      name: 'Katwa-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f851',
      name: 'Ketugram_I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f852',
      name: 'Khandaghosh',
    },
    {
      _id: '60ab6e9586ed1c1a3559f853',
      name: 'Ketugram-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f854',
      name: 'Mangolkote',
    },
    {
      _id: '60ab6e9586ed1c1a3559f855',
      name: 'Manteswar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f856',
      name: 'Memari-1',
    },
    {
      _id: '60ab6e9586ed1c1a3559f857',
      name: 'Memari-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f858',
      name: 'Purbasthali-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f859',
      name: 'Purbasthali-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f85a',
      name: 'Raina-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f85b',
      name: 'Raina-Ii',
    },
  ],
  Purulia: [
    {
      _id: '60ab6e9586ed1c1a3559f85c',
      name: 'Arsha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f85d',
      name: 'Balarampur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f85e',
      name: 'Barabazar',
    },
    {
      _id: '60ab6e9586ed1c1a3559f85f',
      name: 'Bagmundi',
    },
    {
      _id: '60ab6e9586ed1c1a3559f860',
      name: 'Bundwan',
    },
    {
      _id: '60ab6e9586ed1c1a3559f861',
      name: 'Hura',
    },
    {
      _id: '60ab6e9586ed1c1a3559f862',
      name: 'Jaipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f863',
      name: 'Jhalda-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f864',
      name: 'Kashipur',
    },
    {
      _id: '60ab6e9586ed1c1a3559f865',
      name: 'Jhalda-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f866',
      name: 'Manbazar-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f867',
      name: 'Manbazar-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f868',
      name: 'Neturia',
    },
    {
      _id: '60ab6e9586ed1c1a3559f869',
      name: 'Para',
    },
    {
      _id: '60ab6e9586ed1c1a3559f86a',
      name: 'Puncha',
    },
    {
      _id: '60ab6e9586ed1c1a3559f86b',
      name: 'Purulia-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f86c',
      name: 'Purulia-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f86d',
      name: 'Raghunath Pur-I',
    },
    {
      _id: '60ab6e9586ed1c1a3559f86e',
      name: 'Raghunathpur-Ii',
    },
    {
      _id: '60ab6e9586ed1c1a3559f86f',
      name: 'Santuri',
    },
  ],
  'New Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf7314',
      name: 'Chanakya Puri',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7315',
      name: 'Delhi Cantonment',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7317',
      name: 'Vasant Vihar',
    },
  ],
  'North Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf7318',
      name: 'Model Town',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7319',
      name: 'Narela',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7328',
      name: 'Alipur',
    },
  ],
  'North West Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf731a',
      name: 'Rohini',
    },
    {
      _id: '6461dd72b0c65e0b9ecf731b',
      name: 'Khanjhawala',
    },
    {
      _id: '6461dd72b0c65e0b9ecf731c',
      name: 'Saraswati Vihar',
    },
  ],
  'West Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf731d',
      name: 'Patel Nagar',
    },
    {
      _id: '6461dd72b0c65e0b9ecf731e',
      name: 'Rajouri Garden',
    },
    {
      _id: '6461dd72b0c65e0b9ecf731f',
      name: 'Punjabi Bagh',
    },
  ],
  'South West Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf7320',
      name: 'Dwarka',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7321',
      name: 'Najafgarh',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7322',
      name: 'Kapashera',
    },
  ],
  'South Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf7323',
      name: 'Saket',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7324',
      name: 'Hauz Khas',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7325',
      name: 'Mehrauli',
    },
  ],
  'South East Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf7326',
      name: 'Defence Colony',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7327',
      name: 'Kalkaji',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7335',
      name: 'Sarita Vihar',
    },
  ],
  'Central Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf7329',
      name: 'Civil Lines',
    },
    {
      _id: '6461dd72b0c65e0b9ecf732a',
      name: 'Kotwali',
    },
    {
      _id: '6461dd72b0c65e0b9ecf732b',
      name: 'Karol Bagh',
    },
  ],
  'North East Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf732c',
      name: 'Seelam Pur',
    },
    {
      _id: '6461dd72b0c65e0b9ecf732d',
      name: 'Yamuna Vihar',
    },
    {
      _id: '6461dd72b0c65e0b9ecf732e',
      name: 'Karawal Nagar',
    },
  ],
  Shahdara: [
    {
      _id: '6461dd72b0c65e0b9ecf732f',
      name: 'Shahdara',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7330',
      name: 'Seema Puri',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7331',
      name: 'Vivek Vihar',
    },
  ],
  'East Delhi': [
    {
      _id: '6461dd72b0c65e0b9ecf7332',
      name: 'Gandhi Nagar',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7333',
      name: 'Preet Vihar',
    },
    {
      _id: '6461dd72b0c65e0b9ecf7334',
      name: 'Mayur Vihar',
    },
  ],
  Nandyal: [
  {
    _id: '692a9e59061946ee5291f025',
    name: 'Velugodu',
  },

  {
    _id: '692a9e50af28a4e160385503',
    name: 'Uyyalawada',
  },

  {
    _id: '692a9e48787ccdb83c48e746',
    name: 'Srisailam',
  },

  {
    _id: '692a9e3fb1ba4b98d91dee50',
    name: 'Sirivel',
  },

  {
    _id: '692a9e3778c04c9efdf8bb7b',
    name: 'Sanjamala',
  },

  {
    _id: '692a9e2c394a760505cd8a0f',
    name: 'Rudravaram',
  },

  {
    _id: '692a9e235d5d660081742827',
    name: 'Panyam',
  },

  {
    _id: '692a9e1b8ca43b31b4c6db7d',
    name: 'Pamulapadu',
  },

  {
    _id: '692a9e13ac9b0c697e0574d3',
    name: 'Pagidyala',
  },

  {
    _id: '692a9e0a5cae5d718507a4a6',
    name: 'Owk',
  },

  {
    _id: '692a9e01e6f0523dbc2804ec',
    name: 'Nandyal',
  },

  {
    _id: '692a9df6ffa6f2b3413eb6a8',
    name: 'Nandikotkur',
  },

  {
    _id: '692a9ded2dd824083283ab3d',
    name: 'Midthur',
  },

  {
    _id: '692a9dcccedc78d82686673b',
    name: 'Mahanandi',
  },

  {
    _id: '692a9dc00e5fae9c114edca7',
    name: 'Kothapalle',
  },

  {
    _id: '692a9db2e2f90fddb5006d7f',
    name: 'Kolimigundla',
  },

  {
    _id: '692a9da468b8a86c300b0ab2',
    name: 'Koilakuntla',
  },

  {
    _id: '692a9d98c6606fb9945cee86',
    name: 'Jupadu Bungalow',
  },

  {
    _id: '692a9d897fa7c825970cd8a1',
    name: 'Gospadu',
  },

  {
    _id: '692a9d7c6dbef4ac5d98d305',
    name: 'Gadivemula',
  },

  {
    _id: '692a9d6fb708cd6a2abff4e1',
    name: 'Dornipadu',
  },

  {
    _id: '692a9d622fa4c3774c391e4c',
    name: 'Chagalamarri',
  },

  {
    _id: '692a9d5500c222f6783b3b11',
    name: 'Bethamcherla',
  },

  {
    _id: '692a9d480ffd7433d616d339',
    name: 'Bandi Atmakur',
  },

  {
    _id: '692a9d3dd59cf44d5d3e2847',
    name: 'Banaganapalle',
  },

  {
    _id: '692a9d33df7957658aa5b90a',
    name: 'Atmakur',
  },

  {
    _id: '692a9d1e5309551f334b3322',
    name: 'Allagadda',
  },

  {
    _id: '692a9cdb4e4d696b792990a9',
    name: 'Dhone',
  },

  {
    _id: '692414e3b05e56bcec142d2e',
    name: 'Peapully',
  },

  {
    _id: '692414d4e2b6feec509b77cd',
    name: 'Mahanandhi',
  },
  ],

  'Kumuram Bheem Asifabad': [
  {
    _id: '6a047b283b6a3bab82c38aa3',
    name: 'Wankidi',
  },

  {
    _id: '6a047af4290a105c65311ea6',
    name: 'Tiryani',
  },

  {
    _id: '6a047ade95f8d9c29a3562ec',
    name: 'Sirpur U',
  },

  {
    _id: '6a047acab42151e1cbbbb0f9',
    name: 'Sirpur (T)',
  },

  {
    _id: '6a047aba4652cbfb04e8a290',
    name: 'Rebbena',
  },

  {
    _id: '6a047aa58e5a4052a3c73a2e',
    name: 'Penchicalpet',
  },

  {
    _id: '6a047a5973168909e3dca894',
    name: 'Lingapur',
  },

  {
    _id: '6a047a3d8479d0b5dbd37eb6',
    name: 'Koutala',
  },

  {
    _id: '6a047a0aaa22a77aac971ad5',
    name: 'Kerameri',
  },

  {
    _id: '6a0479cd869ab33074041593',
    name: 'Kagaznagar',
  },

  {
    _id: '6a0479aa3c9d15030fcb0e24',
    name: 'Jainoor',
  },

  {
    _id: '6a04798273cb9e4e4180088b',
    name: 'Dahegoan',
  },

  {
    _id: '6a0479610b8fab9d7ec7df11',
    name: 'Chintalamanepalli',
  },

  {
    _id: '6a047916dda15d83d611da2d',
    name: 'Bejjur',
  },

  {
    _id: '6a0478c181b22c48dffb4986',
    name: 'Asifabad',
  },
  ],

};

export const fetchBlockByDistrictName = district => blocks[district] || [];
